/* tslint:disable */
/* eslint-disable */
/**
 * Gateway API
 * API documentation for the Gateway service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface CordeCommonErrorsCustomError
 */
export interface CordeCommonErrorsCustomError {
    /**
     * Custom error code
     * @type {CordeCommonErrorsErrorCode}
     * @memberof CordeCommonErrorsCustomError
     */
    'code'?: CordeCommonErrorsErrorCode;
    /**
     * Wrapped internal error (optional)
     * @type {object}
     * @memberof CordeCommonErrorsCustomError
     */
    'err'?: object;
    /**
     * Error message
     * @type {string}
     * @memberof CordeCommonErrorsCustomError
     */
    'message'?: string;
    /**
     * Service name generating the error
     * @type {string}
     * @memberof CordeCommonErrorsCustomError
     */
    'service'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const CordeCommonErrorsErrorCode = {
    GatewayErrCodeInvalidToken: 1000,
    GatewayErrCodeTokenExpired: 1001,
    GatewayErrCodeSignInFailed: 1002,
    GatewayErrCodeSignUpFailed: 1003,
    GatewayErrCodeVerificationEmail: 1004,
    GatewayErrCodeRefreshFailed: 1005,
    GatewayErrCodeResetPassword: 1006,
    GatewayErrCodeTooManyRequests: 1007,
    ErrCodeInvalidRequest: 1,
    ErrCodeInternal: 2,
    ErrCodeNotFound: 3,
    ErrCodeConflict: 4,
    ErrCodeUnauthorized: 5,
    ErrCodeForbidden: 6,
    UserErrCodeNoUserIDInContext: 7,
    UserErrCodeNoRequestIDInContext: 8,
    ErrCodeNotImplemented: 9,
    ErrCodeTooManyRequests: 10,
    UserProfileErrCodeUnauthorized: 5000,
    UserProfileErrCodeNoUserIDInContext: 5001,
    UserProfileErrCodeAuthzCheckFailed: 5002,
    UserProfileErrCodeNotAllowed: 5003,
    UserProfileErrCodeNotification: 5004,
    UserProfileErrCodeInvalidRequest: 5005,
    UserProfileErrCodeCreateProfile: 5006,
    UserProfileErrCodeGetProfile: 5007,
    UserProfileErrCodeUpdateProfile: 5008,
    UserProfileErrCodeDeleteProfile: 5009,
    UserProfileErrCodeListProfiles: 5010,
    UserProfileErrCodeAddContact: 5011,
    UserProfileErrCodeGetContact: 5012,
    UserProfileErrCodeUpdateContact: 5013,
    UserProfileErrCodeDeleteContact: 5014,
    UserProfileErrCodeListContacts: 5015,
    UserProfileErrCodeCreateAvatar: 5016,
    UserProfileErrCodeUpdateAvatar: 5017,
    UserProfileErrCodeDeleteAvatar: 5018,
    UserProfileErrCodeListAvatars: 5019,
    UserProfileErrCodeGetAvatar: 5020,
    UserProfileErrCodeSetActiveAvatar: 5021,
    UserProfileErrCodeGetUISettings: 5022,
    UserProfileErrCodeUpdateUISettings: 5023,
    UserProfileErrCodeDeleteUISettings: 5024,
    UserProfileErrCodeGetPrivacySettings: 5025,
    UserProfileErrCodeUpdatePrivacySettings: 5026,
    UserProfileErrCodeGetNotificationSettings: 5027,
    UserProfileErrCodeUpdateNotificationSettings: 5028,
    UserProfileErrCodeGetNotificationHistory: 5029,
    UserProfileErrCodeGetChangeHistory: 5030,
    UserProfileErrCodeGetAuditLogs: 5031,
    UserProfileErrCodeSetDefaultProfile: 5032,
    UserProfileErrCodeGetDefaultProfile: 5033,
    UserErrCodeEmailAlreadyUsed: 4000,
    UserErrCodeCreateUserProfile: 4001,
    UserErrCodeDeleteUserProfile: 4002,
    UserErrCodeUsernameAlreadyUsed: 4003,
    UserErrCodePasswordsDoNotMatch: 4004,
    UserErrCodeGetUser: 4005,
    UserErrCodeFailedToHashPassword: 4006,
    UserErrCodeFailedToCreateUser: 4007,
    UserErrCodeFailedToUpdateUser: 4008,
    UserErrCodeFailedToDeleteUser: 4009,
    UserErrCodeFailedToSendVerification: 4010,
    UserErrCodeUserNotFound: 4011,
    UserErrCodeUserprofileNotFound: 4012,
    UserErrCodeIncorrectCredentials: 4013,
    UserErrCodeNewPasswordsDoNotMatch: 4014,
    UserErrCodeOldPasswordDoesNotMatch: 4015,
    UserErrCodeNotAllowed: 4016,
    UserErrCodeFailedToVerifyEmail: 4017,
    UserErrCodeFailedToSendResetEmail: 4018,
    UserErrCodePasswordConfirmationMatch: 4019,
    UserErrCodeEmailNotProvided: 4020,
    UserErrCodeFailedToSetAuthorizationTuple: 4021,
    UserErrCodeFailedToDeleteAuthorizationTuple: 4022,
    UserErrCodeFailedToSendInvite: 4023,
    UserErrCodeFailedToGenerateReferralLink: 4024,
    UserErrCodeFailedToEnableTwoFactorAuth: 4025,
    UserErrCodeFailedToDisableTwoFactorAuth: 4026,
    UserErrCodeIncorrectPassword: 4027,
    UserErrCodeFailedToVerifyTwoFactorAuth: 4028,
    UserErrCodeFailedToGenerateUuid: 4029,
    UserErrCodeFailedToWriteRelationSelf: 4030,
    VoiceErrCodeUnauthorized: 16000,
    VoiceErrCodeNotAllowed: 16001,
    VoiceErrCodeInternalError: 16002,
    VoiceErrCodeInvalidRequest: 16003,
    VoiceErrCodeValidationError: 16004,
    BalanceErrCodeNotFound: 13000,
    BalanceErrCodeInsufficientFunds: 13001,
    BalanceErrCodeTransactionNotFound: 13002,
    BalanceErrCodeInvalidAmount: 13003,
    BalanceErrCodeUnauthorized: 13004,
    BalanceErrCodeReserveNotFound: 13005,
    BalanceErrCodeInvalidReserveStatus: 13006,
    BalanceErrCodeWalletCreationFailed: 13007,
    BalanceErrCodeTransactionFailed: 13008,
    BalanceErrCodeInvalidCurrency: 13009,
    BalanceErrCodeConcurrencyConflict: 13010,
    BalanceErrCodeNoUserIDInContext: 13011,
    BalanceErrCodeDbOperationFailed: 13012,
    BalanceErrCodeNotificationFailed: 13013,
    BalanceErrCodeInvalidRequest: 13014,
    BalanceErrCodeDepositAddressNotFound: 13015,
    BalanceErrCodeInvalidAddress: 13016,
    BalanceErrCodeInvalidPaymentSystem: 13017,
    BalanceErrCodeInvalidBankDetails: 13018,
    BalanceErrCodeInvalidUserID: 13019,
    BalanceErrCodeFiatDetailsNotFound: 13020,
    BalanceErrCodeCryptoAddressNotFound: 13021,
    BalanceErrCodeDuplicateRecord: 13022,
    BalanceErrCodeInvalidNetwork: 13023,
    BalanceErrCodeInvalidIdempotencyKey: 13024,
    BalanceErrCodeTooManyRequests: 13025,
    BalanceErrCodeInvalidStatus: 13026,
    BalanceErrCodeIdempotencyKeyAlreadyExists: 13027,
    BalanceErrCodeCurrencyNotFound: 13028,
    BalanceErrCodeFailedToListCurrencies: 13029,
    BalanceErrCodeFailedToCreateCurrency: 13030,
    BalanceErrCodeFailedToUpdateCurrency: 13031,
    BalanceErrCodeFailedToDisableCurrency: 13032,
    BalanceErrCodeFailedToEnsureBalances: 13033,
    ErrCodeBadRequest: 40000,
    ErrCodeAccessDenied: 40300,
    ErrCodeServiceUnavailable: 50300,
    AuthzErrCodeCheckPermissionFailed: 3000,
    AuthzErrCodeBulkCheckFailed: 3001,
    AuthzErrCodeWriteRelationshipsFailed: 3002,
    AuthzErrCodeDeleteRelationshipsFailed: 3003,
    AuthzErrCodeReadRelationshipsFailed: 3004,
    AuthzErrCodeExpandPermissionTreeFailed: 3005,
    AuthzErrCodeLookupResourcesFailed: 3006,
    AuthzErrCodeLookupSubjectsFailed: 3007,
    AuthzErrCodeReadSchemaFailed: 3008,
    AuthzErrCodeWriteSchemaFailed: 3009,
    AuthzErrCodePermissionDenied: 3000,
    AuthzErrCodeFailedToCheckPermission: 3001,
    AuthzErrCodeFailedToWriteRelationship: 3002,
    AuthzErrCodeFailedToDeleteRelationship: 3003,
    AuthzErrCodeFailedToReadRelationships: 3004,
    AuthzErrCodeFailedToLookupResources: 3005,
    AuthzErrCodeFailedToLookupSubjects: 3006,
    AuthzErrCodeFailedToReadSchema: 3007,
    AuthzErrCodeFailedToWriteSchema: 3008,
    AuthzErrCodeInvalidRequest: 3009,
    AuthzErrCodeInvalidSubject: 3010,
    AuthzErrCodeInvalidResource: 3011,
    AuthzErrCodeInvalidPermission: 3012,
    AuthzErrCodeInvalidSchema: 3013,
    AuthzErrCodeInvalidRelationship: 3014,
    AuthzErrCodeSchemaValidationFailed: 3015,
    AuthzErrCodeRelationshipNotFound: 3016,
    AuthzErrCodeSchemaNotFound: 3017,
    AuthzErrCodeExpandPermissionTree: 3018,
    AuthzErrCodeLookupResources: 3019,
    AuthzErrCodeLookupResourcesStream: 3020,
    AuthzErrCodeLookupSubjects: 3021,
    AuthzErrCodeLookupSubjectsStream: 3022,
    NotificationsErrCodeNotificationNotFound: 7000,
    NotificationsErrCodeChannelNotFound: 7001,
    NotificationsErrCodeTemplateNotFound: 7002,
    NotificationsErrCodeInvalidTemplate: 7003,
    NotificationsErrCodeInvalidChannel: 7004,
    NotificationsErrCodeSendFailed: 7005,
    NotificationsErrCodeDeliveryFailed: 7006,
    NotificationsErrCodeInvalidUserSettings: 7007,
    NotificationsErrCodeSettingsNotFound: 7008,
    NotificationsErrCodeInvalidPolicy: 7009,
    NotificationsErrCodePolicyNotFound: 7010,
    NotificationsErrCodeSubscriptionNotFound: 7011,
    NotificationsErrCodeInvalidSubscription: 7012,
    NotificationsErrCodeFrequencyLimitExceeded: 7013,
    NotificationsErrCodeChannelUnavailable: 7014,
    NotificationsErrCodeTemplateMissingVariables: 7015,
    NotificationsErrCodeInvalidVariables: 7016,
    NotificationsErrCodeUserNotPermitted: 7017,
    NotificationsErrCodeInvalidContext: 7018,
    NotificationsErrCodeQuietHoursActive: 7019,
    NotificationsErrCodeUserOptedOut: 7020,
    NotificationsErrCodeChannelConfigInvalid: 7021,
    NotificationsErrCodeInvalidChannelConfig: 7022,
    NotificationsErrCodeFailedToCreateChannel: 7023,
    NotificationsErrCodeFailedToUpdateChannel: 7024,
    NotificationsErrCodeFailedToDeleteChannel: 7025,
    NotificationsErrCodeFailedToCreateTemplate: 7026,
    NotificationsErrCodeFailedToUpdateTemplate: 7027,
    NotificationsErrCodeFailedToDeleteTemplate: 7028,
    NotificationsErrCodeFailedToUpdateSettings: 7029,
    NotificationsErrCodeFailedToUpdatePolicy: 7030,
    NotificationsErrCodeFailedToMarkAsRead: 7031,
    NotificationsErrCodeFailedToGetStats: 7032,
    NotificationsErrCodeFailedToGetAuditLogs: 7033,
    NotificationsErrCodeInvalidDateRange: 7034,
    NotificationsErrCodeInvalidPriority: 7035,
    NotificationsErrCodeInvalidStatus: 7036,
    NotificationsErrCodeDuplicateChannel: 7037,
    NotificationsErrCodeDuplicateTemplate: 7038,
    NotificationsErrCodeChannelInUse: 7039,
    NotificationsErrCodeTemplateInUse: 7040,
    NotificationsErrCodeInvalidLanguage: 7041,
    NotificationsErrCodeInvalidTimezone: 7042,
    NotificationsErrCodeInvalidQuietHours: 7043,
    NotificationsErrCodeInvalidDigestFrequency: 7044,
    NotificationsErrCodeProviderError: 7045,
    NotificationsErrCodeRateLimitExceeded: 7046,
    NotificationsErrCodeBulkOperationPartialFailure: 7047,
    NotificationsErrCodeInvalidBulkRequest: 7048,
    NotificationsErrCodeFailedToGenerateID: 7049,
    NotificationsErrCodeFailedToCreateNotification: 7050,
    NotificationsErrCodeNotAllowed: 7051,
    NotificationsErrCodeFailedToListNotifications: 7052,
    NotificationsErrCodeFailedToListTemplates: 7053,
    NotificationsErrCodeFailedToListChannels: 7054,
    NotificationsErrCodeFailedToGetPreferences: 7055,
    NotificationsErrCodeFailedToUpdatePreferences: 7056,
    NotificationsErrCodeFailedToGetSubscriptions: 7057,
    NotificationsErrCodeFailedToUpdateSubscriptions: 7058,
    NotificationsErrCodeFailedToGetUserPreferences: 7059,
    NotificationsErrCodeFailedToUpdateUserPreferences: 7060,
    NotificationsErrCodeFailedToGetUserSubscriptions: 7061,
    NotificationsErrCodeFailedToUpdateUserSubscriptions: 7062,
    NotificationsErrCodeValidationFailed: 7063,
    AdminErrCodePlatformNotFound: 2000,
    AdminErrCodePlatformAlreadyExists: 2001,
    AdminErrCodeFailedToCreatePlatform: 2002,
    AdminErrCodeFailedToUpdatePlatform: 2003,
    AdminErrCodeFailedToDeletePlatform: 2004,
    AdminErrCodeFailedToGetPlatform: 2005,
    AdminErrCodeFailedToListPlatforms: 2006,
    AdminErrCodeNotAllowed: 2007,
    AdminErrCodeFailedToAssignRole: 2008,
    AdminErrCodeFailedToRevokeRole: 2009,
    AdminErrCodeFailedToGetRoles: 2010,
    AdminErrCodeFailedToListRoles: 2011,
    AdminErrCodeFailedToUpdateSettings: 2012,
    AdminErrCodeFailedToGetSettings: 2013,
    AdminErrCodeFailedToCreateAuditLog: 2014,
    AdminErrCodeFailedToGetAuditLogs: 2015,
    AdminErrCodeInvalidRequest: 2016,
    AdminErrCodeInvalidPlatformID: 2017,
    AdminErrCodeInvalidUserID: 2018,
    AdminErrCodeInvalidRole: 2019,
    AdminErrCodeInvalidSettings: 2020,
    AdminErrCodeFailedToValidateSettings: 2021,
    AdminErrCodeFailedToCheckPermission: 2022,
    AdminErrCodeFailedToSetAuthzRelation: 2023,
    AdminErrCodeFailedToDeleteAuthzRelation: 2024,
    TeamErrCodeNotAllowed: 6000,
    TeamErrCodeTeamNotFound: 6001,
    TeamErrCodeFailedToCreateTeam: 6002,
    TeamErrCodeFailedToUpdateTeam: 6003,
    TeamErrCodeFailedToDeleteTeam: 6004,
    TeamErrCodeFailedToListTeams: 6005,
    TeamErrCodeFailedToSearchTeams: 6006,
    TeamErrCodeFailedToAddMember: 6007,
    TeamErrCodeFailedToRemoveMember: 6008,
    TeamErrCodeFailedToUpdateRole: 6009,
    TeamErrCodeFailedToListUsers: 6010,
    TeamErrCodeFailedToCreateInvitation: 6011,
    TeamErrCodeInvitationNotFound: 6012,
    TeamErrCodeFailedToUpdateInvitation: 6013,
    TeamErrCodeFailedToListInvitations: 6014,
    TeamErrCodeFailedToCreateRole: 6015,
    TeamErrCodeRoleNotFound: 6016,
    TeamErrCodeFailedToDeleteRole: 6017,
    TeamErrCodeFailedToAssignPermission: 6018,
    TeamErrCodeFailedToRemovePermission: 6019,
    TeamErrCodeFailedToListRoles: 6020,
    TeamErrCodeFailedToListPermissions: 6021,
    TeamErrCodeFailedToCreateRoleRequest: 6022,
    TeamErrCodeRoleRequestNotFound: 6023,
    TeamErrCodeFailedToUpdateRoleRequest: 6024,
    TeamErrCodeFailedToGrantRole: 6025,
    TeamErrCodeFailedToCreateOwnershipRequest: 6026,
    TeamErrCodeFailedToGrantOwnership: 6027,
    TeamErrCodeFailedToRevokeOwnership: 6028,
    TeamErrCodeFailedToTransferOwnership: 6029,
    TeamErrCodeFailedToGetLogs: 6030,
    TeamErrCodeFailedToGetAuditLogs: 6031,
    TeamErrCodeFailedToAddContact: 6032,
    TeamErrCodeFailedToUpdateContact: 6033,
    TeamErrCodeFailedToDeleteContact: 6034,
    TeamErrCodeFailedToListContacts: 6035,
    TeamErrCodeFailedToCreateMembershipRequest: 6036,
    TeamErrCodeMembershipRequestNotFound: 6037,
    TeamErrCodeFailedToUpdateMembershipRequest: 6038,
    TeamErrCodeFailedToAssignRole: 6039,
    TeamErrCodeFailedToRemoveRole: 6040,
    TeamErrCodeFailedToRequestRole: 6041,
    TeamErrCodeFailedToInviteUser: 6042,
    TeamErrCodeFailedToRequestMembership: 6043,
    TeamErrCodeInvalidTimeRange: 6044,
    TeamErrCodeInvalidPermission: 6045,
    TeamErrCodeInvalidPermissions: 6046,
    TeamErrCodeFailedToAssignPermissions: 6047,
    TeamErrCodeFailedToRemovePermissions: 6048,
    TeamErrCodeFailedToAddUserToTeam: 6049,
    TeamErrCodeFailedToCreateTeamAvatar: 6050,
    TeamErrCodeFailedToUpdateTeamAvatar: 6051,
    TeamErrCodeFailedToDeleteTeamAvatar: 6052,
    TeamErrCodeFailedToListTeamAvatars: 6053,
    TeamErrCodeFailedToGetTeamAvatar: 6054,
    TeamErrCodeFailedToSetActiveTeamAvatar: 6055,
    TeamErrCodeFailedToCreateTeamBanner: 6056,
    TeamErrCodeFailedToGetTeamBanner: 6057,
    TeamErrCodeFailedToDeleteTeamBanner: 6058,
    TeamErrCodeFailedToGetTeamSettings: 6059,
    TeamErrCodeFailedToUpdateTeamSettings: 6060,
    TeamErrCodeFailedToResetTeamSettings: 6061,
    TeamErrCodeFailedToSetDefaultProfile: 6062,
    TeamErrCodeFailedToWriteAuthzRelations: 6063,
    TeamErrCodeTeamFull: 6064,
    TeamErrCodeInvitationLimitReached: 6065,
    ErrCodeFailedOperation: 1000,
    ErrCodeInvalidInput: 1001,
    ErrCodeFailedToStoreFile: 1002,
    ErrCodeFailedToReadFile: 1003,
    ErrCodeActionNotAllowed: 1004
} as const;

export type CordeCommonErrorsErrorCode = typeof CordeCommonErrorsErrorCode[keyof typeof CordeCommonErrorsErrorCode];


/**
 * 
 * @export
 * @enum {string}
 */

export const CordeCommonModelsConstantsFilterOperator = {
    OpEq: 'eq',
    OpNe: 'ne',
    OpGt: 'gt',
    OpGte: 'gte',
    OpLt: 'lt',
    OpLte: 'lte',
    OpLike: 'like',
    OpIn: 'in',
    OpNotIn: 'not_in',
    OpIsNull: 'is_null'
} as const;

export type CordeCommonModelsConstantsFilterOperator = typeof CordeCommonModelsConstantsFilterOperator[keyof typeof CordeCommonModelsConstantsFilterOperator];


/**
 * 
 * @export
 * @enum {string}
 */

export const CordeCommonModelsConstantsHTTPMethod = {
    HTTPMethodTypeUnspecified: 'unspecified',
    HTTPMethodTypePost: 'POST',
    HTTPMethodTypePut: 'PUT',
    HTTPMethodTypePatch: 'PATCH'
} as const;

export type CordeCommonModelsConstantsHTTPMethod = typeof CordeCommonModelsConstantsHTTPMethod[keyof typeof CordeCommonModelsConstantsHTTPMethod];


/**
 * 
 * @export
 * @enum {string}
 */

export const CordeCommonModelsConstantsLogicOperator = {
    LogicAnd: 'AND',
    LogicOr: 'OR'
} as const;

export type CordeCommonModelsConstantsLogicOperator = typeof CordeCommonModelsConstantsLogicOperator[keyof typeof CordeCommonModelsConstantsLogicOperator];


/**
 * 
 * @export
 * @enum {string}
 */

export const CordeCommonModelsConstantsRequesterType = {
    REQUESTER_TYPE_USER: 'user',
    REQUESTER_TYPE_TEAM: 'team',
    REQUESTER_TYPE_INTEGRATION: 'integration'
} as const;

export type CordeCommonModelsConstantsRequesterType = typeof CordeCommonModelsConstantsRequesterType[keyof typeof CordeCommonModelsConstantsRequesterType];


/**
 * 
 * @export
 * @enum {string}
 */

export const CordeCommonModelsConstantsTestResult = {
    TestResultTypeUnspecified: 'unspecified',
    TestResultTypeSuccess: 'success',
    TestResultTypeConnectionFailed: 'connection_failed',
    TestResultTypeAuthenticationFailed: 'authentication_failed',
    TestResultTypeInvalidConfig: 'invalid_config',
    TestResultTypeRateLimited: 'rate_limited',
    TestResultTypeRecipientInvalid: 'recipient_invalid',
    TestResultTypeUnknownError: 'unknown_error'
} as const;

export type CordeCommonModelsConstantsTestResult = typeof CordeCommonModelsConstantsTestResult[keyof typeof CordeCommonModelsConstantsTestResult];


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAdminAdminAuditLog
 */
export interface CordeCommonModelsDtoAdminAdminAuditLog {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminAdminAuditLog
     */
    'action'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminAdminAuditLog
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminAdminAuditLog
     */
    'entity_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminAdminAuditLog
     */
    'entity_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminAdminAuditLog
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminAdminAuditLog
     */
    'ip_address'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof CordeCommonModelsDtoAdminAdminAuditLog
     */
    'metadata'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CordeCommonModelsDtoAdminAdminAuditLog
     */
    'new_value'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CordeCommonModelsDtoAdminAdminAuditLog
     */
    'old_value'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminAdminAuditLog
     */
    'platform_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminAdminAuditLog
     */
    'profile_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminAdminAuditLog
     */
    'user_agent'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAdminAssignPlatformRoleRequest
 */
export interface CordeCommonModelsDtoAdminAssignPlatformRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminAssignPlatformRoleRequest
     */
    'platform_id': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminAssignPlatformRoleRequest
     */
    'profile_id': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminAssignPlatformRoleRequest
     */
    'role': string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAdminCreatePlatformRequest
 */
export interface CordeCommonModelsDtoAdminCreatePlatformRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminCreatePlatformRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminCreatePlatformRequest
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAdminGetAdminAuditLogsResponse
 */
export interface CordeCommonModelsDtoAdminGetAdminAuditLogsResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoAdminAdminAuditLog>}
     * @memberof CordeCommonModelsDtoAdminGetAdminAuditLogsResponse
     */
    'logs'?: Array<CordeCommonModelsDtoAdminAdminAuditLog>;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoAdminGetAdminAuditLogsResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAdminGetGlobalSettingsResponse
 */
export interface CordeCommonModelsDtoAdminGetGlobalSettingsResponse {
    /**
     * 
     * @type {Array<number>}
     * @memberof CordeCommonModelsDtoAdminGetGlobalSettingsResponse
     */
    'settings'?: Array<number>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAdminGetPlatformRolesResponse
 */
export interface CordeCommonModelsDtoAdminGetPlatformRolesResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoAdminGetPlatformRolesResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoAdminPlatformRole>}
     * @memberof CordeCommonModelsDtoAdminGetPlatformRolesResponse
     */
    'roles'?: Array<CordeCommonModelsDtoAdminPlatformRole>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAdminGetPlatformsResponse
 */
export interface CordeCommonModelsDtoAdminGetPlatformsResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoAdminGetPlatformsResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoAdminPlatform>}
     * @memberof CordeCommonModelsDtoAdminGetPlatformsResponse
     */
    'platforms'?: Array<CordeCommonModelsDtoAdminPlatform>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAdminPlatform
 */
export interface CordeCommonModelsDtoAdminPlatform {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminPlatform
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminPlatform
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminPlatform
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminPlatform
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminPlatform
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminPlatform
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAdminPlatformRole
 */
export interface CordeCommonModelsDtoAdminPlatformRole {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminPlatformRole
     */
    'assigned_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminPlatformRole
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminPlatformRole
     */
    'platform_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminPlatformRole
     */
    'profile_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminPlatformRole
     */
    'revoked_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminPlatformRole
     */
    'role'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAdminRevokePlatformRoleRequest
 */
export interface CordeCommonModelsDtoAdminRevokePlatformRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminRevokePlatformRoleRequest
     */
    'platform_id': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminRevokePlatformRoleRequest
     */
    'profile_id': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminRevokePlatformRoleRequest
     */
    'role': string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAdminUpdateGlobalSettingsRequest
 */
export interface CordeCommonModelsDtoAdminUpdateGlobalSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminUpdateGlobalSettingsRequest
     */
    'platform_id': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof CordeCommonModelsDtoAdminUpdateGlobalSettingsRequest
     */
    'settings': Array<number>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAdminUpdatePlatformRequest
 */
export interface CordeCommonModelsDtoAdminUpdatePlatformRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminUpdatePlatformRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminUpdatePlatformRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAdminUpdatePlatformRequest
     */
    'platform_id': string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAttachmentBulkDeleteFilesRequest
 */
export interface CordeCommonModelsDtoAttachmentBulkDeleteFilesRequest {
    /**
     * List of IDs of files to delete
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoAttachmentBulkDeleteFilesRequest
     */
    'ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAttachmentBulkFilesMetadataResponse
 */
export interface CordeCommonModelsDtoAttachmentBulkFilesMetadataResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoAttachmentFiles}
     * @memberof CordeCommonModelsDtoAttachmentBulkFilesMetadataResponse
     */
    'files'?: CordeCommonModelsDtoAttachmentFiles;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoAttachmentBulkFilesMetadataResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAttachmentBulkGetFileMetadataRequest
 */
export interface CordeCommonModelsDtoAttachmentBulkGetFileMetadataRequest {
    /**
     * List of IDs for which metadata is requested
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoAttachmentBulkGetFileMetadataRequest
     */
    'ids'?: Array<string>;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedRequest}
     * @memberof CordeCommonModelsDtoAttachmentBulkGetFileMetadataRequest
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedRequest;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAttachmentBulkGetFilesRequest
 */
export interface CordeCommonModelsDtoAttachmentBulkGetFilesRequest {
    /**
     * List of IDs of files to retrieve
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoAttachmentBulkGetFilesRequest
     */
    'ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAttachmentBulkTransferFileOwnershipRequest
 */
export interface CordeCommonModelsDtoAttachmentBulkTransferFileOwnershipRequest {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoAttachmentTransferFileOwnershipRequest>}
     * @memberof CordeCommonModelsDtoAttachmentBulkTransferFileOwnershipRequest
     */
    'transfers'?: Array<CordeCommonModelsDtoAttachmentTransferFileOwnershipRequest>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAttachmentBulkTransferFileOwnershipResponse
 */
export interface CordeCommonModelsDtoAttachmentBulkTransferFileOwnershipResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoAttachmentBulkTransferFileOwnershipResponse
     */
    'failed_transfers'?: Array<string>;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoAttachmentBulkTransferFileOwnershipResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
    /**
     * 
     * @type {CordeCommonModelsDtoAttachmentFiles}
     * @memberof CordeCommonModelsDtoAttachmentBulkTransferFileOwnershipResponse
     */
    'transferred_files'?: CordeCommonModelsDtoAttachmentFiles;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAttachmentBulkUploadFilesResponse
 */
export interface CordeCommonModelsDtoAttachmentBulkUploadFilesResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoAttachmentBulkUploadFilesResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
    /**
     * Metadata of uploaded files
     * @type {CordeCommonModelsDtoAttachmentFiles}
     * @memberof CordeCommonModelsDtoAttachmentBulkUploadFilesResponse
     */
    'uploaded_files'?: CordeCommonModelsDtoAttachmentFiles;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAttachmentFileMetadata
 */
export interface CordeCommonModelsDtoAttachmentFileMetadata {
    /**
     * Date when the file was soft deleted
     * @type {string}
     * @memberof CordeCommonModelsDtoAttachmentFileMetadata
     */
    'delete_at'?: string;
    /**
     * Original file name
     * @type {string}
     * @memberof CordeCommonModelsDtoAttachmentFileMetadata
     */
    'file_name'?: string;
    /**
     * Size of the file in bytes
     * @type {number}
     * @memberof CordeCommonModelsDtoAttachmentFileMetadata
     */
    'file_size'?: number;
    /**
     * ID generated for the file
     * @type {string}
     * @memberof CordeCommonModelsDtoAttachmentFileMetadata
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoAttachmentFileMetadata
     */
    'is_private'?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoAttachmentFileMetadata
     */
    'metadata'?: { [key: string]: string; };
    /**
     * MIME type of the file
     * @type {string}
     * @memberof CordeCommonModelsDtoAttachmentFileMetadata
     */
    'mime_type'?: string;
    /**
     * ID of the owner of the file
     * @type {string}
     * @memberof CordeCommonModelsDtoAttachmentFileMetadata
     */
    'owner_id'?: string;
    /**
     * Type of the owner (e.g., \"user\", \"team\")
     * @type {string}
     * @memberof CordeCommonModelsDtoAttachmentFileMetadata
     */
    'owner_type'?: string;
    /**
     * Location where the file is stored
     * @type {string}
     * @memberof CordeCommonModelsDtoAttachmentFileMetadata
     */
    'storage_location'?: string;
    /**
     * Date when the file was last updated
     * @type {string}
     * @memberof CordeCommonModelsDtoAttachmentFileMetadata
     */
    'update_at'?: string;
    /**
     * Date when the file was uploaded
     * @type {string}
     * @memberof CordeCommonModelsDtoAttachmentFileMetadata
     */
    'upload_at'?: string;
    /**
     * ID of the user who uploaded the file
     * @type {string}
     * @memberof CordeCommonModelsDtoAttachmentFileMetadata
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAttachmentFileOwnershipRecord
 */
export interface CordeCommonModelsDtoAttachmentFileOwnershipRecord {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAttachmentFileOwnershipRecord
     */
    'file_ID'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAttachmentFileOwnershipRecord
     */
    'id'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoAttachmentFileOwnershipRecord
     */
    'metadata'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAttachmentFileOwnershipRecord
     */
    'new_owner_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAttachmentFileOwnershipRecord
     */
    'new_owner_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAttachmentFileOwnershipRecord
     */
    'previous_owner_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAttachmentFileOwnershipRecord
     */
    'previous_owner_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAttachmentFileOwnershipRecord
     */
    'transfer_reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAttachmentFileOwnershipRecord
     */
    'transferred_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAttachmentFileOwnershipRecord
     */
    'transferred_by_user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAttachmentFiles
 */
export interface CordeCommonModelsDtoAttachmentFiles {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoAttachmentFileMetadata>}
     * @memberof CordeCommonModelsDtoAttachmentFiles
     */
    'files'?: Array<CordeCommonModelsDtoAttachmentFileMetadata>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAttachmentGetFileOwnershipHistoryResponse
 */
export interface CordeCommonModelsDtoAttachmentGetFileOwnershipHistoryResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoAttachmentFileOwnershipRecord>}
     * @memberof CordeCommonModelsDtoAttachmentGetFileOwnershipHistoryResponse
     */
    'ownership_history'?: Array<CordeCommonModelsDtoAttachmentFileOwnershipRecord>;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoAttachmentGetFileOwnershipHistoryResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAttachmentTransferFileOwnershipRequest
 */
export interface CordeCommonModelsDtoAttachmentTransferFileOwnershipRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAttachmentTransferFileOwnershipRequest
     */
    'file_ID'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoAttachmentTransferFileOwnershipRequest
     */
    'metadata'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAttachmentTransferFileOwnershipRequest
     */
    'new_owner_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAttachmentTransferFileOwnershipRequest
     */
    'new_owner_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAttachmentTransferFileOwnershipRequest
     */
    'transfer_reason'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzAlgebraicSubjectSet
 */
export interface CordeCommonModelsDtoAuthzAlgebraicSubjectSet {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoAuthzPermissionRelationshipTree>}
     * @memberof CordeCommonModelsDtoAuthzAlgebraicSubjectSet
     */
    'children'?: Array<CordeCommonModelsDtoAuthzPermissionRelationshipTree>;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzOperation}
     * @memberof CordeCommonModelsDtoAuthzAlgebraicSubjectSet
     */
    'operation'?: CordeCommonModelsDtoAuthzOperation;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzCheckBulkPermissionsPair
 */
export interface CordeCommonModelsDtoAuthzCheckBulkPermissionsPair {
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzStatus}
     * @memberof CordeCommonModelsDtoAuthzCheckBulkPermissionsPair
     */
    'error'?: CordeCommonModelsDtoAuthzStatus;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzCheckBulkPermissionsResponseItem}
     * @memberof CordeCommonModelsDtoAuthzCheckBulkPermissionsPair
     */
    'item'?: CordeCommonModelsDtoAuthzCheckBulkPermissionsResponseItem;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzCheckBulkPermissionsRequestItem}
     * @memberof CordeCommonModelsDtoAuthzCheckBulkPermissionsPair
     */
    'request'?: CordeCommonModelsDtoAuthzCheckBulkPermissionsRequestItem;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzCheckBulkPermissionsRequest
 */
export interface CordeCommonModelsDtoAuthzCheckBulkPermissionsRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzConsistency}
     * @memberof CordeCommonModelsDtoAuthzCheckBulkPermissionsRequest
     */
    'consistency'?: CordeCommonModelsDtoAuthzConsistency;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoAuthzCheckBulkPermissionsRequestItem>}
     * @memberof CordeCommonModelsDtoAuthzCheckBulkPermissionsRequest
     */
    'items'?: Array<CordeCommonModelsDtoAuthzCheckBulkPermissionsRequestItem>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzCheckBulkPermissionsRequestItem
 */
export interface CordeCommonModelsDtoAuthzCheckBulkPermissionsRequestItem {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CordeCommonModelsDtoAuthzCheckBulkPermissionsRequestItem
     */
    'context'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAuthzCheckBulkPermissionsRequestItem
     */
    'permission'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzObjectReference}
     * @memberof CordeCommonModelsDtoAuthzCheckBulkPermissionsRequestItem
     */
    'resource'?: CordeCommonModelsDtoAuthzObjectReference;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzSubjectReference}
     * @memberof CordeCommonModelsDtoAuthzCheckBulkPermissionsRequestItem
     */
    'subject'?: CordeCommonModelsDtoAuthzSubjectReference;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzCheckBulkPermissionsResponse
 */
export interface CordeCommonModelsDtoAuthzCheckBulkPermissionsResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzZedToken}
     * @memberof CordeCommonModelsDtoAuthzCheckBulkPermissionsResponse
     */
    'checked_at'?: CordeCommonModelsDtoAuthzZedToken;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoAuthzCheckBulkPermissionsPair>}
     * @memberof CordeCommonModelsDtoAuthzCheckBulkPermissionsResponse
     */
    'pairs'?: Array<CordeCommonModelsDtoAuthzCheckBulkPermissionsPair>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzCheckBulkPermissionsResponseItem
 */
export interface CordeCommonModelsDtoAuthzCheckBulkPermissionsResponseItem {
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzPartialCaveatInfo}
     * @memberof CordeCommonModelsDtoAuthzCheckBulkPermissionsResponseItem
     */
    'partial_caveat_info'?: CordeCommonModelsDtoAuthzPartialCaveatInfo;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzPermissionship}
     * @memberof CordeCommonModelsDtoAuthzCheckBulkPermissionsResponseItem
     */
    'permissionship'?: CordeCommonModelsDtoAuthzPermissionship;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzCheckPermissionRequest
 */
export interface CordeCommonModelsDtoAuthzCheckPermissionRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzConditions}
     * @memberof CordeCommonModelsDtoAuthzCheckPermissionRequest
     */
    'conditions'?: CordeCommonModelsDtoAuthzConditions;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzConsistency}
     * @memberof CordeCommonModelsDtoAuthzCheckPermissionRequest
     */
    'consistency'?: CordeCommonModelsDtoAuthzConsistency;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAuthzCheckPermissionRequest
     */
    'permission'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzObjectReference}
     * @memberof CordeCommonModelsDtoAuthzCheckPermissionRequest
     */
    'resource'?: CordeCommonModelsDtoAuthzObjectReference;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzSubjectReference}
     * @memberof CordeCommonModelsDtoAuthzCheckPermissionRequest
     */
    'subject'?: CordeCommonModelsDtoAuthzSubjectReference;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzCheckPermissionResponse
 */
export interface CordeCommonModelsDtoAuthzCheckPermissionResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzZedToken}
     * @memberof CordeCommonModelsDtoAuthzCheckPermissionResponse
     */
    'checked_at'?: CordeCommonModelsDtoAuthzZedToken;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzPartialCaveatInfo}
     * @memberof CordeCommonModelsDtoAuthzCheckPermissionResponse
     */
    'partial_caveat_info'?: CordeCommonModelsDtoAuthzPartialCaveatInfo;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzPermissionship}
     * @memberof CordeCommonModelsDtoAuthzCheckPermissionResponse
     */
    'permissionship'?: CordeCommonModelsDtoAuthzPermissionship;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzCondition
 */
export interface CordeCommonModelsDtoAuthzCondition {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoAuthzCondition
     */
    'metadata'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAuthzCondition
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzConditions
 */
export interface CordeCommonModelsDtoAuthzConditions {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoAuthzCondition>}
     * @memberof CordeCommonModelsDtoAuthzConditions
     */
    'conditions'?: Array<CordeCommonModelsDtoAuthzCondition>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzConsistency
 */
export interface CordeCommonModelsDtoAuthzConsistency {
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzZedToken}
     * @memberof CordeCommonModelsDtoAuthzConsistency
     */
    'at_exact_snapshot'?: CordeCommonModelsDtoAuthzZedToken;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzZedToken}
     * @memberof CordeCommonModelsDtoAuthzConsistency
     */
    'at_least_as_fresh'?: CordeCommonModelsDtoAuthzZedToken;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoAuthzConsistency
     */
    'fully_consistent'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoAuthzConsistency
     */
    'minimize_latency'?: boolean;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzCursor
 */
export interface CordeCommonModelsDtoAuthzCursor {
    /**
     * 
     * @type {Array<number>}
     * @memberof CordeCommonModelsDtoAuthzCursor
     */
    'token'?: Array<number>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzDeleteRelationshipsRequest
 */
export interface CordeCommonModelsDtoAuthzDeleteRelationshipsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoAuthzDeleteRelationshipsRequest
     */
    'allow_partial_deletions'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoAuthzDeleteRelationshipsRequest
     */
    'optional_limit'?: number;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoAuthzPrecondition>}
     * @memberof CordeCommonModelsDtoAuthzDeleteRelationshipsRequest
     */
    'optional_preconditions'?: Array<CordeCommonModelsDtoAuthzPrecondition>;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzRelationshipsFilters}
     * @memberof CordeCommonModelsDtoAuthzDeleteRelationshipsRequest
     */
    'relationship_filter'?: CordeCommonModelsDtoAuthzRelationshipsFilters;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzDeleteRelationshipsResponse
 */
export interface CordeCommonModelsDtoAuthzDeleteRelationshipsResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzZedToken}
     * @memberof CordeCommonModelsDtoAuthzDeleteRelationshipsResponse
     */
    'deleted_at'?: CordeCommonModelsDtoAuthzZedToken;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzDeletionProgress}
     * @memberof CordeCommonModelsDtoAuthzDeleteRelationshipsResponse
     */
    'deletion_progress'?: CordeCommonModelsDtoAuthzDeletionProgress;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const CordeCommonModelsDtoAuthzDeletionProgress = {
    DeletionProgressUnspecified: 0,
    DeletionProgressComplete: 1,
    DeletionProgressPartial: 2
} as const;

export type CordeCommonModelsDtoAuthzDeletionProgress = typeof CordeCommonModelsDtoAuthzDeletionProgress[keyof typeof CordeCommonModelsDtoAuthzDeletionProgress];


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzDirectSubjectSet
 */
export interface CordeCommonModelsDtoAuthzDirectSubjectSet {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoAuthzSubjectReference>}
     * @memberof CordeCommonModelsDtoAuthzDirectSubjectSet
     */
    'subjects'?: Array<CordeCommonModelsDtoAuthzSubjectReference>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzExpandPermissionTreeRequest
 */
export interface CordeCommonModelsDtoAuthzExpandPermissionTreeRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzConsistency}
     * @memberof CordeCommonModelsDtoAuthzExpandPermissionTreeRequest
     */
    'consistency'?: CordeCommonModelsDtoAuthzConsistency;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAuthzExpandPermissionTreeRequest
     */
    'permission'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzObjectReference}
     * @memberof CordeCommonModelsDtoAuthzExpandPermissionTreeRequest
     */
    'resource'?: CordeCommonModelsDtoAuthzObjectReference;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzExpandPermissionTreeResponse
 */
export interface CordeCommonModelsDtoAuthzExpandPermissionTreeResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzZedToken}
     * @memberof CordeCommonModelsDtoAuthzExpandPermissionTreeResponse
     */
    'expanded_at'?: CordeCommonModelsDtoAuthzZedToken;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzPermissionRelationshipTree}
     * @memberof CordeCommonModelsDtoAuthzExpandPermissionTreeResponse
     */
    'tree_root'?: CordeCommonModelsDtoAuthzPermissionRelationshipTree;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CordeCommonModelsDtoAuthzLookupPermissionship = {
    LookupPermissionshipUnspecified: 0,
    LookupPermissionshipHasPermission: 1,
    LookupPermissionshipConditionalPermission: 2
} as const;

export type CordeCommonModelsDtoAuthzLookupPermissionship = typeof CordeCommonModelsDtoAuthzLookupPermissionship[keyof typeof CordeCommonModelsDtoAuthzLookupPermissionship];


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzLookupResourcesRequest
 */
export interface CordeCommonModelsDtoAuthzLookupResourcesRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzConsistency}
     * @memberof CordeCommonModelsDtoAuthzLookupResourcesRequest
     */
    'consistency'?: CordeCommonModelsDtoAuthzConsistency;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CordeCommonModelsDtoAuthzLookupResourcesRequest
     */
    'context'?: { [key: string]: any; };
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedRequest}
     * @memberof CordeCommonModelsDtoAuthzLookupResourcesRequest
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedRequest;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAuthzLookupResourcesRequest
     */
    'permission'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzObjectReference}
     * @memberof CordeCommonModelsDtoAuthzLookupResourcesRequest
     */
    'resource'?: CordeCommonModelsDtoAuthzObjectReference;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzSubjectReference}
     * @memberof CordeCommonModelsDtoAuthzLookupResourcesRequest
     */
    'subject'?: CordeCommonModelsDtoAuthzSubjectReference;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzLookupResourcesResponse
 */
export interface CordeCommonModelsDtoAuthzLookupResourcesResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzZedToken}
     * @memberof CordeCommonModelsDtoAuthzLookupResourcesResponse
     */
    'looked_up_at'?: CordeCommonModelsDtoAuthzZedToken;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoAuthzLookupResourcesResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAuthzLookupResourcesResponse
     */
    'resource_id'?: string;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoAuthzResourceResponse>}
     * @memberof CordeCommonModelsDtoAuthzLookupResourcesResponse
     */
    'resources'?: Array<CordeCommonModelsDtoAuthzResourceResponse>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzLookupSubjectsRequest
 */
export interface CordeCommonModelsDtoAuthzLookupSubjectsRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzConsistency}
     * @memberof CordeCommonModelsDtoAuthzLookupSubjectsRequest
     */
    'consistency'?: CordeCommonModelsDtoAuthzConsistency;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CordeCommonModelsDtoAuthzLookupSubjectsRequest
     */
    'context'?: { [key: string]: any; };
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedRequest}
     * @memberof CordeCommonModelsDtoAuthzLookupSubjectsRequest
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedRequest;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAuthzLookupSubjectsRequest
     */
    'permission'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzObjectReference}
     * @memberof CordeCommonModelsDtoAuthzLookupSubjectsRequest
     */
    'resource'?: CordeCommonModelsDtoAuthzObjectReference;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAuthzLookupSubjectsRequest
     */
    'subject_object_type'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzWildcardOption}
     * @memberof CordeCommonModelsDtoAuthzLookupSubjectsRequest
     */
    'wildcard_option'?: CordeCommonModelsDtoAuthzWildcardOption;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzLookupSubjectsResponse
 */
export interface CordeCommonModelsDtoAuthzLookupSubjectsResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoAuthzResolvedSubject>}
     * @memberof CordeCommonModelsDtoAuthzLookupSubjectsResponse
     */
    'excluded_subjects'?: Array<CordeCommonModelsDtoAuthzResolvedSubject>;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzZedToken}
     * @memberof CordeCommonModelsDtoAuthzLookupSubjectsResponse
     */
    'looked_up_at'?: CordeCommonModelsDtoAuthzZedToken;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoAuthzLookupSubjectsResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzLookupPermissionship}
     * @memberof CordeCommonModelsDtoAuthzLookupSubjectsResponse
     */
    'permissionship'?: CordeCommonModelsDtoAuthzLookupPermissionship;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoAuthzSubjectReference>}
     * @memberof CordeCommonModelsDtoAuthzLookupSubjectsResponse
     */
    'subject'?: Array<CordeCommonModelsDtoAuthzSubjectReference>;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzObjectReference
 */
export interface CordeCommonModelsDtoAuthzObjectReference {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAuthzObjectReference
     */
    'object_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAuthzObjectReference
     */
    'object_type'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CordeCommonModelsDtoAuthzOperation = {
    OperationUnspecified: 'UNSPECIFIED',
    OperationUnion: 'UNION',
    OperationIntersection: 'INTERSECTION',
    OperationExclusion: 'EXCLUSION'
} as const;

export type CordeCommonModelsDtoAuthzOperation = typeof CordeCommonModelsDtoAuthzOperation[keyof typeof CordeCommonModelsDtoAuthzOperation];


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzPartialCaveatInfo
 */
export interface CordeCommonModelsDtoAuthzPartialCaveatInfo {
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoAuthzPartialCaveatInfo
     */
    'missing_required_context'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzPermissionRelationshipTree
 */
export interface CordeCommonModelsDtoAuthzPermissionRelationshipTree {
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzObjectReference}
     * @memberof CordeCommonModelsDtoAuthzPermissionRelationshipTree
     */
    'expanded_object'?: CordeCommonModelsDtoAuthzObjectReference;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzAlgebraicSubjectSet}
     * @memberof CordeCommonModelsDtoAuthzPermissionRelationshipTree
     */
    'intermediate'?: CordeCommonModelsDtoAuthzAlgebraicSubjectSet;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzDirectSubjectSet}
     * @memberof CordeCommonModelsDtoAuthzPermissionRelationshipTree
     */
    'leaf'?: CordeCommonModelsDtoAuthzDirectSubjectSet;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CordeCommonModelsDtoAuthzPermissionship = {
    PermissionshipUnspecified: 0,
    PermissionshipNoPermission: 1,
    PermissionshipHasPermission: 2,
    PermissionshipConditionalPermission: 3
} as const;

export type CordeCommonModelsDtoAuthzPermissionship = typeof CordeCommonModelsDtoAuthzPermissionship[keyof typeof CordeCommonModelsDtoAuthzPermissionship];


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzPrecondition
 */
export interface CordeCommonModelsDtoAuthzPrecondition {
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzRelationshipFilter}
     * @memberof CordeCommonModelsDtoAuthzPrecondition
     */
    'filter'?: CordeCommonModelsDtoAuthzRelationshipFilter;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzPreconditionOperation}
     * @memberof CordeCommonModelsDtoAuthzPrecondition
     */
    'operation'?: CordeCommonModelsDtoAuthzPreconditionOperation;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const CordeCommonModelsDtoAuthzPreconditionOperation = {
    PreconditionOperationUnspecified: 0,
    PreconditionOperationMustMatch: 1,
    PreconditionOperationMustNotMatch: 2
} as const;

export type CordeCommonModelsDtoAuthzPreconditionOperation = typeof CordeCommonModelsDtoAuthzPreconditionOperation[keyof typeof CordeCommonModelsDtoAuthzPreconditionOperation];


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzReadRelationshipsRequest
 */
export interface CordeCommonModelsDtoAuthzReadRelationshipsRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzConsistency}
     * @memberof CordeCommonModelsDtoAuthzReadRelationshipsRequest
     */
    'consistency'?: CordeCommonModelsDtoAuthzConsistency;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzCursor}
     * @memberof CordeCommonModelsDtoAuthzReadRelationshipsRequest
     */
    'optional_cursor'?: CordeCommonModelsDtoAuthzCursor;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoAuthzReadRelationshipsRequest
     */
    'optional_limit'?: number;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedRequest}
     * @memberof CordeCommonModelsDtoAuthzReadRelationshipsRequest
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedRequest;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzRelationshipFilter}
     * @memberof CordeCommonModelsDtoAuthzReadRelationshipsRequest
     */
    'relationship_filter'?: CordeCommonModelsDtoAuthzRelationshipFilter;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzReadRelationshipsResponse
 */
export interface CordeCommonModelsDtoAuthzReadRelationshipsResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzCursor}
     * @memberof CordeCommonModelsDtoAuthzReadRelationshipsResponse
     */
    'after_result_cursor'?: CordeCommonModelsDtoAuthzCursor;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoAuthzReadRelationshipsResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzZedToken}
     * @memberof CordeCommonModelsDtoAuthzReadRelationshipsResponse
     */
    'read_at'?: CordeCommonModelsDtoAuthzZedToken;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzRelationships}
     * @memberof CordeCommonModelsDtoAuthzReadRelationshipsResponse
     */
    'relationships'?: CordeCommonModelsDtoAuthzRelationships;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzReadSchemaResponse
 */
export interface CordeCommonModelsDtoAuthzReadSchemaResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzZedToken}
     * @memberof CordeCommonModelsDtoAuthzReadSchemaResponse
     */
    'read_at'?: CordeCommonModelsDtoAuthzZedToken;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAuthzReadSchemaResponse
     */
    'schema_text'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzRelationship
 */
export interface CordeCommonModelsDtoAuthzRelationship {
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzConditions}
     * @memberof CordeCommonModelsDtoAuthzRelationship
     */
    'conditions'?: CordeCommonModelsDtoAuthzConditions;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAuthzRelationship
     */
    'relation'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzObjectReference}
     * @memberof CordeCommonModelsDtoAuthzRelationship
     */
    'resource'?: CordeCommonModelsDtoAuthzObjectReference;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzSubjectReference}
     * @memberof CordeCommonModelsDtoAuthzRelationship
     */
    'subject'?: CordeCommonModelsDtoAuthzSubjectReference;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzRelationshipFilter
 */
export interface CordeCommonModelsDtoAuthzRelationshipFilter {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAuthzRelationshipFilter
     */
    'optional_relation'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAuthzRelationshipFilter
     */
    'optional_resource_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAuthzRelationshipFilter
     */
    'optional_resource_id_prefix'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzSubjectFilter}
     * @memberof CordeCommonModelsDtoAuthzRelationshipFilter
     */
    'optional_subject_filter'?: CordeCommonModelsDtoAuthzSubjectFilter;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAuthzRelationshipFilter
     */
    'resource_type'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CordeCommonModelsDtoAuthzRelationshipOperation = {
    RelationshipOperationUnspecified: 0,
    RelationshipOperationCreate: 1,
    RelationshipOperationTouch: 2,
    RelationshipOperationDelete: 3
} as const;

export type CordeCommonModelsDtoAuthzRelationshipOperation = typeof CordeCommonModelsDtoAuthzRelationshipOperation[keyof typeof CordeCommonModelsDtoAuthzRelationshipOperation];


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzRelationshipUpdate
 */
export interface CordeCommonModelsDtoAuthzRelationshipUpdate {
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzRelationshipOperation}
     * @memberof CordeCommonModelsDtoAuthzRelationshipUpdate
     */
    'operation'?: CordeCommonModelsDtoAuthzRelationshipOperation;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzRelationship}
     * @memberof CordeCommonModelsDtoAuthzRelationshipUpdate
     */
    'relationship'?: CordeCommonModelsDtoAuthzRelationship;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzRelationships
 */
export interface CordeCommonModelsDtoAuthzRelationships {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoAuthzRelationship>}
     * @memberof CordeCommonModelsDtoAuthzRelationships
     */
    'relationships'?: Array<CordeCommonModelsDtoAuthzRelationship>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzRelationshipsFilters
 */
export interface CordeCommonModelsDtoAuthzRelationshipsFilters {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoAuthzRelationshipFilter>}
     * @memberof CordeCommonModelsDtoAuthzRelationshipsFilters
     */
    'filters'?: Array<CordeCommonModelsDtoAuthzRelationshipFilter>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzResolvedSubject
 */
export interface CordeCommonModelsDtoAuthzResolvedSubject {
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzPartialCaveatInfo}
     * @memberof CordeCommonModelsDtoAuthzResolvedSubject
     */
    'partial_caveat_info'?: CordeCommonModelsDtoAuthzPartialCaveatInfo;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzPermissionship}
     * @memberof CordeCommonModelsDtoAuthzResolvedSubject
     */
    'permissionship'?: CordeCommonModelsDtoAuthzPermissionship;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAuthzResolvedSubject
     */
    'subject_object_id'?: string;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzResourceResponse
 */
export interface CordeCommonModelsDtoAuthzResourceResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzPartialCaveatInfo}
     * @memberof CordeCommonModelsDtoAuthzResourceResponse
     */
    'partial_caveat_info'?: CordeCommonModelsDtoAuthzPartialCaveatInfo;
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzPermissionship}
     * @memberof CordeCommonModelsDtoAuthzResourceResponse
     */
    'permissionship'?: CordeCommonModelsDtoAuthzPermissionship;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAuthzResourceResponse
     */
    'resource_object_id'?: string;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzStatus
 */
export interface CordeCommonModelsDtoAuthzStatus {
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoAuthzStatus
     */
    'code'?: number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAuthzStatus
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzSubjectFilter
 */
export interface CordeCommonModelsDtoAuthzSubjectFilter {
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzSubjectFilterRelation}
     * @memberof CordeCommonModelsDtoAuthzSubjectFilter
     */
    'optional_relation'?: CordeCommonModelsDtoAuthzSubjectFilterRelation;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAuthzSubjectFilter
     */
    'optional_subject_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAuthzSubjectFilter
     */
    'subject_type'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzSubjectFilterRelation
 */
export interface CordeCommonModelsDtoAuthzSubjectFilterRelation {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAuthzSubjectFilterRelation
     */
    'relation'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzSubjectReference
 */
export interface CordeCommonModelsDtoAuthzSubjectReference {
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzObjectReference}
     * @memberof CordeCommonModelsDtoAuthzSubjectReference
     */
    'object'?: CordeCommonModelsDtoAuthzObjectReference;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAuthzSubjectReference
     */
    'optional_relation'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CordeCommonModelsDtoAuthzWildcardOption = {
    WildcardOptionUnspecified: 0,
    WildcardOptionIncludeWildcards: 1,
    WildcardOptionExcludeWildcards: 2
} as const;

export type CordeCommonModelsDtoAuthzWildcardOption = typeof CordeCommonModelsDtoAuthzWildcardOption[keyof typeof CordeCommonModelsDtoAuthzWildcardOption];


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzWriteRelationshipsRequest
 */
export interface CordeCommonModelsDtoAuthzWriteRelationshipsRequest {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoAuthzPrecondition>}
     * @memberof CordeCommonModelsDtoAuthzWriteRelationshipsRequest
     */
    'optional_preconditions'?: Array<CordeCommonModelsDtoAuthzPrecondition>;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoAuthzRelationshipUpdate>}
     * @memberof CordeCommonModelsDtoAuthzWriteRelationshipsRequest
     */
    'updates'?: Array<CordeCommonModelsDtoAuthzRelationshipUpdate>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzWriteRelationshipsResponse
 */
export interface CordeCommonModelsDtoAuthzWriteRelationshipsResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoAuthzZedToken}
     * @memberof CordeCommonModelsDtoAuthzWriteRelationshipsResponse
     */
    'written_at'?: CordeCommonModelsDtoAuthzZedToken;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzWriteSchemaRequest
 */
export interface CordeCommonModelsDtoAuthzWriteSchemaRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoAuthzWriteSchemaRequest
     */
    'schema'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoAuthzZedToken
 */
export interface CordeCommonModelsDtoAuthzZedToken {
    /**
     * 
     * @type {Array<number>}
     * @memberof CordeCommonModelsDtoAuthzZedToken
     */
    'token'?: Array<number>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceAdminAdjustBalanceRequest
 */
export interface CordeCommonModelsDtoBalanceAdminAdjustBalanceRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceAdminAdjustBalanceRequest
     */
    'admin_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceAmount}
     * @memberof CordeCommonModelsDtoBalanceAdminAdjustBalanceRequest
     */
    'amount'?: CordeCommonModelsDtoBalanceAmount;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceAdminAdjustBalanceRequest
     */
    'idempotency_key'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceAdminAdjustBalanceRequest
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceAdminAdjustBalanceResponse
 */
export interface CordeCommonModelsDtoBalanceAdminAdjustBalanceResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceBalance}
     * @memberof CordeCommonModelsDtoBalanceAdminAdjustBalanceResponse
     */
    'balance_after'?: CordeCommonModelsDtoBalanceBalance;
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceTransaction}
     * @memberof CordeCommonModelsDtoBalanceAdminAdjustBalanceResponse
     */
    'transaction'?: CordeCommonModelsDtoBalanceTransaction;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceAdminFreezeBalanceRequest
 */
export interface CordeCommonModelsDtoBalanceAdminFreezeBalanceRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceAdminFreezeBalanceRequest
     */
    'admin_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceAmount}
     * @memberof CordeCommonModelsDtoBalanceAdminFreezeBalanceRequest
     */
    'amount'?: CordeCommonModelsDtoBalanceAmount;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceAdminFreezeBalanceRequest
     */
    'idempotency_key'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceAdminFreezeBalanceRequest
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceAdminFreezeBalanceResponse
 */
export interface CordeCommonModelsDtoBalanceAdminFreezeBalanceResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceBalance}
     * @memberof CordeCommonModelsDtoBalanceAdminFreezeBalanceResponse
     */
    'balance_after'?: CordeCommonModelsDtoBalanceBalance;
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceTransaction}
     * @memberof CordeCommonModelsDtoBalanceAdminFreezeBalanceResponse
     */
    'transaction'?: CordeCommonModelsDtoBalanceTransaction;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceAdminSetBalanceRequest
 */
export interface CordeCommonModelsDtoBalanceAdminSetBalanceRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceAdminSetBalanceRequest
     */
    'admin_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceAdminSetBalanceRequest
     */
    'idempotency_key'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceAmount}
     * @memberof CordeCommonModelsDtoBalanceAdminSetBalanceRequest
     */
    'new_balance'?: CordeCommonModelsDtoBalanceAmount;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceAdminSetBalanceRequest
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceAdminSetBalanceResponse
 */
export interface CordeCommonModelsDtoBalanceAdminSetBalanceResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceBalance}
     * @memberof CordeCommonModelsDtoBalanceAdminSetBalanceResponse
     */
    'balance_after'?: CordeCommonModelsDtoBalanceBalance;
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceTransaction}
     * @memberof CordeCommonModelsDtoBalanceAdminSetBalanceResponse
     */
    'transaction'?: CordeCommonModelsDtoBalanceTransaction;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceAdminUnfreezeBalanceRequest
 */
export interface CordeCommonModelsDtoBalanceAdminUnfreezeBalanceRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceAdminUnfreezeBalanceRequest
     */
    'admin_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceAmount}
     * @memberof CordeCommonModelsDtoBalanceAdminUnfreezeBalanceRequest
     */
    'amount'?: CordeCommonModelsDtoBalanceAmount;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceAdminUnfreezeBalanceRequest
     */
    'idempotency_key'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceAdminUnfreezeBalanceRequest
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceAdminUnfreezeBalanceResponse
 */
export interface CordeCommonModelsDtoBalanceAdminUnfreezeBalanceResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceBalance}
     * @memberof CordeCommonModelsDtoBalanceAdminUnfreezeBalanceResponse
     */
    'balance_after'?: CordeCommonModelsDtoBalanceBalance;
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceTransaction}
     * @memberof CordeCommonModelsDtoBalanceAdminUnfreezeBalanceResponse
     */
    'transaction'?: CordeCommonModelsDtoBalanceTransaction;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceAmount
 */
export interface CordeCommonModelsDtoBalanceAmount {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceAmount
     */
    'currency'?: string;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoBalanceAmount
     */
    'nanos'?: number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoBalanceAmount
     */
    'units'?: number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceAmount
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceBalance
 */
export interface CordeCommonModelsDtoBalanceBalance {
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceAmount}
     * @memberof CordeCommonModelsDtoBalanceBalance
     */
    'available'?: CordeCommonModelsDtoBalanceAmount;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceBalance
     */
    'currency'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceBalance
     */
    'id'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceAmount}
     * @memberof CordeCommonModelsDtoBalanceBalance
     */
    'locked'?: CordeCommonModelsDtoBalanceAmount;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceBalance
     */
    'platform_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceBalance
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceBankDetails
 */
export interface CordeCommonModelsDtoBalanceBankDetails {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceBankDetails
     */
    'account_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceBankDetails
     */
    'bank_branch'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceBankDetails
     */
    'bank_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceBankDetails
     */
    'correspondent_bank'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceBankDetails
     */
    'iban'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceBankDetails
     */
    'routing_number'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceBankDetails
     */
    'swift_code'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceCancelReserveRequest
 */
export interface CordeCommonModelsDtoBalanceCancelReserveRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCancelReserveRequest
     */
    'reserve_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceCancelReserveResponse
 */
export interface CordeCommonModelsDtoBalanceCancelReserveResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceTransaction}
     * @memberof CordeCommonModelsDtoBalanceCancelReserveResponse
     */
    'transaction'?: CordeCommonModelsDtoBalanceTransaction;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceCommitReserveRequest
 */
export interface CordeCommonModelsDtoBalanceCommitReserveRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceAmount}
     * @memberof CordeCommonModelsDtoBalanceCommitReserveRequest
     */
    'amount'?: CordeCommonModelsDtoBalanceAmount;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCommitReserveRequest
     */
    'idempotency_key'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCommitReserveRequest
     */
    'reserve_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceCommitReserveResponse
 */
export interface CordeCommonModelsDtoBalanceCommitReserveResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceTransaction}
     * @memberof CordeCommonModelsDtoBalanceCommitReserveResponse
     */
    'transaction'?: CordeCommonModelsDtoBalanceTransaction;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceCreateCryptoAddressRequest
 */
export interface CordeCommonModelsDtoBalanceCreateCryptoAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCreateCryptoAddressRequest
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCreateCryptoAddressRequest
     */
    'currency'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCreateCryptoAddressRequest
     */
    'idempotency_key'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoBalanceCreateCryptoAddressRequest
     */
    'is_default'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCreateCryptoAddressRequest
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCreateCryptoAddressRequest
     */
    'memo'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCreateCryptoAddressRequest
     */
    'network'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCreateCryptoAddressRequest
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceCreateCurrencyRequest
 */
export interface CordeCommonModelsDtoBalanceCreateCurrencyRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceCurrency}
     * @memberof CordeCommonModelsDtoBalanceCreateCurrencyRequest
     */
    'currency'?: CordeCommonModelsDtoBalanceCurrency;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCreateCurrencyRequest
     */
    'idempotency_key'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceCreateDepositRequest
 */
export interface CordeCommonModelsDtoBalanceCreateDepositRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceAmount}
     * @memberof CordeCommonModelsDtoBalanceCreateDepositRequest
     */
    'amount'?: CordeCommonModelsDtoBalanceAmount;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCreateDepositRequest
     */
    'currency'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCreateDepositRequest
     */
    'idempotency_key'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCreateDepositRequest
     */
    'platform_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCreateDepositRequest
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceCreateDepositResponse
 */
export interface CordeCommonModelsDtoBalanceCreateDepositResponse {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCreateDepositResponse
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCreateDepositResponse
     */
    'memo'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceTransaction}
     * @memberof CordeCommonModelsDtoBalanceCreateDepositResponse
     */
    'transaction'?: CordeCommonModelsDtoBalanceTransaction;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceCreateFiatDetailsRequest
 */
export interface CordeCommonModelsDtoBalanceCreateFiatDetailsRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceBankDetails}
     * @memberof CordeCommonModelsDtoBalanceCreateFiatDetailsRequest
     */
    'bank_details'?: CordeCommonModelsDtoBalanceBankDetails;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCreateFiatDetailsRequest
     */
    'beneficiary_address'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCreateFiatDetailsRequest
     */
    'beneficiary_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCreateFiatDetailsRequest
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCreateFiatDetailsRequest
     */
    'currency'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCreateFiatDetailsRequest
     */
    'idempotency_key'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoBalanceCreateFiatDetailsRequest
     */
    'is_default'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCreateFiatDetailsRequest
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCreateFiatDetailsRequest
     */
    'payment_system'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCreateFiatDetailsRequest
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceCreateWithdrawalRequest
 */
export interface CordeCommonModelsDtoBalanceCreateWithdrawalRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCreateWithdrawalRequest
     */
    'address'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceAmount}
     * @memberof CordeCommonModelsDtoBalanceCreateWithdrawalRequest
     */
    'amount'?: CordeCommonModelsDtoBalanceAmount;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCreateWithdrawalRequest
     */
    'currency'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCreateWithdrawalRequest
     */
    'idempotency_key'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCreateWithdrawalRequest
     */
    'memo'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCreateWithdrawalRequest
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceCreateWithdrawalResponse
 */
export interface CordeCommonModelsDtoBalanceCreateWithdrawalResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceTransaction}
     * @memberof CordeCommonModelsDtoBalanceCreateWithdrawalResponse
     */
    'transaction'?: CordeCommonModelsDtoBalanceTransaction;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceCryptoAddress
 */
export interface CordeCommonModelsDtoBalanceCryptoAddress {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCryptoAddress
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCryptoAddress
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCryptoAddress
     */
    'currency'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCryptoAddress
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoBalanceCryptoAddress
     */
    'is_default'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCryptoAddress
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCryptoAddress
     */
    'memo'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCryptoAddress
     */
    'network'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCryptoAddress
     */
    'platform_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCryptoAddress
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCryptoAddress
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceCurrency
 */
export interface CordeCommonModelsDtoBalanceCurrency {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCurrency
     */
    'code'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoBalanceCurrency
     */
    'deposit_enabled'?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoBalanceCurrency
     */
    'metadata'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCurrency
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCurrency
     */
    'network'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceCurrency
     */
    'platform_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoBalanceCurrency
     */
    'precision'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoBalanceCurrency
     */
    'withdrawal_enabled'?: boolean;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceEnsureBalancesRequest
 */
export interface CordeCommonModelsDtoBalanceEnsureBalancesRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoBalanceEnsureBalancesRequest
     */
    'currencies'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceEnsureBalancesRequest
     */
    'platform_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceEnsureBalancesRequest
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceFiatDetails
 */
export interface CordeCommonModelsDtoBalanceFiatDetails {
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceBankDetails}
     * @memberof CordeCommonModelsDtoBalanceFiatDetails
     */
    'bank_details'?: CordeCommonModelsDtoBalanceBankDetails;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceFiatDetails
     */
    'beneficiary_address'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceFiatDetails
     */
    'beneficiary_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceFiatDetails
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceFiatDetails
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceFiatDetails
     */
    'currency'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceFiatDetails
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoBalanceFiatDetails
     */
    'is_default'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceFiatDetails
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceFiatDetails
     */
    'payment_system'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceFiatDetails
     */
    'platform_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceFiatDetails
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceFiatDetails
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceGetDepositAddressResponse
 */
export interface CordeCommonModelsDtoBalanceGetDepositAddressResponse {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceGetDepositAddressResponse
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceGetDepositAddressResponse
     */
    'memo'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceListBalancesResponse
 */
export interface CordeCommonModelsDtoBalanceListBalancesResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoBalanceBalance>}
     * @memberof CordeCommonModelsDtoBalanceListBalancesResponse
     */
    'balances'?: Array<CordeCommonModelsDtoBalanceBalance>;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoBalanceListBalancesResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceListCryptoAddressesResponse
 */
export interface CordeCommonModelsDtoBalanceListCryptoAddressesResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoBalanceCryptoAddress>}
     * @memberof CordeCommonModelsDtoBalanceListCryptoAddressesResponse
     */
    'addresses'?: Array<CordeCommonModelsDtoBalanceCryptoAddress>;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoBalanceListCryptoAddressesResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceListCurrenciesResponse
 */
export interface CordeCommonModelsDtoBalanceListCurrenciesResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoBalanceCurrency>}
     * @memberof CordeCommonModelsDtoBalanceListCurrenciesResponse
     */
    'currencies'?: Array<CordeCommonModelsDtoBalanceCurrency>;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoBalanceListCurrenciesResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceListFiatDetailsResponse
 */
export interface CordeCommonModelsDtoBalanceListFiatDetailsResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoBalanceFiatDetails>}
     * @memberof CordeCommonModelsDtoBalanceListFiatDetailsResponse
     */
    'details'?: Array<CordeCommonModelsDtoBalanceFiatDetails>;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoBalanceListFiatDetailsResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceListTransactionsResponse
 */
export interface CordeCommonModelsDtoBalanceListTransactionsResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoBalanceListTransactionsResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoBalanceTransaction>}
     * @memberof CordeCommonModelsDtoBalanceListTransactionsResponse
     */
    'transactions'?: Array<CordeCommonModelsDtoBalanceTransaction>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceReserveFundsRequest
 */
export interface CordeCommonModelsDtoBalanceReserveFundsRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceAmount}
     * @memberof CordeCommonModelsDtoBalanceReserveFundsRequest
     */
    'amount'?: CordeCommonModelsDtoBalanceAmount;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceReserveFundsRequest
     */
    'currency'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceReserveFundsRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceReserveFundsRequest
     */
    'idempotency_key'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceReserveFundsRequest
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceReserveFundsResponse
 */
export interface CordeCommonModelsDtoBalanceReserveFundsResponse {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceReserveFundsResponse
     */
    'reserve_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceTransaction}
     * @memberof CordeCommonModelsDtoBalanceReserveFundsResponse
     */
    'transaction'?: CordeCommonModelsDtoBalanceTransaction;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceRetryPendingTransactionsRequest
 */
export interface CordeCommonModelsDtoBalanceRetryPendingTransactionsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoBalanceRetryPendingTransactionsRequest
     */
    'transaction_i_ds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoBalanceRetryPendingTransactionsRequest
     */
    'user_i_ds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceTransaction
 */
export interface CordeCommonModelsDtoBalanceTransaction {
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceAmount}
     * @memberof CordeCommonModelsDtoBalanceTransaction
     */
    'amount'?: CordeCommonModelsDtoBalanceAmount;
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceBalance}
     * @memberof CordeCommonModelsDtoBalanceTransaction
     */
    'balance_after'?: CordeCommonModelsDtoBalanceBalance;
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceBalance}
     * @memberof CordeCommonModelsDtoBalanceTransaction
     */
    'balance_before'?: CordeCommonModelsDtoBalanceBalance;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceTransaction
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceTransaction
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceTransaction
     */
    'idempotency_key'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoBalanceTransaction
     */
    'metadata'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceTransaction
     */
    'platform_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceTransaction
     */
    'receiver_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceTransaction
     */
    'receiver_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceTransaction
     */
    'sender_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceTransaction
     */
    'sender_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceTransaction
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceTransaction
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceTransaction
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceUpdateCryptoAddressRequest
 */
export interface CordeCommonModelsDtoBalanceUpdateCryptoAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceUpdateCryptoAddressRequest
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoBalanceUpdateCryptoAddressRequest
     */
    'is_default'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceUpdateCryptoAddressRequest
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceUpdateCryptoAddressRequest
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceUpdateCurrencyRequest
 */
export interface CordeCommonModelsDtoBalanceUpdateCurrencyRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceUpdateCurrencyRequest
     */
    'code'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceCurrency}
     * @memberof CordeCommonModelsDtoBalanceUpdateCurrencyRequest
     */
    'currency'?: CordeCommonModelsDtoBalanceCurrency;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceUpdateFiatDetailsRequest
 */
export interface CordeCommonModelsDtoBalanceUpdateFiatDetailsRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceBankDetails}
     * @memberof CordeCommonModelsDtoBalanceUpdateFiatDetailsRequest
     */
    'bank_details'?: CordeCommonModelsDtoBalanceBankDetails;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceUpdateFiatDetailsRequest
     */
    'beneficiary_address'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceUpdateFiatDetailsRequest
     */
    'beneficiary_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceUpdateFiatDetailsRequest
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoBalanceUpdateFiatDetailsRequest
     */
    'is_default'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceUpdateFiatDetailsRequest
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceUpdateFiatDetailsRequest
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceValidateCryptoAddressRequest
 */
export interface CordeCommonModelsDtoBalanceValidateCryptoAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceValidateCryptoAddressRequest
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceValidateCryptoAddressRequest
     */
    'currency'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceValidateCryptoAddressRequest
     */
    'memo'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceValidateCryptoAddressRequest
     */
    'network'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceValidateCryptoAddressResponse
 */
export interface CordeCommonModelsDtoBalanceValidateCryptoAddressResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoBalanceValidateCryptoAddressResponse
     */
    'is_valid'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceValidateCryptoAddressResponse
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceValidateFiatDetailsRequest
 */
export interface CordeCommonModelsDtoBalanceValidateFiatDetailsRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceBankDetails}
     * @memberof CordeCommonModelsDtoBalanceValidateFiatDetailsRequest
     */
    'bank_details'?: CordeCommonModelsDtoBalanceBankDetails;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceValidateFiatDetailsRequest
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceValidateFiatDetailsRequest
     */
    'currency'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceValidateFiatDetailsRequest
     */
    'payment_system'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoBalanceValidateFiatDetailsResponse
 */
export interface CordeCommonModelsDtoBalanceValidateFiatDetailsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoBalanceValidateFiatDetailsResponse
     */
    'is_valid'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoBalanceValidateFiatDetailsResponse
     */
    'message'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoBalanceValidateFiatDetailsResponse
     */
    'warnings'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoContactContact
 */
export interface CordeCommonModelsDtoContactContact {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoContactContact
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoContactContact
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoContactContact
     */
    'description'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoEntityEntity}
     * @memberof CordeCommonModelsDtoContactContact
     */
    'entity'?: CordeCommonModelsDtoEntityEntity;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoContactContact
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoContactContact
     */
    'is_primary'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoContactContact
     */
    'is_verified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoContactContact
     */
    'label'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoContactContact
     */
    'metadata'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoContactContact
     */
    'platform_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoContactContact
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoContactContact
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoContactContact
     */
    'value'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoContactContact
     */
    'verified_at'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoContactContacts
 */
export interface CordeCommonModelsDtoContactContacts {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoContactContact>}
     * @memberof CordeCommonModelsDtoContactContacts
     */
    'contacts'?: Array<CordeCommonModelsDtoContactContact>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoEntityEntity
 */
export interface CordeCommonModelsDtoEntityEntity {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoEntityEntity
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoEntityEntity
     */
    'platform_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoEntityEntity
     */
    'type'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoMachineCloneMachineRequest
 */
export interface CordeCommonModelsDtoMachineCloneMachineRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineCloneMachineRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineCloneMachineRequest
     */
    'new_machine_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineCloneMachineRequest
     */
    'source_machine_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoMachineCreateMachineRequest
 */
export interface CordeCommonModelsDtoMachineCreateMachineRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineCreateMachineRequest
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineCreateMachineRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineCreateMachineRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineCreateMachineRequest
     */
    'platform_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineCreateMachineRequest
     */
    'stream_auth_token'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineCreateMachineRequest
     */
    'stream_url'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoMachineEndSessionRequest
 */
export interface CordeCommonModelsDtoMachineEndSessionRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineEndSessionRequest
     */
    'session_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoMachineGameSession
 */
export interface CordeCommonModelsDtoMachineGameSession {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineGameSession
     */
    'ended_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineGameSession
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineGameSession
     */
    'machine_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineGameSession
     */
    'started_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineGameSession
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoMachineGetStatusResponse
 */
export interface CordeCommonModelsDtoMachineGetStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineGetStatusResponse
     */
    'last_seen'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineGetStatusResponse
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoMachineListMachinesResponse
 */
export interface CordeCommonModelsDtoMachineListMachinesResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoMachineMachines}
     * @memberof CordeCommonModelsDtoMachineListMachinesResponse
     */
    'machines'?: CordeCommonModelsDtoMachineMachines;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoMachineListMachinesResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoMachineMachine
 */
export interface CordeCommonModelsDtoMachineMachine {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineMachine
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineMachine
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineMachine
     */
    'last_seen'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineMachine
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineMachine
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineMachine
     */
    'stream_auth_token'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineMachine
     */
    'stream_url'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoMachineMachineCashOutRequest
 */
export interface CordeCommonModelsDtoMachineMachineCashOutRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceAmount}
     * @memberof CordeCommonModelsDtoMachineMachineCashOutRequest
     */
    'amount'?: CordeCommonModelsDtoBalanceAmount;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineMachineCashOutRequest
     */
    'currency'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineMachineCashOutRequest
     */
    'session_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoMachineMachineTopUpRequest
 */
export interface CordeCommonModelsDtoMachineMachineTopUpRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceAmount}
     * @memberof CordeCommonModelsDtoMachineMachineTopUpRequest
     */
    'amount'?: CordeCommonModelsDtoBalanceAmount;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineMachineTopUpRequest
     */
    'currency'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineMachineTopUpRequest
     */
    'session_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoMachineMachines
 */
export interface CordeCommonModelsDtoMachineMachines {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoMachineMachine>}
     * @memberof CordeCommonModelsDtoMachineMachines
     */
    'machines'?: Array<CordeCommonModelsDtoMachineMachine>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoMachineManagedMachineConfig
 */
export interface CordeCommonModelsDtoMachineManagedMachineConfig {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineManagedMachineConfig
     */
    'machine_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineManagedMachineConfig
     */
    'sas_address'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineManagedMachineConfig
     */
    'sas_host'?: string;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoMachineManagedMachineConfig
     */
    'sas_port'?: number;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoMachineManagedMachineID
 */
export interface CordeCommonModelsDtoMachineManagedMachineID {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineManagedMachineID
     */
    'machine_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoMachineProxyCashOutRequest
 */
export interface CordeCommonModelsDtoMachineProxyCashOutRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceAmount}
     * @memberof CordeCommonModelsDtoMachineProxyCashOutRequest
     */
    'amount'?: CordeCommonModelsDtoBalanceAmount;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineProxyCashOutRequest
     */
    'machine_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoMachineProxyCashOutResponse
 */
export interface CordeCommonModelsDtoMachineProxyCashOutResponse {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineProxyCashOutResponse
     */
    'timestamp'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoMachineProxyTopUpRequest
 */
export interface CordeCommonModelsDtoMachineProxyTopUpRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoBalanceAmount}
     * @memberof CordeCommonModelsDtoMachineProxyTopUpRequest
     */
    'amount'?: CordeCommonModelsDtoBalanceAmount;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineProxyTopUpRequest
     */
    'machine_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoMachineProxyTopUpResponse
 */
export interface CordeCommonModelsDtoMachineProxyTopUpResponse {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineProxyTopUpResponse
     */
    'timestamp'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoMachineReserveMachineRequest
 */
export interface CordeCommonModelsDtoMachineReserveMachineRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineReserveMachineRequest
     */
    'machine_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineReserveMachineRequest
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoMachineUpdateMachineRequest
 */
export interface CordeCommonModelsDtoMachineUpdateMachineRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineUpdateMachineRequest
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineUpdateMachineRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineUpdateMachineRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineUpdateMachineRequest
     */
    'stream_auth_token'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoMachineUpdateMachineRequest
     */
    'stream_url'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsChannelSettings
 */
export interface CordeCommonModelsDtoNotificationsChannelSettings {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsChannelSettings
     */
    'channel_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsChannelSettings
     */
    'custom_template_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsChannelSettings
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoNotificationsChannelSettings
     */
    'specific_contact_ids'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsChannelStats
 */
export interface CordeCommonModelsDtoNotificationsChannelStats {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsChannelStats
     */
    'channel_type'?: string;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsChannelStats
     */
    'delivered'?: number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsChannelStats
     */
    'delivery_rate'?: number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsChannelStats
     */
    'failed'?: number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsChannelStats
     */
    'sent'?: number;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsConfigValidationError
 */
export interface CordeCommonModelsDtoNotificationsConfigValidationError {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsConfigValidationError
     */
    'error_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsConfigValidationError
     */
    'field'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsConfigValidationError
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsConfigValidationWarning
 */
export interface CordeCommonModelsDtoNotificationsConfigValidationWarning {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsConfigValidationWarning
     */
    'field'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsConfigValidationWarning
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsConfigValidationWarning
     */
    'warning_code'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsConnectionPoolConfig
 */
export interface CordeCommonModelsDtoNotificationsConnectionPoolConfig {
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsConnectionPoolConfig
     */
    'connection_timeout_seconds'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsConnectionPoolConfig
     */
    'enable_keep_alive'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsConnectionPoolConfig
     */
    'idle_timeout_seconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsConnectionPoolConfig
     */
    'max_connections'?: number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsConnectionPoolConfig
     */
    'max_lifetime_seconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsConnectionPoolConfig
     */
    'min_connections'?: number;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsCreateChannelRequest
 */
export interface CordeCommonModelsDtoNotificationsCreateChannelRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsNotificationChannel}
     * @memberof CordeCommonModelsDtoNotificationsCreateChannelRequest
     */
    'channel'?: CordeCommonModelsDtoNotificationsNotificationChannel;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsCreateChannelResponse
 */
export interface CordeCommonModelsDtoNotificationsCreateChannelResponse {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsCreateChannelResponse
     */
    'channel_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsCreateContactRequest
 */
export interface CordeCommonModelsDtoNotificationsCreateContactRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoContactContact}
     * @memberof CordeCommonModelsDtoNotificationsCreateContactRequest
     */
    'contact'?: CordeCommonModelsDtoContactContact;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsCreateContactResponse
 */
export interface CordeCommonModelsDtoNotificationsCreateContactResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoContactContact}
     * @memberof CordeCommonModelsDtoNotificationsCreateContactResponse
     */
    'contact'?: CordeCommonModelsDtoContactContact;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsCreateTemplateRequest
 */
export interface CordeCommonModelsDtoNotificationsCreateTemplateRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsNotificationTemplate}
     * @memberof CordeCommonModelsDtoNotificationsCreateTemplateRequest
     */
    'template'?: CordeCommonModelsDtoNotificationsNotificationTemplate;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsCreateTemplateResponse
 */
export interface CordeCommonModelsDtoNotificationsCreateTemplateResponse {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsCreateTemplateResponse
     */
    'template_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsDailyStats
 */
export interface CordeCommonModelsDtoNotificationsDailyStats {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsDailyStats
     */
    'date'?: string;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsDailyStats
     */
    'delivered'?: number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsDailyStats
     */
    'read'?: number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsDailyStats
     */
    'sent'?: number;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsDeliveryAttempt
 */
export interface CordeCommonModelsDtoNotificationsDeliveryAttempt {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsDeliveryAttempt
     */
    'attempted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsDeliveryAttempt
     */
    'error_message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsDeliveryAttempt
     */
    'provider_response'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsDeliveryAttempt
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsDiscordChannelConfig
 */
export interface CordeCommonModelsDtoNotificationsDiscordChannelConfig {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsDiscordChannelConfig
     */
    'bot_token'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoNotificationsDiscordChannelConfig
     */
    'channel_mapping'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsDiscordChannelConfig
     */
    'default_channel_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsDiscordChannelConfig
     */
    'guild_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsDiscordChannelConfig
     */
    'timeout_seconds'?: number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsDiscordChannelConfig
     */
    'webhook_url'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsEmailChannelConfig
 */
export interface CordeCommonModelsDtoNotificationsEmailChannelConfig {
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsEmailChannelConfig
     */
    'connection_timeout'?: number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsEmailChannelConfig
     */
    'from_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsEmailChannelConfig
     */
    'from_name'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoNotificationsEmailChannelConfig
     */
    'headers'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsEmailChannelConfig
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsEmailChannelConfig
     */
    'reply_to'?: string;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsEmailChannelConfig
     */
    'send_timeout'?: number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsEmailChannelConfig
     */
    'smtp_host'?: string;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsEmailChannelConfig
     */
    'smtp_port'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsEmailChannelConfig
     */
    'use_ssl'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsEmailChannelConfig
     */
    'use_tls'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsEmailChannelConfig
     */
    'username'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsEventNotificationRule
 */
export interface CordeCommonModelsDtoNotificationsEventNotificationRule {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoNotificationsChannelSettings>}
     * @memberof CordeCommonModelsDtoNotificationsEventNotificationRule
     */
    'channel_settings'?: Array<CordeCommonModelsDtoNotificationsChannelSettings>;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsEventNotificationRule
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsEventNotificationRule
     */
    'event_type'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsFrequencyLimits}
     * @memberof CordeCommonModelsDtoNotificationsEventNotificationRule
     */
    'frequency_limits'?: CordeCommonModelsDtoNotificationsFrequencyLimits;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsEventNotificationRule
     */
    'send_immediately'?: boolean;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsFailoverConfig
 */
export interface CordeCommonModelsDtoNotificationsFailoverConfig {
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsFailoverConfig
     */
    'auto_recovery'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsFailoverConfig
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoNotificationsFailoverConfig
     */
    'failover_conditions'?: { [key: string]: string; };
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsFailoverConfig
     */
    'failure_threshold'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoNotificationsFailoverConfig
     */
    'fallback_channel_ids'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsFailoverConfig
     */
    'recovery_timeout_seconds'?: number;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsFrequencyLimits
 */
export interface CordeCommonModelsDtoNotificationsFrequencyLimits {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsFrequencyLimits
     */
    'digest_frequency'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsFrequencyLimits
     */
    'digest_mode'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsFrequencyLimits
     */
    'max_per_day'?: number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsFrequencyLimits
     */
    'max_per_hour'?: number;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsGetChannelHealthResponse
 */
export interface CordeCommonModelsDtoNotificationsGetChannelHealthResponse {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsGetChannelHealthResponse
     */
    'channel_id'?: string;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoNotificationsHealthCheck>}
     * @memberof CordeCommonModelsDtoNotificationsGetChannelHealthResponse
     */
    'health_checks'?: Array<CordeCommonModelsDtoNotificationsHealthCheck>;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsGetChannelHealthResponse
     */
    'last_checked'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsGetChannelHealthResponse
     */
    'last_successful_send'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsGetChannelHealthResponse
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsGetChannelHealthResponse
     */
    'status_message'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsGetChannelResponse
 */
export interface CordeCommonModelsDtoNotificationsGetChannelResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsNotificationChannel}
     * @memberof CordeCommonModelsDtoNotificationsGetChannelResponse
     */
    'channel'?: CordeCommonModelsDtoNotificationsNotificationChannel;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsGetContactResponse
 */
export interface CordeCommonModelsDtoNotificationsGetContactResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoContactContact}
     * @memberof CordeCommonModelsDtoNotificationsGetContactResponse
     */
    'contact'?: CordeCommonModelsDtoContactContact;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsGetDeliveryReportResponse
 */
export interface CordeCommonModelsDtoNotificationsGetDeliveryReportResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoNotificationsDeliveryAttempt>}
     * @memberof CordeCommonModelsDtoNotificationsGetDeliveryReportResponse
     */
    'delivery_attempts'?: Array<CordeCommonModelsDtoNotificationsDeliveryAttempt>;
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsNotification}
     * @memberof CordeCommonModelsDtoNotificationsGetDeliveryReportResponse
     */
    'notification'?: CordeCommonModelsDtoNotificationsNotification;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsGetNotificationStatsResponse
 */
export interface CordeCommonModelsDtoNotificationsGetNotificationStatsResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoNotificationsChannelStats>}
     * @memberof CordeCommonModelsDtoNotificationsGetNotificationStatsResponse
     */
    'channel_stats'?: Array<CordeCommonModelsDtoNotificationsChannelStats>;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoNotificationsDailyStats>}
     * @memberof CordeCommonModelsDtoNotificationsGetNotificationStatsResponse
     */
    'daily_stats'?: Array<CordeCommonModelsDtoNotificationsDailyStats>;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsGetNotificationStatsResponse
     */
    'total_delivered'?: number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsGetNotificationStatsResponse
     */
    'total_failed'?: number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsGetNotificationStatsResponse
     */
    'total_read'?: number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsGetNotificationStatsResponse
     */
    'total_sent'?: number;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsGetNotificationStatusResponse
 */
export interface CordeCommonModelsDtoNotificationsGetNotificationStatusResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsNotification}
     * @memberof CordeCommonModelsDtoNotificationsGetNotificationStatusResponse
     */
    'notification'?: CordeCommonModelsDtoNotificationsNotification;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsGetNotificationsAuditLogsResponse
 */
export interface CordeCommonModelsDtoNotificationsGetNotificationsAuditLogsResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoNotificationsNotificationsAuditLog>}
     * @memberof CordeCommonModelsDtoNotificationsGetNotificationsAuditLogsResponse
     */
    'logs'?: Array<CordeCommonModelsDtoNotificationsNotificationsAuditLog>;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoNotificationsGetNotificationsAuditLogsResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsGetTeamMemberNotificationOverridesResponse
 */
export interface CordeCommonModelsDtoNotificationsGetTeamMemberNotificationOverridesResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsTeamMemberNotificationOverrides}
     * @memberof CordeCommonModelsDtoNotificationsGetTeamMemberNotificationOverridesResponse
     */
    'overrides'?: CordeCommonModelsDtoNotificationsTeamMemberNotificationOverrides;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsGetTeamNotificationSettingsResponse
 */
export interface CordeCommonModelsDtoNotificationsGetTeamNotificationSettingsResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsTeamNotificationSettings}
     * @memberof CordeCommonModelsDtoNotificationsGetTeamNotificationSettingsResponse
     */
    'settings'?: CordeCommonModelsDtoNotificationsTeamNotificationSettings;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsGetTemplateResponse
 */
export interface CordeCommonModelsDtoNotificationsGetTemplateResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsNotificationTemplate}
     * @memberof CordeCommonModelsDtoNotificationsGetTemplateResponse
     */
    'template'?: CordeCommonModelsDtoNotificationsNotificationTemplate;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsGetUserEventChannelSettingsResponse
 */
export interface CordeCommonModelsDtoNotificationsGetUserEventChannelSettingsResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsUserEventChannelSettings}
     * @memberof CordeCommonModelsDtoNotificationsGetUserEventChannelSettingsResponse
     */
    'settings'?: CordeCommonModelsDtoNotificationsUserEventChannelSettings;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsHealthCheck
 */
export interface CordeCommonModelsDtoNotificationsHealthCheck {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsHealthCheck
     */
    'check_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsHealthCheck
     */
    'checked_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsHealthCheck
     */
    'details'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsHealthCheck
     */
    'passed'?: boolean;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsHealthMonitoring
 */
export interface CordeCommonModelsDtoNotificationsHealthMonitoring {
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsHealthMonitoring
     */
    'check_interval_seconds'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoNotificationsHealthMonitoring
     */
    'check_types'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsHealthMonitoring
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsHealthMonitoring
     */
    'failure_threshold'?: number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsHealthMonitoring
     */
    'success_threshold'?: number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsHealthMonitoring
     */
    'timeout_seconds'?: number;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsListChannelsResponse
 */
export interface CordeCommonModelsDtoNotificationsListChannelsResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoNotificationsNotificationChannel>}
     * @memberof CordeCommonModelsDtoNotificationsListChannelsResponse
     */
    'channels'?: Array<CordeCommonModelsDtoNotificationsNotificationChannel>;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoNotificationsListChannelsResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsListContactsResponse
 */
export interface CordeCommonModelsDtoNotificationsListContactsResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoContactContact>}
     * @memberof CordeCommonModelsDtoNotificationsListContactsResponse
     */
    'contacts'?: Array<CordeCommonModelsDtoContactContact>;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoNotificationsListContactsResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsListScheduledNotificationsResponse
 */
export interface CordeCommonModelsDtoNotificationsListScheduledNotificationsResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoNotificationsScheduledNotification>}
     * @memberof CordeCommonModelsDtoNotificationsListScheduledNotificationsResponse
     */
    'notifications'?: Array<CordeCommonModelsDtoNotificationsScheduledNotification>;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoNotificationsListScheduledNotificationsResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsListTemplatesResponse
 */
export interface CordeCommonModelsDtoNotificationsListTemplatesResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoNotificationsListTemplatesResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoNotificationsNotificationTemplate>}
     * @memberof CordeCommonModelsDtoNotificationsListTemplatesResponse
     */
    'templates'?: Array<CordeCommonModelsDtoNotificationsNotificationTemplate>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsListUserNotificationsResponse
 */
export interface CordeCommonModelsDtoNotificationsListUserNotificationsResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoNotificationsNotification>}
     * @memberof CordeCommonModelsDtoNotificationsListUserNotificationsResponse
     */
    'notifications'?: Array<CordeCommonModelsDtoNotificationsNotification>;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoNotificationsListUserNotificationsResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsListUserNotificationsResponse
     */
    'unread_count'?: number;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsMarkAllNotificationsAsReadRequest
 */
export interface CordeCommonModelsDtoNotificationsMarkAllNotificationsAsReadRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsMarkAllNotificationsAsReadRequest
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsMarkNotificationAsReadRequest
 */
export interface CordeCommonModelsDtoNotificationsMarkNotificationAsReadRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsMarkNotificationAsReadRequest
     */
    'notification_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsMarkNotificationAsReadRequest
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsNotification
 */
export interface CordeCommonModelsDtoNotificationsNotification {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotification
     */
    'channel_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotification
     */
    'content'?: string;
    /**
     * Enhanced delivery tracking
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotification
     */
    'correlation_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotification
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotification
     */
    'delivered_at'?: string;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoNotificationsDeliveryAttempt>}
     * @memberof CordeCommonModelsDtoNotificationsNotification
     */
    'delivery_attempts'?: Array<CordeCommonModelsDtoNotificationsDeliveryAttempt>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoNotificationsNotification
     */
    'delivery_receipts'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotification
     */
    'fallback_reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotification
     */
    'id'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoNotificationsNotification
     */
    'metadata'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotification
     */
    'priority'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotification
     */
    'read_at'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsNotification
     */
    'requires_delivery_confirmation'?: boolean;
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsRetryConfig}
     * @memberof CordeCommonModelsDtoNotificationsNotification
     */
    'retry_config'?: CordeCommonModelsDtoNotificationsRetryConfig;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoNotificationsNotification
     */
    'routing_tags'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotification
     */
    'scheduled_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotification
     */
    'sent_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotification
     */
    'source_service'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotification
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotification
     */
    'subject'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotification
     */
    'template_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotification
     */
    'tenant_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotification
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsNotificationChannel
 */
export interface CordeCommonModelsDtoNotificationsNotificationChannel {
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsConnectionPoolConfig}
     * @memberof CordeCommonModelsDtoNotificationsNotificationChannel
     */
    'connection_pool'?: CordeCommonModelsDtoNotificationsConnectionPoolConfig;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotificationChannel
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotificationChannel
     */
    'description'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsDiscordChannelConfig}
     * @memberof CordeCommonModelsDtoNotificationsNotificationChannel
     */
    'discord_config'?: CordeCommonModelsDtoNotificationsDiscordChannelConfig;
    /**
     * Channel-specific configurations (oneof in proto)
     * @type {CordeCommonModelsDtoNotificationsEmailChannelConfig}
     * @memberof CordeCommonModelsDtoNotificationsNotificationChannel
     */
    'email_config'?: CordeCommonModelsDtoNotificationsEmailChannelConfig;
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsFailoverConfig}
     * @memberof CordeCommonModelsDtoNotificationsNotificationChannel
     */
    'failover_config'?: CordeCommonModelsDtoNotificationsFailoverConfig;
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsHealthMonitoring}
     * @memberof CordeCommonModelsDtoNotificationsNotificationChannel
     */
    'health_monitoring'?: CordeCommonModelsDtoNotificationsHealthMonitoring;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotificationChannel
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsNotificationChannel
     */
    'is_enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotificationChannel
     */
    'name'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoEntityEntity}
     * @memberof CordeCommonModelsDtoNotificationsNotificationChannel
     */
    'owner'?: CordeCommonModelsDtoEntityEntity;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsNotificationChannel
     */
    'priority'?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoNotificationsNotificationChannel
     */
    'provider_quotas'?: { [key: string]: string; };
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsPushChannelConfig}
     * @memberof CordeCommonModelsDtoNotificationsNotificationChannel
     */
    'push_config'?: CordeCommonModelsDtoNotificationsPushChannelConfig;
    /**
     * Enterprise scaling features
     * @type {CordeCommonModelsDtoNotificationsRateLimitConfig}
     * @memberof CordeCommonModelsDtoNotificationsNotificationChannel
     */
    'rate_limits'?: CordeCommonModelsDtoNotificationsRateLimitConfig;
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsSlackChannelConfig}
     * @memberof CordeCommonModelsDtoNotificationsNotificationChannel
     */
    'slack_config'?: CordeCommonModelsDtoNotificationsSlackChannelConfig;
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsSmsChannelConfig}
     * @memberof CordeCommonModelsDtoNotificationsNotificationChannel
     */
    'sms_config'?: CordeCommonModelsDtoNotificationsSmsChannelConfig;
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoNotificationsNotificationChannel
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsTelegramChannelConfig}
     * @memberof CordeCommonModelsDtoNotificationsNotificationChannel
     */
    'telegram_config'?: CordeCommonModelsDtoNotificationsTelegramChannelConfig;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotificationChannel
     */
    'tenant_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotificationChannel
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotificationChannel
     */
    'updated_at'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsWebhookChannelConfig}
     * @memberof CordeCommonModelsDtoNotificationsNotificationChannel
     */
    'webhook_config'?: CordeCommonModelsDtoNotificationsWebhookChannelConfig;
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsWhatsappChannelConfig}
     * @memberof CordeCommonModelsDtoNotificationsNotificationChannel
     */
    'whatsapp_config'?: CordeCommonModelsDtoNotificationsWhatsappChannelConfig;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsNotificationDeliveryResult
 */
export interface CordeCommonModelsDtoNotificationsNotificationDeliveryResult {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotificationDeliveryResult
     */
    'channel_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotificationDeliveryResult
     */
    'contact_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotificationDeliveryResult
     */
    'notification_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotificationDeliveryResult
     */
    'reason'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsNotificationDeliveryResult
     */
    'sent'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotificationDeliveryResult
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsNotificationTemplate
 */
export interface CordeCommonModelsDtoNotificationsNotificationTemplate {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotificationTemplate
     */
    'body_template'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotificationTemplate
     */
    'channel_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotificationTemplate
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotificationTemplate
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotificationTemplate
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotificationTemplate
     */
    'language'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotificationTemplate
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoNotificationsNotificationTemplate
     */
    'required_variables'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotificationTemplate
     */
    'subject_template'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotificationTemplate
     */
    'updated_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsNotificationTemplate
     */
    'version'?: number;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsNotificationsAuditLog
 */
export interface CordeCommonModelsDtoNotificationsNotificationsAuditLog {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotificationsAuditLog
     */
    'action'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoEntityEntity}
     * @memberof CordeCommonModelsDtoNotificationsNotificationsAuditLog
     */
    'entity'?: CordeCommonModelsDtoEntityEntity;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotificationsAuditLog
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotificationsAuditLog
     */
    'new_value'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotificationsAuditLog
     */
    'old_value'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotificationsAuditLog
     */
    'platform_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotificationsAuditLog
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsNotificationsAuditLog
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsProcessDeliveryConfirmationRequest
 */
export interface CordeCommonModelsDtoNotificationsProcessDeliveryConfirmationRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsProcessDeliveryConfirmationRequest
     */
    'confirmation_status'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsProcessDeliveryConfirmationRequest
     */
    'confirmed_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsProcessDeliveryConfirmationRequest
     */
    'notification_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsProcessDeliveryConfirmationRequest
     */
    'provider_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsProcessDeliveryConfirmationRequest
     */
    'provider_message_id'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoNotificationsProcessDeliveryConfirmationRequest
     */
    'provider_metadata'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsProcessDeliveryConfirmationRequest
     */
    'provider_response'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsPushChannelConfig
 */
export interface CordeCommonModelsDtoNotificationsPushChannelConfig {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsPushChannelConfig
     */
    'apns_bundle_id'?: string;
    /**
     * Apple APNS configuration
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsPushChannelConfig
     */
    'apns_key_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsPushChannelConfig
     */
    'apns_private_key'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsPushChannelConfig
     */
    'apns_production'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsPushChannelConfig
     */
    'apns_team_id'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoNotificationsPushChannelConfig
     */
    'default_data'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsPushChannelConfig
     */
    'fcm_project_id'?: string;
    /**
     * Firebase/FCM configuration
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsPushChannelConfig
     */
    'fcm_server_key'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsPushChannelConfig
     */
    'fcm_service_account'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsPushChannelConfig
     */
    'provider'?: string;
    /**
     * Common settings
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsPushChannelConfig
     */
    'timeout_seconds'?: number;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsRateLimitConfig
 */
export interface CordeCommonModelsDtoNotificationsRateLimitConfig {
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsRateLimitConfig
     */
    'burst_limit'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsRateLimitConfig
     */
    'enable_throttling'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsRateLimitConfig
     */
    'requests_per_day'?: number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsRateLimitConfig
     */
    'requests_per_hour'?: number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsRateLimitConfig
     */
    'requests_per_minute'?: number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsRateLimitConfig
     */
    'throttling_strategy'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsRetryConfig
 */
export interface CordeCommonModelsDtoNotificationsRetryConfig {
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsRetryConfig
     */
    'backoff_multiplier'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsRetryConfig
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsRetryConfig
     */
    'initial_delay_seconds'?: number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsRetryConfig
     */
    'max_attempts'?: number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsRetryConfig
     */
    'max_delay_seconds'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoNotificationsRetryConfig
     */
    'retry_on_errors'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsRetryConfig
     */
    'retry_on_timeout'?: boolean;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsRoleNotificationRule
 */
export interface CordeCommonModelsDtoNotificationsRoleNotificationRule {
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoNotificationsRoleNotificationRule
     */
    'channels'?: Array<string>;
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsFrequencyLimits}
     * @memberof CordeCommonModelsDtoNotificationsRoleNotificationRule
     */
    'frequency_limits'?: CordeCommonModelsDtoNotificationsFrequencyLimits;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsRoleNotificationRule
     */
    'is_mandatory'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoNotificationsRoleNotificationRule
     */
    'notification_types'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsRoleNotificationRule
     */
    'role_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsRoleNotificationRule
     */
    'role_name'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsScheduleNotificationRequest
 */
export interface CordeCommonModelsDtoNotificationsScheduleNotificationRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsScheduleNotificationRequest
     */
    'allow_duplicate'?: boolean;
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsSendNotificationRequest}
     * @memberof CordeCommonModelsDtoNotificationsScheduleNotificationRequest
     */
    'notification'?: CordeCommonModelsDtoNotificationsSendNotificationRequest;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsScheduleNotificationRequest
     */
    'schedule_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsScheduleNotificationRequest
     */
    'scheduled_at'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsScheduleNotificationResponse
 */
export interface CordeCommonModelsDtoNotificationsScheduleNotificationResponse {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsScheduleNotificationResponse
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsScheduleNotificationResponse
     */
    'schedule_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsScheduleNotificationResponse
     */
    'scheduled_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsScheduleNotificationResponse
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsScheduledNotification
 */
export interface CordeCommonModelsDtoNotificationsScheduledNotification {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsScheduledNotification
     */
    'cancellation_reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsScheduledNotification
     */
    'cancelled_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsScheduledNotification
     */
    'created_at'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsSendNotificationRequest}
     * @memberof CordeCommonModelsDtoNotificationsScheduledNotification
     */
    'notification'?: CordeCommonModelsDtoNotificationsSendNotificationRequest;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsScheduledNotification
     */
    'schedule_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsScheduledNotification
     */
    'scheduled_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsScheduledNotification
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsSendBulkNotificationsRequest
 */
export interface CordeCommonModelsDtoNotificationsSendBulkNotificationsRequest {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoNotificationsSendNotificationRequest>}
     * @memberof CordeCommonModelsDtoNotificationsSendBulkNotificationsRequest
     */
    'notifications'?: Array<CordeCommonModelsDtoNotificationsSendNotificationRequest>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsSendBulkNotificationsResponse
 */
export interface CordeCommonModelsDtoNotificationsSendBulkNotificationsResponse {
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsSendBulkNotificationsResponse
     */
    'failed_count'?: number;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoNotificationsSendNotificationResponse>}
     * @memberof CordeCommonModelsDtoNotificationsSendBulkNotificationsResponse
     */
    'results'?: Array<CordeCommonModelsDtoNotificationsSendNotificationResponse>;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsSendBulkNotificationsResponse
     */
    'successful_count'?: number;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsSendNotificationRequest
 */
export interface CordeCommonModelsDtoNotificationsSendNotificationRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsSendNotificationRequest
     */
    'context_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsSendNotificationRequest
     */
    'context_type'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoNotificationsSendNotificationRequest
     */
    'metadata'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsSendNotificationRequest
     */
    'notification_type'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoNotificationsSendNotificationRequest
     */
    'preferred_channels'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsSendNotificationRequest
     */
    'priority'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsSendNotificationRequest
     */
    'template_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsSendNotificationRequest
     */
    'user_id'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoNotificationsSendNotificationRequest
     */
    'variables'?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsSendNotificationResponse
 */
export interface CordeCommonModelsDtoNotificationsSendNotificationResponse {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsSendNotificationResponse
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsSendNotificationResponse
     */
    'notification_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsSendNotificationResponse
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsSendSmartNotificationRequest
 */
export interface CordeCommonModelsDtoNotificationsSendSmartNotificationRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsSendSmartNotificationRequest
     */
    'context_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsSendSmartNotificationRequest
     */
    'context_type'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsSendSmartNotificationRequest
     */
    'force_send'?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoNotificationsSendSmartNotificationRequest
     */
    'metadata'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsSendSmartNotificationRequest
     */
    'notification_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsSendSmartNotificationRequest
     */
    'priority'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoEntityEntity}
     * @memberof CordeCommonModelsDtoNotificationsSendSmartNotificationRequest
     */
    'target_entity'?: CordeCommonModelsDtoEntityEntity;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsSendSmartNotificationRequest
     */
    'template_id'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoNotificationsSendSmartNotificationRequest
     */
    'template_variables'?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsSendSmartNotificationResponse
 */
export interface CordeCommonModelsDtoNotificationsSendSmartNotificationResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoNotificationsNotificationDeliveryResult>}
     * @memberof CordeCommonModelsDtoNotificationsSendSmartNotificationResponse
     */
    'delivery_results'?: Array<CordeCommonModelsDtoNotificationsNotificationDeliveryResult>;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsSendSmartNotificationResponse
     */
    'failed_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsSendSmartNotificationResponse
     */
    'skipped_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsSendSmartNotificationResponse
     */
    'successful_count'?: number;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsSetPrimaryContactRequest
 */
export interface CordeCommonModelsDtoNotificationsSetPrimaryContactRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsSetPrimaryContactRequest
     */
    'contact_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsSetPrimaryContactRequest
     */
    'contact_type'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoEntityEntity}
     * @memberof CordeCommonModelsDtoNotificationsSetPrimaryContactRequest
     */
    'entity'?: CordeCommonModelsDtoEntityEntity;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsSlackChannelConfig
 */
export interface CordeCommonModelsDtoNotificationsSlackChannelConfig {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsSlackChannelConfig
     */
    'bot_token'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoNotificationsSlackChannelConfig
     */
    'channel_mapping'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsSlackChannelConfig
     */
    'default_channel'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsSlackChannelConfig
     */
    'signing_secret'?: string;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsSlackChannelConfig
     */
    'timeout_seconds'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsSlackChannelConfig
     */
    'use_bot_token'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsSlackChannelConfig
     */
    'webhook_url'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsSmsChannelConfig
 */
export interface CordeCommonModelsDtoNotificationsSmsChannelConfig {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsSmsChannelConfig
     */
    'api_key'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsSmsChannelConfig
     */
    'api_secret'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsSmsChannelConfig
     */
    'base_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsSmsChannelConfig
     */
    'provider'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoNotificationsSmsChannelConfig
     */
    'provider_settings'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsSmsChannelConfig
     */
    'sender_id'?: string;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsSmsChannelConfig
     */
    'timeout_seconds'?: number;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsTeamEventRule
 */
export interface CordeCommonModelsDtoNotificationsTeamEventRule {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsTeamEventRule
     */
    'custom_template_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsTeamEventRule
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsTeamEventRule
     */
    'event_type'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsFrequencyLimits}
     * @memberof CordeCommonModelsDtoNotificationsTeamEventRule
     */
    'frequency_limits'?: CordeCommonModelsDtoNotificationsFrequencyLimits;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsTeamEventRule
     */
    'is_mandatory'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsTeamEventRule
     */
    'notify_all_members'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoNotificationsTeamEventRule
     */
    'preferred_channels'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoNotificationsTeamEventRule
     */
    'target_roles'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsTeamMemberNotificationOverrides
 */
export interface CordeCommonModelsDtoNotificationsTeamMemberNotificationOverrides {
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsTeamMemberNotificationOverrides
     */
    'notifications_enabled'?: boolean;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoNotificationsEventNotificationRule>}
     * @memberof CordeCommonModelsDtoNotificationsTeamMemberNotificationOverrides
     */
    'personal_overrides'?: Array<CordeCommonModelsDtoNotificationsEventNotificationRule>;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsTeamMemberNotificationOverrides
     */
    'platform_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsTeamMemberNotificationOverrides
     */
    'team_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsTeamMemberNotificationOverrides
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsTeamMemberNotificationOverrides
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsTeamNotificationSettings
 */
export interface CordeCommonModelsDtoNotificationsTeamNotificationSettings {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsTeamNotificationSettings
     */
    'created_at'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsTeamNotificationSettings
     */
    'notifications_enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsTeamNotificationSettings
     */
    'platform_id'?: string;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoNotificationsRoleNotificationRule>}
     * @memberof CordeCommonModelsDtoNotificationsTeamNotificationSettings
     */
    'role_rules'?: Array<CordeCommonModelsDtoNotificationsRoleNotificationRule>;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoNotificationsTeamEventRule>}
     * @memberof CordeCommonModelsDtoNotificationsTeamNotificationSettings
     */
    'team_event_rules'?: Array<CordeCommonModelsDtoNotificationsTeamEventRule>;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsTeamNotificationSettings
     */
    'team_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsTeamNotificationSettings
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsTelegramChannelConfig
 */
export interface CordeCommonModelsDtoNotificationsTelegramChannelConfig {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsTelegramChannelConfig
     */
    'bot_token'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoNotificationsTelegramChannelConfig
     */
    'default_buttons'?: { [key: string]: string; };
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsTelegramChannelConfig
     */
    'timeout_seconds'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsTelegramChannelConfig
     */
    'use_webhook'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsTelegramChannelConfig
     */
    'webhook_secret'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsTelegramChannelConfig
     */
    'webhook_url'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsTestChannelRequest
 */
export interface CordeCommonModelsDtoNotificationsTestChannelRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsTestChannelRequest
     */
    'channel_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsTestChannelRequest
     */
    'test_message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsTestChannelRequest
     */
    'test_recipient'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsTestChannelResponse
 */
export interface CordeCommonModelsDtoNotificationsTestChannelResponse {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsTestChannelResponse
     */
    'error_details'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsTestChannelResponse
     */
    'message'?: string;
    /**
     * 
     * @type {CordeCommonModelsConstantsTestResult}
     * @memberof CordeCommonModelsDtoNotificationsTestChannelResponse
     */
    'result'?: CordeCommonModelsConstantsTestResult;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsTestChannelResponse
     */
    'success'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsTestChannelResponse
     */
    'tested_at'?: string;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsUpdateChannelConfigRequest
 */
export interface CordeCommonModelsDtoNotificationsUpdateChannelConfigRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsUpdateChannelConfigRequest
     */
    'channel_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsDiscordChannelConfig}
     * @memberof CordeCommonModelsDtoNotificationsUpdateChannelConfigRequest
     */
    'discord_config'?: CordeCommonModelsDtoNotificationsDiscordChannelConfig;
    /**
     * Specific configuration update for each channel type (oneof)
     * @type {CordeCommonModelsDtoNotificationsEmailChannelConfig}
     * @memberof CordeCommonModelsDtoNotificationsUpdateChannelConfigRequest
     */
    'email_config'?: CordeCommonModelsDtoNotificationsEmailChannelConfig;
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsPushChannelConfig}
     * @memberof CordeCommonModelsDtoNotificationsUpdateChannelConfigRequest
     */
    'push_config'?: CordeCommonModelsDtoNotificationsPushChannelConfig;
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsSlackChannelConfig}
     * @memberof CordeCommonModelsDtoNotificationsUpdateChannelConfigRequest
     */
    'slack_config'?: CordeCommonModelsDtoNotificationsSlackChannelConfig;
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsSmsChannelConfig}
     * @memberof CordeCommonModelsDtoNotificationsUpdateChannelConfigRequest
     */
    'sms_config'?: CordeCommonModelsDtoNotificationsSmsChannelConfig;
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsTelegramChannelConfig}
     * @memberof CordeCommonModelsDtoNotificationsUpdateChannelConfigRequest
     */
    'telegram_config'?: CordeCommonModelsDtoNotificationsTelegramChannelConfig;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsUpdateChannelConfigRequest
     */
    'validate_config'?: boolean;
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsWebhookChannelConfig}
     * @memberof CordeCommonModelsDtoNotificationsUpdateChannelConfigRequest
     */
    'webhook_config'?: CordeCommonModelsDtoNotificationsWebhookChannelConfig;
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsWhatsappChannelConfig}
     * @memberof CordeCommonModelsDtoNotificationsUpdateChannelConfigRequest
     */
    'whatsapp_config'?: CordeCommonModelsDtoNotificationsWhatsappChannelConfig;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsUpdateChannelRequest
 */
export interface CordeCommonModelsDtoNotificationsUpdateChannelRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsNotificationChannel}
     * @memberof CordeCommonModelsDtoNotificationsUpdateChannelRequest
     */
    'channel'?: CordeCommonModelsDtoNotificationsNotificationChannel;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsUpdateChannelRequest
     */
    'channel_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsUpdateContactRequest
 */
export interface CordeCommonModelsDtoNotificationsUpdateContactRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoContactContact}
     * @memberof CordeCommonModelsDtoNotificationsUpdateContactRequest
     */
    'contact'?: CordeCommonModelsDtoContactContact;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsUpdateTeamMemberNotificationOverridesRequest
 */
export interface CordeCommonModelsDtoNotificationsUpdateTeamMemberNotificationOverridesRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsTeamMemberNotificationOverrides}
     * @memberof CordeCommonModelsDtoNotificationsUpdateTeamMemberNotificationOverridesRequest
     */
    'overrides'?: CordeCommonModelsDtoNotificationsTeamMemberNotificationOverrides;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsUpdateTeamNotificationSettingsRequest
 */
export interface CordeCommonModelsDtoNotificationsUpdateTeamNotificationSettingsRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsTeamNotificationSettings}
     * @memberof CordeCommonModelsDtoNotificationsUpdateTeamNotificationSettingsRequest
     */
    'settings'?: CordeCommonModelsDtoNotificationsTeamNotificationSettings;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsUpdateTemplateRequest
 */
export interface CordeCommonModelsDtoNotificationsUpdateTemplateRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsNotificationTemplate}
     * @memberof CordeCommonModelsDtoNotificationsUpdateTemplateRequest
     */
    'template'?: CordeCommonModelsDtoNotificationsNotificationTemplate;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsUpdateTemplateRequest
     */
    'template_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsUpdateUserEventChannelSettingsRequest
 */
export interface CordeCommonModelsDtoNotificationsUpdateUserEventChannelSettingsRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsUserEventChannelSettings}
     * @memberof CordeCommonModelsDtoNotificationsUpdateUserEventChannelSettingsRequest
     */
    'settings'?: CordeCommonModelsDtoNotificationsUserEventChannelSettings;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsUserEventChannelSettings
 */
export interface CordeCommonModelsDtoNotificationsUserEventChannelSettings {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoNotificationsEventNotificationRule>}
     * @memberof CordeCommonModelsDtoNotificationsUserEventChannelSettings
     */
    'event_rules'?: Array<CordeCommonModelsDtoNotificationsEventNotificationRule>;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsUserEventChannelSettings
     */
    'platform_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsUserEventChannelSettings
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsUserEventChannelSettings
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsValidateChannelConfigRequest
 */
export interface CordeCommonModelsDtoNotificationsValidateChannelConfigRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsValidateChannelConfigRequest
     */
    'channel_type'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsDiscordChannelConfig}
     * @memberof CordeCommonModelsDtoNotificationsValidateChannelConfigRequest
     */
    'discord_config'?: CordeCommonModelsDtoNotificationsDiscordChannelConfig;
    /**
     * Specific configuration to validate (oneof)
     * @type {CordeCommonModelsDtoNotificationsEmailChannelConfig}
     * @memberof CordeCommonModelsDtoNotificationsValidateChannelConfigRequest
     */
    'email_config'?: CordeCommonModelsDtoNotificationsEmailChannelConfig;
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsPushChannelConfig}
     * @memberof CordeCommonModelsDtoNotificationsValidateChannelConfigRequest
     */
    'push_config'?: CordeCommonModelsDtoNotificationsPushChannelConfig;
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsSlackChannelConfig}
     * @memberof CordeCommonModelsDtoNotificationsValidateChannelConfigRequest
     */
    'slack_config'?: CordeCommonModelsDtoNotificationsSlackChannelConfig;
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsSmsChannelConfig}
     * @memberof CordeCommonModelsDtoNotificationsValidateChannelConfigRequest
     */
    'sms_config'?: CordeCommonModelsDtoNotificationsSmsChannelConfig;
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsTelegramChannelConfig}
     * @memberof CordeCommonModelsDtoNotificationsValidateChannelConfigRequest
     */
    'telegram_config'?: CordeCommonModelsDtoNotificationsTelegramChannelConfig;
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsWebhookChannelConfig}
     * @memberof CordeCommonModelsDtoNotificationsValidateChannelConfigRequest
     */
    'webhook_config'?: CordeCommonModelsDtoNotificationsWebhookChannelConfig;
    /**
     * 
     * @type {CordeCommonModelsDtoNotificationsWhatsappChannelConfig}
     * @memberof CordeCommonModelsDtoNotificationsValidateChannelConfigRequest
     */
    'whatsapp_config'?: CordeCommonModelsDtoNotificationsWhatsappChannelConfig;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsValidateChannelConfigResponse
 */
export interface CordeCommonModelsDtoNotificationsValidateChannelConfigResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoNotificationsConfigValidationError>}
     * @memberof CordeCommonModelsDtoNotificationsValidateChannelConfigResponse
     */
    'errors'?: Array<CordeCommonModelsDtoNotificationsConfigValidationError>;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsValidateChannelConfigResponse
     */
    'is_valid'?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoNotificationsValidateChannelConfigResponse
     */
    'validated_fields'?: { [key: string]: string; };
    /**
     * 
     * @type {Array<CordeCommonModelsDtoNotificationsConfigValidationWarning>}
     * @memberof CordeCommonModelsDtoNotificationsValidateChannelConfigResponse
     */
    'warnings'?: Array<CordeCommonModelsDtoNotificationsConfigValidationWarning>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsValidateContactValueResponse
 */
export interface CordeCommonModelsDtoNotificationsValidateContactValueResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsValidateContactValueResponse
     */
    'is_valid'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoNotificationsValidateContactValueResponse
     */
    'suggestions'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsValidateContactValueResponse
     */
    'validation_message'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsVerifyContactRequest
 */
export interface CordeCommonModelsDtoNotificationsVerifyContactRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsVerifyContactRequest
     */
    'contact_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsVerifyContactRequest
     */
    'verification_code'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsWebhookChannelConfig
 */
export interface CordeCommonModelsDtoNotificationsWebhookChannelConfig {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsWebhookChannelConfig
     */
    'content_type'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoNotificationsWebhookChannelConfig
     */
    'headers'?: { [key: string]: string; };
    /**
     * 
     * @type {CordeCommonModelsConstantsHTTPMethod}
     * @memberof CordeCommonModelsDtoNotificationsWebhookChannelConfig
     */
    'method'?: CordeCommonModelsConstantsHTTPMethod;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsWebhookChannelConfig
     */
    'retry_attempts'?: number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsWebhookChannelConfig
     */
    'retry_delay_seconds'?: number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsWebhookChannelConfig
     */
    'secret_token'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsWebhookChannelConfig
     */
    'template'?: string;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsWebhookChannelConfig
     */
    'timeout_seconds'?: number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsWebhookChannelConfig
     */
    'url'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoNotificationsWebhookChannelConfig
     */
    'verify_ssl'?: boolean;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoNotificationsWhatsappChannelConfig
 */
export interface CordeCommonModelsDtoNotificationsWhatsappChannelConfig {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsWhatsappChannelConfig
     */
    'access_token'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsWhatsappChannelConfig
     */
    'app_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsWhatsappChannelConfig
     */
    'app_secret'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsWhatsappChannelConfig
     */
    'base_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsWhatsappChannelConfig
     */
    'phone_number_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsWhatsappChannelConfig
     */
    'provider'?: string;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoNotificationsWhatsappChannelConfig
     */
    'timeout_seconds'?: number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoNotificationsWhatsappChannelConfig
     */
    'webhook_verify_token'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoPaginationDateRangeFilter
 */
export interface CordeCommonModelsDtoPaginationDateRangeFilter {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoPaginationDateRangeFilter
     */
    'end_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoPaginationDateRangeFilter
     */
    'start_date'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoPaginationFilterGroup
 */
export interface CordeCommonModelsDtoPaginationFilterGroup {
    /**
     * Вложенные группы
     * @type {Array<CordeCommonModelsDtoPaginationFilterGroup>}
     * @memberof CordeCommonModelsDtoPaginationFilterGroup
     */
    'groups'?: Array<CordeCommonModelsDtoPaginationFilterGroup>;
    /**
     * AND / OR
     * @type {CordeCommonModelsConstantsLogicOperator}
     * @memberof CordeCommonModelsDtoPaginationFilterGroup
     */
    'logic'?: CordeCommonModelsConstantsLogicOperator;
    /**
     * Простые условия
     * @type {Array<CordeCommonModelsDtoPaginationFilterRule>}
     * @memberof CordeCommonModelsDtoPaginationFilterGroup
     */
    'rules'?: Array<CordeCommonModelsDtoPaginationFilterRule>;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoPaginationFilterRule
 */
export interface CordeCommonModelsDtoPaginationFilterRule {
    /**
     * Название поля
     * @type {string}
     * @memberof CordeCommonModelsDtoPaginationFilterRule
     */
    'field'?: string;
    /**
     * eq, lt, gt и т.д.
     * @type {CordeCommonModelsConstantsFilterOperator}
     * @memberof CordeCommonModelsDtoPaginationFilterRule
     */
    'operator'?: CordeCommonModelsConstantsFilterOperator;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationFilterValue}
     * @memberof CordeCommonModelsDtoPaginationFilterRule
     */
    'value'?: CordeCommonModelsDtoPaginationFilterValue;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoPaginationFilterValue
 */
export interface CordeCommonModelsDtoPaginationFilterValue {
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoPaginationFilterValue
     */
    'bool'?: boolean;
    /**
     * RFC 3339
     * @type {string}
     * @memberof CordeCommonModelsDtoPaginationFilterValue
     */
    'date'?: string;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoPaginationFilterValue
     */
    'int'?: number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoPaginationFilterValue
     */
    'string'?: string;
    /**
     * для IN/NOT IN
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoPaginationFilterValue
     */
    'strings'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoPaginationPageInfo
 */
export interface CordeCommonModelsDtoPaginationPageInfo {
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoPaginationPageInfo
     */
    'limit'?: number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoPaginationPageInfo
     */
    'offset'?: number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoPaginationPageInfo
     */
    'total_items'?: number;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoPaginationPaginatedRequest
 */
export interface CordeCommonModelsDtoPaginationPaginatedRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationDateRangeFilter}
     * @memberof CordeCommonModelsDtoPaginationPaginatedRequest
     */
    'date_range'?: CordeCommonModelsDtoPaginationDateRangeFilter;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationFilterGroup}
     * @memberof CordeCommonModelsDtoPaginationPaginatedRequest
     */
    'filters'?: CordeCommonModelsDtoPaginationFilterGroup;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPagination}
     * @memberof CordeCommonModelsDtoPaginationPaginatedRequest
     */
    'pagination'?: CordeCommonModelsDtoPaginationPagination;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoPaginationSortInfo>}
     * @memberof CordeCommonModelsDtoPaginationPaginatedRequest
     */
    'sort'?: Array<CordeCommonModelsDtoPaginationSortInfo>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoPaginationPaginatedResponse
 */
export interface CordeCommonModelsDtoPaginationPaginatedResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPageInfo}
     * @memberof CordeCommonModelsDtoPaginationPaginatedResponse
     */
    'page_info'?: CordeCommonModelsDtoPaginationPageInfo;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoPaginationPagination
 */
export interface CordeCommonModelsDtoPaginationPagination {
    /**
     * Number of items per page
     * @type {number}
     * @memberof CordeCommonModelsDtoPaginationPagination
     */
    'limit'?: number;
    /**
     * Number of items to skip
     * @type {number}
     * @memberof CordeCommonModelsDtoPaginationPagination
     */
    'offset'?: number;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoPaginationSortInfo
 */
export interface CordeCommonModelsDtoPaginationSortInfo {
    /**
     * Field to sort by
     * @type {string}
     * @memberof CordeCommonModelsDtoPaginationSortInfo
     */
    'field'?: string;
    /**
     * Sort order (asc/desc)
     * @type {string}
     * @memberof CordeCommonModelsDtoPaginationSortInfo
     */
    'order'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoResourceResource
 */
export interface CordeCommonModelsDtoResourceResource {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoResourceResource
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoResourceResource
     */
    'linked_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoResourceResource
     */
    'linked_by'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoResourceResource
     */
    'metadata'?: { [key: string]: string; };
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoResourceResource
     */
    'order'?: number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoResourceResource
     */
    'resource_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoResourceResource
     */
    'resource_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoResourceResource
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoResourceResources
 */
export interface CordeCommonModelsDtoResourceResources {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoResourceResource>}
     * @memberof CordeCommonModelsDtoResourceResources
     */
    'resources'?: Array<CordeCommonModelsDtoResourceResource>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoResponseResponse
 */
export interface CordeCommonModelsDtoResponseResponse {
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoResponseResponse
     */
    'code'?: number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoResponseResponse
     */
    'message'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoResponseResponse
     */
    'metadata'?: { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoResponseResponse
     */
    'success'?: boolean;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamAddUserToTeamRequest
 */
export interface CordeCommonModelsDtoTeamAddUserToTeamRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamAddUserToTeamRequest
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamAddUserToTeamRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsConstantsRequesterType}
     * @memberof CordeCommonModelsDtoTeamAddUserToTeamRequest
     */
    'requester_type'?: CordeCommonModelsConstantsRequesterType;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamAddUserToTeamRequest
     */
    'role_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamAddUserToTeamRequest
     */
    'team_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamUserIdentity}
     * @memberof CordeCommonModelsDtoTeamAddUserToTeamRequest
     */
    'user'?: CordeCommonModelsDtoTeamTeamUserIdentity;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamApproveTeamMembershipRequest
 */
export interface CordeCommonModelsDtoTeamApproveTeamMembershipRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamApproveTeamMembershipRequest
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamApproveTeamMembershipRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamApproveTeamMembershipRequest
     */
    'request_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsConstantsRequesterType}
     * @memberof CordeCommonModelsDtoTeamApproveTeamMembershipRequest
     */
    'requester_type'?: CordeCommonModelsConstantsRequesterType;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamApproveTeamRoleRequest
 */
export interface CordeCommonModelsDtoTeamApproveTeamRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamApproveTeamRoleRequest
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamApproveTeamRoleRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamApproveTeamRoleRequest
     */
    'request_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsConstantsRequesterType}
     * @memberof CordeCommonModelsDtoTeamApproveTeamRoleRequest
     */
    'requester_type'?: CordeCommonModelsConstantsRequesterType;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamAssignPermissionToRoleRequest
 */
export interface CordeCommonModelsDtoTeamAssignPermissionToRoleRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoTeamAssignPermissionToRoleRequest
     */
    'permissions'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamAssignPermissionToRoleRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsConstantsRequesterType}
     * @memberof CordeCommonModelsDtoTeamAssignPermissionToRoleRequest
     */
    'requester_type'?: CordeCommonModelsConstantsRequesterType;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamAssignPermissionToRoleRequest
     */
    'role_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamAssignPermissionToRoleRequest
     */
    'team_id'?: string;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamAssignRoleToUserRequest
 */
export interface CordeCommonModelsDtoTeamAssignRoleToUserRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamAssignRoleToUserRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsConstantsRequesterType}
     * @memberof CordeCommonModelsDtoTeamAssignRoleToUserRequest
     */
    'requester_type'?: CordeCommonModelsConstantsRequesterType;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamAssignRoleToUserRequest
     */
    'role_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamAssignRoleToUserRequest
     */
    'team_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamUserIdentity}
     * @memberof CordeCommonModelsDtoTeamAssignRoleToUserRequest
     */
    'user'?: CordeCommonModelsDtoTeamTeamUserIdentity;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamAssignRoleToUserRequest
     */
    'valid_from'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamAssignRoleToUserRequest
     */
    'valid_to'?: string;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamCreateRoleRequest
 */
export interface CordeCommonModelsDtoTeamCreateRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamCreateRoleRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamCreateRoleRequest
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoTeamCreateRoleRequest
     */
    'permissions'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamCreateRoleRequest
     */
    'platform_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamCreateRoleRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsConstantsRequesterType}
     * @memberof CordeCommonModelsDtoTeamCreateRoleRequest
     */
    'requester_type'?: CordeCommonModelsConstantsRequesterType;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamCreateRoleRequest
     */
    'role_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamCreateRoleRequest
     */
    'team_id'?: string;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamCreateTeamRequest
 */
export interface CordeCommonModelsDtoTeamCreateTeamRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamNotificationSettings}
     * @memberof CordeCommonModelsDtoTeamCreateTeamRequest
     */
    'notification_settings'?: CordeCommonModelsDtoTeamTeamNotificationSettings;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamCreateTeamRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsConstantsRequesterType}
     * @memberof CordeCommonModelsDtoTeamCreateTeamRequest
     */
    'requester_type'?: CordeCommonModelsConstantsRequesterType;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamSecuritySettings}
     * @memberof CordeCommonModelsDtoTeamCreateTeamRequest
     */
    'security_settings'?: CordeCommonModelsDtoTeamTeamSecuritySettings;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeam}
     * @memberof CordeCommonModelsDtoTeamCreateTeamRequest
     */
    'team'?: CordeCommonModelsDtoTeamTeam;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamUISettings}
     * @memberof CordeCommonModelsDtoTeamCreateTeamRequest
     */
    'ui_settings'?: CordeCommonModelsDtoTeamTeamUISettings;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamUserSettings}
     * @memberof CordeCommonModelsDtoTeamCreateTeamRequest
     */
    'user_settings'?: CordeCommonModelsDtoTeamTeamUserSettings;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamEmailNotificationSettings
 */
export interface CordeCommonModelsDtoTeamEmailNotificationSettings {
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoTeamEmailNotificationSettings
     */
    'digest_enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamEmailNotificationSettings
     */
    'digest_frequency'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamEmailNotificationSettings
     */
    'digest_time'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoTeamEmailNotificationSettings
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamEmailNotificationSettings
     */
    'from_email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamEmailNotificationSettings
     */
    'from_name'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamEventNotificationSetting
 */
export interface CordeCommonModelsDtoTeamEventNotificationSetting {
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoTeamEventNotificationSetting
     */
    'channels'?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoTeamEventNotificationSetting
     */
    'custom_settings'?: { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoTeamEventNotificationSetting
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamEventNotificationSetting
     */
    'event_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamEventNotificationSetting
     */
    'template_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamGetTeamAuditLogsResponse
 */
export interface CordeCommonModelsDtoTeamGetTeamAuditLogsResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoTeamTeamAuditLog>}
     * @memberof CordeCommonModelsDtoTeamGetTeamAuditLogsResponse
     */
    'logs'?: Array<CordeCommonModelsDtoTeamTeamAuditLog>;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoTeamGetTeamAuditLogsResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamGetTeamAvailableActionsResponse
 */
export interface CordeCommonModelsDtoTeamGetTeamAvailableActionsResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoTeamTeamAction>}
     * @memberof CordeCommonModelsDtoTeamGetTeamAvailableActionsResponse
     */
    'actions'?: Array<CordeCommonModelsDtoTeamTeamAction>;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoTeamTeamCategory>}
     * @memberof CordeCommonModelsDtoTeamGetTeamAvailableActionsResponse
     */
    'categories'?: Array<CordeCommonModelsDtoTeamTeamCategory>;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamGetTeamAvailableActionsResponse
     */
    'team_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamGetTeamLogsResponse
 */
export interface CordeCommonModelsDtoTeamGetTeamLogsResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoTeamTeamLogEntry>}
     * @memberof CordeCommonModelsDtoTeamGetTeamLogsResponse
     */
    'logs'?: Array<CordeCommonModelsDtoTeamTeamLogEntry>;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoTeamGetTeamLogsResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamGetTeamMembershipRequestRequest
 */
export interface CordeCommonModelsDtoTeamGetTeamMembershipRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamGetTeamMembershipRequestRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamGetTeamMembershipRequestRequest
     */
    'request_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsConstantsRequesterType}
     * @memberof CordeCommonModelsDtoTeamGetTeamMembershipRequestRequest
     */
    'requester_type'?: CordeCommonModelsConstantsRequesterType;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamGrantTeamOwnershipRequest
 */
export interface CordeCommonModelsDtoTeamGrantTeamOwnershipRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamGrantTeamOwnershipRequest
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamGrantTeamOwnershipRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsConstantsRequesterType}
     * @memberof CordeCommonModelsDtoTeamGrantTeamOwnershipRequest
     */
    'requester_type'?: CordeCommonModelsConstantsRequesterType;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamGrantTeamOwnershipRequest
     */
    'team_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamUserIdentity}
     * @memberof CordeCommonModelsDtoTeamGrantTeamOwnershipRequest
     */
    'user'?: CordeCommonModelsDtoTeamTeamUserIdentity;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamGrantTeamRoleRequest
 */
export interface CordeCommonModelsDtoTeamGrantTeamRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamGrantTeamRoleRequest
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamGrantTeamRoleRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsConstantsRequesterType}
     * @memberof CordeCommonModelsDtoTeamGrantTeamRoleRequest
     */
    'requester_type'?: CordeCommonModelsConstantsRequesterType;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamGrantTeamRoleRequest
     */
    'role_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamGrantTeamRoleRequest
     */
    'team_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamUserIdentity}
     * @memberof CordeCommonModelsDtoTeamGrantTeamRoleRequest
     */
    'user'?: CordeCommonModelsDtoTeamTeamUserIdentity;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamInviteUserToTeamRequest
 */
export interface CordeCommonModelsDtoTeamInviteUserToTeamRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamInviteUserToTeamRequest
     */
    'expiration_time'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamInviteUserToTeamRequest
     */
    'id'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamUserIdentity}
     * @memberof CordeCommonModelsDtoTeamInviteUserToTeamRequest
     */
    'invitee'?: CordeCommonModelsDtoTeamTeamUserIdentity;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamUserIdentity}
     * @memberof CordeCommonModelsDtoTeamInviteUserToTeamRequest
     */
    'inviter'?: CordeCommonModelsDtoTeamTeamUserIdentity;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamInviteUserToTeamRequest
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamInviteUserToTeamRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsConstantsRequesterType}
     * @memberof CordeCommonModelsDtoTeamInviteUserToTeamRequest
     */
    'requester_type'?: CordeCommonModelsConstantsRequesterType;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamInviteUserToTeamRequest
     */
    'role'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamInviteUserToTeamRequest
     */
    'team_id'?: string;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamListPermissionsResponse
 */
export interface CordeCommonModelsDtoTeamListPermissionsResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoTeamListPermissionsResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoTeamListPermissionsResponse
     */
    'permissions'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamListRolesResponse
 */
export interface CordeCommonModelsDtoTeamListRolesResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoTeamListRolesResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamRoles}
     * @memberof CordeCommonModelsDtoTeamListRolesResponse
     */
    'roles'?: CordeCommonModelsDtoTeamRoles;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamListTeamAvatarsResponse
 */
export interface CordeCommonModelsDtoTeamListTeamAvatarsResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamAvatars}
     * @memberof CordeCommonModelsDtoTeamListTeamAvatarsResponse
     */
    'avatars'?: CordeCommonModelsDtoTeamTeamAvatars;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoTeamListTeamAvatarsResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamListTeamInvitationsResponse
 */
export interface CordeCommonModelsDtoTeamListTeamInvitationsResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoTeamTeamInvitation>}
     * @memberof CordeCommonModelsDtoTeamListTeamInvitationsResponse
     */
    'invitations'?: Array<CordeCommonModelsDtoTeamTeamInvitation>;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoTeamListTeamInvitationsResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamListTeamInvitationsResponse
     */
    'userprofile_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamListTeamMembershipRequestsResponse
 */
export interface CordeCommonModelsDtoTeamListTeamMembershipRequestsResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoTeamListTeamMembershipRequestsResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoTeamTeamMembershipRequest>}
     * @memberof CordeCommonModelsDtoTeamListTeamMembershipRequestsResponse
     */
    'requests'?: Array<CordeCommonModelsDtoTeamTeamMembershipRequest>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamListTeamOwnershipRequestsResponse
 */
export interface CordeCommonModelsDtoTeamListTeamOwnershipRequestsResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoTeamListTeamOwnershipRequestsResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoTeamTeamOwnershipRequest>}
     * @memberof CordeCommonModelsDtoTeamListTeamOwnershipRequestsResponse
     */
    'requests'?: Array<CordeCommonModelsDtoTeamTeamOwnershipRequest>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamListTeamsResponse
 */
export interface CordeCommonModelsDtoTeamListTeamsResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoTeamListTeamsResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoTeamTeam>}
     * @memberof CordeCommonModelsDtoTeamListTeamsResponse
     */
    'teams'?: Array<CordeCommonModelsDtoTeamTeam>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamListUsersByRoleResponse
 */
export interface CordeCommonModelsDtoTeamListUsersByRoleResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoTeamListUsersByRoleResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamUsers}
     * @memberof CordeCommonModelsDtoTeamListUsersByRoleResponse
     */
    'users'?: CordeCommonModelsDtoTeamTeamUsers;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamListUsersInTeamResponse
 */
export interface CordeCommonModelsDtoTeamListUsersInTeamResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoTeamListUsersInTeamResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoTeamTeamUserWithMembership>}
     * @memberof CordeCommonModelsDtoTeamListUsersInTeamResponse
     */
    'users'?: Array<CordeCommonModelsDtoTeamTeamUserWithMembership>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamPushNotificationSettings
 */
export interface CordeCommonModelsDtoTeamPushNotificationSettings {
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoTeamPushNotificationSettings
     */
    'badge_enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamPushNotificationSettings
     */
    'default_sound'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoTeamPushNotificationSettings
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoTeamPushNotificationSettings
     */
    'sound_enabled'?: boolean;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamRequestTeamMembershipRequest
 */
export interface CordeCommonModelsDtoTeamRequestTeamMembershipRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamRequestTeamMembershipRequest
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamRequestTeamMembershipRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsConstantsRequesterType}
     * @memberof CordeCommonModelsDtoTeamRequestTeamMembershipRequest
     */
    'requester_type'?: CordeCommonModelsConstantsRequesterType;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamRequestTeamMembershipRequest
     */
    'role_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamRequestTeamMembershipRequest
     */
    'team_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamUserIdentity}
     * @memberof CordeCommonModelsDtoTeamRequestTeamMembershipRequest
     */
    'user'?: CordeCommonModelsDtoTeamTeamUserIdentity;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamRequestTeamMembershipRequest
     */
    'userprofile_id'?: string;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamRequestTeamOwnershipRequest
 */
export interface CordeCommonModelsDtoTeamRequestTeamOwnershipRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamRequestTeamOwnershipRequest
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamRequestTeamOwnershipRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsConstantsRequesterType}
     * @memberof CordeCommonModelsDtoTeamRequestTeamOwnershipRequest
     */
    'requester_type'?: CordeCommonModelsConstantsRequesterType;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamRequestTeamOwnershipRequest
     */
    'team_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamUserIdentity}
     * @memberof CordeCommonModelsDtoTeamRequestTeamOwnershipRequest
     */
    'user'?: CordeCommonModelsDtoTeamTeamUserIdentity;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamRequestTeamRoleRequest
 */
export interface CordeCommonModelsDtoTeamRequestTeamRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamRequestTeamRoleRequest
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamRequestTeamRoleRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsConstantsRequesterType}
     * @memberof CordeCommonModelsDtoTeamRequestTeamRoleRequest
     */
    'requester_type'?: CordeCommonModelsConstantsRequesterType;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamRequestTeamRoleRequest
     */
    'role_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamRequestTeamRoleRequest
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamRequestTeamRoleRequest
     */
    'team_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamUserIdentity}
     * @memberof CordeCommonModelsDtoTeamRequestTeamRoleRequest
     */
    'user'?: CordeCommonModelsDtoTeamTeamUserIdentity;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamRequestTeamRoleRequest
     */
    'valid_from'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamRequestTeamRoleRequest
     */
    'valid_to'?: string;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamRevokeTeamOwnershipRequest
 */
export interface CordeCommonModelsDtoTeamRevokeTeamOwnershipRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamRevokeTeamOwnershipRequest
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamRevokeTeamOwnershipRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsConstantsRequesterType}
     * @memberof CordeCommonModelsDtoTeamRevokeTeamOwnershipRequest
     */
    'requester_type'?: CordeCommonModelsConstantsRequesterType;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamRevokeTeamOwnershipRequest
     */
    'team_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamUserIdentity}
     * @memberof CordeCommonModelsDtoTeamRevokeTeamOwnershipRequest
     */
    'user'?: CordeCommonModelsDtoTeamTeamUserIdentity;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamRole
 */
export interface CordeCommonModelsDtoTeamRole {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamRole
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamRole
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamRole
     */
    'id'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoTeamRole
     */
    'metadata'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamRole
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoTeamRole
     */
    'permissions'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamRole
     */
    'team_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamRole
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamRoleNotificationRule
 */
export interface CordeCommonModelsDtoTeamRoleNotificationRule {
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoTeamRoleNotificationRule
     */
    'channels'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoTeamRoleNotificationRule
     */
    'is_mandatory'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoTeamRoleNotificationRule
     */
    'notification_types'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamRoleNotificationRule
     */
    'role_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamRoleNotificationRule
     */
    'role_name'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamRoles
 */
export interface CordeCommonModelsDtoTeamRoles {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoTeamRole>}
     * @memberof CordeCommonModelsDtoTeamRoles
     */
    'roles'?: Array<CordeCommonModelsDtoTeamRole>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamSMSNotificationSettings
 */
export interface CordeCommonModelsDtoTeamSMSNotificationSettings {
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoTeamSMSNotificationSettings
     */
    'emergency_only'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoTeamSMSNotificationSettings
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamSMSNotificationSettings
     */
    'sender_name'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamSearchTeamsRequest
 */
export interface CordeCommonModelsDtoTeamSearchTeamsRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedRequest}
     * @memberof CordeCommonModelsDtoTeamSearchTeamsRequest
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedRequest;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamSearchTeamsRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsConstantsRequesterType}
     * @memberof CordeCommonModelsDtoTeamSearchTeamsRequest
     */
    'requester_type'?: CordeCommonModelsConstantsRequesterType;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeam}
     * @memberof CordeCommonModelsDtoTeamSearchTeamsRequest
     */
    'team'?: CordeCommonModelsDtoTeamTeam;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamSetActiveTeamAvatarRequest
 */
export interface CordeCommonModelsDtoTeamSetActiveTeamAvatarRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamSetActiveTeamAvatarRequest
     */
    'avatar_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamSetActiveTeamAvatarRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsConstantsRequesterType}
     * @memberof CordeCommonModelsDtoTeamSetActiveTeamAvatarRequest
     */
    'requester_type'?: CordeCommonModelsConstantsRequesterType;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamSetActiveTeamAvatarRequest
     */
    'team_id'?: string;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamTeam
 */
export interface CordeCommonModelsDtoTeamTeam {
    /**
     * 
     * @type {CordeCommonModelsDtoContactContacts}
     * @memberof CordeCommonModelsDtoTeamTeam
     */
    'contacts'?: CordeCommonModelsDtoContactContacts;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeam
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeam
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeam
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeam
     */
    'id'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoTeamTeam
     */
    'metadata'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeam
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeam
     */
    'parent_team_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeam
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeam
     */
    'team_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeam
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamTeamAction
 */
export interface CordeCommonModelsDtoTeamTeamAction {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamAction
     */
    'action'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamAction
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamAction
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamAction
     */
    'translation'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamTeamAuditLog
 */
export interface CordeCommonModelsDtoTeamTeamAuditLog {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamAuditLog
     */
    'action'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamAuditLog
     */
    'entity_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamAuditLog
     */
    'entity_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamAuditLog
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamAuditLog
     */
    'new_value'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamAuditLog
     */
    'old_value'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamAuditLog
     */
    'timestamp'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamUserIdentity}
     * @memberof CordeCommonModelsDtoTeamTeamAuditLog
     */
    'user'?: CordeCommonModelsDtoTeamTeamUserIdentity;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamTeamAvatar
 */
export interface CordeCommonModelsDtoTeamTeamAvatar {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamAvatar
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamAvatar
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamAvatar
     */
    'file_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamAvatar
     */
    'file_path'?: string;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoTeamTeamAvatar
     */
    'file_size'?: number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamAvatar
     */
    'file_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamAvatar
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoTeamTeamAvatar
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamAvatar
     */
    'platform_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamAvatar
     */
    'storage_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamAvatar
     */
    'team_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamAvatar
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamAvatar
     */
    'uploaded_by_profile_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamAvatar
     */
    'uploaded_by_user_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamAvatar
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamTeamAvatars
 */
export interface CordeCommonModelsDtoTeamTeamAvatars {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoTeamTeamAvatar>}
     * @memberof CordeCommonModelsDtoTeamTeamAvatars
     */
    'avatars'?: Array<CordeCommonModelsDtoTeamTeamAvatar>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamTeamBanner
 */
export interface CordeCommonModelsDtoTeamTeamBanner {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamBanner
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamBanner
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamBanner
     */
    'file_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamBanner
     */
    'file_path'?: string;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoTeamTeamBanner
     */
    'file_size'?: number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamBanner
     */
    'file_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamBanner
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamBanner
     */
    'platform_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamBanner
     */
    'storage_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamBanner
     */
    'team_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamBanner
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamBanner
     */
    'uploaded_by_profile_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamBanner
     */
    'uploaded_by_user_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamBanner
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamTeamCategory
 */
export interface CordeCommonModelsDtoTeamTeamCategory {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamCategory
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamCategory
     */
    'translation'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamTeamInvitation
 */
export interface CordeCommonModelsDtoTeamTeamInvitation {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamInvitation
     */
    'expires_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamInvitation
     */
    'id'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamUserIdentity}
     * @memberof CordeCommonModelsDtoTeamTeamInvitation
     */
    'invitee'?: CordeCommonModelsDtoTeamTeamUserIdentity;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamUserIdentity}
     * @memberof CordeCommonModelsDtoTeamTeamInvitation
     */
    'inviter'?: CordeCommonModelsDtoTeamTeamUserIdentity;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamInvitation
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamInvitation
     */
    'responded_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamInvitation
     */
    'role'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamInvitation
     */
    'sent_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamInvitation
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamInvitation
     */
    'team_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamInvitation
     */
    'team_name'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamTeamLogEntry
 */
export interface CordeCommonModelsDtoTeamTeamLogEntry {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamLogEntry
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamLogEntry
     */
    'details'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamLogEntry
     */
    'event_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamLogEntry
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamLogEntry
     */
    'team_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamUserIdentity}
     * @memberof CordeCommonModelsDtoTeamTeamLogEntry
     */
    'user'?: CordeCommonModelsDtoTeamTeamUserIdentity;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamTeamMembershipRequest
 */
export interface CordeCommonModelsDtoTeamTeamMembershipRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamMembershipRequest
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamMembershipRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamMembershipRequest
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamMembershipRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsConstantsRequesterType}
     * @memberof CordeCommonModelsDtoTeamTeamMembershipRequest
     */
    'requester_type'?: CordeCommonModelsConstantsRequesterType;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamMembershipRequest
     */
    'responded_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamMembershipRequest
     */
    'role_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamMembershipRequest
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamMembershipRequest
     */
    'team_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamMembershipRequest
     */
    'updated_at'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamUserIdentity}
     * @memberof CordeCommonModelsDtoTeamTeamMembershipRequest
     */
    'user'?: CordeCommonModelsDtoTeamTeamUserIdentity;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamTeamNotificationSettings
 */
export interface CordeCommonModelsDtoTeamTeamNotificationSettings {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamNotificationSettings
     */
    'created_at'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamEmailNotificationSettings}
     * @memberof CordeCommonModelsDtoTeamTeamNotificationSettings
     */
    'email_settings'?: CordeCommonModelsDtoTeamEmailNotificationSettings;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoTeamEventNotificationSetting>}
     * @memberof CordeCommonModelsDtoTeamTeamNotificationSettings
     */
    'event_settings'?: Array<CordeCommonModelsDtoTeamEventNotificationSetting>;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamNotificationSettings
     */
    'id'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoTeamTeamNotificationSettings
     */
    'notification_channels'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoTeamTeamNotificationSettings
     */
    'notifications_enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamNotificationSettings
     */
    'platform_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamPushNotificationSettings}
     * @memberof CordeCommonModelsDtoTeamTeamNotificationSettings
     */
    'push_settings'?: CordeCommonModelsDtoTeamPushNotificationSettings;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoTeamRoleNotificationRule>}
     * @memberof CordeCommonModelsDtoTeamTeamNotificationSettings
     */
    'role_rules'?: Array<CordeCommonModelsDtoTeamRoleNotificationRule>;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamSMSNotificationSettings}
     * @memberof CordeCommonModelsDtoTeamTeamNotificationSettings
     */
    'sms_settings'?: CordeCommonModelsDtoTeamSMSNotificationSettings;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamNotificationSettings
     */
    'team_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamNotificationSettings
     */
    'updated_at'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamWebhookNotificationSettings}
     * @memberof CordeCommonModelsDtoTeamTeamNotificationSettings
     */
    'webhook_settings'?: CordeCommonModelsDtoTeamWebhookNotificationSettings;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamTeamOwnershipRequest
 */
export interface CordeCommonModelsDtoTeamTeamOwnershipRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamOwnershipRequest
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamOwnershipRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamOwnershipRequest
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamOwnershipRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsConstantsRequesterType}
     * @memberof CordeCommonModelsDtoTeamTeamOwnershipRequest
     */
    'requester_type'?: CordeCommonModelsConstantsRequesterType;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamOwnershipRequest
     */
    'responded_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamOwnershipRequest
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamOwnershipRequest
     */
    'team_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamOwnershipRequest
     */
    'updated_at'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamUser}
     * @memberof CordeCommonModelsDtoTeamTeamOwnershipRequest
     */
    'user'?: CordeCommonModelsDtoTeamTeamUser;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamTeamRoleRequest
 */
export interface CordeCommonModelsDtoTeamTeamRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamRoleRequest
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamRoleRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamRoleRequest
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamRoleRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsConstantsRequesterType}
     * @memberof CordeCommonModelsDtoTeamTeamRoleRequest
     */
    'requester_type'?: CordeCommonModelsConstantsRequesterType;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamRoleRequest
     */
    'responded_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamRoleRequest
     */
    'role_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamRoleRequest
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamRoleRequest
     */
    'team_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamRoleRequest
     */
    'updated_at'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamUser}
     * @memberof CordeCommonModelsDtoTeamTeamRoleRequest
     */
    'user'?: CordeCommonModelsDtoTeamTeamUser;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamTeamSecuritySettings
 */
export interface CordeCommonModelsDtoTeamTeamSecuritySettings {
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoTeamTeamSecuritySettings
     */
    'allow_role_requests'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoTeamTeamSecuritySettings
     */
    'allow_self_join'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoTeamTeamSecuritySettings
     */
    'allowed_ip_ranges'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoTeamTeamSecuritySettings
     */
    'auto_delete_inactive_users'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamSecuritySettings
     */
    'created_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoTeamTeamSecuritySettings
     */
    'data_retention_days'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoTeamTeamSecuritySettings
     */
    'enable_audit_logging'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoTeamTeamSecuritySettings
     */
    'enable_concurrent_sessions'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoTeamTeamSecuritySettings
     */
    'enable_ip_restrictions'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamSecuritySettings
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoTeamTeamSecuritySettings
     */
    'inactive_user_days'?: number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoTeamTeamSecuritySettings
     */
    'max_concurrent_sessions'?: number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoTeamTeamSecuritySettings
     */
    'max_members'?: number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoTeamTeamSecuritySettings
     */
    'password_min_length'?: number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamSecuritySettings
     */
    'platform_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoTeamTeamSecuritySettings
     */
    'require_2fa_for_admins'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoTeamTeamSecuritySettings
     */
    'require_admin_approval'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoTeamTeamSecuritySettings
     */
    'require_invitation'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoTeamTeamSecuritySettings
     */
    'require_role_approval'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoTeamTeamSecuritySettings
     */
    'restricted_roles'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoTeamTeamSecuritySettings
     */
    'session_timeout_minutes'?: number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamSecuritySettings
     */
    'team_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamSecuritySettings
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamTeamUISettings
 */
export interface CordeCommonModelsDtoTeamTeamUISettings {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUISettings
     */
    'banner_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUISettings
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUISettings
     */
    'date_format'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUISettings
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUISettings
     */
    'language'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUISettings
     */
    'logo_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUISettings
     */
    'platform_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUISettings
     */
    'sidebar_layout'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUISettings
     */
    'team_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUISettings
     */
    'time_format'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUISettings
     */
    'timezone'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUISettings
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamTeamUser
 */
export interface CordeCommonModelsDtoTeamTeamUser {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUser
     */
    'avatar_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUser
     */
    'display_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUser
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUser
     */
    'first_name'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamUserIdentity}
     * @memberof CordeCommonModelsDtoTeamTeamUser
     */
    'identity'?: CordeCommonModelsDtoTeamTeamUserIdentity;
    /**
     * Является ли пользователь администратором команды
     * @type {boolean}
     * @memberof CordeCommonModelsDtoTeamTeamUser
     */
    'is_team_admin'?: boolean;
    /**
     * Является ли пользователь владельцем команды
     * @type {boolean}
     * @memberof CordeCommonModelsDtoTeamTeamUser
     */
    'is_team_owner'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUser
     */
    'joined_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUser
     */
    'last_active_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUser
     */
    'last_name'?: string;
    /**
     * Тип членства (прямой участник, приглашенный и т.д.)
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUser
     */
    'membership_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUser
     */
    'status'?: string;
    /**
     * Роли пользователя в команде
     * @type {CordeCommonModelsDtoTeamRoles}
     * @memberof CordeCommonModelsDtoTeamTeamUser
     */
    'team_roles'?: CordeCommonModelsDtoTeamRoles;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUser
     */
    'username'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamTeamUserIdentity
 */
export interface CordeCommonModelsDtoTeamTeamUserIdentity {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUserIdentity
     */
    'profile_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUserIdentity
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamTeamUserSettings
 */
export interface CordeCommonModelsDtoTeamTeamUserSettings {
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoTeamTeamUserSettings
     */
    'allow_member_invitations'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoTeamTeamUserSettings
     */
    'auto_approve_members'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUserSettings
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUserSettings
     */
    'default_role_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUserSettings
     */
    'default_role_name'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoTeamTeamUserSettings
     */
    'enable_exit_interviews'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUserSettings
     */
    'id'?: string;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoTeamTeamUserSettings
     */
    'invitation_expiry_days'?: number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoTeamTeamUserSettings
     */
    'max_invitations_per_user'?: number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUserSettings
     */
    'platform_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoTeamTeamUserSettings
     */
    'require_email_verification'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoTeamTeamUserSettings
     */
    'required_fields'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUserSettings
     */
    'team_id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoTeamTeamUserSettings
     */
    'transfer_ownership_on_leave'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUserSettings
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUserSettings
     */
    'welcome_message'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamTeamUserWithMembership
 */
export interface CordeCommonModelsDtoTeamTeamUserWithMembership {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUserWithMembership
     */
    'expires_at'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamUser}
     * @memberof CordeCommonModelsDtoTeamTeamUserWithMembership
     */
    'invited_by'?: CordeCommonModelsDtoTeamTeamUser;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUserWithMembership
     */
    'joined_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUserWithMembership
     */
    'last_active_at'?: string;
    /**
     * direct, invited, temporary
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUserWithMembership
     */
    'membership_type'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoTeamTeamUserWithMembership
     */
    'metadata'?: { [key: string]: string; };
    /**
     * Основная роль в команде
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUserWithMembership
     */
    'role'?: string;
    /**
     * Все роли в команде
     * @type {CordeCommonModelsDtoTeamRoles}
     * @memberof CordeCommonModelsDtoTeamTeamUserWithMembership
     */
    'roles'?: CordeCommonModelsDtoTeamRoles;
    /**
     * active, inactive, suspended
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUserWithMembership
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTeamUserWithMembership
     */
    'team_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamUser}
     * @memberof CordeCommonModelsDtoTeamTeamUserWithMembership
     */
    'user'?: CordeCommonModelsDtoTeamTeamUser;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamTeamUsers
 */
export interface CordeCommonModelsDtoTeamTeamUsers {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoTeamTeamUser>}
     * @memberof CordeCommonModelsDtoTeamTeamUsers
     */
    'users'?: Array<CordeCommonModelsDtoTeamTeamUser>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamTransferTeamOwnershipRequest
 */
export interface CordeCommonModelsDtoTeamTransferTeamOwnershipRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTransferTeamOwnershipRequest
     */
    'new_owner_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTransferTeamOwnershipRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsConstantsRequesterType}
     * @memberof CordeCommonModelsDtoTeamTransferTeamOwnershipRequest
     */
    'requester_type'?: CordeCommonModelsConstantsRequesterType;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamTransferTeamOwnershipRequest
     */
    'team_id'?: string;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamUpdateRoleRequest
 */
export interface CordeCommonModelsDtoTeamUpdateRoleRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamUpdateRoleRequest
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamUpdateRoleRequest
     */
    'name'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoTeamUpdateRoleRequest
     */
    'permissions'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamUpdateRoleRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsConstantsRequesterType}
     * @memberof CordeCommonModelsDtoTeamUpdateRoleRequest
     */
    'requester_type'?: CordeCommonModelsConstantsRequesterType;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamUpdateRoleRequest
     */
    'role_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamUpdateRoleRequest
     */
    'team_id'?: string;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamUpdateTeamRequest
 */
export interface CordeCommonModelsDtoTeamUpdateTeamRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamUpdateTeamRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsConstantsRequesterType}
     * @memberof CordeCommonModelsDtoTeamUpdateTeamRequest
     */
    'requester_type'?: CordeCommonModelsConstantsRequesterType;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeam}
     * @memberof CordeCommonModelsDtoTeamUpdateTeamRequest
     */
    'team'?: CordeCommonModelsDtoTeamTeam;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamUpdateTeamSecuritySettingsRequest
 */
export interface CordeCommonModelsDtoTeamUpdateTeamSecuritySettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamUpdateTeamSecuritySettingsRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsConstantsRequesterType}
     * @memberof CordeCommonModelsDtoTeamUpdateTeamSecuritySettingsRequest
     */
    'requester_type'?: CordeCommonModelsConstantsRequesterType;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamSecuritySettings}
     * @memberof CordeCommonModelsDtoTeamUpdateTeamSecuritySettingsRequest
     */
    'settings'?: CordeCommonModelsDtoTeamTeamSecuritySettings;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamUpdateTeamUISettingsRequest
 */
export interface CordeCommonModelsDtoTeamUpdateTeamUISettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamUpdateTeamUISettingsRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsConstantsRequesterType}
     * @memberof CordeCommonModelsDtoTeamUpdateTeamUISettingsRequest
     */
    'requester_type'?: CordeCommonModelsConstantsRequesterType;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamUISettings}
     * @memberof CordeCommonModelsDtoTeamUpdateTeamUISettingsRequest
     */
    'settings'?: CordeCommonModelsDtoTeamTeamUISettings;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamUpdateTeamUserSettingsRequest
 */
export interface CordeCommonModelsDtoTeamUpdateTeamUserSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamUpdateTeamUserSettingsRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsConstantsRequesterType}
     * @memberof CordeCommonModelsDtoTeamUpdateTeamUserSettingsRequest
     */
    'requester_type'?: CordeCommonModelsConstantsRequesterType;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamUserSettings}
     * @memberof CordeCommonModelsDtoTeamUpdateTeamUserSettingsRequest
     */
    'settings'?: CordeCommonModelsDtoTeamTeamUserSettings;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamUpdateUserRoleInTeamRequest
 */
export interface CordeCommonModelsDtoTeamUpdateUserRoleInTeamRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamUpdateUserRoleInTeamRequest
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamUpdateUserRoleInTeamRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsConstantsRequesterType}
     * @memberof CordeCommonModelsDtoTeamUpdateUserRoleInTeamRequest
     */
    'requester_type'?: CordeCommonModelsConstantsRequesterType;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamUpdateUserRoleInTeamRequest
     */
    'role_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamUpdateUserRoleInTeamRequest
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamUpdateUserRoleInTeamRequest
     */
    'team_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoTeamTeamUserIdentity}
     * @memberof CordeCommonModelsDtoTeamUpdateUserRoleInTeamRequest
     */
    'user'?: CordeCommonModelsDtoTeamTeamUserIdentity;
}


/**
 * 
 * @export
 * @interface CordeCommonModelsDtoTeamWebhookNotificationSettings
 */
export interface CordeCommonModelsDtoTeamWebhookNotificationSettings {
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoTeamWebhookNotificationSettings
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoTeamWebhookNotificationSettings
     */
    'headers'?: { [key: string]: string; };
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoTeamWebhookNotificationSettings
     */
    'retry_attempts'?: number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamWebhookNotificationSettings
     */
    'secret_token'?: string;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoTeamWebhookNotificationSettings
     */
    'timeout_seconds'?: number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoTeamWebhookNotificationSettings
     */
    'webhook_url'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserDisableTwoFactorAuthRequest
 */
export interface CordeCommonModelsDtoUserDisableTwoFactorAuthRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserDisableTwoFactorAuthRequest
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserEnableTwoFactorAuthRequest
 */
export interface CordeCommonModelsDtoUserEnableTwoFactorAuthRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserEnableTwoFactorAuthRequest
     */
    'method'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserEnableTwoFactorAuthRequest
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserGenerateReferralLinkRequest
 */
export interface CordeCommonModelsDtoUserGenerateReferralLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserGenerateReferralLinkRequest
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserGenerateReferralLinkResponse
 */
export interface CordeCommonModelsDtoUserGenerateReferralLinkResponse {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserGenerateReferralLinkResponse
     */
    'referral_link'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserGetInvitedAndReferralUsersResponse
 */
export interface CordeCommonModelsDtoUserGetInvitedAndReferralUsersResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoUserGetInvitedAndReferralUsersResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoUserUser>}
     * @memberof CordeCommonModelsDtoUserGetInvitedAndReferralUsersResponse
     */
    'users'?: Array<CordeCommonModelsDtoUserUser>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserInvalidateTokensRequest
 */
export interface CordeCommonModelsDtoUserInvalidateTokensRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserInvalidateTokensRequest
     */
    'access_token'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserInvalidateTokensRequest
     */
    'refresh_token'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserInviteUserRequest
 */
export interface CordeCommonModelsDtoUserInviteUserRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserInviteUserRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserInviteUserRequest
     */
    'inviter_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserInviteUserRequest
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserInviteUserRequest
     */
    'phone_number'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserListLoginRecordsResponse
 */
export interface CordeCommonModelsDtoUserListLoginRecordsResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoUserLoginRecord>}
     * @memberof CordeCommonModelsDtoUserListLoginRecordsResponse
     */
    'login_records'?: Array<CordeCommonModelsDtoUserLoginRecord>;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoUserListLoginRecordsResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserLoginRecord
 */
export interface CordeCommonModelsDtoUserLoginRecord {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserLoginRecord
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserLoginRecord
     */
    'ip_address'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserLoginRecord
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserLoginRecord
     */
    'user_agent'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserLoginRecord
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserRefreshRequest
 */
export interface CordeCommonModelsDtoUserRefreshRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserRefreshRequest
     */
    'access_token'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserRefreshRequest
     */
    'refresh_token'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserRequestPasswordResetRequest
 */
export interface CordeCommonModelsDtoUserRequestPasswordResetRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserRequestPasswordResetRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserRequestPasswordResetRequest
     */
    'username'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserResendVerificationEmailRequest
 */
export interface CordeCommonModelsDtoUserResendVerificationEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserResendVerificationEmailRequest
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserResetPasswordRequest
 */
export interface CordeCommonModelsDtoUserResetPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserResetPasswordRequest
     */
    'new_password'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserResetPasswordRequest
     */
    'password_confirmation'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserResetPasswordRequest
     */
    'token'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserSendOneTimeCodeRequest
 */
export interface CordeCommonModelsDtoUserSendOneTimeCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserSendOneTimeCodeRequest
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserSendVerificationEmailRequest
 */
export interface CordeCommonModelsDtoUserSendVerificationEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserSendVerificationEmailRequest
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserSignInRequest
 */
export interface CordeCommonModelsDtoUserSignInRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserSignInRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserSignInRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserSignInRequest
     */
    'two_factor_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserSignInRequest
     */
    'username'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserSignInResponse
 */
export interface CordeCommonModelsDtoUserSignInResponse {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserSignInResponse
     */
    'access_token'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserSignInResponse
     */
    'platform_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserSignInResponse
     */
    'refresh_token'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoUserSignInResponse
     */
    'two_factor_required'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserSignInResponse
     */
    'user_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserSignInResponse
     */
    'userprofile_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserSignInWithCodeRequest
 */
export interface CordeCommonModelsDtoUserSignInWithCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserSignInWithCodeRequest
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserSignInWithCodeRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserSignInWithCodeRequest
     */
    'username'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserSignUpRequest
 */
export interface CordeCommonModelsDtoUserSignUpRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserSignUpRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserSignUpRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserSignUpRequest
     */
    'password_confirmation': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserSignUpRequest
     */
    'referral_code'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserSignUpRequest
     */
    'username': string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserUpdatePasswordRequest
 */
export interface CordeCommonModelsDtoUserUpdatePasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserUpdatePasswordRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserUpdatePasswordRequest
     */
    'new_password'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserUpdatePasswordRequest
     */
    'old_password'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserUpdatePasswordRequest
     */
    'password_confirmation'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserUpdateUserRequest
 */
export interface CordeCommonModelsDtoUserUpdateUserRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserUpdateUserRequest
     */
    'email'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoUserUpdateUserRequest
     */
    'email_verified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserUpdateUserRequest
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserUpdateUserRequest
     */
    'phone'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoUserUpdateUserRequest
     */
    'phone_verified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserUpdateUserRequest
     */
    'status'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoUserUpdateUserRequest
     */
    'two_factor_enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserUpdateUserRequest
     */
    'username'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserUser
 */
export interface CordeCommonModelsDtoUserUser {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserUser
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserUser
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserUser
     */
    'email'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoUserUser
     */
    'email_verified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserUser
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserUser
     */
    'last_seen_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserUser
     */
    'phone'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoUserUser
     */
    'phone_verified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserUser
     */
    'status'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoUserUser
     */
    'two_factor_enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserUser
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserUser
     */
    'username'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserUserListResponse
 */
export interface CordeCommonModelsDtoUserUserListResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoUserUserListResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoUserUser>}
     * @memberof CordeCommonModelsDtoUserUserListResponse
     */
    'users'?: Array<CordeCommonModelsDtoUserUser>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserVerifyActionWithPasswordRequest
 */
export interface CordeCommonModelsDtoUserVerifyActionWithPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserVerifyActionWithPasswordRequest
     */
    'action'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserVerifyActionWithPasswordRequest
     */
    'password'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserVerifyActionWithPasswordRequest
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofileActionNotification
 */
export interface CordeCommonModelsDtoUserprofileActionNotification {
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoUserprofileActionNotification
     */
    'action'?: number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileActionNotification
     */
    'channel'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileActionNotification
     */
    'created_at'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoUserprofileActionNotification
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileActionNotification
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileActionNotification
     */
    'platform_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileActionNotification
     */
    'settings_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileActionNotification
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofileAdminBanProfileRequest
 */
export interface CordeCommonModelsDtoUserprofileAdminBanProfileRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileAdminBanProfileRequest
     */
    'admin_comment'?: string;
    /**
     * Optional: Ban expiration time (permanent if not set)
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileAdminBanProfileRequest
     */
    'ban_until'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileAdminBanProfileRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileAdminBanProfileRequest
     */
    'reason'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofileAdminGetProfileBanHistoryResponse
 */
export interface CordeCommonModelsDtoUserprofileAdminGetProfileBanHistoryResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoUserprofileProfileBanRecord>}
     * @memberof CordeCommonModelsDtoUserprofileAdminGetProfileBanHistoryResponse
     */
    'ban_records'?: Array<CordeCommonModelsDtoUserprofileProfileBanRecord>;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoUserprofileAdminGetProfileBanHistoryResponse
     */
    'pagination_response'?: CordeCommonModelsDtoPaginationPaginatedResponse;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofileAdminGetProfileDetailsResponse
 */
export interface CordeCommonModelsDtoUserprofileAdminGetProfileDetailsResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoUserprofileUserProfile}
     * @memberof CordeCommonModelsDtoUserprofileAdminGetProfileDetailsResponse
     */
    'profile'?: CordeCommonModelsDtoUserprofileUserProfile;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofileAdminListProfilesResponse
 */
export interface CordeCommonModelsDtoUserprofileAdminListProfilesResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoUserprofileAdminListProfilesResponse
     */
    'pagination_response'?: CordeCommonModelsDtoPaginationPaginatedResponse;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoUserprofileUserProfile>}
     * @memberof CordeCommonModelsDtoUserprofileAdminListProfilesResponse
     */
    'profiles'?: Array<CordeCommonModelsDtoUserprofileUserProfile>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofileAdminUnbanProfileRequest
 */
export interface CordeCommonModelsDtoUserprofileAdminUnbanProfileRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileAdminUnbanProfileRequest
     */
    'admin_comment'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileAdminUnbanProfileRequest
     */
    'profile_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofileAuditLog
 */
export interface CordeCommonModelsDtoUserprofileAuditLog {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileAuditLog
     */
    'action'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileAuditLog
     */
    'entity_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileAuditLog
     */
    'entity_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileAuditLog
     */
    'id'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoUserprofileAuditLog
     */
    'metadata'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileAuditLog
     */
    'new_value'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileAuditLog
     */
    'old_value'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileAuditLog
     */
    'platform_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileAuditLog
     */
    'timestamp'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileAuditLog
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofileAvatar
 */
export interface CordeCommonModelsDtoUserprofileAvatar {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileAvatar
     */
    'avatar_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileAvatar
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileAvatar
     */
    'deleted_at'?: string;
    /**
     * Original file name
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileAvatar
     */
    'file_name'?: string;
    /**
     * Size of the file in bytes
     * @type {number}
     * @memberof CordeCommonModelsDtoUserprofileAvatar
     */
    'file_size'?: number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileAvatar
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoUserprofileAvatar
     */
    'is_active'?: boolean;
    /**
     * MIME type of the file
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileAvatar
     */
    'mime_type'?: string;
    /**
     * ID of the owner of the file
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileAvatar
     */
    'owner_id'?: string;
    /**
     * Type of the owner (e.g., \"user\", \"team\")
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileAvatar
     */
    'owner_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileAvatar
     */
    'platform_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileAvatar
     */
    'profile_id'?: string;
    /**
     * Location where the file is stored
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileAvatar
     */
    'storage_location'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileAvatar
     */
    'updated_at'?: string;
    /**
     * ID of the user who uploaded the file
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileAvatar
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofileCreateUserProfileRequest
 */
export interface CordeCommonModelsDtoUserprofileCreateUserProfileRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoUserprofileUserProfile}
     * @memberof CordeCommonModelsDtoUserprofileCreateUserProfileRequest
     */
    'profile'?: CordeCommonModelsDtoUserprofileUserProfile;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofileGetActiveUserProfileResponse
 */
export interface CordeCommonModelsDtoUserprofileGetActiveUserProfileResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoUserprofileUserProfile}
     * @memberof CordeCommonModelsDtoUserprofileGetActiveUserProfileResponse
     */
    'profile'?: CordeCommonModelsDtoUserprofileUserProfile;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofileGetAuditLogsResponse
 */
export interface CordeCommonModelsDtoUserprofileGetAuditLogsResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoUserprofileAuditLog>}
     * @memberof CordeCommonModelsDtoUserprofileGetAuditLogsResponse
     */
    'logs'?: Array<CordeCommonModelsDtoUserprofileAuditLog>;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoUserprofileGetAuditLogsResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofileGetPrivacySettingsResponse
 */
export interface CordeCommonModelsDtoUserprofileGetPrivacySettingsResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoUserprofilePrivacySettings}
     * @memberof CordeCommonModelsDtoUserprofileGetPrivacySettingsResponse
     */
    'settings'?: CordeCommonModelsDtoUserprofilePrivacySettings;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofileGetProfileChangeHistoryResponse
 */
export interface CordeCommonModelsDtoUserprofileGetProfileChangeHistoryResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoUserprofileProfileChange>}
     * @memberof CordeCommonModelsDtoUserprofileGetProfileChangeHistoryResponse
     */
    'changes'?: Array<CordeCommonModelsDtoUserprofileProfileChange>;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoUserprofileGetProfileChangeHistoryResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofileGetUISettingsResponse
 */
export interface CordeCommonModelsDtoUserprofileGetUISettingsResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoUserprofileUISettings}
     * @memberof CordeCommonModelsDtoUserprofileGetUISettingsResponse
     */
    'settings'?: CordeCommonModelsDtoUserprofileUISettings;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofileGetUserAvatarResponse
 */
export interface CordeCommonModelsDtoUserprofileGetUserAvatarResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoUserprofileAvatar}
     * @memberof CordeCommonModelsDtoUserprofileGetUserAvatarResponse
     */
    'avatar'?: CordeCommonModelsDtoUserprofileAvatar;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofileGetUserProfilesForServiceResponse
 */
export interface CordeCommonModelsDtoUserprofileGetUserProfilesForServiceResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoUserprofileUserProfile>}
     * @memberof CordeCommonModelsDtoUserprofileGetUserProfilesForServiceResponse
     */
    'profiles'?: Array<CordeCommonModelsDtoUserprofileUserProfile>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofileListUserAvatarsResponse
 */
export interface CordeCommonModelsDtoUserprofileListUserAvatarsResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoUserprofileAvatar>}
     * @memberof CordeCommonModelsDtoUserprofileListUserAvatarsResponse
     */
    'avatars'?: Array<CordeCommonModelsDtoUserprofileAvatar>;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoUserprofileListUserAvatarsResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofileListUserProfilesResponse
 */
export interface CordeCommonModelsDtoUserprofileListUserProfilesResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoUserprofileListUserProfilesResponse
     */
    'pagination'?: CordeCommonModelsDtoPaginationPaginatedResponse;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoUserprofileUserProfile>}
     * @memberof CordeCommonModelsDtoUserprofileListUserProfilesResponse
     */
    'profiles'?: Array<CordeCommonModelsDtoUserprofileUserProfile>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofileNotificationSettings
 */
export interface CordeCommonModelsDtoUserprofileNotificationSettings {
    /**
     * 
     * @type {{ [key: string]: CordeCommonModelsDtoUserprofileActionNotification; }}
     * @memberof CordeCommonModelsDtoUserprofileNotificationSettings
     */
    'action_notification'?: { [key: string]: CordeCommonModelsDtoUserprofileActionNotification; };
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileNotificationSettings
     */
    'created_at'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoUserprofileNotificationSettings
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileNotificationSettings
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileNotificationSettings
     */
    'platform_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileNotificationSettings
     */
    'profile_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileNotificationSettings
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofilePrivacySettings
 */
export interface CordeCommonModelsDtoUserprofilePrivacySettings {
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoUserprofilePrivacySettings
     */
    'custom_settings'?: { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoUserprofilePrivacySettings
     */
    'is_profile_public'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoUserprofilePrivacySettings
     */
    'show_email'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoUserprofilePrivacySettings
     */
    'show_location'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoUserprofilePrivacySettings
     */
    'show_phone'?: boolean;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofileProfileBanRecord
 */
export interface CordeCommonModelsDtoUserprofileProfileBanRecord {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileProfileBanRecord
     */
    'admin_comment'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileProfileBanRecord
     */
    'ban_until'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileProfileBanRecord
     */
    'banned_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileProfileBanRecord
     */
    'banned_by_admin_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileProfileBanRecord
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoUserprofileProfileBanRecord
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileProfileBanRecord
     */
    'platform_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileProfileBanRecord
     */
    'profile_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileProfileBanRecord
     */
    'reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileProfileBanRecord
     */
    'unban_comment'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileProfileBanRecord
     */
    'unbanned_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileProfileBanRecord
     */
    'unbanned_by_admin_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofileProfileChange
 */
export interface CordeCommonModelsDtoUserprofileProfileChange {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileProfileChange
     */
    'changed_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileProfileChange
     */
    'changed_by'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileProfileChange
     */
    'field_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileProfileChange
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileProfileChange
     */
    'new_value'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileProfileChange
     */
    'old_value'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileProfileChange
     */
    'platform_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileProfileChange
     */
    'profile_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofileSetActiveUserProfileRequest
 */
export interface CordeCommonModelsDtoUserprofileSetActiveUserProfileRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileSetActiveUserProfileRequest
     */
    'profile_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofileSetDefaultUserProfileRequest
 */
export interface CordeCommonModelsDtoUserprofileSetDefaultUserProfileRequest {
    /**
     * Optional: Entity ID for scoped default
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileSetDefaultUserProfileRequest
     */
    'entity_id'?: string;
    /**
     * Optional: Entity type (e.g., \"team\", \"project\")
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileSetDefaultUserProfileRequest
     */
    'entity_type'?: string;
    /**
     * Required: platform id
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileSetDefaultUserProfileRequest
     */
    'platform_id'?: string;
    /**
     * Required: Profile ID to set as default
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileSetDefaultUserProfileRequest
     */
    'profile_id'?: string;
    /**
     * Required: User ID for whom to set default profile
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileSetDefaultUserProfileRequest
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofileUISettings
 */
export interface CordeCommonModelsDtoUserprofileUISettings {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileUISettings
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileUISettings
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileUISettings
     */
    'platform_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileUISettings
     */
    'profile_id'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoUserprofileUISettings
     */
    'settings'?: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileUISettings
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofileUpdatePrivacySettingsRequest
 */
export interface CordeCommonModelsDtoUserprofileUpdatePrivacySettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileUpdatePrivacySettingsRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoUserprofilePrivacySettings}
     * @memberof CordeCommonModelsDtoUserprofileUpdatePrivacySettingsRequest
     */
    'settings'?: CordeCommonModelsDtoUserprofilePrivacySettings;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofileUpdateUISettingsRequest
 */
export interface CordeCommonModelsDtoUserprofileUpdateUISettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileUpdateUISettingsRequest
     */
    'profile_id'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CordeCommonModelsDtoUserprofileUpdateUISettingsRequest
     */
    'settings'?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofileUpdateUserProfileRequest
 */
export interface CordeCommonModelsDtoUserprofileUpdateUserProfileRequest {
    /**
     * 
     * @type {CordeCommonModelsDtoUserprofileUserProfile}
     * @memberof CordeCommonModelsDtoUserprofileUpdateUserProfileRequest
     */
    'profile'?: CordeCommonModelsDtoUserprofileUserProfile;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofileUserProfile
 */
export interface CordeCommonModelsDtoUserprofileUserProfile {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileUserProfile
     */
    'active_avatar_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileUserProfile
     */
    'ban_comment'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileUserProfile
     */
    'ban_reason'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileUserProfile
     */
    'ban_until'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileUserProfile
     */
    'banned_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileUserProfile
     */
    'bio'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoContactContacts}
     * @memberof CordeCommonModelsDtoUserprofileUserProfile
     */
    'contacts'?: CordeCommonModelsDtoContactContacts;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileUserProfile
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileUserProfile
     */
    'date_of_birth'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileUserProfile
     */
    'display_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileUserProfile
     */
    'first_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileUserProfile
     */
    'gender'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileUserProfile
     */
    'id'?: string;
    /**
     * Ban status fields
     * @type {boolean}
     * @memberof CordeCommonModelsDtoUserprofileUserProfile
     */
    'is_banned'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoUserprofileUserProfile
     */
    'is_default'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileUserProfile
     */
    'language'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileUserProfile
     */
    'last_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileUserProfile
     */
    'location'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileUserProfile
     */
    'middle_name'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoUserprofileNotificationSettings}
     * @memberof CordeCommonModelsDtoUserprofileUserProfile
     */
    'notification_settings'?: CordeCommonModelsDtoUserprofileNotificationSettings;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileUserProfile
     */
    'platform_id'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoUserprofilePrivacySettings}
     * @memberof CordeCommonModelsDtoUserprofileUserProfile
     */
    'privacy_settings'?: CordeCommonModelsDtoUserprofilePrivacySettings;
    /**
     * 
     * @type {CordeCommonModelsDtoResourceResources}
     * @memberof CordeCommonModelsDtoUserprofileUserProfile
     */
    'resources'?: CordeCommonModelsDtoResourceResources;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileUserProfile
     */
    'timezone'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoUserprofileUISettings}
     * @memberof CordeCommonModelsDtoUserprofileUserProfile
     */
    'ui_settings'?: CordeCommonModelsDtoUserprofileUISettings;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileUserProfile
     */
    'updated_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoUserprofileUserProfile
     */
    'user_id'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoUserprofileUserProfileResponse
 */
export interface CordeCommonModelsDtoUserprofileUserProfileResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoUserprofileUserProfile}
     * @memberof CordeCommonModelsDtoUserprofileUserProfileResponse
     */
    'profile'?: CordeCommonModelsDtoUserprofileUserProfile;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceAcceptInviteRequest
 */
export interface CordeCommonModelsDtoVoiceAcceptInviteRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceAcceptInviteRequest
     */
    'invite_code': string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceAcceptInviteResponse
 */
export interface CordeCommonModelsDtoVoiceAcceptInviteResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoVoiceVoiceGroupMember}
     * @memberof CordeCommonModelsDtoVoiceAcceptInviteResponse
     */
    'member': CordeCommonModelsDtoVoiceVoiceGroupMember;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceAcceptInviteResponse
     */
    'voice_group_id': string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceAcceptOwnershipTransferRequest
 */
export interface CordeCommonModelsDtoVoiceAcceptOwnershipTransferRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceAcceptOwnershipTransferRequest
     */
    'transfer_id': string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceAddMemberRequest
 */
export interface CordeCommonModelsDtoVoiceAddMemberRequest {
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoVoiceAddMemberRequest
     */
    'role': number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceAddMemberRequest
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceAddMemberRequest
     */
    'userprofile_id': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceAddMemberRequest
     */
    'voice_group_id': string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceAddMemberResponse
 */
export interface CordeCommonModelsDtoVoiceAddMemberResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoVoiceVoiceGroupMember}
     * @memberof CordeCommonModelsDtoVoiceAddMemberResponse
     */
    'member': CordeCommonModelsDtoVoiceVoiceGroupMember;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceCancelOwnershipTransferRequest
 */
export interface CordeCommonModelsDtoVoiceCancelOwnershipTransferRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceCancelOwnershipTransferRequest
     */
    'reason': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceCancelOwnershipTransferRequest
     */
    'transfer_id': string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceCreateInviteRequest
 */
export interface CordeCommonModelsDtoVoiceCreateInviteRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceCreateInviteRequest
     */
    'expires_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceCreateInviteRequest
     */
    'invited_user_id': string;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoVoiceCreateInviteRequest
     */
    'max_uses': number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceCreateInviteRequest
     */
    'voice_group_id': string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceCreateInviteResponse
 */
export interface CordeCommonModelsDtoVoiceCreateInviteResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoVoiceVoiceGroupInvite}
     * @memberof CordeCommonModelsDtoVoiceCreateInviteResponse
     */
    'invite': CordeCommonModelsDtoVoiceVoiceGroupInvite;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceCreateInviteResponse
     */
    'invite_url': string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceCreateRoomRequest
 */
export interface CordeCommonModelsDtoVoiceCreateRoomRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceCreateRoomRequest
     */
    'default_group_name': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceCreateRoomRequest
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceCreateRoomRequest
     */
    'name': string;
    /**
     * 
     * @type {CordeCommonModelsDtoVoiceRoomSettings}
     * @memberof CordeCommonModelsDtoVoiceCreateRoomRequest
     */
    'settings': CordeCommonModelsDtoVoiceRoomSettings;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceCreateRoomRequest
     */
    'team_id': string;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoVoiceCreateRoomRequest
     */
    'type': number;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceCreateRoomResponse
 */
export interface CordeCommonModelsDtoVoiceCreateRoomResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoVoiceVoiceRoom}
     * @memberof CordeCommonModelsDtoVoiceCreateRoomResponse
     */
    'room': CordeCommonModelsDtoVoiceVoiceRoom;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceCreateVoiceGroupRequest
 */
export interface CordeCommonModelsDtoVoiceCreateVoiceGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceCreateVoiceGroupRequest
     */
    'description': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoVoiceCreateVoiceGroupRequest
     */
    'initial_member_ids'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoVoiceCreateVoiceGroupRequest
     */
    'is_private': boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceCreateVoiceGroupRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceCreateVoiceGroupRequest
     */
    'room_id': string;
    /**
     * 
     * @type {CordeCommonModelsDtoVoiceVoiceGroupSettings}
     * @memberof CordeCommonModelsDtoVoiceCreateVoiceGroupRequest
     */
    'settings': CordeCommonModelsDtoVoiceVoiceGroupSettings;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoVoiceCreateVoiceGroupRequest
     */
    'type': number;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceCreateVoiceGroupResponse
 */
export interface CordeCommonModelsDtoVoiceCreateVoiceGroupResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoVoiceVoiceGroup}
     * @memberof CordeCommonModelsDtoVoiceCreateVoiceGroupResponse
     */
    'voice_group': CordeCommonModelsDtoVoiceVoiceGroup;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceDeclineInviteRequest
 */
export interface CordeCommonModelsDtoVoiceDeclineInviteRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceDeclineInviteRequest
     */
    'invite_code': string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceDeclineOwnershipTransferRequest
 */
export interface CordeCommonModelsDtoVoiceDeclineOwnershipTransferRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceDeclineOwnershipTransferRequest
     */
    'reason': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceDeclineOwnershipTransferRequest
     */
    'transfer_id': string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceDefaultGroupSettings
 */
export interface CordeCommonModelsDtoVoiceDefaultGroupSettings {
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoVoiceDefaultGroupSettings
     */
    'allow_guest': boolean;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoVoiceDefaultGroupSettings
     */
    'audio_quality': number;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoVoiceDefaultGroupSettings
     */
    'is_public': boolean;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoVoiceDefaultGroupSettings
     */
    'max_members': number;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceGetGroupMoveHistoryResponse
 */
export interface CordeCommonModelsDtoVoiceGetGroupMoveHistoryResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoVoiceGroupMoveHistory>}
     * @memberof CordeCommonModelsDtoVoiceGetGroupMoveHistoryResponse
     */
    'moves'?: Array<CordeCommonModelsDtoVoiceGroupMoveHistory>;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoVoiceGetGroupMoveHistoryResponse
     */
    'pagination': CordeCommonModelsDtoPaginationPaginatedResponse;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceGetInviteByCodeResponse
 */
export interface CordeCommonModelsDtoVoiceGetInviteByCodeResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoVoiceVoiceGroupInvite}
     * @memberof CordeCommonModelsDtoVoiceGetInviteByCodeResponse
     */
    'invite': CordeCommonModelsDtoVoiceVoiceGroupInvite;
    /**
     * 
     * @type {CordeCommonModelsDtoVoiceVoiceGroup}
     * @memberof CordeCommonModelsDtoVoiceGetInviteByCodeResponse
     */
    'voice_group': CordeCommonModelsDtoVoiceVoiceGroup;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceGetOwnershipTransferHistoryResponse
 */
export interface CordeCommonModelsDtoVoiceGetOwnershipTransferHistoryResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoVoiceGetOwnershipTransferHistoryResponse
     */
    'pagination': CordeCommonModelsDtoPaginationPaginatedResponse;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoVoiceOwnershipTransfer>}
     * @memberof CordeCommonModelsDtoVoiceGetOwnershipTransferHistoryResponse
     */
    'transfers'?: Array<CordeCommonModelsDtoVoiceOwnershipTransfer>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceGetRoomResponse
 */
export interface CordeCommonModelsDtoVoiceGetRoomResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoVoiceVoiceGroup>}
     * @memberof CordeCommonModelsDtoVoiceGetRoomResponse
     */
    'groups'?: Array<CordeCommonModelsDtoVoiceVoiceGroup>;
    /**
     * 
     * @type {CordeCommonModelsDtoVoiceVoiceRoom}
     * @memberof CordeCommonModelsDtoVoiceGetRoomResponse
     */
    'room': CordeCommonModelsDtoVoiceVoiceRoom;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceGetVoiceGroupResponse
 */
export interface CordeCommonModelsDtoVoiceGetVoiceGroupResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoVoiceVoiceGroup}
     * @memberof CordeCommonModelsDtoVoiceGetVoiceGroupResponse
     */
    'voice_group': CordeCommonModelsDtoVoiceVoiceGroup;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceGroupMoveHistory
 */
export interface CordeCommonModelsDtoVoiceGroupMoveHistory {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceGroupMoveHistory
     */
    'from_room_id': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceGroupMoveHistory
     */
    'group_id': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceGroupMoveHistory
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceGroupMoveHistory
     */
    'moved_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceGroupMoveHistory
     */
    'moved_by': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceGroupMoveHistory
     */
    'reason': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceGroupMoveHistory
     */
    'to_room_id': string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceJoinVoiceGroupRequest
 */
export interface CordeCommonModelsDtoVoiceJoinVoiceGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceJoinVoiceGroupRequest
     */
    'client_type': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceJoinVoiceGroupRequest
     */
    'client_version': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceJoinVoiceGroupRequest
     */
    'join_code': string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoVoiceJoinVoiceGroupRequest
     */
    'keep_existing_connections': boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceJoinVoiceGroupRequest
     */
    'voice_group_id': string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceJoinVoiceGroupResponse
 */
export interface CordeCommonModelsDtoVoiceJoinVoiceGroupResponse {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceJoinVoiceGroupResponse
     */
    'voice_group_id': string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceLeaveVoiceGroupRequest
 */
export interface CordeCommonModelsDtoVoiceLeaveVoiceGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceLeaveVoiceGroupRequest
     */
    'voice_group_id': string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceListInvitesResponse
 */
export interface CordeCommonModelsDtoVoiceListInvitesResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoVoiceVoiceGroupInvite>}
     * @memberof CordeCommonModelsDtoVoiceListInvitesResponse
     */
    'invites'?: Array<CordeCommonModelsDtoVoiceVoiceGroupInvite>;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoVoiceListInvitesResponse
     */
    'pagination': CordeCommonModelsDtoPaginationPaginatedResponse;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceListMembersResponse
 */
export interface CordeCommonModelsDtoVoiceListMembersResponse {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoVoiceVoiceGroupMember>}
     * @memberof CordeCommonModelsDtoVoiceListMembersResponse
     */
    'members'?: Array<CordeCommonModelsDtoVoiceVoiceGroupMember>;
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoVoiceListMembersResponse
     */
    'pagination': CordeCommonModelsDtoPaginationPaginatedResponse;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceListRoomsResponse
 */
export interface CordeCommonModelsDtoVoiceListRoomsResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoVoiceListRoomsResponse
     */
    'pagination': CordeCommonModelsDtoPaginationPaginatedResponse;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoVoiceVoiceRoom>}
     * @memberof CordeCommonModelsDtoVoiceListRoomsResponse
     */
    'rooms'?: Array<CordeCommonModelsDtoVoiceVoiceRoom>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceListVoiceGroupsResponse
 */
export interface CordeCommonModelsDtoVoiceListVoiceGroupsResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoPaginationPaginatedResponse}
     * @memberof CordeCommonModelsDtoVoiceListVoiceGroupsResponse
     */
    'pagination': CordeCommonModelsDtoPaginationPaginatedResponse;
    /**
     * 
     * @type {Array<CordeCommonModelsDtoVoiceVoiceGroup>}
     * @memberof CordeCommonModelsDtoVoiceListVoiceGroupsResponse
     */
    'voice_groups'?: Array<CordeCommonModelsDtoVoiceVoiceGroup>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceMoveGroupToRoomRequest
 */
export interface CordeCommonModelsDtoVoiceMoveGroupToRoomRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceMoveGroupToRoomRequest
     */
    'from_room_id': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceMoveGroupToRoomRequest
     */
    'group_id': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceMoveGroupToRoomRequest
     */
    'reason': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceMoveGroupToRoomRequest
     */
    'to_room_id': string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceMoveGroupToRoomResponse
 */
export interface CordeCommonModelsDtoVoiceMoveGroupToRoomResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoVoiceVoiceGroup}
     * @memberof CordeCommonModelsDtoVoiceMoveGroupToRoomResponse
     */
    'group': CordeCommonModelsDtoVoiceVoiceGroup;
    /**
     * 
     * @type {CordeCommonModelsDtoVoiceGroupMoveHistory}
     * @memberof CordeCommonModelsDtoVoiceMoveGroupToRoomResponse
     */
    'move_history': CordeCommonModelsDtoVoiceGroupMoveHistory;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceOwnershipTransfer
 */
export interface CordeCommonModelsDtoVoiceOwnershipTransfer {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceOwnershipTransfer
     */
    'completed_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceOwnershipTransfer
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceOwnershipTransfer
     */
    'expires_at'?: string;
    /**
     * 
     * @type {CordeCommonModelsDtoEntityEntity}
     * @memberof CordeCommonModelsDtoVoiceOwnershipTransfer
     */
    'from_owner': CordeCommonModelsDtoEntityEntity;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceOwnershipTransfer
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceOwnershipTransfer
     */
    'initiated_by': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceOwnershipTransfer
     */
    'reason': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceOwnershipTransfer
     */
    'resource_id': string;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoVoiceOwnershipTransfer
     */
    'resource_type': number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoVoiceOwnershipTransfer
     */
    'status': number;
    /**
     * 
     * @type {CordeCommonModelsDtoEntityEntity}
     * @memberof CordeCommonModelsDtoVoiceOwnershipTransfer
     */
    'to_owner': CordeCommonModelsDtoEntityEntity;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceRoomSettings
 */
export interface CordeCommonModelsDtoVoiceRoomSettings {
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoVoiceRoomSettings
     */
    'allow_guest_groups': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoVoiceRoomSettings
     */
    'allowed_group_types'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoVoiceRoomSettings
     */
    'auto_archive_days': number;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoVoiceRoomSettings
     */
    'auto_archive_empty_groups': boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceRoomSettings
     */
    'default_group_id': string;
    /**
     * 
     * @type {CordeCommonModelsDtoVoiceDefaultGroupSettings}
     * @memberof CordeCommonModelsDtoVoiceRoomSettings
     */
    'default_group_settings': CordeCommonModelsDtoVoiceDefaultGroupSettings;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoVoiceRoomSettings
     */
    'is_public': boolean;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoVoiceRoomSettings
     */
    'max_created_groups_per_user': number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoVoiceRoomSettings
     */
    'max_groups': number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoVoiceRoomSettings
     */
    'max_owned_groups_per_user': number;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceTransferGroupOwnershipRequest
 */
export interface CordeCommonModelsDtoVoiceTransferGroupOwnershipRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceTransferGroupOwnershipRequest
     */
    'expires_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceTransferGroupOwnershipRequest
     */
    'group_id': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceTransferGroupOwnershipRequest
     */
    'new_owner_entity_id': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceTransferGroupOwnershipRequest
     */
    'new_owner_entity_type': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceTransferGroupOwnershipRequest
     */
    'reason': string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoVoiceTransferGroupOwnershipRequest
     */
    'require_acceptance': boolean;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceTransferGroupOwnershipResponse
 */
export interface CordeCommonModelsDtoVoiceTransferGroupOwnershipResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoVoiceOwnershipTransfer}
     * @memberof CordeCommonModelsDtoVoiceTransferGroupOwnershipResponse
     */
    'transfer': CordeCommonModelsDtoVoiceOwnershipTransfer;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceTransferRoomOwnershipRequest
 */
export interface CordeCommonModelsDtoVoiceTransferRoomOwnershipRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceTransferRoomOwnershipRequest
     */
    'expires_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceTransferRoomOwnershipRequest
     */
    'new_owner_entity_id': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceTransferRoomOwnershipRequest
     */
    'new_owner_entity_type': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceTransferRoomOwnershipRequest
     */
    'reason': string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoVoiceTransferRoomOwnershipRequest
     */
    'require_acceptance': boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceTransferRoomOwnershipRequest
     */
    'room_id': string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceTransferRoomOwnershipResponse
 */
export interface CordeCommonModelsDtoVoiceTransferRoomOwnershipResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoVoiceOwnershipTransfer}
     * @memberof CordeCommonModelsDtoVoiceTransferRoomOwnershipResponse
     */
    'transfer': CordeCommonModelsDtoVoiceOwnershipTransfer;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceUpdateMemberRoleRequest
 */
export interface CordeCommonModelsDtoVoiceUpdateMemberRoleRequest {
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoVoiceUpdateMemberRoleRequest
     */
    'new_role': number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceUpdateMemberRoleRequest
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceUpdateMemberRoleRequest
     */
    'voice_group_id': string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceUpdateRoomRequest
 */
export interface CordeCommonModelsDtoVoiceUpdateRoomRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceUpdateRoomRequest
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceUpdateRoomRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceUpdateRoomRequest
     */
    'room_id': string;
    /**
     * 
     * @type {CordeCommonModelsDtoVoiceRoomSettings}
     * @memberof CordeCommonModelsDtoVoiceUpdateRoomRequest
     */
    'settings': CordeCommonModelsDtoVoiceRoomSettings;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceUpdateRoomResponse
 */
export interface CordeCommonModelsDtoVoiceUpdateRoomResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoVoiceVoiceRoom}
     * @memberof CordeCommonModelsDtoVoiceUpdateRoomResponse
     */
    'room': CordeCommonModelsDtoVoiceVoiceRoom;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceUpdateVoiceGroupRequest
 */
export interface CordeCommonModelsDtoVoiceUpdateVoiceGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceUpdateVoiceGroupRequest
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceUpdateVoiceGroupRequest
     */
    'name': string;
    /**
     * 
     * @type {CordeCommonModelsDtoVoiceVoiceGroupSettings}
     * @memberof CordeCommonModelsDtoVoiceUpdateVoiceGroupRequest
     */
    'settings': CordeCommonModelsDtoVoiceVoiceGroupSettings;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceUpdateVoiceGroupRequest
     */
    'voice_group_id': string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceUpdateVoiceGroupResponse
 */
export interface CordeCommonModelsDtoVoiceUpdateVoiceGroupResponse {
    /**
     * 
     * @type {CordeCommonModelsDtoVoiceVoiceGroup}
     * @memberof CordeCommonModelsDtoVoiceUpdateVoiceGroupResponse
     */
    'voice_group': CordeCommonModelsDtoVoiceVoiceGroup;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceVoiceGroup
 */
export interface CordeCommonModelsDtoVoiceVoiceGroup {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroup
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroup
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroup
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroup
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroup
     */
    'id': string;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroup
     */
    'is_default': boolean;
    /**
     * 
     * @type {CordeCommonModelsDtoVoiceVoiceGroupMembers}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroup
     */
    'members': CordeCommonModelsDtoVoiceVoiceGroupMembers;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroup
     */
    'name': string;
    /**
     * 
     * @type {CordeCommonModelsDtoEntityEntity}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroup
     */
    'owner': CordeCommonModelsDtoEntityEntity;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroup
     */
    'position': number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroup
     */
    'room_id': string;
    /**
     * 
     * @type {CordeCommonModelsDtoVoiceVoiceGroupSettings}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroup
     */
    'settings': CordeCommonModelsDtoVoiceVoiceGroupSettings;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroup
     */
    'status': number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroup
     */
    'type': number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroup
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceVoiceGroupInvite
 */
export interface CordeCommonModelsDtoVoiceVoiceGroupInvite {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroupInvite
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroupInvite
     */
    'expires_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroupInvite
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroupInvite
     */
    'invite_code': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroupInvite
     */
    'invited_by': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroupInvite
     */
    'invited_user_id': string;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroupInvite
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroupInvite
     */
    'used_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroupInvite
     */
    'voice_group_id': string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceVoiceGroupMember
 */
export interface CordeCommonModelsDtoVoiceVoiceGroupMember {
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroupMember
     */
    'is_deafened': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroupMember
     */
    'is_muted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroupMember
     */
    'is_speaking': boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroupMember
     */
    'joined_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroupMember
     */
    'last_active_at'?: string;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroupMember
     */
    'role': number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroupMember
     */
    'status': number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroupMember
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroupMember
     */
    'userprofile_id': string;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceVoiceGroupMembers
 */
export interface CordeCommonModelsDtoVoiceVoiceGroupMembers {
    /**
     * 
     * @type {Array<CordeCommonModelsDtoVoiceVoiceGroupMember>}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroupMembers
     */
    'members'?: Array<CordeCommonModelsDtoVoiceVoiceGroupMember>;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceVoiceGroupSettings
 */
export interface CordeCommonModelsDtoVoiceVoiceGroupSettings {
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroupSettings
     */
    'allow_guest': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroupSettings
     */
    'allowed_roles'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroupSettings
     */
    'audio_quality': number;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroupSettings
     */
    'is_public': boolean;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroupSettings
     */
    'join_code': string;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroupSettings
     */
    'max_members': number;
    /**
     * 
     * @type {boolean}
     * @memberof CordeCommonModelsDtoVoiceVoiceGroupSettings
     */
    'require_approval': boolean;
}
/**
 * 
 * @export
 * @interface CordeCommonModelsDtoVoiceVoiceRoom
 */
export interface CordeCommonModelsDtoVoiceVoiceRoom {
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceVoiceRoom
     */
    'created_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceVoiceRoom
     */
    'created_by': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceVoiceRoom
     */
    'deleted_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceVoiceRoom
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoVoiceVoiceRoom
     */
    'groups_count': number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceVoiceRoom
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceVoiceRoom
     */
    'name': string;
    /**
     * 
     * @type {CordeCommonModelsDtoEntityEntity}
     * @memberof CordeCommonModelsDtoVoiceVoiceRoom
     */
    'owner': CordeCommonModelsDtoEntityEntity;
    /**
     * 
     * @type {CordeCommonModelsDtoVoiceRoomSettings}
     * @memberof CordeCommonModelsDtoVoiceVoiceRoom
     */
    'settings': CordeCommonModelsDtoVoiceRoomSettings;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoVoiceVoiceRoom
     */
    'status': number;
    /**
     * 
     * @type {number}
     * @memberof CordeCommonModelsDtoVoiceVoiceRoom
     */
    'type': number;
    /**
     * 
     * @type {string}
     * @memberof CordeCommonModelsDtoVoiceVoiceRoom
     */
    'updated_at'?: string;
}

/**
 * AdminApi - axios parameter creator
 * @export
 */
export const AdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves admin audit logs with filtering and pagination
         * @summary Get Admin Audit Logs
         * @param {string} [platformId] Platform ID
         * @param {string} [profileId] Profile ID
         * @param {string} [entityType] Entity Type
         * @param {string} [entityId] Entity ID
         * @param {string} [fromDate] From Date (RFC3339)
         * @param {string} [toDate] To Date (RFC3339)
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAuditLogsGet: async (platformId?: string, profileId?: string, entityType?: string, entityId?: string, fromDate?: string, toDate?: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/audit-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (platformId !== undefined) {
                localVarQueryParameter['platform_id'] = platformId;
            }

            if (profileId !== undefined) {
                localVarQueryParameter['profile_id'] = profileId;
            }

            if (entityType !== undefined) {
                localVarQueryParameter['entity_type'] = entityType;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entity_id'] = entityId;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['from_date'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['to_date'] = toDate;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves global settings for a platform
         * @summary Get Global Settings
         * @param {string} platformId Platform ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminGlobalSettingsGet: async (platformId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformId' is not null or undefined
            assertParamExists('apiV1AdminGlobalSettingsGet', 'platformId', platformId)
            const localVarPath = `/api/v1/admin/global-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (platformId !== undefined) {
                localVarQueryParameter['platform_id'] = platformId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates global settings for a platform
         * @summary Update Global Settings
         * @param {CordeCommonModelsDtoAdminUpdateGlobalSettingsRequest} updateGlobalSettingsRequest Update Global Settings Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminGlobalSettingsPut: async (updateGlobalSettingsRequest: CordeCommonModelsDtoAdminUpdateGlobalSettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateGlobalSettingsRequest' is not null or undefined
            assertParamExists('apiV1AdminGlobalSettingsPut', 'updateGlobalSettingsRequest', updateGlobalSettingsRequest)
            const localVarPath = `/api/v1/admin/global-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGlobalSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revokes a role from a user on a platform
         * @summary Revoke Platform Role
         * @param {CordeCommonModelsDtoAdminRevokePlatformRoleRequest} revokePlatformRoleRequest Revoke Platform Role Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminPlatformRolesDelete: async (revokePlatformRoleRequest: CordeCommonModelsDtoAdminRevokePlatformRoleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'revokePlatformRoleRequest' is not null or undefined
            assertParamExists('apiV1AdminPlatformRolesDelete', 'revokePlatformRoleRequest', revokePlatformRoleRequest)
            const localVarPath = `/api/v1/admin/platform-roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(revokePlatformRoleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a list of platform roles with pagination
         * @summary List Platform Roles
         * @param {string} platformId Platform ID
         * @param {string} [profileId] Profile ID
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminPlatformRolesGet: async (platformId: string, profileId?: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformId' is not null or undefined
            assertParamExists('apiV1AdminPlatformRolesGet', 'platformId', platformId)
            const localVarPath = `/api/v1/admin/platform-roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (platformId !== undefined) {
                localVarQueryParameter['platform_id'] = platformId;
            }

            if (profileId !== undefined) {
                localVarQueryParameter['profile_id'] = profileId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Assigns a role to a user on a platform
         * @summary Assign Platform Role
         * @param {CordeCommonModelsDtoAdminAssignPlatformRoleRequest} assignPlatformRoleRequest Assign Platform Role Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminPlatformRolesPost: async (assignPlatformRoleRequest: CordeCommonModelsDtoAdminAssignPlatformRoleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'assignPlatformRoleRequest' is not null or undefined
            assertParamExists('apiV1AdminPlatformRolesPost', 'assignPlatformRoleRequest', assignPlatformRoleRequest)
            const localVarPath = `/api/v1/admin/platform-roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignPlatformRoleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a list of platforms with pagination
         * @summary List Platforms
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [search] Search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminPlatformsGet: async (limit?: number, offset?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/platforms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a platform from the system
         * @summary Delete Platform
         * @param {string} platformId Platform ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminPlatformsPlatformIdDelete: async (platformId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformId' is not null or undefined
            assertParamExists('apiV1AdminPlatformsPlatformIdDelete', 'platformId', platformId)
            const localVarPath = `/api/v1/admin/platforms/{platform_id}`
                .replace(`{${"platform_id"}}`, encodeURIComponent(String(platformId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves platform information by ID
         * @summary Get Platform
         * @param {string} platformId Platform ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminPlatformsPlatformIdGet: async (platformId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformId' is not null or undefined
            assertParamExists('apiV1AdminPlatformsPlatformIdGet', 'platformId', platformId)
            const localVarPath = `/api/v1/admin/platforms/{platform_id}`
                .replace(`{${"platform_id"}}`, encodeURIComponent(String(platformId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates platform information
         * @summary Update Platform
         * @param {string} platformId Platform ID
         * @param {CordeCommonModelsDtoAdminUpdatePlatformRequest} updatePlatformRequest Update Platform Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminPlatformsPlatformIdPut: async (platformId: string, updatePlatformRequest: CordeCommonModelsDtoAdminUpdatePlatformRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'platformId' is not null or undefined
            assertParamExists('apiV1AdminPlatformsPlatformIdPut', 'platformId', platformId)
            // verify required parameter 'updatePlatformRequest' is not null or undefined
            assertParamExists('apiV1AdminPlatformsPlatformIdPut', 'updatePlatformRequest', updatePlatformRequest)
            const localVarPath = `/api/v1/admin/platforms/{platform_id}`
                .replace(`{${"platform_id"}}`, encodeURIComponent(String(platformId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePlatformRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new platform in the system
         * @summary Create Platform
         * @param {CordeCommonModelsDtoAdminCreatePlatformRequest} createPlatformRequest Create Platform Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminPlatformsPost: async (createPlatformRequest: CordeCommonModelsDtoAdminCreatePlatformRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPlatformRequest' is not null or undefined
            assertParamExists('apiV1AdminPlatformsPost', 'createPlatformRequest', createPlatformRequest)
            const localVarPath = `/api/v1/admin/platforms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPlatformRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminApi - functional programming interface
 * @export
 */
export const AdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves admin audit logs with filtering and pagination
         * @summary Get Admin Audit Logs
         * @param {string} [platformId] Platform ID
         * @param {string} [profileId] Profile ID
         * @param {string} [entityType] Entity Type
         * @param {string} [entityId] Entity ID
         * @param {string} [fromDate] From Date (RFC3339)
         * @param {string} [toDate] To Date (RFC3339)
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminAuditLogsGet(platformId?: string, profileId?: string, entityType?: string, entityId?: string, fromDate?: string, toDate?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoAdminGetAdminAuditLogsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminAuditLogsGet(platformId, profileId, entityType, entityId, fromDate, toDate, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiV1AdminAuditLogsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves global settings for a platform
         * @summary Get Global Settings
         * @param {string} platformId Platform ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminGlobalSettingsGet(platformId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoAdminGetGlobalSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminGlobalSettingsGet(platformId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiV1AdminGlobalSettingsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates global settings for a platform
         * @summary Update Global Settings
         * @param {CordeCommonModelsDtoAdminUpdateGlobalSettingsRequest} updateGlobalSettingsRequest Update Global Settings Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminGlobalSettingsPut(updateGlobalSettingsRequest: CordeCommonModelsDtoAdminUpdateGlobalSettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminGlobalSettingsPut(updateGlobalSettingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiV1AdminGlobalSettingsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Revokes a role from a user on a platform
         * @summary Revoke Platform Role
         * @param {CordeCommonModelsDtoAdminRevokePlatformRoleRequest} revokePlatformRoleRequest Revoke Platform Role Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminPlatformRolesDelete(revokePlatformRoleRequest: CordeCommonModelsDtoAdminRevokePlatformRoleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminPlatformRolesDelete(revokePlatformRoleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiV1AdminPlatformRolesDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a list of platform roles with pagination
         * @summary List Platform Roles
         * @param {string} platformId Platform ID
         * @param {string} [profileId] Profile ID
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminPlatformRolesGet(platformId: string, profileId?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoAdminGetPlatformRolesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminPlatformRolesGet(platformId, profileId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiV1AdminPlatformRolesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Assigns a role to a user on a platform
         * @summary Assign Platform Role
         * @param {CordeCommonModelsDtoAdminAssignPlatformRoleRequest} assignPlatformRoleRequest Assign Platform Role Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminPlatformRolesPost(assignPlatformRoleRequest: CordeCommonModelsDtoAdminAssignPlatformRoleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminPlatformRolesPost(assignPlatformRoleRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiV1AdminPlatformRolesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a list of platforms with pagination
         * @summary List Platforms
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [search] Search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminPlatformsGet(limit?: number, offset?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoAdminGetPlatformsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminPlatformsGet(limit, offset, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiV1AdminPlatformsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a platform from the system
         * @summary Delete Platform
         * @param {string} platformId Platform ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminPlatformsPlatformIdDelete(platformId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminPlatformsPlatformIdDelete(platformId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiV1AdminPlatformsPlatformIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves platform information by ID
         * @summary Get Platform
         * @param {string} platformId Platform ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminPlatformsPlatformIdGet(platformId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoAdminPlatform>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminPlatformsPlatformIdGet(platformId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiV1AdminPlatformsPlatformIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates platform information
         * @summary Update Platform
         * @param {string} platformId Platform ID
         * @param {CordeCommonModelsDtoAdminUpdatePlatformRequest} updatePlatformRequest Update Platform Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminPlatformsPlatformIdPut(platformId: string, updatePlatformRequest: CordeCommonModelsDtoAdminUpdatePlatformRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminPlatformsPlatformIdPut(platformId, updatePlatformRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiV1AdminPlatformsPlatformIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new platform in the system
         * @summary Create Platform
         * @param {CordeCommonModelsDtoAdminCreatePlatformRequest} createPlatformRequest Create Platform Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1AdminPlatformsPost(createPlatformRequest: CordeCommonModelsDtoAdminCreatePlatformRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoAdminPlatform>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1AdminPlatformsPost(createPlatformRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.apiV1AdminPlatformsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminApi - factory interface
 * @export
 */
export const AdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminApiFp(configuration)
    return {
        /**
         * Retrieves admin audit logs with filtering and pagination
         * @summary Get Admin Audit Logs
         * @param {string} [platformId] Platform ID
         * @param {string} [profileId] Profile ID
         * @param {string} [entityType] Entity Type
         * @param {string} [entityId] Entity ID
         * @param {string} [fromDate] From Date (RFC3339)
         * @param {string} [toDate] To Date (RFC3339)
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminAuditLogsGet(platformId?: string, profileId?: string, entityType?: string, entityId?: string, fromDate?: string, toDate?: string, limit?: number, offset?: number, options?: any): AxiosPromise<CordeCommonModelsDtoAdminGetAdminAuditLogsResponse> {
            return localVarFp.apiV1AdminAuditLogsGet(platformId, profileId, entityType, entityId, fromDate, toDate, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves global settings for a platform
         * @summary Get Global Settings
         * @param {string} platformId Platform ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminGlobalSettingsGet(platformId: string, options?: any): AxiosPromise<CordeCommonModelsDtoAdminGetGlobalSettingsResponse> {
            return localVarFp.apiV1AdminGlobalSettingsGet(platformId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates global settings for a platform
         * @summary Update Global Settings
         * @param {CordeCommonModelsDtoAdminUpdateGlobalSettingsRequest} updateGlobalSettingsRequest Update Global Settings Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminGlobalSettingsPut(updateGlobalSettingsRequest: CordeCommonModelsDtoAdminUpdateGlobalSettingsRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.apiV1AdminGlobalSettingsPut(updateGlobalSettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Revokes a role from a user on a platform
         * @summary Revoke Platform Role
         * @param {CordeCommonModelsDtoAdminRevokePlatformRoleRequest} revokePlatformRoleRequest Revoke Platform Role Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminPlatformRolesDelete(revokePlatformRoleRequest: CordeCommonModelsDtoAdminRevokePlatformRoleRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.apiV1AdminPlatformRolesDelete(revokePlatformRoleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of platform roles with pagination
         * @summary List Platform Roles
         * @param {string} platformId Platform ID
         * @param {string} [profileId] Profile ID
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminPlatformRolesGet(platformId: string, profileId?: string, limit?: number, offset?: number, options?: any): AxiosPromise<CordeCommonModelsDtoAdminGetPlatformRolesResponse> {
            return localVarFp.apiV1AdminPlatformRolesGet(platformId, profileId, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Assigns a role to a user on a platform
         * @summary Assign Platform Role
         * @param {CordeCommonModelsDtoAdminAssignPlatformRoleRequest} assignPlatformRoleRequest Assign Platform Role Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminPlatformRolesPost(assignPlatformRoleRequest: CordeCommonModelsDtoAdminAssignPlatformRoleRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.apiV1AdminPlatformRolesPost(assignPlatformRoleRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of platforms with pagination
         * @summary List Platforms
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [search] Search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminPlatformsGet(limit?: number, offset?: number, search?: string, options?: any): AxiosPromise<CordeCommonModelsDtoAdminGetPlatformsResponse> {
            return localVarFp.apiV1AdminPlatformsGet(limit, offset, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a platform from the system
         * @summary Delete Platform
         * @param {string} platformId Platform ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminPlatformsPlatformIdDelete(platformId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.apiV1AdminPlatformsPlatformIdDelete(platformId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves platform information by ID
         * @summary Get Platform
         * @param {string} platformId Platform ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminPlatformsPlatformIdGet(platformId: string, options?: any): AxiosPromise<CordeCommonModelsDtoAdminPlatform> {
            return localVarFp.apiV1AdminPlatformsPlatformIdGet(platformId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates platform information
         * @summary Update Platform
         * @param {string} platformId Platform ID
         * @param {CordeCommonModelsDtoAdminUpdatePlatformRequest} updatePlatformRequest Update Platform Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminPlatformsPlatformIdPut(platformId: string, updatePlatformRequest: CordeCommonModelsDtoAdminUpdatePlatformRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.apiV1AdminPlatformsPlatformIdPut(platformId, updatePlatformRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new platform in the system
         * @summary Create Platform
         * @param {CordeCommonModelsDtoAdminCreatePlatformRequest} createPlatformRequest Create Platform Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AdminPlatformsPost(createPlatformRequest: CordeCommonModelsDtoAdminCreatePlatformRequest, options?: any): AxiosPromise<CordeCommonModelsDtoAdminPlatform> {
            return localVarFp.apiV1AdminPlatformsPost(createPlatformRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
export class AdminApi extends BaseAPI {
    /**
     * Retrieves admin audit logs with filtering and pagination
     * @summary Get Admin Audit Logs
     * @param {string} [platformId] Platform ID
     * @param {string} [profileId] Profile ID
     * @param {string} [entityType] Entity Type
     * @param {string} [entityId] Entity ID
     * @param {string} [fromDate] From Date (RFC3339)
     * @param {string} [toDate] To Date (RFC3339)
     * @param {number} [limit] Limit
     * @param {number} [offset] Offset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public apiV1AdminAuditLogsGet(platformId?: string, profileId?: string, entityType?: string, entityId?: string, fromDate?: string, toDate?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiV1AdminAuditLogsGet(platformId, profileId, entityType, entityId, fromDate, toDate, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves global settings for a platform
     * @summary Get Global Settings
     * @param {string} platformId Platform ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public apiV1AdminGlobalSettingsGet(platformId: string, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiV1AdminGlobalSettingsGet(platformId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates global settings for a platform
     * @summary Update Global Settings
     * @param {CordeCommonModelsDtoAdminUpdateGlobalSettingsRequest} updateGlobalSettingsRequest Update Global Settings Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public apiV1AdminGlobalSettingsPut(updateGlobalSettingsRequest: CordeCommonModelsDtoAdminUpdateGlobalSettingsRequest, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiV1AdminGlobalSettingsPut(updateGlobalSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revokes a role from a user on a platform
     * @summary Revoke Platform Role
     * @param {CordeCommonModelsDtoAdminRevokePlatformRoleRequest} revokePlatformRoleRequest Revoke Platform Role Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public apiV1AdminPlatformRolesDelete(revokePlatformRoleRequest: CordeCommonModelsDtoAdminRevokePlatformRoleRequest, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiV1AdminPlatformRolesDelete(revokePlatformRoleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a list of platform roles with pagination
     * @summary List Platform Roles
     * @param {string} platformId Platform ID
     * @param {string} [profileId] Profile ID
     * @param {number} [limit] Limit
     * @param {number} [offset] Offset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public apiV1AdminPlatformRolesGet(platformId: string, profileId?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiV1AdminPlatformRolesGet(platformId, profileId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Assigns a role to a user on a platform
     * @summary Assign Platform Role
     * @param {CordeCommonModelsDtoAdminAssignPlatformRoleRequest} assignPlatformRoleRequest Assign Platform Role Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public apiV1AdminPlatformRolesPost(assignPlatformRoleRequest: CordeCommonModelsDtoAdminAssignPlatformRoleRequest, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiV1AdminPlatformRolesPost(assignPlatformRoleRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a list of platforms with pagination
     * @summary List Platforms
     * @param {number} [limit] Limit
     * @param {number} [offset] Offset
     * @param {string} [search] Search query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public apiV1AdminPlatformsGet(limit?: number, offset?: number, search?: string, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiV1AdminPlatformsGet(limit, offset, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a platform from the system
     * @summary Delete Platform
     * @param {string} platformId Platform ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public apiV1AdminPlatformsPlatformIdDelete(platformId: string, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiV1AdminPlatformsPlatformIdDelete(platformId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves platform information by ID
     * @summary Get Platform
     * @param {string} platformId Platform ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public apiV1AdminPlatformsPlatformIdGet(platformId: string, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiV1AdminPlatformsPlatformIdGet(platformId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates platform information
     * @summary Update Platform
     * @param {string} platformId Platform ID
     * @param {CordeCommonModelsDtoAdminUpdatePlatformRequest} updatePlatformRequest Update Platform Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public apiV1AdminPlatformsPlatformIdPut(platformId: string, updatePlatformRequest: CordeCommonModelsDtoAdminUpdatePlatformRequest, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiV1AdminPlatformsPlatformIdPut(platformId, updatePlatformRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new platform in the system
     * @summary Create Platform
     * @param {CordeCommonModelsDtoAdminCreatePlatformRequest} createPlatformRequest Create Platform Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public apiV1AdminPlatformsPost(createPlatformRequest: CordeCommonModelsDtoAdminCreatePlatformRequest, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiV1AdminPlatformsPost(createPlatformRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AttachmentsApi - axios parameter creator
 * @export
 */
export const AttachmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete multiple files from S3 by their IDs.
         * @summary Delete multiple files
         * @param {CordeCommonModelsDtoAttachmentBulkDeleteFilesRequest} body List of file IDs to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteFiles: async (body: CordeCommonModelsDtoAttachmentBulkDeleteFilesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('bulkDeleteFiles', 'body', body)
            const localVarPath = `/attachments/bulk-delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete multiple images from S3 by their IDs
         * @summary Delete multiple images
         * @param {CordeCommonModelsDtoAttachmentBulkDeleteFilesRequest} request List of image IDs to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteImages: async (request: CordeCommonModelsDtoAttachmentBulkDeleteFilesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('bulkDeleteImages', 'request', request)
            const localVarPath = `/attachments/images/bulk-delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve metadata for multiple files by their IDs.
         * @summary Retrieve metadata for multiple files
         * @param {CordeCommonModelsDtoAttachmentBulkGetFileMetadataRequest} body List of file IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetFileMetadata: async (body: CordeCommonModelsDtoAttachmentBulkGetFileMetadataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('bulkGetFileMetadata', 'body', body)
            const localVarPath = `/attachments/bulk-metadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download multiple files from S3 and bundle them as a zip archive.
         * @summary Download multiple files as a zip archive
         * @param {CordeCommonModelsDtoAttachmentBulkGetFilesRequest} body List of file IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetFiles: async (body: CordeCommonModelsDtoAttachmentBulkGetFilesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('bulkGetFiles', 'body', body)
            const localVarPath = `/attachments/bulk-get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve metadata for multiple images by their IDs.
         * @summary Retrieve metadata for multiple images
         * @param {CordeCommonModelsDtoAttachmentBulkGetFileMetadataRequest} body List of image IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetImageMetadata: async (body: CordeCommonModelsDtoAttachmentBulkGetFileMetadataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('bulkGetImageMetadata', 'body', body)
            const localVarPath = `/attachments/images/bulk-metadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download multiple image files from S3 and bundle them as a zip archive.
         * @summary Retrieve multiple images as a zip archive
         * @param {CordeCommonModelsDtoAttachmentBulkGetFileMetadataRequest} body List of image IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetImages: async (body: CordeCommonModelsDtoAttachmentBulkGetFileMetadataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('bulkGetImages', 'body', body)
            const localVarPath = `/attachments/images`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Transfer ownership of multiple files to other users
         * @summary Transfer ownership of multiple files
         * @param {CordeCommonModelsDtoAttachmentBulkTransferFileOwnershipRequest} request Bulk transfer ownership details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkTransferFileOwnership: async (request: CordeCommonModelsDtoAttachmentBulkTransferFileOwnershipRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('bulkTransferFileOwnership', 'request', request)
            const localVarPath = `/attachments/bulk-transfer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload multiple files to S3 bucket and store their metadata.
         * @summary Upload multiple files to the server
         * @param {File} files Files to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUploadFiles: async (files: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'files' is not null or undefined
            assertParamExists('bulkUploadFiles', 'files', files)
            const localVarPath = `/attachments/bulk-upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (files !== undefined) { 
                localVarFormParams.append('files', files as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload multiple image files to S3 bucket and store their metadata
         * @summary Upload multiple images
         * @param {File} files Image files to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUploadImages: async (files: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'files' is not null or undefined
            assertParamExists('bulkUploadImages', 'files', files)
            const localVarPath = `/attachments/images/bulk-upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (files !== undefined) { 
                localVarFormParams.append('files', files as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a file from S3 using its ID.
         * @summary Delete a file
         * @param {string} id File ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteFile', 'id', id)
            const localVarPath = `/attachments/file/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an image from S3 by its ID
         * @summary Delete an image
         * @param {string} id Image ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteImage: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteImage', 'id', id)
            const localVarPath = `/attachments/images/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download a file from S3 bucket using its ID.
         * @summary Download a file
         * @param {string} id File ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFile: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFile', 'id', id)
            const localVarPath = `/attachments/file/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve metadata of a file from S3.
         * @summary Get metadata of a file
         * @param {string} id File ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileMetadata: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFileMetadata', 'id', id)
            const localVarPath = `/attachments/metadata/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the ownership transfer history of a file
         * @summary Get file ownership history
         * @param {string} id File ID
         * @param {string} [fromDate] Start date (RFC3339 format)
         * @param {string} [toDate] End date (RFC3339 format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileOwnershipHistory: async (id: string, fromDate?: string, toDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFileOwnershipHistory', 'id', id)
            const localVarPath = `/attachments/ownership-history/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fromDate !== undefined) {
                localVarQueryParameter['from_date'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['to_date'] = toDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve an image file from S3 by its ID.
         * @summary Retrieve an image file
         * @param {string} id File ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImage: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getImage', 'id', id)
            const localVarPath = `/attachments/images/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Transfer ownership of a file to another user
         * @summary Transfer file ownership
         * @param {string} id File ID
         * @param {CordeCommonModelsDtoAttachmentTransferFileOwnershipRequest} request Transfer ownership details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferFileOwnership: async (id: string, request: CordeCommonModelsDtoAttachmentTransferFileOwnershipRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('transferFileOwnership', 'id', id)
            // verify required parameter 'request' is not null or undefined
            assertParamExists('transferFileOwnership', 'request', request)
            const localVarPath = `/attachments/transfer/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload a file to S3 bucket and store its metadata.
         * @summary Upload a file to the server
         * @param {File} file File to upload
         * @param {string} ownerType Type of the resource that owns the file (e.g. user, task, project)
         * @param {string} ownerId ID of the resource that owns the file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile: async (file: File, ownerType: string, ownerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadFile', 'file', file)
            // verify required parameter 'ownerType' is not null or undefined
            assertParamExists('uploadFile', 'ownerType', ownerType)
            // verify required parameter 'ownerId' is not null or undefined
            assertParamExists('uploadFile', 'ownerId', ownerId)
            const localVarPath = `/attachments/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (ownerType !== undefined) { 
                localVarFormParams.append('ownerType', ownerType as any);
            }
    
            if (ownerId !== undefined) { 
                localVarFormParams.append('ownerId', ownerId as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload an image file to S3 bucket and store its metadata
         * @summary Upload an image
         * @param {File} file Image file to upload
         * @param {string} ownerType Type of the resource that owns the file (e.g. user, team)
         * @param {string} ownerId ID of the resource that owns the file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImage: async (file: File, ownerType: string, ownerId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadImage', 'file', file)
            // verify required parameter 'ownerType' is not null or undefined
            assertParamExists('uploadImage', 'ownerType', ownerType)
            // verify required parameter 'ownerId' is not null or undefined
            assertParamExists('uploadImage', 'ownerId', ownerId)
            const localVarPath = `/attachments/images/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (ownerType !== undefined) { 
                localVarFormParams.append('ownerType', ownerType as any);
            }
    
            if (ownerId !== undefined) { 
                localVarFormParams.append('ownerId', ownerId as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AttachmentsApi - functional programming interface
 * @export
 */
export const AttachmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AttachmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete multiple files from S3 by their IDs.
         * @summary Delete multiple files
         * @param {CordeCommonModelsDtoAttachmentBulkDeleteFilesRequest} body List of file IDs to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkDeleteFiles(body: CordeCommonModelsDtoAttachmentBulkDeleteFilesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkDeleteFiles(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttachmentsApi.bulkDeleteFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete multiple images from S3 by their IDs
         * @summary Delete multiple images
         * @param {CordeCommonModelsDtoAttachmentBulkDeleteFilesRequest} request List of image IDs to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkDeleteImages(request: CordeCommonModelsDtoAttachmentBulkDeleteFilesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkDeleteImages(request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttachmentsApi.bulkDeleteImages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve metadata for multiple files by their IDs.
         * @summary Retrieve metadata for multiple files
         * @param {CordeCommonModelsDtoAttachmentBulkGetFileMetadataRequest} body List of file IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetFileMetadata(body: CordeCommonModelsDtoAttachmentBulkGetFileMetadataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoAttachmentBulkFilesMetadataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetFileMetadata(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttachmentsApi.bulkGetFileMetadata']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download multiple files from S3 and bundle them as a zip archive.
         * @summary Download multiple files as a zip archive
         * @param {CordeCommonModelsDtoAttachmentBulkGetFilesRequest} body List of file IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetFiles(body: CordeCommonModelsDtoAttachmentBulkGetFilesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetFiles(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttachmentsApi.bulkGetFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve metadata for multiple images by their IDs.
         * @summary Retrieve metadata for multiple images
         * @param {CordeCommonModelsDtoAttachmentBulkGetFileMetadataRequest} body List of image IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetImageMetadata(body: CordeCommonModelsDtoAttachmentBulkGetFileMetadataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoAttachmentBulkFilesMetadataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetImageMetadata(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttachmentsApi.bulkGetImageMetadata']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download multiple image files from S3 and bundle them as a zip archive.
         * @summary Retrieve multiple images as a zip archive
         * @param {CordeCommonModelsDtoAttachmentBulkGetFileMetadataRequest} body List of image IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkGetImages(body: CordeCommonModelsDtoAttachmentBulkGetFileMetadataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkGetImages(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttachmentsApi.bulkGetImages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Transfer ownership of multiple files to other users
         * @summary Transfer ownership of multiple files
         * @param {CordeCommonModelsDtoAttachmentBulkTransferFileOwnershipRequest} request Bulk transfer ownership details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkTransferFileOwnership(request: CordeCommonModelsDtoAttachmentBulkTransferFileOwnershipRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoAttachmentBulkTransferFileOwnershipResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkTransferFileOwnership(request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttachmentsApi.bulkTransferFileOwnership']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload multiple files to S3 bucket and store their metadata.
         * @summary Upload multiple files to the server
         * @param {File} files Files to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUploadFiles(files: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoAttachmentBulkUploadFilesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUploadFiles(files, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttachmentsApi.bulkUploadFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload multiple image files to S3 bucket and store their metadata
         * @summary Upload multiple images
         * @param {File} files Image files to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUploadImages(files: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoAttachmentBulkUploadFilesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUploadImages(files, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttachmentsApi.bulkUploadImages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a file from S3 using its ID.
         * @summary Delete a file
         * @param {string} id File ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFile(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFile(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttachmentsApi.deleteFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an image from S3 by its ID
         * @summary Delete an image
         * @param {string} id Image ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteImage(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteImage(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttachmentsApi.deleteImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Download a file from S3 bucket using its ID.
         * @summary Download a file
         * @param {string} id File ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFile(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFile(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttachmentsApi.getFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve metadata of a file from S3.
         * @summary Get metadata of a file
         * @param {string} id File ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFileMetadata(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoAttachmentFileMetadata>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFileMetadata(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttachmentsApi.getFileMetadata']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the ownership transfer history of a file
         * @summary Get file ownership history
         * @param {string} id File ID
         * @param {string} [fromDate] Start date (RFC3339 format)
         * @param {string} [toDate] End date (RFC3339 format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFileOwnershipHistory(id: string, fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoAttachmentGetFileOwnershipHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFileOwnershipHistory(id, fromDate, toDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttachmentsApi.getFileOwnershipHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve an image file from S3 by its ID.
         * @summary Retrieve an image file
         * @param {string} id File ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImage(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImage(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttachmentsApi.getImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Transfer ownership of a file to another user
         * @summary Transfer file ownership
         * @param {string} id File ID
         * @param {CordeCommonModelsDtoAttachmentTransferFileOwnershipRequest} request Transfer ownership details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transferFileOwnership(id: string, request: CordeCommonModelsDtoAttachmentTransferFileOwnershipRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoAttachmentFileMetadata>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transferFileOwnership(id, request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttachmentsApi.transferFileOwnership']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload a file to S3 bucket and store its metadata.
         * @summary Upload a file to the server
         * @param {File} file File to upload
         * @param {string} ownerType Type of the resource that owns the file (e.g. user, task, project)
         * @param {string} ownerId ID of the resource that owns the file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadFile(file: File, ownerType: string, ownerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoAttachmentFileMetadata>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadFile(file, ownerType, ownerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttachmentsApi.uploadFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload an image file to S3 bucket and store its metadata
         * @summary Upload an image
         * @param {File} file Image file to upload
         * @param {string} ownerType Type of the resource that owns the file (e.g. user, team)
         * @param {string} ownerId ID of the resource that owns the file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadImage(file: File, ownerType: string, ownerId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoAttachmentFileMetadata>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadImage(file, ownerType, ownerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttachmentsApi.uploadImage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AttachmentsApi - factory interface
 * @export
 */
export const AttachmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AttachmentsApiFp(configuration)
    return {
        /**
         * Delete multiple files from S3 by their IDs.
         * @summary Delete multiple files
         * @param {CordeCommonModelsDtoAttachmentBulkDeleteFilesRequest} body List of file IDs to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteFiles(body: CordeCommonModelsDtoAttachmentBulkDeleteFilesRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.bulkDeleteFiles(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete multiple images from S3 by their IDs
         * @summary Delete multiple images
         * @param {CordeCommonModelsDtoAttachmentBulkDeleteFilesRequest} request List of image IDs to delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkDeleteImages(request: CordeCommonModelsDtoAttachmentBulkDeleteFilesRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.bulkDeleteImages(request, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve metadata for multiple files by their IDs.
         * @summary Retrieve metadata for multiple files
         * @param {CordeCommonModelsDtoAttachmentBulkGetFileMetadataRequest} body List of file IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetFileMetadata(body: CordeCommonModelsDtoAttachmentBulkGetFileMetadataRequest, options?: any): AxiosPromise<CordeCommonModelsDtoAttachmentBulkFilesMetadataResponse> {
            return localVarFp.bulkGetFileMetadata(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Download multiple files from S3 and bundle them as a zip archive.
         * @summary Download multiple files as a zip archive
         * @param {CordeCommonModelsDtoAttachmentBulkGetFilesRequest} body List of file IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetFiles(body: CordeCommonModelsDtoAttachmentBulkGetFilesRequest, options?: any): AxiosPromise<File> {
            return localVarFp.bulkGetFiles(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve metadata for multiple images by their IDs.
         * @summary Retrieve metadata for multiple images
         * @param {CordeCommonModelsDtoAttachmentBulkGetFileMetadataRequest} body List of image IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetImageMetadata(body: CordeCommonModelsDtoAttachmentBulkGetFileMetadataRequest, options?: any): AxiosPromise<CordeCommonModelsDtoAttachmentBulkFilesMetadataResponse> {
            return localVarFp.bulkGetImageMetadata(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Download multiple image files from S3 and bundle them as a zip archive.
         * @summary Retrieve multiple images as a zip archive
         * @param {CordeCommonModelsDtoAttachmentBulkGetFileMetadataRequest} body List of image IDs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkGetImages(body: CordeCommonModelsDtoAttachmentBulkGetFileMetadataRequest, options?: any): AxiosPromise<File> {
            return localVarFp.bulkGetImages(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Transfer ownership of multiple files to other users
         * @summary Transfer ownership of multiple files
         * @param {CordeCommonModelsDtoAttachmentBulkTransferFileOwnershipRequest} request Bulk transfer ownership details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkTransferFileOwnership(request: CordeCommonModelsDtoAttachmentBulkTransferFileOwnershipRequest, options?: any): AxiosPromise<CordeCommonModelsDtoAttachmentBulkTransferFileOwnershipResponse> {
            return localVarFp.bulkTransferFileOwnership(request, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload multiple files to S3 bucket and store their metadata.
         * @summary Upload multiple files to the server
         * @param {File} files Files to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUploadFiles(files: File, options?: any): AxiosPromise<CordeCommonModelsDtoAttachmentBulkUploadFilesResponse> {
            return localVarFp.bulkUploadFiles(files, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload multiple image files to S3 bucket and store their metadata
         * @summary Upload multiple images
         * @param {File} files Image files to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUploadImages(files: File, options?: any): AxiosPromise<CordeCommonModelsDtoAttachmentBulkUploadFilesResponse> {
            return localVarFp.bulkUploadImages(files, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a file from S3 using its ID.
         * @summary Delete a file
         * @param {string} id File ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFile(id: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.deleteFile(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an image from S3 by its ID
         * @summary Delete an image
         * @param {string} id Image ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteImage(id: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.deleteImage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Download a file from S3 bucket using its ID.
         * @summary Download a file
         * @param {string} id File ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFile(id: string, options?: any): AxiosPromise<File> {
            return localVarFp.getFile(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve metadata of a file from S3.
         * @summary Get metadata of a file
         * @param {string} id File ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileMetadata(id: string, options?: any): AxiosPromise<CordeCommonModelsDtoAttachmentFileMetadata> {
            return localVarFp.getFileMetadata(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the ownership transfer history of a file
         * @summary Get file ownership history
         * @param {string} id File ID
         * @param {string} [fromDate] Start date (RFC3339 format)
         * @param {string} [toDate] End date (RFC3339 format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFileOwnershipHistory(id: string, fromDate?: string, toDate?: string, options?: any): AxiosPromise<CordeCommonModelsDtoAttachmentGetFileOwnershipHistoryResponse> {
            return localVarFp.getFileOwnershipHistory(id, fromDate, toDate, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve an image file from S3 by its ID.
         * @summary Retrieve an image file
         * @param {string} id File ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImage(id: string, options?: any): AxiosPromise<File> {
            return localVarFp.getImage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Transfer ownership of a file to another user
         * @summary Transfer file ownership
         * @param {string} id File ID
         * @param {CordeCommonModelsDtoAttachmentTransferFileOwnershipRequest} request Transfer ownership details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferFileOwnership(id: string, request: CordeCommonModelsDtoAttachmentTransferFileOwnershipRequest, options?: any): AxiosPromise<CordeCommonModelsDtoAttachmentFileMetadata> {
            return localVarFp.transferFileOwnership(id, request, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload a file to S3 bucket and store its metadata.
         * @summary Upload a file to the server
         * @param {File} file File to upload
         * @param {string} ownerType Type of the resource that owns the file (e.g. user, task, project)
         * @param {string} ownerId ID of the resource that owns the file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFile(file: File, ownerType: string, ownerId: string, options?: any): AxiosPromise<CordeCommonModelsDtoAttachmentFileMetadata> {
            return localVarFp.uploadFile(file, ownerType, ownerId, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload an image file to S3 bucket and store its metadata
         * @summary Upload an image
         * @param {File} file Image file to upload
         * @param {string} ownerType Type of the resource that owns the file (e.g. user, team)
         * @param {string} ownerId ID of the resource that owns the file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImage(file: File, ownerType: string, ownerId: string, options?: any): AxiosPromise<CordeCommonModelsDtoAttachmentFileMetadata> {
            return localVarFp.uploadImage(file, ownerType, ownerId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AttachmentsApi - object-oriented interface
 * @export
 * @class AttachmentsApi
 * @extends {BaseAPI}
 */
export class AttachmentsApi extends BaseAPI {
    /**
     * Delete multiple files from S3 by their IDs.
     * @summary Delete multiple files
     * @param {CordeCommonModelsDtoAttachmentBulkDeleteFilesRequest} body List of file IDs to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public bulkDeleteFiles(body: CordeCommonModelsDtoAttachmentBulkDeleteFilesRequest, options?: RawAxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).bulkDeleteFiles(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete multiple images from S3 by their IDs
     * @summary Delete multiple images
     * @param {CordeCommonModelsDtoAttachmentBulkDeleteFilesRequest} request List of image IDs to delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public bulkDeleteImages(request: CordeCommonModelsDtoAttachmentBulkDeleteFilesRequest, options?: RawAxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).bulkDeleteImages(request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve metadata for multiple files by their IDs.
     * @summary Retrieve metadata for multiple files
     * @param {CordeCommonModelsDtoAttachmentBulkGetFileMetadataRequest} body List of file IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public bulkGetFileMetadata(body: CordeCommonModelsDtoAttachmentBulkGetFileMetadataRequest, options?: RawAxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).bulkGetFileMetadata(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download multiple files from S3 and bundle them as a zip archive.
     * @summary Download multiple files as a zip archive
     * @param {CordeCommonModelsDtoAttachmentBulkGetFilesRequest} body List of file IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public bulkGetFiles(body: CordeCommonModelsDtoAttachmentBulkGetFilesRequest, options?: RawAxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).bulkGetFiles(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve metadata for multiple images by their IDs.
     * @summary Retrieve metadata for multiple images
     * @param {CordeCommonModelsDtoAttachmentBulkGetFileMetadataRequest} body List of image IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public bulkGetImageMetadata(body: CordeCommonModelsDtoAttachmentBulkGetFileMetadataRequest, options?: RawAxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).bulkGetImageMetadata(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download multiple image files from S3 and bundle them as a zip archive.
     * @summary Retrieve multiple images as a zip archive
     * @param {CordeCommonModelsDtoAttachmentBulkGetFileMetadataRequest} body List of image IDs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public bulkGetImages(body: CordeCommonModelsDtoAttachmentBulkGetFileMetadataRequest, options?: RawAxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).bulkGetImages(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Transfer ownership of multiple files to other users
     * @summary Transfer ownership of multiple files
     * @param {CordeCommonModelsDtoAttachmentBulkTransferFileOwnershipRequest} request Bulk transfer ownership details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public bulkTransferFileOwnership(request: CordeCommonModelsDtoAttachmentBulkTransferFileOwnershipRequest, options?: RawAxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).bulkTransferFileOwnership(request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload multiple files to S3 bucket and store their metadata.
     * @summary Upload multiple files to the server
     * @param {File} files Files to upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public bulkUploadFiles(files: File, options?: RawAxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).bulkUploadFiles(files, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload multiple image files to S3 bucket and store their metadata
     * @summary Upload multiple images
     * @param {File} files Image files to upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public bulkUploadImages(files: File, options?: RawAxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).bulkUploadImages(files, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a file from S3 using its ID.
     * @summary Delete a file
     * @param {string} id File ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public deleteFile(id: string, options?: RawAxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).deleteFile(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an image from S3 by its ID
     * @summary Delete an image
     * @param {string} id Image ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public deleteImage(id: string, options?: RawAxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).deleteImage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download a file from S3 bucket using its ID.
     * @summary Download a file
     * @param {string} id File ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public getFile(id: string, options?: RawAxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).getFile(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve metadata of a file from S3.
     * @summary Get metadata of a file
     * @param {string} id File ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public getFileMetadata(id: string, options?: RawAxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).getFileMetadata(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve the ownership transfer history of a file
     * @summary Get file ownership history
     * @param {string} id File ID
     * @param {string} [fromDate] Start date (RFC3339 format)
     * @param {string} [toDate] End date (RFC3339 format)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public getFileOwnershipHistory(id: string, fromDate?: string, toDate?: string, options?: RawAxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).getFileOwnershipHistory(id, fromDate, toDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve an image file from S3 by its ID.
     * @summary Retrieve an image file
     * @param {string} id File ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public getImage(id: string, options?: RawAxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).getImage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Transfer ownership of a file to another user
     * @summary Transfer file ownership
     * @param {string} id File ID
     * @param {CordeCommonModelsDtoAttachmentTransferFileOwnershipRequest} request Transfer ownership details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public transferFileOwnership(id: string, request: CordeCommonModelsDtoAttachmentTransferFileOwnershipRequest, options?: RawAxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).transferFileOwnership(id, request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload a file to S3 bucket and store its metadata.
     * @summary Upload a file to the server
     * @param {File} file File to upload
     * @param {string} ownerType Type of the resource that owns the file (e.g. user, task, project)
     * @param {string} ownerId ID of the resource that owns the file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public uploadFile(file: File, ownerType: string, ownerId: string, options?: RawAxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).uploadFile(file, ownerType, ownerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload an image file to S3 bucket and store its metadata
     * @summary Upload an image
     * @param {File} file Image file to upload
     * @param {string} ownerType Type of the resource that owns the file (e.g. user, team)
     * @param {string} ownerId ID of the resource that owns the file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentsApi
     */
    public uploadImage(file: File, ownerType: string, ownerId: string, options?: RawAxiosRequestConfig) {
        return AttachmentsApiFp(this.configuration).uploadImage(file, ownerType, ownerId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Generates QR code containing access and refresh tokens
         * @summary Generate QR code with tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTokensQRCode: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/tokens/qr`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends a one-time authentication code to the user\'s email.
         * @summary Send One-Time Code
         * @param {CordeCommonModelsDtoUserSendOneTimeCodeRequest} sendOneTimeCodeRequest Send One-Time Code Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOneTimeCode: async (sendOneTimeCodeRequest: CordeCommonModelsDtoUserSendOneTimeCodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendOneTimeCodeRequest' is not null or undefined
            assertParamExists('sendOneTimeCode', 'sendOneTimeCodeRequest', sendOneTimeCodeRequest)
            const localVarPath = `/auth/send-one-time-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendOneTimeCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authenticates a user using a one-time code sent to their email.
         * @summary Sign In with One-Time Code
         * @param {CordeCommonModelsDtoUserSignInWithCodeRequest} signInWithCodeRequest Sign In with Code Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signInWithCode: async (signInWithCodeRequest: CordeCommonModelsDtoUserSignInWithCodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signInWithCodeRequest' is not null or undefined
            assertParamExists('signInWithCode', 'signInWithCodeRequest', signInWithCodeRequest)
            const localVarPath = `/auth/signin-with-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signInWithCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * Generates QR code containing access and refresh tokens
         * @summary Generate QR code with tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateTokensQRCode(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateTokensQRCode(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.generateTokensQRCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sends a one-time authentication code to the user\'s email.
         * @summary Send One-Time Code
         * @param {CordeCommonModelsDtoUserSendOneTimeCodeRequest} sendOneTimeCodeRequest Send One-Time Code Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendOneTimeCode(sendOneTimeCodeRequest: CordeCommonModelsDtoUserSendOneTimeCodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendOneTimeCode(sendOneTimeCodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.sendOneTimeCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authenticates a user using a one-time code sent to their email.
         * @summary Sign In with One-Time Code
         * @param {CordeCommonModelsDtoUserSignInWithCodeRequest} signInWithCodeRequest Sign In with Code Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signInWithCode(signInWithCodeRequest: CordeCommonModelsDtoUserSignInWithCodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoUserSignInResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signInWithCode(signInWithCodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.signInWithCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * Generates QR code containing access and refresh tokens
         * @summary Generate QR code with tokens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTokensQRCode(options?: any): AxiosPromise<File> {
            return localVarFp.generateTokensQRCode(options).then((request) => request(axios, basePath));
        },
        /**
         * Sends a one-time authentication code to the user\'s email.
         * @summary Send One-Time Code
         * @param {CordeCommonModelsDtoUserSendOneTimeCodeRequest} sendOneTimeCodeRequest Send One-Time Code Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendOneTimeCode(sendOneTimeCodeRequest: CordeCommonModelsDtoUserSendOneTimeCodeRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.sendOneTimeCode(sendOneTimeCodeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Authenticates a user using a one-time code sent to their email.
         * @summary Sign In with One-Time Code
         * @param {CordeCommonModelsDtoUserSignInWithCodeRequest} signInWithCodeRequest Sign In with Code Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signInWithCode(signInWithCodeRequest: CordeCommonModelsDtoUserSignInWithCodeRequest, options?: any): AxiosPromise<CordeCommonModelsDtoUserSignInResponse> {
            return localVarFp.signInWithCode(signInWithCodeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * Generates QR code containing access and refresh tokens
     * @summary Generate QR code with tokens
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public generateTokensQRCode(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).generateTokensQRCode(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends a one-time authentication code to the user\'s email.
     * @summary Send One-Time Code
     * @param {CordeCommonModelsDtoUserSendOneTimeCodeRequest} sendOneTimeCodeRequest Send One-Time Code Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public sendOneTimeCode(sendOneTimeCodeRequest: CordeCommonModelsDtoUserSendOneTimeCodeRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).sendOneTimeCode(sendOneTimeCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Authenticates a user using a one-time code sent to their email.
     * @summary Sign In with One-Time Code
     * @param {CordeCommonModelsDtoUserSignInWithCodeRequest} signInWithCodeRequest Sign In with Code Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public signInWithCode(signInWithCodeRequest: CordeCommonModelsDtoUserSignInWithCodeRequest, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).signInWithCode(signInWithCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthorizationApi - axios parameter creator
 * @export
 */
export const AuthorizationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Check multiple permissions in a single request
         * @summary Check bulk permissions
         * @param {CordeCommonModelsDtoAuthzCheckBulkPermissionsRequest} body Bulk Check Permissions Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkBulkPermissions: async (body: CordeCommonModelsDtoAuthzCheckBulkPermissionsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('checkBulkPermissions', 'body', body)
            const localVarPath = `/authz/check-bulk-permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Check if a user has permission for a specific object
         * @summary Check permission
         * @param {CordeCommonModelsDtoAuthzCheckPermissionRequest} body Check Permission Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPermission: async (body: CordeCommonModelsDtoAuthzCheckPermissionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('checkPermission', 'body', body)
            const localVarPath = `/authz/check-permission`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete relationships between subjects and objects
         * @summary Delete relationships
         * @param {CordeCommonModelsDtoAuthzDeleteRelationshipsRequest} body Delete Relationships Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRelationships: async (body: CordeCommonModelsDtoAuthzDeleteRelationshipsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('deleteRelationships', 'body', body)
            const localVarPath = `/authz/relationships/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the expanded permission tree for a resource
         * @summary Expand permission tree
         * @param {CordeCommonModelsDtoAuthzExpandPermissionTreeRequest} body Expand Permission Tree Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expandPermissionTree: async (body: CordeCommonModelsDtoAuthzExpandPermissionTreeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('expandPermissionTree', 'body', body)
            const localVarPath = `/authz/expand-permission-tree`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find resources where subject has the specified permission
         * @summary Lookup resources
         * @param {CordeCommonModelsDtoAuthzLookupResourcesRequest} body Lookup resources request
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookupResources: async (body: CordeCommonModelsDtoAuthzLookupResourcesRequest, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('lookupResources', 'body', body)
            const localVarPath = `/authz/resources/lookup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Find subjects that have the specified permission on a resource
         * @summary Lookup subjects
         * @param {CordeCommonModelsDtoAuthzLookupSubjectsRequest} body Lookup subjects request
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookupSubjects: async (body: CordeCommonModelsDtoAuthzLookupSubjectsRequest, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('lookupSubjects', 'body', body)
            const localVarPath = `/authz/subjects/lookup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read relationships with optional filtering and pagination
         * @summary Read relationships
         * @param {CordeCommonModelsDtoAuthzReadRelationshipsRequest} body Read relationships request
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readRelationships: async (body: CordeCommonModelsDtoAuthzReadRelationshipsRequest, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('readRelationships', 'body', body)
            const localVarPath = `/authz/relationships/read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read the authorization schema
         * @summary Read schema
         * @param {object} body Read Schema Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readSchema: async (body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('readSchema', 'body', body)
            const localVarPath = `/authz/schema/read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Write relationships between subjects and objects
         * @summary Write relationships
         * @param {CordeCommonModelsDtoAuthzWriteRelationshipsRequest} body Write Relationships Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        writeRelationships: async (body: CordeCommonModelsDtoAuthzWriteRelationshipsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('writeRelationships', 'body', body)
            const localVarPath = `/authz/relationships/write`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Write the authorization schema
         * @summary Write schema
         * @param {CordeCommonModelsDtoAuthzWriteSchemaRequest} body Write Schema Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        writeSchema: async (body: CordeCommonModelsDtoAuthzWriteSchemaRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('writeSchema', 'body', body)
            const localVarPath = `/authz/schema/write`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthorizationApi - functional programming interface
 * @export
 */
export const AuthorizationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthorizationApiAxiosParamCreator(configuration)
    return {
        /**
         * Check multiple permissions in a single request
         * @summary Check bulk permissions
         * @param {CordeCommonModelsDtoAuthzCheckBulkPermissionsRequest} body Bulk Check Permissions Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkBulkPermissions(body: CordeCommonModelsDtoAuthzCheckBulkPermissionsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoAuthzCheckBulkPermissionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkBulkPermissions(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorizationApi.checkBulkPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Check if a user has permission for a specific object
         * @summary Check permission
         * @param {CordeCommonModelsDtoAuthzCheckPermissionRequest} body Check Permission Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkPermission(body: CordeCommonModelsDtoAuthzCheckPermissionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoAuthzCheckPermissionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkPermission(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorizationApi.checkPermission']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete relationships between subjects and objects
         * @summary Delete relationships
         * @param {CordeCommonModelsDtoAuthzDeleteRelationshipsRequest} body Delete Relationships Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRelationships(body: CordeCommonModelsDtoAuthzDeleteRelationshipsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoAuthzDeleteRelationshipsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRelationships(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorizationApi.deleteRelationships']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the expanded permission tree for a resource
         * @summary Expand permission tree
         * @param {CordeCommonModelsDtoAuthzExpandPermissionTreeRequest} body Expand Permission Tree Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async expandPermissionTree(body: CordeCommonModelsDtoAuthzExpandPermissionTreeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoAuthzExpandPermissionTreeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.expandPermissionTree(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorizationApi.expandPermissionTree']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find resources where subject has the specified permission
         * @summary Lookup resources
         * @param {CordeCommonModelsDtoAuthzLookupResourcesRequest} body Lookup resources request
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lookupResources(body: CordeCommonModelsDtoAuthzLookupResourcesRequest, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoAuthzLookupResourcesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lookupResources(body, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorizationApi.lookupResources']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Find subjects that have the specified permission on a resource
         * @summary Lookup subjects
         * @param {CordeCommonModelsDtoAuthzLookupSubjectsRequest} body Lookup subjects request
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lookupSubjects(body: CordeCommonModelsDtoAuthzLookupSubjectsRequest, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoAuthzLookupSubjectsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lookupSubjects(body, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorizationApi.lookupSubjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read relationships with optional filtering and pagination
         * @summary Read relationships
         * @param {CordeCommonModelsDtoAuthzReadRelationshipsRequest} body Read relationships request
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readRelationships(body: CordeCommonModelsDtoAuthzReadRelationshipsRequest, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoAuthzReadRelationshipsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readRelationships(body, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorizationApi.readRelationships']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read the authorization schema
         * @summary Read schema
         * @param {object} body Read Schema Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readSchema(body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoAuthzReadSchemaResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readSchema(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorizationApi.readSchema']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Write relationships between subjects and objects
         * @summary Write relationships
         * @param {CordeCommonModelsDtoAuthzWriteRelationshipsRequest} body Write Relationships Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async writeRelationships(body: CordeCommonModelsDtoAuthzWriteRelationshipsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoAuthzWriteRelationshipsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.writeRelationships(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorizationApi.writeRelationships']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Write the authorization schema
         * @summary Write schema
         * @param {CordeCommonModelsDtoAuthzWriteSchemaRequest} body Write Schema Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async writeSchema(body: CordeCommonModelsDtoAuthzWriteSchemaRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.writeSchema(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthorizationApi.writeSchema']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthorizationApi - factory interface
 * @export
 */
export const AuthorizationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthorizationApiFp(configuration)
    return {
        /**
         * Check multiple permissions in a single request
         * @summary Check bulk permissions
         * @param {CordeCommonModelsDtoAuthzCheckBulkPermissionsRequest} body Bulk Check Permissions Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkBulkPermissions(body: CordeCommonModelsDtoAuthzCheckBulkPermissionsRequest, options?: any): AxiosPromise<CordeCommonModelsDtoAuthzCheckBulkPermissionsResponse> {
            return localVarFp.checkBulkPermissions(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Check if a user has permission for a specific object
         * @summary Check permission
         * @param {CordeCommonModelsDtoAuthzCheckPermissionRequest} body Check Permission Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPermission(body: CordeCommonModelsDtoAuthzCheckPermissionRequest, options?: any): AxiosPromise<CordeCommonModelsDtoAuthzCheckPermissionResponse> {
            return localVarFp.checkPermission(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete relationships between subjects and objects
         * @summary Delete relationships
         * @param {CordeCommonModelsDtoAuthzDeleteRelationshipsRequest} body Delete Relationships Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRelationships(body: CordeCommonModelsDtoAuthzDeleteRelationshipsRequest, options?: any): AxiosPromise<CordeCommonModelsDtoAuthzDeleteRelationshipsResponse> {
            return localVarFp.deleteRelationships(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the expanded permission tree for a resource
         * @summary Expand permission tree
         * @param {CordeCommonModelsDtoAuthzExpandPermissionTreeRequest} body Expand Permission Tree Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expandPermissionTree(body: CordeCommonModelsDtoAuthzExpandPermissionTreeRequest, options?: any): AxiosPromise<CordeCommonModelsDtoAuthzExpandPermissionTreeResponse> {
            return localVarFp.expandPermissionTree(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Find resources where subject has the specified permission
         * @summary Lookup resources
         * @param {CordeCommonModelsDtoAuthzLookupResourcesRequest} body Lookup resources request
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookupResources(body: CordeCommonModelsDtoAuthzLookupResourcesRequest, limit?: number, offset?: number, options?: any): AxiosPromise<CordeCommonModelsDtoAuthzLookupResourcesResponse> {
            return localVarFp.lookupResources(body, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Find subjects that have the specified permission on a resource
         * @summary Lookup subjects
         * @param {CordeCommonModelsDtoAuthzLookupSubjectsRequest} body Lookup subjects request
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookupSubjects(body: CordeCommonModelsDtoAuthzLookupSubjectsRequest, limit?: number, offset?: number, options?: any): AxiosPromise<CordeCommonModelsDtoAuthzLookupSubjectsResponse> {
            return localVarFp.lookupSubjects(body, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Read relationships with optional filtering and pagination
         * @summary Read relationships
         * @param {CordeCommonModelsDtoAuthzReadRelationshipsRequest} body Read relationships request
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readRelationships(body: CordeCommonModelsDtoAuthzReadRelationshipsRequest, limit?: number, offset?: number, options?: any): AxiosPromise<CordeCommonModelsDtoAuthzReadRelationshipsResponse> {
            return localVarFp.readRelationships(body, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Read the authorization schema
         * @summary Read schema
         * @param {object} body Read Schema Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readSchema(body: object, options?: any): AxiosPromise<CordeCommonModelsDtoAuthzReadSchemaResponse> {
            return localVarFp.readSchema(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Write relationships between subjects and objects
         * @summary Write relationships
         * @param {CordeCommonModelsDtoAuthzWriteRelationshipsRequest} body Write Relationships Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        writeRelationships(body: CordeCommonModelsDtoAuthzWriteRelationshipsRequest, options?: any): AxiosPromise<CordeCommonModelsDtoAuthzWriteRelationshipsResponse> {
            return localVarFp.writeRelationships(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Write the authorization schema
         * @summary Write schema
         * @param {CordeCommonModelsDtoAuthzWriteSchemaRequest} body Write Schema Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        writeSchema(body: CordeCommonModelsDtoAuthzWriteSchemaRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.writeSchema(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthorizationApi - object-oriented interface
 * @export
 * @class AuthorizationApi
 * @extends {BaseAPI}
 */
export class AuthorizationApi extends BaseAPI {
    /**
     * Check multiple permissions in a single request
     * @summary Check bulk permissions
     * @param {CordeCommonModelsDtoAuthzCheckBulkPermissionsRequest} body Bulk Check Permissions Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public checkBulkPermissions(body: CordeCommonModelsDtoAuthzCheckBulkPermissionsRequest, options?: RawAxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).checkBulkPermissions(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Check if a user has permission for a specific object
     * @summary Check permission
     * @param {CordeCommonModelsDtoAuthzCheckPermissionRequest} body Check Permission Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public checkPermission(body: CordeCommonModelsDtoAuthzCheckPermissionRequest, options?: RawAxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).checkPermission(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete relationships between subjects and objects
     * @summary Delete relationships
     * @param {CordeCommonModelsDtoAuthzDeleteRelationshipsRequest} body Delete Relationships Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public deleteRelationships(body: CordeCommonModelsDtoAuthzDeleteRelationshipsRequest, options?: RawAxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).deleteRelationships(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the expanded permission tree for a resource
     * @summary Expand permission tree
     * @param {CordeCommonModelsDtoAuthzExpandPermissionTreeRequest} body Expand Permission Tree Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public expandPermissionTree(body: CordeCommonModelsDtoAuthzExpandPermissionTreeRequest, options?: RawAxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).expandPermissionTree(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find resources where subject has the specified permission
     * @summary Lookup resources
     * @param {CordeCommonModelsDtoAuthzLookupResourcesRequest} body Lookup resources request
     * @param {number} [limit] Number of items to return
     * @param {number} [offset] Number of items to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public lookupResources(body: CordeCommonModelsDtoAuthzLookupResourcesRequest, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).lookupResources(body, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Find subjects that have the specified permission on a resource
     * @summary Lookup subjects
     * @param {CordeCommonModelsDtoAuthzLookupSubjectsRequest} body Lookup subjects request
     * @param {number} [limit] Number of items to return
     * @param {number} [offset] Number of items to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public lookupSubjects(body: CordeCommonModelsDtoAuthzLookupSubjectsRequest, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).lookupSubjects(body, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read relationships with optional filtering and pagination
     * @summary Read relationships
     * @param {CordeCommonModelsDtoAuthzReadRelationshipsRequest} body Read relationships request
     * @param {number} [limit] Number of items to return
     * @param {number} [offset] Number of items to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public readRelationships(body: CordeCommonModelsDtoAuthzReadRelationshipsRequest, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).readRelationships(body, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read the authorization schema
     * @summary Read schema
     * @param {object} body Read Schema Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public readSchema(body: object, options?: RawAxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).readSchema(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Write relationships between subjects and objects
     * @summary Write relationships
     * @param {CordeCommonModelsDtoAuthzWriteRelationshipsRequest} body Write Relationships Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public writeRelationships(body: CordeCommonModelsDtoAuthzWriteRelationshipsRequest, options?: RawAxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).writeRelationships(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Write the authorization schema
     * @summary Write schema
     * @param {CordeCommonModelsDtoAuthzWriteSchemaRequest} body Write Schema Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationApi
     */
    public writeSchema(body: CordeCommonModelsDtoAuthzWriteSchemaRequest, options?: RawAxiosRequestConfig) {
        return AuthorizationApiFp(this.configuration).writeSchema(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BalanceApi - axios parameter creator
 * @export
 */
export const BalanceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes a cryptocurrency address
         * @summary Delete a crypto address
         * @param {string} addressId Address ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceCryptoAddressesAddressIdDelete: async (addressId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('balanceCryptoAddressesAddressIdDelete', 'addressId', addressId)
            const localVarPath = `/balance/crypto-addresses/{address_id}`
                .replace(`{${"address_id"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves details for a specific cryptocurrency address
         * @summary Get crypto address details
         * @param {string} addressId Address ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceCryptoAddressesAddressIdGet: async (addressId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('balanceCryptoAddressesAddressIdGet', 'addressId', addressId)
            const localVarPath = `/balance/crypto-addresses/{address_id}`
                .replace(`{${"address_id"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates details for an existing crypto address
         * @summary Update a crypto address
         * @param {string} addressId Address ID
         * @param {CordeCommonModelsDtoBalanceUpdateCryptoAddressRequest} address Crypto address update details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceCryptoAddressesAddressIdPut: async (addressId: string, address: CordeCommonModelsDtoBalanceUpdateCryptoAddressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('balanceCryptoAddressesAddressIdPut', 'addressId', addressId)
            // verify required parameter 'address' is not null or undefined
            assertParamExists('balanceCryptoAddressesAddressIdPut', 'address', address)
            const localVarPath = `/balance/crypto-addresses/{address_id}`
                .replace(`{${"address_id"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(address, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a paginated list of cryptocurrency addresses for a user
         * @summary List crypto addresses
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [currency] Filter by currency
         * @param {string} [network] Filter by network
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceCryptoAddressesGet: async (limit?: number, offset?: number, currency?: string, network?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/balance/crypto-addresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            if (network !== undefined) {
                localVarQueryParameter['network'] = network;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new cryptocurrency address for the user
         * @summary Create a new crypto address
         * @param {CordeCommonModelsDtoBalanceCreateCryptoAddressRequest} address Crypto address details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceCryptoAddressesPost: async (address: CordeCommonModelsDtoBalanceCreateCryptoAddressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'address' is not null or undefined
            assertParamExists('balanceCryptoAddressesPost', 'address', address)
            const localVarPath = `/balance/crypto-addresses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(address, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validates if a cryptocurrency address is valid for the specified currency
         * @summary Validate a crypto address
         * @param {CordeCommonModelsDtoBalanceValidateCryptoAddressRequest} validate Validation details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceCryptoAddressesValidatePost: async (validate: CordeCommonModelsDtoBalanceValidateCryptoAddressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'validate' is not null or undefined
            assertParamExists('balanceCryptoAddressesValidatePost', 'validate', validate)
            const localVarPath = `/balance/crypto-addresses/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns details for a specific currency
         * @summary Get currency details
         * @param {string} code Currency code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceCurrenciesCodeGet: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('balanceCurrenciesCodeGet', 'code', code)
            const localVarPath = `/balance/currencies/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a paginated list of available currencies
         * @summary List currencies
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {boolean} [onlyEnabled] Only enabled currencies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceCurrenciesGet: async (limit?: number, offset?: number, onlyEnabled?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/balance/currencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (onlyEnabled !== undefined) {
                localVarQueryParameter['only_enabled'] = onlyEnabled;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the deposit address for a specific currency
         * @summary Get deposit address
         * @param {string} currency Currency code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceDepositAddressGet: async (currency: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'currency' is not null or undefined
            assertParamExists('balanceDepositAddressGet', 'currency', currency)
            const localVarPath = `/balance/deposit-address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiates a deposit to the user\'s account
         * @summary Create a deposit
         * @param {CordeCommonModelsDtoBalanceCreateDepositRequest} deposit Deposit details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceDepositPost: async (deposit: CordeCommonModelsDtoBalanceCreateDepositRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deposit' is not null or undefined
            assertParamExists('balanceDepositPost', 'deposit', deposit)
            const localVarPath = `/balance/deposit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deposit, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ensures that balances exist for the specified user in the given currencies
         * @summary Ensure balances for user
         * @param {CordeCommonModelsDtoBalanceEnsureBalancesRequest} ensure Ensure balances request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceEnsurePost: async (ensure: CordeCommonModelsDtoBalanceEnsureBalancesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ensure' is not null or undefined
            assertParamExists('balanceEnsurePost', 'ensure', ensure)
            const localVarPath = `/balance/ensure`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ensure, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes an existing bank details record
         * @summary Delete fiat bank details
         * @param {string} detailsId Details ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceFiatDetailsDetailsIdDelete: async (detailsId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'detailsId' is not null or undefined
            assertParamExists('balanceFiatDetailsDetailsIdDelete', 'detailsId', detailsId)
            const localVarPath = `/balance/fiat-details/{details_id}`
                .replace(`{${"details_id"}}`, encodeURIComponent(String(detailsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns details for a specific bank details record
         * @summary Get fiat bank details
         * @param {string} detailsId Details ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceFiatDetailsDetailsIdGet: async (detailsId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'detailsId' is not null or undefined
            assertParamExists('balanceFiatDetailsDetailsIdGet', 'detailsId', detailsId)
            const localVarPath = `/balance/fiat-details/{details_id}`
                .replace(`{${"details_id"}}`, encodeURIComponent(String(detailsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an existing bank details record
         * @summary Update fiat bank details
         * @param {string} detailsId Details ID
         * @param {CordeCommonModelsDtoBalanceUpdateFiatDetailsRequest} details Fiat details to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceFiatDetailsDetailsIdPut: async (detailsId: string, details: CordeCommonModelsDtoBalanceUpdateFiatDetailsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'detailsId' is not null or undefined
            assertParamExists('balanceFiatDetailsDetailsIdPut', 'detailsId', detailsId)
            // verify required parameter 'details' is not null or undefined
            assertParamExists('balanceFiatDetailsDetailsIdPut', 'details', details)
            const localVarPath = `/balance/fiat-details/{details_id}`
                .replace(`{${"details_id"}}`, encodeURIComponent(String(detailsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(details, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a paginated list of bank details records for a user
         * @summary List fiat bank details
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [currency] Filter by currency
         * @param {string} [country] Filter by country
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceFiatDetailsGet: async (limit?: number, offset?: number, currency?: string, country?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/balance/fiat-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new bank details record for withdrawals
         * @summary Create fiat bank details
         * @param {CordeCommonModelsDtoBalanceCreateFiatDetailsRequest} details Fiat details to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceFiatDetailsPost: async (details: CordeCommonModelsDtoBalanceCreateFiatDetailsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'details' is not null or undefined
            assertParamExists('balanceFiatDetailsPost', 'details', details)
            const localVarPath = `/balance/fiat-details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(details, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validates that the provided bank details are valid for the specified currency
         * @summary Validate fiat bank details
         * @param {CordeCommonModelsDtoBalanceValidateFiatDetailsRequest} details Fiat details to validate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceFiatDetailsValidatePost: async (details: CordeCommonModelsDtoBalanceValidateFiatDetailsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'details' is not null or undefined
            assertParamExists('balanceFiatDetailsValidatePost', 'details', details)
            const localVarPath = `/balance/fiat-details/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(details, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the balance for a specific user and currency
         * @summary Get user balance
         * @param {string} currency Currency code
         * @param {string} [userId] User ID (defaults to current user if not specified)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceGet: async (currency: string, userId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'currency' is not null or undefined
            assertParamExists('balanceGet', 'currency', currency)
            const localVarPath = `/balance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a list of balances for a user across all currencies
         * @summary List user balances
         * @param {string} [userId] User ID (defaults to current user if not specified)
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceListGet: async (userId?: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/balance/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancels a reservation, returning funds to the available balance
         * @summary Cancel reserved funds
         * @param {CordeCommonModelsDtoBalanceCancelReserveRequest} cancel Cancel reserve request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceReserveCancelPost: async (cancel: CordeCommonModelsDtoBalanceCancelReserveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cancel' is not null or undefined
            assertParamExists('balanceReserveCancelPost', 'cancel', cancel)
            const localVarPath = `/balance/reserve/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cancel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Commits a reservation, finalizing the transaction
         * @summary Commit reserved funds
         * @param {CordeCommonModelsDtoBalanceCommitReserveRequest} commit Commit reserve request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceReserveCommitPost: async (commit: CordeCommonModelsDtoBalanceCommitReserveRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'commit' is not null or undefined
            assertParamExists('balanceReserveCommitPost', 'commit', commit)
            const localVarPath = `/balance/reserve/commit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commit, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reserves funds from a user\'s balance for a pending transaction
         * @summary Reserve funds
         * @param {CordeCommonModelsDtoBalanceReserveFundsRequest} reserve Reserve funds request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceReservePost: async (reserve: CordeCommonModelsDtoBalanceReserveFundsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reserve' is not null or undefined
            assertParamExists('balanceReservePost', 'reserve', reserve)
            const localVarPath = `/balance/reserve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reserve, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a paginated list of transactions for a user
         * @summary List user transactions
         * @param {string} [userId] User ID (defaults to current user if not specified)
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [type] Transaction type (DEPOSIT, WITHDRAWAL, FEE, ADJUSTMENT)
         * @param {string} [status] Transaction status (PENDING, PROCESSING, COMPLETED, CANCELLED, REJECTED, FAILED)
         * @param {string} [from] Start date (RFC3339 format)
         * @param {string} [to] End date (RFC3339 format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceTransactionsGet: async (userId?: string, limit?: number, offset?: number, type?: string, status?: string, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/balance/transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns details for a specific transaction
         * @summary Get transaction details
         * @param {string} transactionId Transaction ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceTransactionsTransactionIdGet: async (transactionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'transactionId' is not null or undefined
            assertParamExists('balanceTransactionsTransactionIdGet', 'transactionId', transactionId)
            const localVarPath = `/balance/transactions/{transaction_id}`
                .replace(`{${"transaction_id"}}`, encodeURIComponent(String(transactionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiates a withdrawal from the user\'s account
         * @summary Create a withdrawal
         * @param {CordeCommonModelsDtoBalanceCreateWithdrawalRequest} withdrawal Withdrawal details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceWithdrawalPost: async (withdrawal: CordeCommonModelsDtoBalanceCreateWithdrawalRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'withdrawal' is not null or undefined
            assertParamExists('balanceWithdrawalPost', 'withdrawal', withdrawal)
            const localVarPath = `/balance/withdrawal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(withdrawal, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BalanceApi - functional programming interface
 * @export
 */
export const BalanceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BalanceApiAxiosParamCreator(configuration)
    return {
        /**
         * Deletes a cryptocurrency address
         * @summary Delete a crypto address
         * @param {string} addressId Address ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceCryptoAddressesAddressIdDelete(addressId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceCryptoAddressesAddressIdDelete(addressId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceApi.balanceCryptoAddressesAddressIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves details for a specific cryptocurrency address
         * @summary Get crypto address details
         * @param {string} addressId Address ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceCryptoAddressesAddressIdGet(addressId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceCryptoAddress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceCryptoAddressesAddressIdGet(addressId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceApi.balanceCryptoAddressesAddressIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates details for an existing crypto address
         * @summary Update a crypto address
         * @param {string} addressId Address ID
         * @param {CordeCommonModelsDtoBalanceUpdateCryptoAddressRequest} address Crypto address update details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceCryptoAddressesAddressIdPut(addressId: string, address: CordeCommonModelsDtoBalanceUpdateCryptoAddressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceCryptoAddress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceCryptoAddressesAddressIdPut(addressId, address, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceApi.balanceCryptoAddressesAddressIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a paginated list of cryptocurrency addresses for a user
         * @summary List crypto addresses
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [currency] Filter by currency
         * @param {string} [network] Filter by network
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceCryptoAddressesGet(limit?: number, offset?: number, currency?: string, network?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceListCryptoAddressesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceCryptoAddressesGet(limit, offset, currency, network, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceApi.balanceCryptoAddressesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new cryptocurrency address for the user
         * @summary Create a new crypto address
         * @param {CordeCommonModelsDtoBalanceCreateCryptoAddressRequest} address Crypto address details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceCryptoAddressesPost(address: CordeCommonModelsDtoBalanceCreateCryptoAddressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceCryptoAddress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceCryptoAddressesPost(address, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceApi.balanceCryptoAddressesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validates if a cryptocurrency address is valid for the specified currency
         * @summary Validate a crypto address
         * @param {CordeCommonModelsDtoBalanceValidateCryptoAddressRequest} validate Validation details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceCryptoAddressesValidatePost(validate: CordeCommonModelsDtoBalanceValidateCryptoAddressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceValidateCryptoAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceCryptoAddressesValidatePost(validate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceApi.balanceCryptoAddressesValidatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns details for a specific currency
         * @summary Get currency details
         * @param {string} code Currency code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceCurrenciesCodeGet(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceCurrency>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceCurrenciesCodeGet(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceApi.balanceCurrenciesCodeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a paginated list of available currencies
         * @summary List currencies
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {boolean} [onlyEnabled] Only enabled currencies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceCurrenciesGet(limit?: number, offset?: number, onlyEnabled?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceListCurrenciesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceCurrenciesGet(limit, offset, onlyEnabled, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceApi.balanceCurrenciesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the deposit address for a specific currency
         * @summary Get deposit address
         * @param {string} currency Currency code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceDepositAddressGet(currency: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceGetDepositAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceDepositAddressGet(currency, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceApi.balanceDepositAddressGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Initiates a deposit to the user\'s account
         * @summary Create a deposit
         * @param {CordeCommonModelsDtoBalanceCreateDepositRequest} deposit Deposit details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceDepositPost(deposit: CordeCommonModelsDtoBalanceCreateDepositRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceCreateDepositResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceDepositPost(deposit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceApi.balanceDepositPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Ensures that balances exist for the specified user in the given currencies
         * @summary Ensure balances for user
         * @param {CordeCommonModelsDtoBalanceEnsureBalancesRequest} ensure Ensure balances request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceEnsurePost(ensure: CordeCommonModelsDtoBalanceEnsureBalancesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceEnsurePost(ensure, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceApi.balanceEnsurePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes an existing bank details record
         * @summary Delete fiat bank details
         * @param {string} detailsId Details ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceFiatDetailsDetailsIdDelete(detailsId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceFiatDetailsDetailsIdDelete(detailsId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceApi.balanceFiatDetailsDetailsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns details for a specific bank details record
         * @summary Get fiat bank details
         * @param {string} detailsId Details ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceFiatDetailsDetailsIdGet(detailsId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceFiatDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceFiatDetailsDetailsIdGet(detailsId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceApi.balanceFiatDetailsDetailsIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates an existing bank details record
         * @summary Update fiat bank details
         * @param {string} detailsId Details ID
         * @param {CordeCommonModelsDtoBalanceUpdateFiatDetailsRequest} details Fiat details to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceFiatDetailsDetailsIdPut(detailsId: string, details: CordeCommonModelsDtoBalanceUpdateFiatDetailsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceFiatDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceFiatDetailsDetailsIdPut(detailsId, details, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceApi.balanceFiatDetailsDetailsIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a paginated list of bank details records for a user
         * @summary List fiat bank details
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [currency] Filter by currency
         * @param {string} [country] Filter by country
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceFiatDetailsGet(limit?: number, offset?: number, currency?: string, country?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceListFiatDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceFiatDetailsGet(limit, offset, currency, country, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceApi.balanceFiatDetailsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new bank details record for withdrawals
         * @summary Create fiat bank details
         * @param {CordeCommonModelsDtoBalanceCreateFiatDetailsRequest} details Fiat details to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceFiatDetailsPost(details: CordeCommonModelsDtoBalanceCreateFiatDetailsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceFiatDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceFiatDetailsPost(details, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceApi.balanceFiatDetailsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validates that the provided bank details are valid for the specified currency
         * @summary Validate fiat bank details
         * @param {CordeCommonModelsDtoBalanceValidateFiatDetailsRequest} details Fiat details to validate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceFiatDetailsValidatePost(details: CordeCommonModelsDtoBalanceValidateFiatDetailsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceValidateFiatDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceFiatDetailsValidatePost(details, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceApi.balanceFiatDetailsValidatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the balance for a specific user and currency
         * @summary Get user balance
         * @param {string} currency Currency code
         * @param {string} [userId] User ID (defaults to current user if not specified)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceGet(currency: string, userId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceBalance>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceGet(currency, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceApi.balanceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a list of balances for a user across all currencies
         * @summary List user balances
         * @param {string} [userId] User ID (defaults to current user if not specified)
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceListGet(userId?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceListBalancesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceListGet(userId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceApi.balanceListGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cancels a reservation, returning funds to the available balance
         * @summary Cancel reserved funds
         * @param {CordeCommonModelsDtoBalanceCancelReserveRequest} cancel Cancel reserve request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceReserveCancelPost(cancel: CordeCommonModelsDtoBalanceCancelReserveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceCancelReserveResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceReserveCancelPost(cancel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceApi.balanceReserveCancelPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Commits a reservation, finalizing the transaction
         * @summary Commit reserved funds
         * @param {CordeCommonModelsDtoBalanceCommitReserveRequest} commit Commit reserve request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceReserveCommitPost(commit: CordeCommonModelsDtoBalanceCommitReserveRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceCommitReserveResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceReserveCommitPost(commit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceApi.balanceReserveCommitPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reserves funds from a user\'s balance for a pending transaction
         * @summary Reserve funds
         * @param {CordeCommonModelsDtoBalanceReserveFundsRequest} reserve Reserve funds request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceReservePost(reserve: CordeCommonModelsDtoBalanceReserveFundsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceReserveFundsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceReservePost(reserve, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceApi.balanceReservePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a paginated list of transactions for a user
         * @summary List user transactions
         * @param {string} [userId] User ID (defaults to current user if not specified)
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [type] Transaction type (DEPOSIT, WITHDRAWAL, FEE, ADJUSTMENT)
         * @param {string} [status] Transaction status (PENDING, PROCESSING, COMPLETED, CANCELLED, REJECTED, FAILED)
         * @param {string} [from] Start date (RFC3339 format)
         * @param {string} [to] End date (RFC3339 format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceTransactionsGet(userId?: string, limit?: number, offset?: number, type?: string, status?: string, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceListTransactionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceTransactionsGet(userId, limit, offset, type, status, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceApi.balanceTransactionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns details for a specific transaction
         * @summary Get transaction details
         * @param {string} transactionId Transaction ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceTransactionsTransactionIdGet(transactionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceTransaction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceTransactionsTransactionIdGet(transactionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceApi.balanceTransactionsTransactionIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Initiates a withdrawal from the user\'s account
         * @summary Create a withdrawal
         * @param {CordeCommonModelsDtoBalanceCreateWithdrawalRequest} withdrawal Withdrawal details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceWithdrawalPost(withdrawal: CordeCommonModelsDtoBalanceCreateWithdrawalRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceCreateWithdrawalResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceWithdrawalPost(withdrawal, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceApi.balanceWithdrawalPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BalanceApi - factory interface
 * @export
 */
export const BalanceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BalanceApiFp(configuration)
    return {
        /**
         * Deletes a cryptocurrency address
         * @summary Delete a crypto address
         * @param {string} addressId Address ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceCryptoAddressesAddressIdDelete(addressId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.balanceCryptoAddressesAddressIdDelete(addressId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves details for a specific cryptocurrency address
         * @summary Get crypto address details
         * @param {string} addressId Address ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceCryptoAddressesAddressIdGet(addressId: string, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceCryptoAddress> {
            return localVarFp.balanceCryptoAddressesAddressIdGet(addressId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates details for an existing crypto address
         * @summary Update a crypto address
         * @param {string} addressId Address ID
         * @param {CordeCommonModelsDtoBalanceUpdateCryptoAddressRequest} address Crypto address update details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceCryptoAddressesAddressIdPut(addressId: string, address: CordeCommonModelsDtoBalanceUpdateCryptoAddressRequest, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceCryptoAddress> {
            return localVarFp.balanceCryptoAddressesAddressIdPut(addressId, address, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a paginated list of cryptocurrency addresses for a user
         * @summary List crypto addresses
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [currency] Filter by currency
         * @param {string} [network] Filter by network
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceCryptoAddressesGet(limit?: number, offset?: number, currency?: string, network?: string, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceListCryptoAddressesResponse> {
            return localVarFp.balanceCryptoAddressesGet(limit, offset, currency, network, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new cryptocurrency address for the user
         * @summary Create a new crypto address
         * @param {CordeCommonModelsDtoBalanceCreateCryptoAddressRequest} address Crypto address details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceCryptoAddressesPost(address: CordeCommonModelsDtoBalanceCreateCryptoAddressRequest, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceCryptoAddress> {
            return localVarFp.balanceCryptoAddressesPost(address, options).then((request) => request(axios, basePath));
        },
        /**
         * Validates if a cryptocurrency address is valid for the specified currency
         * @summary Validate a crypto address
         * @param {CordeCommonModelsDtoBalanceValidateCryptoAddressRequest} validate Validation details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceCryptoAddressesValidatePost(validate: CordeCommonModelsDtoBalanceValidateCryptoAddressRequest, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceValidateCryptoAddressResponse> {
            return localVarFp.balanceCryptoAddressesValidatePost(validate, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns details for a specific currency
         * @summary Get currency details
         * @param {string} code Currency code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceCurrenciesCodeGet(code: string, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceCurrency> {
            return localVarFp.balanceCurrenciesCodeGet(code, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a paginated list of available currencies
         * @summary List currencies
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {boolean} [onlyEnabled] Only enabled currencies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceCurrenciesGet(limit?: number, offset?: number, onlyEnabled?: boolean, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceListCurrenciesResponse> {
            return localVarFp.balanceCurrenciesGet(limit, offset, onlyEnabled, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the deposit address for a specific currency
         * @summary Get deposit address
         * @param {string} currency Currency code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceDepositAddressGet(currency: string, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceGetDepositAddressResponse> {
            return localVarFp.balanceDepositAddressGet(currency, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiates a deposit to the user\'s account
         * @summary Create a deposit
         * @param {CordeCommonModelsDtoBalanceCreateDepositRequest} deposit Deposit details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceDepositPost(deposit: CordeCommonModelsDtoBalanceCreateDepositRequest, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceCreateDepositResponse> {
            return localVarFp.balanceDepositPost(deposit, options).then((request) => request(axios, basePath));
        },
        /**
         * Ensures that balances exist for the specified user in the given currencies
         * @summary Ensure balances for user
         * @param {CordeCommonModelsDtoBalanceEnsureBalancesRequest} ensure Ensure balances request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceEnsurePost(ensure: CordeCommonModelsDtoBalanceEnsureBalancesRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.balanceEnsurePost(ensure, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes an existing bank details record
         * @summary Delete fiat bank details
         * @param {string} detailsId Details ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceFiatDetailsDetailsIdDelete(detailsId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.balanceFiatDetailsDetailsIdDelete(detailsId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns details for a specific bank details record
         * @summary Get fiat bank details
         * @param {string} detailsId Details ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceFiatDetailsDetailsIdGet(detailsId: string, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceFiatDetails> {
            return localVarFp.balanceFiatDetailsDetailsIdGet(detailsId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an existing bank details record
         * @summary Update fiat bank details
         * @param {string} detailsId Details ID
         * @param {CordeCommonModelsDtoBalanceUpdateFiatDetailsRequest} details Fiat details to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceFiatDetailsDetailsIdPut(detailsId: string, details: CordeCommonModelsDtoBalanceUpdateFiatDetailsRequest, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceFiatDetails> {
            return localVarFp.balanceFiatDetailsDetailsIdPut(detailsId, details, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a paginated list of bank details records for a user
         * @summary List fiat bank details
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [currency] Filter by currency
         * @param {string} [country] Filter by country
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceFiatDetailsGet(limit?: number, offset?: number, currency?: string, country?: string, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceListFiatDetailsResponse> {
            return localVarFp.balanceFiatDetailsGet(limit, offset, currency, country, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new bank details record for withdrawals
         * @summary Create fiat bank details
         * @param {CordeCommonModelsDtoBalanceCreateFiatDetailsRequest} details Fiat details to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceFiatDetailsPost(details: CordeCommonModelsDtoBalanceCreateFiatDetailsRequest, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceFiatDetails> {
            return localVarFp.balanceFiatDetailsPost(details, options).then((request) => request(axios, basePath));
        },
        /**
         * Validates that the provided bank details are valid for the specified currency
         * @summary Validate fiat bank details
         * @param {CordeCommonModelsDtoBalanceValidateFiatDetailsRequest} details Fiat details to validate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceFiatDetailsValidatePost(details: CordeCommonModelsDtoBalanceValidateFiatDetailsRequest, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceValidateFiatDetailsResponse> {
            return localVarFp.balanceFiatDetailsValidatePost(details, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the balance for a specific user and currency
         * @summary Get user balance
         * @param {string} currency Currency code
         * @param {string} [userId] User ID (defaults to current user if not specified)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceGet(currency: string, userId?: string, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceBalance> {
            return localVarFp.balanceGet(currency, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a list of balances for a user across all currencies
         * @summary List user balances
         * @param {string} [userId] User ID (defaults to current user if not specified)
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceListGet(userId?: string, limit?: number, offset?: number, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceListBalancesResponse> {
            return localVarFp.balanceListGet(userId, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancels a reservation, returning funds to the available balance
         * @summary Cancel reserved funds
         * @param {CordeCommonModelsDtoBalanceCancelReserveRequest} cancel Cancel reserve request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceReserveCancelPost(cancel: CordeCommonModelsDtoBalanceCancelReserveRequest, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceCancelReserveResponse> {
            return localVarFp.balanceReserveCancelPost(cancel, options).then((request) => request(axios, basePath));
        },
        /**
         * Commits a reservation, finalizing the transaction
         * @summary Commit reserved funds
         * @param {CordeCommonModelsDtoBalanceCommitReserveRequest} commit Commit reserve request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceReserveCommitPost(commit: CordeCommonModelsDtoBalanceCommitReserveRequest, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceCommitReserveResponse> {
            return localVarFp.balanceReserveCommitPost(commit, options).then((request) => request(axios, basePath));
        },
        /**
         * Reserves funds from a user\'s balance for a pending transaction
         * @summary Reserve funds
         * @param {CordeCommonModelsDtoBalanceReserveFundsRequest} reserve Reserve funds request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceReservePost(reserve: CordeCommonModelsDtoBalanceReserveFundsRequest, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceReserveFundsResponse> {
            return localVarFp.balanceReservePost(reserve, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a paginated list of transactions for a user
         * @summary List user transactions
         * @param {string} [userId] User ID (defaults to current user if not specified)
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [type] Transaction type (DEPOSIT, WITHDRAWAL, FEE, ADJUSTMENT)
         * @param {string} [status] Transaction status (PENDING, PROCESSING, COMPLETED, CANCELLED, REJECTED, FAILED)
         * @param {string} [from] Start date (RFC3339 format)
         * @param {string} [to] End date (RFC3339 format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceTransactionsGet(userId?: string, limit?: number, offset?: number, type?: string, status?: string, from?: string, to?: string, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceListTransactionsResponse> {
            return localVarFp.balanceTransactionsGet(userId, limit, offset, type, status, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns details for a specific transaction
         * @summary Get transaction details
         * @param {string} transactionId Transaction ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceTransactionsTransactionIdGet(transactionId: string, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceTransaction> {
            return localVarFp.balanceTransactionsTransactionIdGet(transactionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiates a withdrawal from the user\'s account
         * @summary Create a withdrawal
         * @param {CordeCommonModelsDtoBalanceCreateWithdrawalRequest} withdrawal Withdrawal details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceWithdrawalPost(withdrawal: CordeCommonModelsDtoBalanceCreateWithdrawalRequest, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceCreateWithdrawalResponse> {
            return localVarFp.balanceWithdrawalPost(withdrawal, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BalanceApi - object-oriented interface
 * @export
 * @class BalanceApi
 * @extends {BaseAPI}
 */
export class BalanceApi extends BaseAPI {
    /**
     * Deletes a cryptocurrency address
     * @summary Delete a crypto address
     * @param {string} addressId Address ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApi
     */
    public balanceCryptoAddressesAddressIdDelete(addressId: string, options?: RawAxiosRequestConfig) {
        return BalanceApiFp(this.configuration).balanceCryptoAddressesAddressIdDelete(addressId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves details for a specific cryptocurrency address
     * @summary Get crypto address details
     * @param {string} addressId Address ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApi
     */
    public balanceCryptoAddressesAddressIdGet(addressId: string, options?: RawAxiosRequestConfig) {
        return BalanceApiFp(this.configuration).balanceCryptoAddressesAddressIdGet(addressId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates details for an existing crypto address
     * @summary Update a crypto address
     * @param {string} addressId Address ID
     * @param {CordeCommonModelsDtoBalanceUpdateCryptoAddressRequest} address Crypto address update details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApi
     */
    public balanceCryptoAddressesAddressIdPut(addressId: string, address: CordeCommonModelsDtoBalanceUpdateCryptoAddressRequest, options?: RawAxiosRequestConfig) {
        return BalanceApiFp(this.configuration).balanceCryptoAddressesAddressIdPut(addressId, address, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a paginated list of cryptocurrency addresses for a user
     * @summary List crypto addresses
     * @param {number} [limit] Limit
     * @param {number} [offset] Offset
     * @param {string} [currency] Filter by currency
     * @param {string} [network] Filter by network
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApi
     */
    public balanceCryptoAddressesGet(limit?: number, offset?: number, currency?: string, network?: string, options?: RawAxiosRequestConfig) {
        return BalanceApiFp(this.configuration).balanceCryptoAddressesGet(limit, offset, currency, network, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new cryptocurrency address for the user
     * @summary Create a new crypto address
     * @param {CordeCommonModelsDtoBalanceCreateCryptoAddressRequest} address Crypto address details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApi
     */
    public balanceCryptoAddressesPost(address: CordeCommonModelsDtoBalanceCreateCryptoAddressRequest, options?: RawAxiosRequestConfig) {
        return BalanceApiFp(this.configuration).balanceCryptoAddressesPost(address, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validates if a cryptocurrency address is valid for the specified currency
     * @summary Validate a crypto address
     * @param {CordeCommonModelsDtoBalanceValidateCryptoAddressRequest} validate Validation details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApi
     */
    public balanceCryptoAddressesValidatePost(validate: CordeCommonModelsDtoBalanceValidateCryptoAddressRequest, options?: RawAxiosRequestConfig) {
        return BalanceApiFp(this.configuration).balanceCryptoAddressesValidatePost(validate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns details for a specific currency
     * @summary Get currency details
     * @param {string} code Currency code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApi
     */
    public balanceCurrenciesCodeGet(code: string, options?: RawAxiosRequestConfig) {
        return BalanceApiFp(this.configuration).balanceCurrenciesCodeGet(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a paginated list of available currencies
     * @summary List currencies
     * @param {number} [limit] Limit
     * @param {number} [offset] Offset
     * @param {boolean} [onlyEnabled] Only enabled currencies
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApi
     */
    public balanceCurrenciesGet(limit?: number, offset?: number, onlyEnabled?: boolean, options?: RawAxiosRequestConfig) {
        return BalanceApiFp(this.configuration).balanceCurrenciesGet(limit, offset, onlyEnabled, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the deposit address for a specific currency
     * @summary Get deposit address
     * @param {string} currency Currency code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApi
     */
    public balanceDepositAddressGet(currency: string, options?: RawAxiosRequestConfig) {
        return BalanceApiFp(this.configuration).balanceDepositAddressGet(currency, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initiates a deposit to the user\'s account
     * @summary Create a deposit
     * @param {CordeCommonModelsDtoBalanceCreateDepositRequest} deposit Deposit details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApi
     */
    public balanceDepositPost(deposit: CordeCommonModelsDtoBalanceCreateDepositRequest, options?: RawAxiosRequestConfig) {
        return BalanceApiFp(this.configuration).balanceDepositPost(deposit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ensures that balances exist for the specified user in the given currencies
     * @summary Ensure balances for user
     * @param {CordeCommonModelsDtoBalanceEnsureBalancesRequest} ensure Ensure balances request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApi
     */
    public balanceEnsurePost(ensure: CordeCommonModelsDtoBalanceEnsureBalancesRequest, options?: RawAxiosRequestConfig) {
        return BalanceApiFp(this.configuration).balanceEnsurePost(ensure, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes an existing bank details record
     * @summary Delete fiat bank details
     * @param {string} detailsId Details ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApi
     */
    public balanceFiatDetailsDetailsIdDelete(detailsId: string, options?: RawAxiosRequestConfig) {
        return BalanceApiFp(this.configuration).balanceFiatDetailsDetailsIdDelete(detailsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns details for a specific bank details record
     * @summary Get fiat bank details
     * @param {string} detailsId Details ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApi
     */
    public balanceFiatDetailsDetailsIdGet(detailsId: string, options?: RawAxiosRequestConfig) {
        return BalanceApiFp(this.configuration).balanceFiatDetailsDetailsIdGet(detailsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an existing bank details record
     * @summary Update fiat bank details
     * @param {string} detailsId Details ID
     * @param {CordeCommonModelsDtoBalanceUpdateFiatDetailsRequest} details Fiat details to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApi
     */
    public balanceFiatDetailsDetailsIdPut(detailsId: string, details: CordeCommonModelsDtoBalanceUpdateFiatDetailsRequest, options?: RawAxiosRequestConfig) {
        return BalanceApiFp(this.configuration).balanceFiatDetailsDetailsIdPut(detailsId, details, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a paginated list of bank details records for a user
     * @summary List fiat bank details
     * @param {number} [limit] Limit
     * @param {number} [offset] Offset
     * @param {string} [currency] Filter by currency
     * @param {string} [country] Filter by country
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApi
     */
    public balanceFiatDetailsGet(limit?: number, offset?: number, currency?: string, country?: string, options?: RawAxiosRequestConfig) {
        return BalanceApiFp(this.configuration).balanceFiatDetailsGet(limit, offset, currency, country, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new bank details record for withdrawals
     * @summary Create fiat bank details
     * @param {CordeCommonModelsDtoBalanceCreateFiatDetailsRequest} details Fiat details to create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApi
     */
    public balanceFiatDetailsPost(details: CordeCommonModelsDtoBalanceCreateFiatDetailsRequest, options?: RawAxiosRequestConfig) {
        return BalanceApiFp(this.configuration).balanceFiatDetailsPost(details, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validates that the provided bank details are valid for the specified currency
     * @summary Validate fiat bank details
     * @param {CordeCommonModelsDtoBalanceValidateFiatDetailsRequest} details Fiat details to validate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApi
     */
    public balanceFiatDetailsValidatePost(details: CordeCommonModelsDtoBalanceValidateFiatDetailsRequest, options?: RawAxiosRequestConfig) {
        return BalanceApiFp(this.configuration).balanceFiatDetailsValidatePost(details, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the balance for a specific user and currency
     * @summary Get user balance
     * @param {string} currency Currency code
     * @param {string} [userId] User ID (defaults to current user if not specified)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApi
     */
    public balanceGet(currency: string, userId?: string, options?: RawAxiosRequestConfig) {
        return BalanceApiFp(this.configuration).balanceGet(currency, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a list of balances for a user across all currencies
     * @summary List user balances
     * @param {string} [userId] User ID (defaults to current user if not specified)
     * @param {number} [limit] Limit
     * @param {number} [offset] Offset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApi
     */
    public balanceListGet(userId?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return BalanceApiFp(this.configuration).balanceListGet(userId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancels a reservation, returning funds to the available balance
     * @summary Cancel reserved funds
     * @param {CordeCommonModelsDtoBalanceCancelReserveRequest} cancel Cancel reserve request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApi
     */
    public balanceReserveCancelPost(cancel: CordeCommonModelsDtoBalanceCancelReserveRequest, options?: RawAxiosRequestConfig) {
        return BalanceApiFp(this.configuration).balanceReserveCancelPost(cancel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Commits a reservation, finalizing the transaction
     * @summary Commit reserved funds
     * @param {CordeCommonModelsDtoBalanceCommitReserveRequest} commit Commit reserve request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApi
     */
    public balanceReserveCommitPost(commit: CordeCommonModelsDtoBalanceCommitReserveRequest, options?: RawAxiosRequestConfig) {
        return BalanceApiFp(this.configuration).balanceReserveCommitPost(commit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reserves funds from a user\'s balance for a pending transaction
     * @summary Reserve funds
     * @param {CordeCommonModelsDtoBalanceReserveFundsRequest} reserve Reserve funds request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApi
     */
    public balanceReservePost(reserve: CordeCommonModelsDtoBalanceReserveFundsRequest, options?: RawAxiosRequestConfig) {
        return BalanceApiFp(this.configuration).balanceReservePost(reserve, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a paginated list of transactions for a user
     * @summary List user transactions
     * @param {string} [userId] User ID (defaults to current user if not specified)
     * @param {number} [limit] Limit
     * @param {number} [offset] Offset
     * @param {string} [type] Transaction type (DEPOSIT, WITHDRAWAL, FEE, ADJUSTMENT)
     * @param {string} [status] Transaction status (PENDING, PROCESSING, COMPLETED, CANCELLED, REJECTED, FAILED)
     * @param {string} [from] Start date (RFC3339 format)
     * @param {string} [to] End date (RFC3339 format)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApi
     */
    public balanceTransactionsGet(userId?: string, limit?: number, offset?: number, type?: string, status?: string, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return BalanceApiFp(this.configuration).balanceTransactionsGet(userId, limit, offset, type, status, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns details for a specific transaction
     * @summary Get transaction details
     * @param {string} transactionId Transaction ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApi
     */
    public balanceTransactionsTransactionIdGet(transactionId: string, options?: RawAxiosRequestConfig) {
        return BalanceApiFp(this.configuration).balanceTransactionsTransactionIdGet(transactionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initiates a withdrawal from the user\'s account
     * @summary Create a withdrawal
     * @param {CordeCommonModelsDtoBalanceCreateWithdrawalRequest} withdrawal Withdrawal details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceApi
     */
    public balanceWithdrawalPost(withdrawal: CordeCommonModelsDtoBalanceCreateWithdrawalRequest, options?: RawAxiosRequestConfig) {
        return BalanceApiFp(this.configuration).balanceWithdrawalPost(withdrawal, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BalanceAdminApi - axios parameter creator
 * @export
 */
export const BalanceAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a paginated list of all transactions across all users (admin only)
         * @summary List all transactions
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [type] Transaction type (DEPOSIT, WITHDRAWAL, FEE, ADJUSTMENT)
         * @param {string} [status] Transaction status (PENDING, PROCESSING, COMPLETED, CANCELLED, REJECTED, FAILED)
         * @param {string} [from] Start date (RFC3339 format)
         * @param {string} [to] End date (RFC3339 format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceAdminAllTransactionsGet: async (limit?: number, offset?: number, type?: string, status?: string, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/balance/admin/all-transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Disables a currency in the system
         * @summary Disable currency (admin only)
         * @param {string} code Currency code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceAdminCurrenciesCodeDisablePost: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('balanceAdminCurrenciesCodeDisablePost', 'code', code)
            const localVarPath = `/balance/admin/currencies/{code}/disable`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an existing currency
         * @summary Update currency (admin only)
         * @param {string} code Currency code
         * @param {CordeCommonModelsDtoBalanceUpdateCurrencyRequest} currency Currency update details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceAdminCurrenciesCodePut: async (code: string, currency: CordeCommonModelsDtoBalanceUpdateCurrencyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('balanceAdminCurrenciesCodePut', 'code', code)
            // verify required parameter 'currency' is not null or undefined
            assertParamExists('balanceAdminCurrenciesCodePut', 'currency', currency)
            const localVarPath = `/balance/admin/currencies/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(currency, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new currency in the system
         * @summary Create a new currency (admin only)
         * @param {CordeCommonModelsDtoBalanceCreateCurrencyRequest} currency Currency details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceAdminCurrenciesPost: async (currency: CordeCommonModelsDtoBalanceCreateCurrencyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'currency' is not null or undefined
            assertParamExists('balanceAdminCurrenciesPost', 'currency', currency)
            const localVarPath = `/balance/admin/currencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(currency, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Attempts to retry transactions that are in a pending state
         * @summary Retry pending transactions
         * @param {CordeCommonModelsDtoBalanceRetryPendingTransactionsRequest} retry Retry request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceAdminRetryPendingPost: async (retry: CordeCommonModelsDtoBalanceRetryPendingTransactionsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'retry' is not null or undefined
            assertParamExists('balanceAdminRetryPendingPost', 'retry', retry)
            const localVarPath = `/balance/admin/retry-pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(retry, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adjusts user balance by specified amount (admin only)
         * @summary Admin adjust user balance
         * @param {string} userId User ID
         * @param {string} currency Currency code
         * @param {CordeCommonModelsDtoBalanceAdminAdjustBalanceRequest} adjustment Balance adjustment request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceAdminUserIdCurrencyAdjustPost: async (userId: string, currency: string, adjustment: CordeCommonModelsDtoBalanceAdminAdjustBalanceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('balanceAdminUserIdCurrencyAdjustPost', 'userId', userId)
            // verify required parameter 'currency' is not null or undefined
            assertParamExists('balanceAdminUserIdCurrencyAdjustPost', 'currency', currency)
            // verify required parameter 'adjustment' is not null or undefined
            assertParamExists('balanceAdminUserIdCurrencyAdjustPost', 'adjustment', adjustment)
            const localVarPath = `/balance/admin/{user_id}/{currency}/adjust`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"currency"}}`, encodeURIComponent(String(currency)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adjustment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Freezes specified amount from user\'s available balance (admin only)
         * @summary Admin freeze user balance
         * @param {string} userId User ID
         * @param {string} currency Currency code
         * @param {CordeCommonModelsDtoBalanceAdminFreezeBalanceRequest} freeze Freeze balance request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceAdminUserIdCurrencyFreezePost: async (userId: string, currency: string, freeze: CordeCommonModelsDtoBalanceAdminFreezeBalanceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('balanceAdminUserIdCurrencyFreezePost', 'userId', userId)
            // verify required parameter 'currency' is not null or undefined
            assertParamExists('balanceAdminUserIdCurrencyFreezePost', 'currency', currency)
            // verify required parameter 'freeze' is not null or undefined
            assertParamExists('balanceAdminUserIdCurrencyFreezePost', 'freeze', freeze)
            const localVarPath = `/balance/admin/{user_id}/{currency}/freeze`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"currency"}}`, encodeURIComponent(String(currency)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(freeze, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets exact user balance value (admin only)
         * @summary Admin set user balance
         * @param {string} userId User ID
         * @param {string} currency Currency code
         * @param {CordeCommonModelsDtoBalanceAdminSetBalanceRequest} setBalance Set balance request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceAdminUserIdCurrencySetPost: async (userId: string, currency: string, setBalance: CordeCommonModelsDtoBalanceAdminSetBalanceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('balanceAdminUserIdCurrencySetPost', 'userId', userId)
            // verify required parameter 'currency' is not null or undefined
            assertParamExists('balanceAdminUserIdCurrencySetPost', 'currency', currency)
            // verify required parameter 'setBalance' is not null or undefined
            assertParamExists('balanceAdminUserIdCurrencySetPost', 'setBalance', setBalance)
            const localVarPath = `/balance/admin/{user_id}/{currency}/set`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"currency"}}`, encodeURIComponent(String(currency)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setBalance, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unfreezes specified amount from user\'s locked balance (admin only)
         * @summary Admin unfreeze user balance
         * @param {string} userId User ID
         * @param {string} currency Currency code
         * @param {CordeCommonModelsDtoBalanceAdminUnfreezeBalanceRequest} unfreeze Unfreeze balance request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceAdminUserIdCurrencyUnfreezePost: async (userId: string, currency: string, unfreeze: CordeCommonModelsDtoBalanceAdminUnfreezeBalanceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('balanceAdminUserIdCurrencyUnfreezePost', 'userId', userId)
            // verify required parameter 'currency' is not null or undefined
            assertParamExists('balanceAdminUserIdCurrencyUnfreezePost', 'currency', currency)
            // verify required parameter 'unfreeze' is not null or undefined
            assertParamExists('balanceAdminUserIdCurrencyUnfreezePost', 'unfreeze', unfreeze)
            const localVarPath = `/balance/admin/{user_id}/{currency}/unfreeze`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"currency"}}`, encodeURIComponent(String(currency)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(unfreeze, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BalanceAdminApi - functional programming interface
 * @export
 */
export const BalanceAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BalanceAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a paginated list of all transactions across all users (admin only)
         * @summary List all transactions
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [type] Transaction type (DEPOSIT, WITHDRAWAL, FEE, ADJUSTMENT)
         * @param {string} [status] Transaction status (PENDING, PROCESSING, COMPLETED, CANCELLED, REJECTED, FAILED)
         * @param {string} [from] Start date (RFC3339 format)
         * @param {string} [to] End date (RFC3339 format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceAdminAllTransactionsGet(limit?: number, offset?: number, type?: string, status?: string, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceListTransactionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceAdminAllTransactionsGet(limit, offset, type, status, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceAdminApi.balanceAdminAllTransactionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Disables a currency in the system
         * @summary Disable currency (admin only)
         * @param {string} code Currency code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceAdminCurrenciesCodeDisablePost(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceAdminCurrenciesCodeDisablePost(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceAdminApi.balanceAdminCurrenciesCodeDisablePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates an existing currency
         * @summary Update currency (admin only)
         * @param {string} code Currency code
         * @param {CordeCommonModelsDtoBalanceUpdateCurrencyRequest} currency Currency update details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceAdminCurrenciesCodePut(code: string, currency: CordeCommonModelsDtoBalanceUpdateCurrencyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceCurrency>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceAdminCurrenciesCodePut(code, currency, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceAdminApi.balanceAdminCurrenciesCodePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new currency in the system
         * @summary Create a new currency (admin only)
         * @param {CordeCommonModelsDtoBalanceCreateCurrencyRequest} currency Currency details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceAdminCurrenciesPost(currency: CordeCommonModelsDtoBalanceCreateCurrencyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceCurrency>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceAdminCurrenciesPost(currency, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceAdminApi.balanceAdminCurrenciesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Attempts to retry transactions that are in a pending state
         * @summary Retry pending transactions
         * @param {CordeCommonModelsDtoBalanceRetryPendingTransactionsRequest} retry Retry request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceAdminRetryPendingPost(retry: CordeCommonModelsDtoBalanceRetryPendingTransactionsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceAdminRetryPendingPost(retry, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceAdminApi.balanceAdminRetryPendingPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Adjusts user balance by specified amount (admin only)
         * @summary Admin adjust user balance
         * @param {string} userId User ID
         * @param {string} currency Currency code
         * @param {CordeCommonModelsDtoBalanceAdminAdjustBalanceRequest} adjustment Balance adjustment request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceAdminUserIdCurrencyAdjustPost(userId: string, currency: string, adjustment: CordeCommonModelsDtoBalanceAdminAdjustBalanceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceAdminAdjustBalanceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceAdminUserIdCurrencyAdjustPost(userId, currency, adjustment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceAdminApi.balanceAdminUserIdCurrencyAdjustPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Freezes specified amount from user\'s available balance (admin only)
         * @summary Admin freeze user balance
         * @param {string} userId User ID
         * @param {string} currency Currency code
         * @param {CordeCommonModelsDtoBalanceAdminFreezeBalanceRequest} freeze Freeze balance request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceAdminUserIdCurrencyFreezePost(userId: string, currency: string, freeze: CordeCommonModelsDtoBalanceAdminFreezeBalanceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceAdminFreezeBalanceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceAdminUserIdCurrencyFreezePost(userId, currency, freeze, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceAdminApi.balanceAdminUserIdCurrencyFreezePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sets exact user balance value (admin only)
         * @summary Admin set user balance
         * @param {string} userId User ID
         * @param {string} currency Currency code
         * @param {CordeCommonModelsDtoBalanceAdminSetBalanceRequest} setBalance Set balance request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceAdminUserIdCurrencySetPost(userId: string, currency: string, setBalance: CordeCommonModelsDtoBalanceAdminSetBalanceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceAdminSetBalanceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceAdminUserIdCurrencySetPost(userId, currency, setBalance, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceAdminApi.balanceAdminUserIdCurrencySetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unfreezes specified amount from user\'s locked balance (admin only)
         * @summary Admin unfreeze user balance
         * @param {string} userId User ID
         * @param {string} currency Currency code
         * @param {CordeCommonModelsDtoBalanceAdminUnfreezeBalanceRequest} unfreeze Unfreeze balance request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balanceAdminUserIdCurrencyUnfreezePost(userId: string, currency: string, unfreeze: CordeCommonModelsDtoBalanceAdminUnfreezeBalanceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceAdminUnfreezeBalanceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balanceAdminUserIdCurrencyUnfreezePost(userId, currency, unfreeze, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BalanceAdminApi.balanceAdminUserIdCurrencyUnfreezePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BalanceAdminApi - factory interface
 * @export
 */
export const BalanceAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BalanceAdminApiFp(configuration)
    return {
        /**
         * Returns a paginated list of all transactions across all users (admin only)
         * @summary List all transactions
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [type] Transaction type (DEPOSIT, WITHDRAWAL, FEE, ADJUSTMENT)
         * @param {string} [status] Transaction status (PENDING, PROCESSING, COMPLETED, CANCELLED, REJECTED, FAILED)
         * @param {string} [from] Start date (RFC3339 format)
         * @param {string} [to] End date (RFC3339 format)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceAdminAllTransactionsGet(limit?: number, offset?: number, type?: string, status?: string, from?: string, to?: string, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceListTransactionsResponse> {
            return localVarFp.balanceAdminAllTransactionsGet(limit, offset, type, status, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * Disables a currency in the system
         * @summary Disable currency (admin only)
         * @param {string} code Currency code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceAdminCurrenciesCodeDisablePost(code: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.balanceAdminCurrenciesCodeDisablePost(code, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an existing currency
         * @summary Update currency (admin only)
         * @param {string} code Currency code
         * @param {CordeCommonModelsDtoBalanceUpdateCurrencyRequest} currency Currency update details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceAdminCurrenciesCodePut(code: string, currency: CordeCommonModelsDtoBalanceUpdateCurrencyRequest, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceCurrency> {
            return localVarFp.balanceAdminCurrenciesCodePut(code, currency, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new currency in the system
         * @summary Create a new currency (admin only)
         * @param {CordeCommonModelsDtoBalanceCreateCurrencyRequest} currency Currency details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceAdminCurrenciesPost(currency: CordeCommonModelsDtoBalanceCreateCurrencyRequest, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceCurrency> {
            return localVarFp.balanceAdminCurrenciesPost(currency, options).then((request) => request(axios, basePath));
        },
        /**
         * Attempts to retry transactions that are in a pending state
         * @summary Retry pending transactions
         * @param {CordeCommonModelsDtoBalanceRetryPendingTransactionsRequest} retry Retry request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceAdminRetryPendingPost(retry: CordeCommonModelsDtoBalanceRetryPendingTransactionsRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.balanceAdminRetryPendingPost(retry, options).then((request) => request(axios, basePath));
        },
        /**
         * Adjusts user balance by specified amount (admin only)
         * @summary Admin adjust user balance
         * @param {string} userId User ID
         * @param {string} currency Currency code
         * @param {CordeCommonModelsDtoBalanceAdminAdjustBalanceRequest} adjustment Balance adjustment request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceAdminUserIdCurrencyAdjustPost(userId: string, currency: string, adjustment: CordeCommonModelsDtoBalanceAdminAdjustBalanceRequest, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceAdminAdjustBalanceResponse> {
            return localVarFp.balanceAdminUserIdCurrencyAdjustPost(userId, currency, adjustment, options).then((request) => request(axios, basePath));
        },
        /**
         * Freezes specified amount from user\'s available balance (admin only)
         * @summary Admin freeze user balance
         * @param {string} userId User ID
         * @param {string} currency Currency code
         * @param {CordeCommonModelsDtoBalanceAdminFreezeBalanceRequest} freeze Freeze balance request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceAdminUserIdCurrencyFreezePost(userId: string, currency: string, freeze: CordeCommonModelsDtoBalanceAdminFreezeBalanceRequest, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceAdminFreezeBalanceResponse> {
            return localVarFp.balanceAdminUserIdCurrencyFreezePost(userId, currency, freeze, options).then((request) => request(axios, basePath));
        },
        /**
         * Sets exact user balance value (admin only)
         * @summary Admin set user balance
         * @param {string} userId User ID
         * @param {string} currency Currency code
         * @param {CordeCommonModelsDtoBalanceAdminSetBalanceRequest} setBalance Set balance request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceAdminUserIdCurrencySetPost(userId: string, currency: string, setBalance: CordeCommonModelsDtoBalanceAdminSetBalanceRequest, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceAdminSetBalanceResponse> {
            return localVarFp.balanceAdminUserIdCurrencySetPost(userId, currency, setBalance, options).then((request) => request(axios, basePath));
        },
        /**
         * Unfreezes specified amount from user\'s locked balance (admin only)
         * @summary Admin unfreeze user balance
         * @param {string} userId User ID
         * @param {string} currency Currency code
         * @param {CordeCommonModelsDtoBalanceAdminUnfreezeBalanceRequest} unfreeze Unfreeze balance request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balanceAdminUserIdCurrencyUnfreezePost(userId: string, currency: string, unfreeze: CordeCommonModelsDtoBalanceAdminUnfreezeBalanceRequest, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceAdminUnfreezeBalanceResponse> {
            return localVarFp.balanceAdminUserIdCurrencyUnfreezePost(userId, currency, unfreeze, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BalanceAdminApi - object-oriented interface
 * @export
 * @class BalanceAdminApi
 * @extends {BaseAPI}
 */
export class BalanceAdminApi extends BaseAPI {
    /**
     * Returns a paginated list of all transactions across all users (admin only)
     * @summary List all transactions
     * @param {number} [limit] Limit
     * @param {number} [offset] Offset
     * @param {string} [type] Transaction type (DEPOSIT, WITHDRAWAL, FEE, ADJUSTMENT)
     * @param {string} [status] Transaction status (PENDING, PROCESSING, COMPLETED, CANCELLED, REJECTED, FAILED)
     * @param {string} [from] Start date (RFC3339 format)
     * @param {string} [to] End date (RFC3339 format)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceAdminApi
     */
    public balanceAdminAllTransactionsGet(limit?: number, offset?: number, type?: string, status?: string, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return BalanceAdminApiFp(this.configuration).balanceAdminAllTransactionsGet(limit, offset, type, status, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Disables a currency in the system
     * @summary Disable currency (admin only)
     * @param {string} code Currency code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceAdminApi
     */
    public balanceAdminCurrenciesCodeDisablePost(code: string, options?: RawAxiosRequestConfig) {
        return BalanceAdminApiFp(this.configuration).balanceAdminCurrenciesCodeDisablePost(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an existing currency
     * @summary Update currency (admin only)
     * @param {string} code Currency code
     * @param {CordeCommonModelsDtoBalanceUpdateCurrencyRequest} currency Currency update details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceAdminApi
     */
    public balanceAdminCurrenciesCodePut(code: string, currency: CordeCommonModelsDtoBalanceUpdateCurrencyRequest, options?: RawAxiosRequestConfig) {
        return BalanceAdminApiFp(this.configuration).balanceAdminCurrenciesCodePut(code, currency, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new currency in the system
     * @summary Create a new currency (admin only)
     * @param {CordeCommonModelsDtoBalanceCreateCurrencyRequest} currency Currency details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceAdminApi
     */
    public balanceAdminCurrenciesPost(currency: CordeCommonModelsDtoBalanceCreateCurrencyRequest, options?: RawAxiosRequestConfig) {
        return BalanceAdminApiFp(this.configuration).balanceAdminCurrenciesPost(currency, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Attempts to retry transactions that are in a pending state
     * @summary Retry pending transactions
     * @param {CordeCommonModelsDtoBalanceRetryPendingTransactionsRequest} retry Retry request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceAdminApi
     */
    public balanceAdminRetryPendingPost(retry: CordeCommonModelsDtoBalanceRetryPendingTransactionsRequest, options?: RawAxiosRequestConfig) {
        return BalanceAdminApiFp(this.configuration).balanceAdminRetryPendingPost(retry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adjusts user balance by specified amount (admin only)
     * @summary Admin adjust user balance
     * @param {string} userId User ID
     * @param {string} currency Currency code
     * @param {CordeCommonModelsDtoBalanceAdminAdjustBalanceRequest} adjustment Balance adjustment request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceAdminApi
     */
    public balanceAdminUserIdCurrencyAdjustPost(userId: string, currency: string, adjustment: CordeCommonModelsDtoBalanceAdminAdjustBalanceRequest, options?: RawAxiosRequestConfig) {
        return BalanceAdminApiFp(this.configuration).balanceAdminUserIdCurrencyAdjustPost(userId, currency, adjustment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Freezes specified amount from user\'s available balance (admin only)
     * @summary Admin freeze user balance
     * @param {string} userId User ID
     * @param {string} currency Currency code
     * @param {CordeCommonModelsDtoBalanceAdminFreezeBalanceRequest} freeze Freeze balance request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceAdminApi
     */
    public balanceAdminUserIdCurrencyFreezePost(userId: string, currency: string, freeze: CordeCommonModelsDtoBalanceAdminFreezeBalanceRequest, options?: RawAxiosRequestConfig) {
        return BalanceAdminApiFp(this.configuration).balanceAdminUserIdCurrencyFreezePost(userId, currency, freeze, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets exact user balance value (admin only)
     * @summary Admin set user balance
     * @param {string} userId User ID
     * @param {string} currency Currency code
     * @param {CordeCommonModelsDtoBalanceAdminSetBalanceRequest} setBalance Set balance request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceAdminApi
     */
    public balanceAdminUserIdCurrencySetPost(userId: string, currency: string, setBalance: CordeCommonModelsDtoBalanceAdminSetBalanceRequest, options?: RawAxiosRequestConfig) {
        return BalanceAdminApiFp(this.configuration).balanceAdminUserIdCurrencySetPost(userId, currency, setBalance, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unfreezes specified amount from user\'s locked balance (admin only)
     * @summary Admin unfreeze user balance
     * @param {string} userId User ID
     * @param {string} currency Currency code
     * @param {CordeCommonModelsDtoBalanceAdminUnfreezeBalanceRequest} unfreeze Unfreeze balance request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BalanceAdminApi
     */
    public balanceAdminUserIdCurrencyUnfreezePost(userId: string, currency: string, unfreeze: CordeCommonModelsDtoBalanceAdminUnfreezeBalanceRequest, options?: RawAxiosRequestConfig) {
        return BalanceAdminApiFp(this.configuration).balanceAdminUserIdCurrencyUnfreezePost(userId, currency, unfreeze, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MachineApi - axios parameter creator
 * @export
 */
export const MachineApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Withdraws credits from a machine during an active session.
         * @summary Cash Out Machine
         * @param {CordeCommonModelsDtoMachineMachineCashOutRequest} cashOutRequest Cash Out Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashOutMachine: async (cashOutRequest: CordeCommonModelsDtoMachineMachineCashOutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cashOutRequest' is not null or undefined
            assertParamExists('cashOutMachine', 'cashOutRequest', cashOutRequest)
            const localVarPath = `/machine/cashout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cashOutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new machine by cloning an existing one.
         * @summary Clone Machine
         * @param {CordeCommonModelsDtoMachineCloneMachineRequest} cloneMachineRequest Clone Machine Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneMachine: async (cloneMachineRequest: CordeCommonModelsDtoMachineCloneMachineRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cloneMachineRequest' is not null or undefined
            assertParamExists('cloneMachine', 'cloneMachineRequest', cloneMachineRequest)
            const localVarPath = `/machine/clone`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cloneMachineRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new machine in the system.
         * @summary Create Machine
         * @param {CordeCommonModelsDtoMachineCreateMachineRequest} createMachineRequest Create Machine Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMachine: async (createMachineRequest: CordeCommonModelsDtoMachineCreateMachineRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createMachineRequest' is not null or undefined
            assertParamExists('createMachine', 'createMachineRequest', createMachineRequest)
            const localVarPath = `/machine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createMachineRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Disables a machine, making it unavailable for use.
         * @summary Disable Machine
         * @param {string} machineId Machine ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableMachine: async (machineId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'machineId' is not null or undefined
            assertParamExists('disableMachine', 'machineId', machineId)
            const localVarPath = `/machine/{machine_id}/disable`
                .replace(`{${"machine_id"}}`, encodeURIComponent(String(machineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enables a previously disabled machine.
         * @summary Enable Machine
         * @param {string} machineId Machine ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableMachine: async (machineId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'machineId' is not null or undefined
            assertParamExists('enableMachine', 'machineId', machineId)
            const localVarPath = `/machine/{machine_id}/enable`
                .replace(`{${"machine_id"}}`, encodeURIComponent(String(machineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves detailed information about a specific machine.
         * @summary Get Machine Details
         * @param {string} machineId Machine ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMachine: async (machineId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'machineId' is not null or undefined
            assertParamExists('getMachine', 'machineId', machineId)
            const localVarPath = `/machine/{machine_id}`
                .replace(`{${"machine_id"}}`, encodeURIComponent(String(machineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a paginated list of machines with optional filtering
         * @summary List machines
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {string} [sortBy] Sort field
         * @param {ListMachinesSortOrderEnum} [sortOrder] Sort order
         * @param {string} [search] Search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMachines: async (limit?: number, offset?: number, sortBy?: string, sortOrder?: ListMachinesSortOrderEnum, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/machine/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Real-time WebSocket stream of machine statuses. Returns current state of all machines on connect, then sends status updates in real-time.
         * @summary Machine Status Stream (WebSocket)
         * @param {string} authorization Bearer {token}
         * @param {string} [status] Filter by status
         * @param {string} [category] Filter by category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineStatusStream: async (authorization: string, status?: string, category?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('machineStatusStream', 'authorization', authorization)
            const localVarPath = `/machine/status-stream`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ends a game session and releases the machine.
         * @summary Release Machine
         * @param {CordeCommonModelsDtoMachineEndSessionRequest} endSessionRequest End Session Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseMachine: async (endSessionRequest: CordeCommonModelsDtoMachineEndSessionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'endSessionRequest' is not null or undefined
            assertParamExists('releaseMachine', 'endSessionRequest', endSessionRequest)
            const localVarPath = `/machine/release`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(endSessionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reserves a machine for a specific user, creating a game session.
         * @summary Reserve Machine
         * @param {CordeCommonModelsDtoMachineReserveMachineRequest} reserveMachineRequest Reserve Machine Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reserveMachine: async (reserveMachineRequest: CordeCommonModelsDtoMachineReserveMachineRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reserveMachineRequest' is not null or undefined
            assertParamExists('reserveMachine', 'reserveMachineRequest', reserveMachineRequest)
            const localVarPath = `/machine/reserve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reserveMachineRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds credits to a machine during an active session.
         * @summary Top Up Machine
         * @param {CordeCommonModelsDtoMachineMachineTopUpRequest} topUpRequest Top Up Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        topUpMachine: async (topUpRequest: CordeCommonModelsDtoMachineMachineTopUpRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'topUpRequest' is not null or undefined
            assertParamExists('topUpMachine', 'topUpRequest', topUpRequest)
            const localVarPath = `/machine/topup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(topUpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an existing machine\'s details.
         * @summary Update Machine
         * @param {string} machineId Machine ID
         * @param {CordeCommonModelsDtoMachineUpdateMachineRequest} updateMachineRequest Update Machine Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMachine: async (machineId: string, updateMachineRequest: CordeCommonModelsDtoMachineUpdateMachineRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'machineId' is not null or undefined
            assertParamExists('updateMachine', 'machineId', machineId)
            // verify required parameter 'updateMachineRequest' is not null or undefined
            assertParamExists('updateMachine', 'updateMachineRequest', updateMachineRequest)
            const localVarPath = `/machine/{machine_id}`
                .replace(`{${"machine_id"}}`, encodeURIComponent(String(machineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMachineRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MachineApi - functional programming interface
 * @export
 */
export const MachineApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MachineApiAxiosParamCreator(configuration)
    return {
        /**
         * Withdraws credits from a machine during an active session.
         * @summary Cash Out Machine
         * @param {CordeCommonModelsDtoMachineMachineCashOutRequest} cashOutRequest Cash Out Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cashOutMachine(cashOutRequest: CordeCommonModelsDtoMachineMachineCashOutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceTransaction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cashOutMachine(cashOutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MachineApi.cashOutMachine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new machine by cloning an existing one.
         * @summary Clone Machine
         * @param {CordeCommonModelsDtoMachineCloneMachineRequest} cloneMachineRequest Clone Machine Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cloneMachine(cloneMachineRequest: CordeCommonModelsDtoMachineCloneMachineRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoMachineMachine>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cloneMachine(cloneMachineRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MachineApi.cloneMachine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new machine in the system.
         * @summary Create Machine
         * @param {CordeCommonModelsDtoMachineCreateMachineRequest} createMachineRequest Create Machine Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createMachine(createMachineRequest: CordeCommonModelsDtoMachineCreateMachineRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoMachineMachine>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createMachine(createMachineRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MachineApi.createMachine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Disables a machine, making it unavailable for use.
         * @summary Disable Machine
         * @param {string} machineId Machine ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableMachine(machineId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoMachineMachine>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableMachine(machineId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MachineApi.disableMachine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Enables a previously disabled machine.
         * @summary Enable Machine
         * @param {string} machineId Machine ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enableMachine(machineId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableMachine(machineId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MachineApi.enableMachine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves detailed information about a specific machine.
         * @summary Get Machine Details
         * @param {string} machineId Machine ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMachine(machineId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoMachineMachine>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMachine(machineId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MachineApi.getMachine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a paginated list of machines with optional filtering
         * @summary List machines
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {string} [sortBy] Sort field
         * @param {ListMachinesSortOrderEnum} [sortOrder] Sort order
         * @param {string} [search] Search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMachines(limit?: number, offset?: number, sortBy?: string, sortOrder?: ListMachinesSortOrderEnum, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoMachineListMachinesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMachines(limit, offset, sortBy, sortOrder, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MachineApi.listMachines']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Real-time WebSocket stream of machine statuses. Returns current state of all machines on connect, then sends status updates in real-time.
         * @summary Machine Status Stream (WebSocket)
         * @param {string} authorization Bearer {token}
         * @param {string} [status] Filter by status
         * @param {string} [category] Filter by category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async machineStatusStream(authorization: string, status?: string, category?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.machineStatusStream(authorization, status, category, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MachineApi.machineStatusStream']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Ends a game session and releases the machine.
         * @summary Release Machine
         * @param {CordeCommonModelsDtoMachineEndSessionRequest} endSessionRequest End Session Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async releaseMachine(endSessionRequest: CordeCommonModelsDtoMachineEndSessionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.releaseMachine(endSessionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MachineApi.releaseMachine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reserves a machine for a specific user, creating a game session.
         * @summary Reserve Machine
         * @param {CordeCommonModelsDtoMachineReserveMachineRequest} reserveMachineRequest Reserve Machine Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reserveMachine(reserveMachineRequest: CordeCommonModelsDtoMachineReserveMachineRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoMachineGameSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reserveMachine(reserveMachineRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MachineApi.reserveMachine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Adds credits to a machine during an active session.
         * @summary Top Up Machine
         * @param {CordeCommonModelsDtoMachineMachineTopUpRequest} topUpRequest Top Up Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async topUpMachine(topUpRequest: CordeCommonModelsDtoMachineMachineTopUpRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoBalanceTransaction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.topUpMachine(topUpRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MachineApi.topUpMachine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates an existing machine\'s details.
         * @summary Update Machine
         * @param {string} machineId Machine ID
         * @param {CordeCommonModelsDtoMachineUpdateMachineRequest} updateMachineRequest Update Machine Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMachine(machineId: string, updateMachineRequest: CordeCommonModelsDtoMachineUpdateMachineRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoMachineMachine>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMachine(machineId, updateMachineRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MachineApi.updateMachine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MachineApi - factory interface
 * @export
 */
export const MachineApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MachineApiFp(configuration)
    return {
        /**
         * Withdraws credits from a machine during an active session.
         * @summary Cash Out Machine
         * @param {CordeCommonModelsDtoMachineMachineCashOutRequest} cashOutRequest Cash Out Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashOutMachine(cashOutRequest: CordeCommonModelsDtoMachineMachineCashOutRequest, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceTransaction> {
            return localVarFp.cashOutMachine(cashOutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new machine by cloning an existing one.
         * @summary Clone Machine
         * @param {CordeCommonModelsDtoMachineCloneMachineRequest} cloneMachineRequest Clone Machine Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cloneMachine(cloneMachineRequest: CordeCommonModelsDtoMachineCloneMachineRequest, options?: any): AxiosPromise<CordeCommonModelsDtoMachineMachine> {
            return localVarFp.cloneMachine(cloneMachineRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new machine in the system.
         * @summary Create Machine
         * @param {CordeCommonModelsDtoMachineCreateMachineRequest} createMachineRequest Create Machine Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMachine(createMachineRequest: CordeCommonModelsDtoMachineCreateMachineRequest, options?: any): AxiosPromise<CordeCommonModelsDtoMachineMachine> {
            return localVarFp.createMachine(createMachineRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Disables a machine, making it unavailable for use.
         * @summary Disable Machine
         * @param {string} machineId Machine ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableMachine(machineId: string, options?: any): AxiosPromise<CordeCommonModelsDtoMachineMachine> {
            return localVarFp.disableMachine(machineId, options).then((request) => request(axios, basePath));
        },
        /**
         * Enables a previously disabled machine.
         * @summary Enable Machine
         * @param {string} machineId Machine ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableMachine(machineId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.enableMachine(machineId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves detailed information about a specific machine.
         * @summary Get Machine Details
         * @param {string} machineId Machine ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMachine(machineId: string, options?: any): AxiosPromise<CordeCommonModelsDtoMachineMachine> {
            return localVarFp.getMachine(machineId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a paginated list of machines with optional filtering
         * @summary List machines
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {string} [sortBy] Sort field
         * @param {ListMachinesSortOrderEnum} [sortOrder] Sort order
         * @param {string} [search] Search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMachines(limit?: number, offset?: number, sortBy?: string, sortOrder?: ListMachinesSortOrderEnum, search?: string, options?: any): AxiosPromise<CordeCommonModelsDtoMachineListMachinesResponse> {
            return localVarFp.listMachines(limit, offset, sortBy, sortOrder, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Real-time WebSocket stream of machine statuses. Returns current state of all machines on connect, then sends status updates in real-time.
         * @summary Machine Status Stream (WebSocket)
         * @param {string} authorization Bearer {token}
         * @param {string} [status] Filter by status
         * @param {string} [category] Filter by category
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        machineStatusStream(authorization: string, status?: string, category?: string, options?: any): AxiosPromise<void> {
            return localVarFp.machineStatusStream(authorization, status, category, options).then((request) => request(axios, basePath));
        },
        /**
         * Ends a game session and releases the machine.
         * @summary Release Machine
         * @param {CordeCommonModelsDtoMachineEndSessionRequest} endSessionRequest End Session Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseMachine(endSessionRequest: CordeCommonModelsDtoMachineEndSessionRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.releaseMachine(endSessionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Reserves a machine for a specific user, creating a game session.
         * @summary Reserve Machine
         * @param {CordeCommonModelsDtoMachineReserveMachineRequest} reserveMachineRequest Reserve Machine Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reserveMachine(reserveMachineRequest: CordeCommonModelsDtoMachineReserveMachineRequest, options?: any): AxiosPromise<CordeCommonModelsDtoMachineGameSession> {
            return localVarFp.reserveMachine(reserveMachineRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds credits to a machine during an active session.
         * @summary Top Up Machine
         * @param {CordeCommonModelsDtoMachineMachineTopUpRequest} topUpRequest Top Up Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        topUpMachine(topUpRequest: CordeCommonModelsDtoMachineMachineTopUpRequest, options?: any): AxiosPromise<CordeCommonModelsDtoBalanceTransaction> {
            return localVarFp.topUpMachine(topUpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an existing machine\'s details.
         * @summary Update Machine
         * @param {string} machineId Machine ID
         * @param {CordeCommonModelsDtoMachineUpdateMachineRequest} updateMachineRequest Update Machine Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMachine(machineId: string, updateMachineRequest: CordeCommonModelsDtoMachineUpdateMachineRequest, options?: any): AxiosPromise<CordeCommonModelsDtoMachineMachine> {
            return localVarFp.updateMachine(machineId, updateMachineRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MachineApi - object-oriented interface
 * @export
 * @class MachineApi
 * @extends {BaseAPI}
 */
export class MachineApi extends BaseAPI {
    /**
     * Withdraws credits from a machine during an active session.
     * @summary Cash Out Machine
     * @param {CordeCommonModelsDtoMachineMachineCashOutRequest} cashOutRequest Cash Out Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineApi
     */
    public cashOutMachine(cashOutRequest: CordeCommonModelsDtoMachineMachineCashOutRequest, options?: RawAxiosRequestConfig) {
        return MachineApiFp(this.configuration).cashOutMachine(cashOutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new machine by cloning an existing one.
     * @summary Clone Machine
     * @param {CordeCommonModelsDtoMachineCloneMachineRequest} cloneMachineRequest Clone Machine Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineApi
     */
    public cloneMachine(cloneMachineRequest: CordeCommonModelsDtoMachineCloneMachineRequest, options?: RawAxiosRequestConfig) {
        return MachineApiFp(this.configuration).cloneMachine(cloneMachineRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new machine in the system.
     * @summary Create Machine
     * @param {CordeCommonModelsDtoMachineCreateMachineRequest} createMachineRequest Create Machine Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineApi
     */
    public createMachine(createMachineRequest: CordeCommonModelsDtoMachineCreateMachineRequest, options?: RawAxiosRequestConfig) {
        return MachineApiFp(this.configuration).createMachine(createMachineRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Disables a machine, making it unavailable for use.
     * @summary Disable Machine
     * @param {string} machineId Machine ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineApi
     */
    public disableMachine(machineId: string, options?: RawAxiosRequestConfig) {
        return MachineApiFp(this.configuration).disableMachine(machineId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enables a previously disabled machine.
     * @summary Enable Machine
     * @param {string} machineId Machine ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineApi
     */
    public enableMachine(machineId: string, options?: RawAxiosRequestConfig) {
        return MachineApiFp(this.configuration).enableMachine(machineId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves detailed information about a specific machine.
     * @summary Get Machine Details
     * @param {string} machineId Machine ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineApi
     */
    public getMachine(machineId: string, options?: RawAxiosRequestConfig) {
        return MachineApiFp(this.configuration).getMachine(machineId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a paginated list of machines with optional filtering
     * @summary List machines
     * @param {number} [limit] Number of items to return
     * @param {number} [offset] Number of items to skip
     * @param {string} [sortBy] Sort field
     * @param {ListMachinesSortOrderEnum} [sortOrder] Sort order
     * @param {string} [search] Search query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineApi
     */
    public listMachines(limit?: number, offset?: number, sortBy?: string, sortOrder?: ListMachinesSortOrderEnum, search?: string, options?: RawAxiosRequestConfig) {
        return MachineApiFp(this.configuration).listMachines(limit, offset, sortBy, sortOrder, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Real-time WebSocket stream of machine statuses. Returns current state of all machines on connect, then sends status updates in real-time.
     * @summary Machine Status Stream (WebSocket)
     * @param {string} authorization Bearer {token}
     * @param {string} [status] Filter by status
     * @param {string} [category] Filter by category
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineApi
     */
    public machineStatusStream(authorization: string, status?: string, category?: string, options?: RawAxiosRequestConfig) {
        return MachineApiFp(this.configuration).machineStatusStream(authorization, status, category, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ends a game session and releases the machine.
     * @summary Release Machine
     * @param {CordeCommonModelsDtoMachineEndSessionRequest} endSessionRequest End Session Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineApi
     */
    public releaseMachine(endSessionRequest: CordeCommonModelsDtoMachineEndSessionRequest, options?: RawAxiosRequestConfig) {
        return MachineApiFp(this.configuration).releaseMachine(endSessionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reserves a machine for a specific user, creating a game session.
     * @summary Reserve Machine
     * @param {CordeCommonModelsDtoMachineReserveMachineRequest} reserveMachineRequest Reserve Machine Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineApi
     */
    public reserveMachine(reserveMachineRequest: CordeCommonModelsDtoMachineReserveMachineRequest, options?: RawAxiosRequestConfig) {
        return MachineApiFp(this.configuration).reserveMachine(reserveMachineRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adds credits to a machine during an active session.
     * @summary Top Up Machine
     * @param {CordeCommonModelsDtoMachineMachineTopUpRequest} topUpRequest Top Up Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineApi
     */
    public topUpMachine(topUpRequest: CordeCommonModelsDtoMachineMachineTopUpRequest, options?: RawAxiosRequestConfig) {
        return MachineApiFp(this.configuration).topUpMachine(topUpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an existing machine\'s details.
     * @summary Update Machine
     * @param {string} machineId Machine ID
     * @param {CordeCommonModelsDtoMachineUpdateMachineRequest} updateMachineRequest Update Machine Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineApi
     */
    public updateMachine(machineId: string, updateMachineRequest: CordeCommonModelsDtoMachineUpdateMachineRequest, options?: RawAxiosRequestConfig) {
        return MachineApiFp(this.configuration).updateMachine(machineId, updateMachineRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListMachinesSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListMachinesSortOrderEnum = typeof ListMachinesSortOrderEnum[keyof typeof ListMachinesSortOrderEnum];


/**
 * MachineProxyApi - axios parameter creator
 * @export
 */
export const MachineProxyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Adds a new machine to be managed by a specific proxy.
         * @summary Add Managed Machine
         * @param {CordeCommonModelsDtoMachineManagedMachineConfig} managedMachineRequest Managed Machine Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addManagedMachine: async (managedMachineRequest: CordeCommonModelsDtoMachineManagedMachineConfig, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'managedMachineRequest' is not null or undefined
            assertParamExists('addManagedMachine', 'managedMachineRequest', managedMachineRequest)
            const localVarPath = `/machine/proxy/managed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(managedMachineRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the current status of a specific machine.
         * @summary Get Machine Status
         * @param {string} machineId Machine ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMachineStatus: async (machineId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'machineId' is not null or undefined
            assertParamExists('getMachineStatus', 'machineId', machineId)
            const localVarPath = `/machine/proxy/status/{machine_id}`
                .replace(`{${"machine_id"}}`, encodeURIComponent(String(machineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bidirectional WebSocket connection for streaming button events
         * @summary Button Events WebSocket Stream
         * @param {string} authorization Bearer {token}
         * @param {string} machineId Machine ID
         * @param {string} sessionId Session ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleButtonEvents: async (authorization: string, machineId: string, sessionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('handleButtonEvents', 'authorization', authorization)
            // verify required parameter 'machineId' is not null or undefined
            assertParamExists('handleButtonEvents', 'machineId', machineId)
            // verify required parameter 'sessionId' is not null or undefined
            assertParamExists('handleButtonEvents', 'sessionId', sessionId)
            const localVarPath = `/machine/proxy/buttons-stream`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (machineId !== undefined) {
                localVarQueryParameter['machine_id'] = machineId;
            }

            if (sessionId !== undefined) {
                localVarQueryParameter['session_id'] = sessionId;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Withdraws credits from a machine through the physical proxy.
         * @summary Cash Out via Proxy
         * @param {CordeCommonModelsDtoMachineProxyCashOutRequest} proxyCashOutRequest Proxy Cash Out Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proxyCashOut: async (proxyCashOutRequest: CordeCommonModelsDtoMachineProxyCashOutRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'proxyCashOutRequest' is not null or undefined
            assertParamExists('proxyCashOut', 'proxyCashOutRequest', proxyCashOutRequest)
            const localVarPath = `/machine/proxy/cashout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(proxyCashOutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds credits to a machine through the physical proxy.
         * @summary Top Up via Proxy
         * @param {CordeCommonModelsDtoMachineProxyTopUpRequest} proxyTopUpRequest Proxy Top Up Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proxyTopUp: async (proxyTopUpRequest: CordeCommonModelsDtoMachineProxyTopUpRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'proxyTopUpRequest' is not null or undefined
            assertParamExists('proxyTopUp', 'proxyTopUpRequest', proxyTopUpRequest)
            const localVarPath = `/machine/proxy/topup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(proxyTopUpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Removes a machine from being managed by a proxy.
         * @summary Remove Managed Machine
         * @param {CordeCommonModelsDtoMachineManagedMachineID} managedMachineIdRequest Managed Machine ID Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeManagedMachine: async (managedMachineIdRequest: CordeCommonModelsDtoMachineManagedMachineID, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'managedMachineIdRequest' is not null or undefined
            assertParamExists('removeManagedMachine', 'managedMachineIdRequest', managedMachineIdRequest)
            const localVarPath = `/machine/proxy/managed/remove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(managedMachineIdRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MachineProxyApi - functional programming interface
 * @export
 */
export const MachineProxyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MachineProxyApiAxiosParamCreator(configuration)
    return {
        /**
         * Adds a new machine to be managed by a specific proxy.
         * @summary Add Managed Machine
         * @param {CordeCommonModelsDtoMachineManagedMachineConfig} managedMachineRequest Managed Machine Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addManagedMachine(managedMachineRequest: CordeCommonModelsDtoMachineManagedMachineConfig, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addManagedMachine(managedMachineRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MachineProxyApi.addManagedMachine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the current status of a specific machine.
         * @summary Get Machine Status
         * @param {string} machineId Machine ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMachineStatus(machineId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoMachineGetStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMachineStatus(machineId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MachineProxyApi.getMachineStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Bidirectional WebSocket connection for streaming button events
         * @summary Button Events WebSocket Stream
         * @param {string} authorization Bearer {token}
         * @param {string} machineId Machine ID
         * @param {string} sessionId Session ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleButtonEvents(authorization: string, machineId: string, sessionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleButtonEvents(authorization, machineId, sessionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MachineProxyApi.handleButtonEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Withdraws credits from a machine through the physical proxy.
         * @summary Cash Out via Proxy
         * @param {CordeCommonModelsDtoMachineProxyCashOutRequest} proxyCashOutRequest Proxy Cash Out Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async proxyCashOut(proxyCashOutRequest: CordeCommonModelsDtoMachineProxyCashOutRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoMachineProxyCashOutResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.proxyCashOut(proxyCashOutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MachineProxyApi.proxyCashOut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Adds credits to a machine through the physical proxy.
         * @summary Top Up via Proxy
         * @param {CordeCommonModelsDtoMachineProxyTopUpRequest} proxyTopUpRequest Proxy Top Up Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async proxyTopUp(proxyTopUpRequest: CordeCommonModelsDtoMachineProxyTopUpRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoMachineProxyTopUpResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.proxyTopUp(proxyTopUpRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MachineProxyApi.proxyTopUp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Removes a machine from being managed by a proxy.
         * @summary Remove Managed Machine
         * @param {CordeCommonModelsDtoMachineManagedMachineID} managedMachineIdRequest Managed Machine ID Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeManagedMachine(managedMachineIdRequest: CordeCommonModelsDtoMachineManagedMachineID, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeManagedMachine(managedMachineIdRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MachineProxyApi.removeManagedMachine']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MachineProxyApi - factory interface
 * @export
 */
export const MachineProxyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MachineProxyApiFp(configuration)
    return {
        /**
         * Adds a new machine to be managed by a specific proxy.
         * @summary Add Managed Machine
         * @param {CordeCommonModelsDtoMachineManagedMachineConfig} managedMachineRequest Managed Machine Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addManagedMachine(managedMachineRequest: CordeCommonModelsDtoMachineManagedMachineConfig, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.addManagedMachine(managedMachineRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the current status of a specific machine.
         * @summary Get Machine Status
         * @param {string} machineId Machine ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMachineStatus(machineId: string, options?: any): AxiosPromise<CordeCommonModelsDtoMachineGetStatusResponse> {
            return localVarFp.getMachineStatus(machineId, options).then((request) => request(axios, basePath));
        },
        /**
         * Bidirectional WebSocket connection for streaming button events
         * @summary Button Events WebSocket Stream
         * @param {string} authorization Bearer {token}
         * @param {string} machineId Machine ID
         * @param {string} sessionId Session ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleButtonEvents(authorization: string, machineId: string, sessionId: string, options?: any): AxiosPromise<void> {
            return localVarFp.handleButtonEvents(authorization, machineId, sessionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Withdraws credits from a machine through the physical proxy.
         * @summary Cash Out via Proxy
         * @param {CordeCommonModelsDtoMachineProxyCashOutRequest} proxyCashOutRequest Proxy Cash Out Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proxyCashOut(proxyCashOutRequest: CordeCommonModelsDtoMachineProxyCashOutRequest, options?: any): AxiosPromise<CordeCommonModelsDtoMachineProxyCashOutResponse> {
            return localVarFp.proxyCashOut(proxyCashOutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Adds credits to a machine through the physical proxy.
         * @summary Top Up via Proxy
         * @param {CordeCommonModelsDtoMachineProxyTopUpRequest} proxyTopUpRequest Proxy Top Up Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proxyTopUp(proxyTopUpRequest: CordeCommonModelsDtoMachineProxyTopUpRequest, options?: any): AxiosPromise<CordeCommonModelsDtoMachineProxyTopUpResponse> {
            return localVarFp.proxyTopUp(proxyTopUpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes a machine from being managed by a proxy.
         * @summary Remove Managed Machine
         * @param {CordeCommonModelsDtoMachineManagedMachineID} managedMachineIdRequest Managed Machine ID Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeManagedMachine(managedMachineIdRequest: CordeCommonModelsDtoMachineManagedMachineID, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.removeManagedMachine(managedMachineIdRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MachineProxyApi - object-oriented interface
 * @export
 * @class MachineProxyApi
 * @extends {BaseAPI}
 */
export class MachineProxyApi extends BaseAPI {
    /**
     * Adds a new machine to be managed by a specific proxy.
     * @summary Add Managed Machine
     * @param {CordeCommonModelsDtoMachineManagedMachineConfig} managedMachineRequest Managed Machine Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineProxyApi
     */
    public addManagedMachine(managedMachineRequest: CordeCommonModelsDtoMachineManagedMachineConfig, options?: RawAxiosRequestConfig) {
        return MachineProxyApiFp(this.configuration).addManagedMachine(managedMachineRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the current status of a specific machine.
     * @summary Get Machine Status
     * @param {string} machineId Machine ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineProxyApi
     */
    public getMachineStatus(machineId: string, options?: RawAxiosRequestConfig) {
        return MachineProxyApiFp(this.configuration).getMachineStatus(machineId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Bidirectional WebSocket connection for streaming button events
     * @summary Button Events WebSocket Stream
     * @param {string} authorization Bearer {token}
     * @param {string} machineId Machine ID
     * @param {string} sessionId Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineProxyApi
     */
    public handleButtonEvents(authorization: string, machineId: string, sessionId: string, options?: RawAxiosRequestConfig) {
        return MachineProxyApiFp(this.configuration).handleButtonEvents(authorization, machineId, sessionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Withdraws credits from a machine through the physical proxy.
     * @summary Cash Out via Proxy
     * @param {CordeCommonModelsDtoMachineProxyCashOutRequest} proxyCashOutRequest Proxy Cash Out Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineProxyApi
     */
    public proxyCashOut(proxyCashOutRequest: CordeCommonModelsDtoMachineProxyCashOutRequest, options?: RawAxiosRequestConfig) {
        return MachineProxyApiFp(this.configuration).proxyCashOut(proxyCashOutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adds credits to a machine through the physical proxy.
     * @summary Top Up via Proxy
     * @param {CordeCommonModelsDtoMachineProxyTopUpRequest} proxyTopUpRequest Proxy Top Up Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineProxyApi
     */
    public proxyTopUp(proxyTopUpRequest: CordeCommonModelsDtoMachineProxyTopUpRequest, options?: RawAxiosRequestConfig) {
        return MachineProxyApiFp(this.configuration).proxyTopUp(proxyTopUpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Removes a machine from being managed by a proxy.
     * @summary Remove Managed Machine
     * @param {CordeCommonModelsDtoMachineManagedMachineID} managedMachineIdRequest Managed Machine ID Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MachineProxyApi
     */
    public removeManagedMachine(managedMachineIdRequest: CordeCommonModelsDtoMachineManagedMachineID, options?: RawAxiosRequestConfig) {
        return MachineProxyApiFp(this.configuration).removeManagedMachine(managedMachineIdRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Cancels a previously scheduled notification
         * @summary Cancel Scheduled Notification
         * @param {string} scheduleId Schedule ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelScheduledNotification: async (scheduleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scheduleId' is not null or undefined
            assertParamExists('cancelScheduledNotification', 'scheduleId', scheduleId)
            const localVarPath = `/notification/schedule/{schedule_id}`
                .replace(`{${"schedule_id"}}`, encodeURIComponent(String(scheduleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new notification channel
         * @summary Create Channel
         * @param {CordeCommonModelsDtoNotificationsCreateChannelRequest} channel Channel to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChannel: async (channel: CordeCommonModelsDtoNotificationsCreateChannelRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'channel' is not null or undefined
            assertParamExists('createChannel', 'channel', channel)
            const localVarPath = `/notification/channel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(channel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new contact for an entity
         * @summary Create Contact
         * @param {CordeCommonModelsDtoNotificationsCreateContactRequest} contact Contact to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContact: async (contact: CordeCommonModelsDtoNotificationsCreateContactRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contact' is not null or undefined
            assertParamExists('createContact', 'contact', contact)
            const localVarPath = `/notification/contact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contact, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new notification template
         * @summary Create Template
         * @param {CordeCommonModelsDtoNotificationsCreateTemplateRequest} template Template to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplate: async (template: CordeCommonModelsDtoNotificationsCreateTemplateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'template' is not null or undefined
            assertParamExists('createTemplate', 'template', template)
            const localVarPath = `/notification/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(template, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a notification channel
         * @summary Delete Channel
         * @param {string} channelId Channel ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChannel: async (channelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('deleteChannel', 'channelId', channelId)
            const localVarPath = `/notification/channel/{channel_id}`
                .replace(`{${"channel_id"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a contact
         * @summary Delete Contact
         * @param {string} contactId Contact ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContact: async (contactId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('deleteContact', 'contactId', contactId)
            const localVarPath = `/notification/contact/{contact_id}`
                .replace(`{${"contact_id"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a notification template
         * @summary Delete Template
         * @param {string} templateId Template ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplate: async (templateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('deleteTemplate', 'templateId', templateId)
            const localVarPath = `/notification/template/{template_id}`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a notification channel by ID
         * @summary Get Channel
         * @param {string} channelId Channel ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChannel: async (channelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('getChannel', 'channelId', channelId)
            const localVarPath = `/notification/channel/{channel_id}`
                .replace(`{${"channel_id"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets health status of a notification channel
         * @summary Get Channel Health
         * @param {string} channelId Channel ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChannelHealth: async (channelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('getChannelHealth', 'channelId', channelId)
            const localVarPath = `/notification/channel/{channel_id}/health`
                .replace(`{${"channel_id"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a contact by ID
         * @summary Get Contact
         * @param {string} contactId Contact ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContact: async (contactId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('getContact', 'contactId', contactId)
            const localVarPath = `/notification/contact/{contact_id}`
                .replace(`{${"contact_id"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a contact by its value (email, phone, etc.)
         * @summary Get Contact By Value
         * @param {string} value Contact value
         * @param {string} type Contact type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactByValue: async (value: string, type: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'value' is not null or undefined
            assertParamExists('getContactByValue', 'value', value)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getContactByValue', 'type', type)
            const localVarPath = `/notification/contact/by-value`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets detailed delivery report for a specific notification
         * @summary Get Delivery Report
         * @param {string} notificationId Notification ID
         * @param {boolean} [includeAttempts] Include delivery attempt details
         * @param {boolean} [includeEvents] Include delivery events timeline
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryReport: async (notificationId: string, includeAttempts?: boolean, includeEvents?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('getDeliveryReport', 'notificationId', notificationId)
            const localVarPath = `/notification/{notification_id}/delivery-report`
                .replace(`{${"notification_id"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (includeAttempts !== undefined) {
                localVarQueryParameter['include_attempts'] = includeAttempts;
            }

            if (includeEvents !== undefined) {
                localVarQueryParameter['include_events'] = includeEvents;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets statistical data about notifications
         * @summary Get Notification Stats
         * @param {string} [startDate] Start date for statistics (RFC3339 format)
         * @param {string} [endDate] End date for statistics (RFC3339 format)
         * @param {string} [channelType] Filter by channel type
         * @param {string} [userId] Filter by user ID
         * @param {string} [platformId] Filter by platform ID
         * @param {string} [granularity] Granularity (hour, day, week, month)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationStats: async (startDate?: string, endDate?: string, channelType?: string, userId?: string, platformId?: string, granularity?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notification/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (channelType !== undefined) {
                localVarQueryParameter['channel_type'] = channelType;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (platformId !== undefined) {
                localVarQueryParameter['platform_id'] = platformId;
            }

            if (granularity !== undefined) {
                localVarQueryParameter['granularity'] = granularity;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets the status of a specific notification
         * @summary Get Notification Status
         * @param {string} notificationId Notification ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationStatus: async (notificationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('getNotificationStatus', 'notificationId', notificationId)
            const localVarPath = `/notification/{notification_id}/status`
                .replace(`{${"notification_id"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets audit logs for notification-related activities
         * @summary Get Notifications Audit Logs
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [startDate] Start date filter (RFC3339 format)
         * @param {string} [endDate] End date filter (RFC3339 format)
         * @param {string} [action] Filter by action type
         * @param {string} [entityType] Filter by entity type
         * @param {string} [entityId] Filter by entity ID
         * @param {string} [userId] Filter by user ID
         * @param {string} [platformId] Filter by platform ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationsAuditLogs: async (limit?: number, offset?: number, startDate?: string, endDate?: string, action?: string, entityType?: string, entityId?: string, userId?: string, platformId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notification/audit-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }

            if (entityType !== undefined) {
                localVarQueryParameter['entity_type'] = entityType;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entity_id'] = entityId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (platformId !== undefined) {
                localVarQueryParameter['platform_id'] = platformId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets personal notification overrides for a team member
         * @summary Get Team Member Notification Overrides
         * @param {string} teamId Team ID
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamMemberNotificationOverrides: async (teamId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamMemberNotificationOverrides', 'teamId', teamId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getTeamMemberNotificationOverrides', 'userId', userId)
            const localVarPath = `/notification/team/{team_id}/member/{user_id}/notification-overrides`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets notification settings for a team (respecting user preferences)
         * @summary Get Team Notification Settings
         * @param {string} teamId Team ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamNotificationSettings: async (teamId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamNotificationSettings', 'teamId', teamId)
            const localVarPath = `/notification/team/{team_id}/notification-settings`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets a notification template by ID
         * @summary Get Template
         * @param {string} templateId Template ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplate: async (templateId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('getTemplate', 'templateId', templateId)
            const localVarPath = `/notification/template/{template_id}`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Gets event-specific channel settings for a user (event -> multiple channels with contact mapping)
         * @summary Get User Event Channel Settings
         * @param {string} userId User ID
         * @param {string} [eventType] Filter by event type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserEventChannelSettings: async (userId: string, eventType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserEventChannelSettings', 'userId', userId)
            const localVarPath = `/notification/user/{user_id}/event-channel-settings`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (eventType !== undefined) {
                localVarQueryParameter['event_type'] = eventType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists all notification channels with optional filtering
         * @summary List Channels
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [type] Filter by channel type
         * @param {boolean} [enabled] Filter by enabled status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChannels: async (limit?: number, offset?: number, type?: string, enabled?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notification/channels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (enabled !== undefined) {
                localVarQueryParameter['enabled'] = enabled;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists contacts with optional filtering
         * @summary List Contacts
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [entityType] Filter by entity type
         * @param {string} [entityId] Filter by entity ID
         * @param {string} [contactType] Filter by contact type
         * @param {boolean} [verifiedOnly] Show only verified contacts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listContacts: async (limit?: number, offset?: number, entityType?: string, entityId?: string, contactType?: string, verifiedOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notification/contact/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (entityType !== undefined) {
                localVarQueryParameter['entity_type'] = entityType;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entity_id'] = entityId;
            }

            if (contactType !== undefined) {
                localVarQueryParameter['contact_type'] = contactType;
            }

            if (verifiedOnly !== undefined) {
                localVarQueryParameter['verified_only'] = verifiedOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists all scheduled notifications with optional filtering
         * @summary List Scheduled Notifications
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [userId] Filter by user ID
         * @param {string} [status] Filter by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScheduledNotifications: async (limit?: number, offset?: number, userId?: string, status?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notification/scheduled`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists all notification templates with optional filtering
         * @summary List Templates
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [channelType] Filter by channel type
         * @param {string} [language] Filter by language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplates: async (limit?: number, offset?: number, channelType?: string, language?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notification/templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (channelType !== undefined) {
                localVarQueryParameter['channel_type'] = channelType;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists notifications for a specific user
         * @summary List User Notifications
         * @param {string} userId User ID
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserNotifications: async (userId: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('listUserNotifications', 'userId', userId)
            const localVarPath = `/notification/user/{user_id}/notifications`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Marks all notifications for a user as read
         * @summary Mark All Notifications As Read
         * @param {CordeCommonModelsDtoNotificationsMarkAllNotificationsAsReadRequest} request Mark all as read request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAllNotificationsAsRead: async (request: CordeCommonModelsDtoNotificationsMarkAllNotificationsAsReadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('markAllNotificationsAsRead', 'request', request)
            const localVarPath = `/notification/mark-all-read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Marks a specific notification as read
         * @summary Mark Notification As Read
         * @param {string} notificationId Notification ID
         * @param {CordeCommonModelsDtoNotificationsMarkNotificationAsReadRequest} request Mark as read request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationAsRead: async (notificationId: string, request: CordeCommonModelsDtoNotificationsMarkNotificationAsReadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('markNotificationAsRead', 'notificationId', notificationId)
            // verify required parameter 'request' is not null or undefined
            assertParamExists('markNotificationAsRead', 'request', request)
            const localVarPath = `/notification/{notification_id}/mark-read`
                .replace(`{${"notification_id"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Processes delivery confirmation webhooks from notification providers
         * @summary Process Delivery Confirmation
         * @param {CordeCommonModelsDtoNotificationsProcessDeliveryConfirmationRequest} confirmation Delivery confirmation data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processDeliveryConfirmation: async (confirmation: CordeCommonModelsDtoNotificationsProcessDeliveryConfirmationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'confirmation' is not null or undefined
            assertParamExists('processDeliveryConfirmation', 'confirmation', confirmation)
            const localVarPath = `/notification/delivery-confirmation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(confirmation, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Schedules a notification for future delivery
         * @summary Schedule Notification
         * @param {CordeCommonModelsDtoNotificationsScheduleNotificationRequest} notification Notification to schedule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleNotification: async (notification: CordeCommonModelsDtoNotificationsScheduleNotificationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notification' is not null or undefined
            assertParamExists('scheduleNotification', 'notification', notification)
            const localVarPath = `/notification/schedule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notification, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Searches contacts by value or other criteria
         * @summary Search Contacts
         * @param {string} q Search query
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [contactType] Filter by contact type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchContacts: async (q: string, limit?: number, offset?: number, contactType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('searchContacts', 'q', q)
            const localVarPath = `/notification/contact/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (contactType !== undefined) {
                localVarQueryParameter['contact_type'] = contactType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends multiple notifications to users
         * @summary Send Bulk Notifications
         * @param {CordeCommonModelsDtoNotificationsSendBulkNotificationsRequest} notifications Bulk notifications to send
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBulkNotifications: async (notifications: CordeCommonModelsDtoNotificationsSendBulkNotificationsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notifications' is not null or undefined
            assertParamExists('sendBulkNotifications', 'notifications', notifications)
            const localVarPath = `/notification/send-bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notifications, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends a verification message to a contact
         * @summary Send Contact Verification
         * @param {string} contactId Contact ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendContactVerification: async (contactId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('sendContactVerification', 'contactId', contactId)
            const localVarPath = `/notification/contact/{contact_id}/send-verification`
                .replace(`{${"contact_id"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends a single notification to a user
         * @summary Send Notification
         * @param {CordeCommonModelsDtoNotificationsSendNotificationRequest} notification Notification to send
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNotification: async (notification: CordeCommonModelsDtoNotificationsSendNotificationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notification' is not null or undefined
            assertParamExists('sendNotification', 'notification', notification)
            const localVarPath = `/notification/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notification, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends a smart notification with automatic channel selection
         * @summary Send Smart Notification
         * @param {CordeCommonModelsDtoNotificationsSendSmartNotificationRequest} notification Smart notification to send
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSmartNotification: async (notification: CordeCommonModelsDtoNotificationsSendSmartNotificationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notification' is not null or undefined
            assertParamExists('sendSmartNotification', 'notification', notification)
            const localVarPath = `/notification/send-smart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notification, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets a contact as primary for an entity and contact type
         * @summary Set Primary Contact
         * @param {CordeCommonModelsDtoNotificationsSetPrimaryContactRequest} request Primary contact data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPrimaryContact: async (request: CordeCommonModelsDtoNotificationsSetPrimaryContactRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'request' is not null or undefined
            assertParamExists('setPrimaryContact', 'request', request)
            const localVarPath = `/notification/contact/set-primary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Tests a notification channel configuration
         * @summary Test Channel
         * @param {string} channelId Channel ID
         * @param {CordeCommonModelsDtoNotificationsTestChannelRequest} test Test configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testChannel: async (channelId: string, test: CordeCommonModelsDtoNotificationsTestChannelRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('testChannel', 'channelId', channelId)
            // verify required parameter 'test' is not null or undefined
            assertParamExists('testChannel', 'test', test)
            const localVarPath = `/notification/channel/{channel_id}/test`
                .replace(`{${"channel_id"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(test, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an existing notification channel
         * @summary Update Channel
         * @param {string} channelId Channel ID
         * @param {CordeCommonModelsDtoNotificationsUpdateChannelRequest} channel Updated channel data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChannel: async (channelId: string, channel: CordeCommonModelsDtoNotificationsUpdateChannelRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('updateChannel', 'channelId', channelId)
            // verify required parameter 'channel' is not null or undefined
            assertParamExists('updateChannel', 'channel', channel)
            const localVarPath = `/notification/channel/{channel_id}`
                .replace(`{${"channel_id"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(channel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates configuration for a notification channel
         * @summary Update Channel Config
         * @param {string} channelId Channel ID
         * @param {CordeCommonModelsDtoNotificationsUpdateChannelConfigRequest} config Updated configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChannelConfig: async (channelId: string, config: CordeCommonModelsDtoNotificationsUpdateChannelConfigRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'channelId' is not null or undefined
            assertParamExists('updateChannelConfig', 'channelId', channelId)
            // verify required parameter 'config' is not null or undefined
            assertParamExists('updateChannelConfig', 'config', config)
            const localVarPath = `/notification/channel/{channel_id}/config`
                .replace(`{${"channel_id"}}`, encodeURIComponent(String(channelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(config, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an existing contact
         * @summary Update Contact
         * @param {string} contactId Contact ID
         * @param {CordeCommonModelsDtoNotificationsUpdateContactRequest} contact Updated contact data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContact: async (contactId: string, contact: CordeCommonModelsDtoNotificationsUpdateContactRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('updateContact', 'contactId', contactId)
            // verify required parameter 'contact' is not null or undefined
            assertParamExists('updateContact', 'contact', contact)
            const localVarPath = `/notification/contact/{contact_id}`
                .replace(`{${"contact_id"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contact, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates personal notification overrides for a team member
         * @summary Update Team Member Notification Overrides
         * @param {string} teamId Team ID
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoNotificationsUpdateTeamMemberNotificationOverridesRequest} overrides Updated member overrides
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamMemberNotificationOverrides: async (teamId: string, userId: string, overrides: CordeCommonModelsDtoNotificationsUpdateTeamMemberNotificationOverridesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('updateTeamMemberNotificationOverrides', 'teamId', teamId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateTeamMemberNotificationOverrides', 'userId', userId)
            // verify required parameter 'overrides' is not null or undefined
            assertParamExists('updateTeamMemberNotificationOverrides', 'overrides', overrides)
            const localVarPath = `/notification/team/{team_id}/member/{user_id}/notification-overrides`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(overrides, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates notification settings for a team
         * @summary Update Team Notification Settings
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoNotificationsUpdateTeamNotificationSettingsRequest} settings Updated team settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamNotificationSettings: async (teamId: string, settings: CordeCommonModelsDtoNotificationsUpdateTeamNotificationSettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('updateTeamNotificationSettings', 'teamId', teamId)
            // verify required parameter 'settings' is not null or undefined
            assertParamExists('updateTeamNotificationSettings', 'settings', settings)
            const localVarPath = `/notification/team/{team_id}/notification-settings`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(settings, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an existing notification template
         * @summary Update Template
         * @param {string} templateId Template ID
         * @param {CordeCommonModelsDtoNotificationsUpdateTemplateRequest} template Updated template data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplate: async (templateId: string, template: CordeCommonModelsDtoNotificationsUpdateTemplateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'templateId' is not null or undefined
            assertParamExists('updateTemplate', 'templateId', templateId)
            // verify required parameter 'template' is not null or undefined
            assertParamExists('updateTemplate', 'template', template)
            const localVarPath = `/notification/template/{template_id}`
                .replace(`{${"template_id"}}`, encodeURIComponent(String(templateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(template, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates event-specific channel settings for a user
         * @summary Update User Event Channel Settings
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoNotificationsUpdateUserEventChannelSettingsRequest} settings Updated event channel settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserEventChannelSettings: async (userId: string, settings: CordeCommonModelsDtoNotificationsUpdateUserEventChannelSettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserEventChannelSettings', 'userId', userId)
            // verify required parameter 'settings' is not null or undefined
            assertParamExists('updateUserEventChannelSettings', 'settings', settings)
            const localVarPath = `/notification/user/{user_id}/event-channel-settings`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(settings, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validates channel configuration without saving it
         * @summary Validate Channel Config
         * @param {CordeCommonModelsDtoNotificationsValidateChannelConfigRequest} config Configuration to validate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateChannelConfig: async (config: CordeCommonModelsDtoNotificationsValidateChannelConfigRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'config' is not null or undefined
            assertParamExists('validateChannelConfig', 'config', config)
            const localVarPath = `/notification/channel/validate-config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(config, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Validates if a contact value is properly formatted
         * @summary Validate Contact Value
         * @param {string} contactValue Contact value to validate
         * @param {string} contactType Contact type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateContactValue: async (contactValue: string, contactType: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactValue' is not null or undefined
            assertParamExists('validateContactValue', 'contactValue', contactValue)
            // verify required parameter 'contactType' is not null or undefined
            assertParamExists('validateContactValue', 'contactType', contactType)
            const localVarPath = `/notification/contact/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (contactValue !== undefined) {
                localVarQueryParameter['contact_value'] = contactValue;
            }

            if (contactType !== undefined) {
                localVarQueryParameter['contact_type'] = contactType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verifies a contact using a verification code
         * @summary Verify Contact
         * @param {string} contactId Contact ID
         * @param {CordeCommonModelsDtoNotificationsVerifyContactRequest} verification Verification data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyContact: async (contactId: string, verification: CordeCommonModelsDtoNotificationsVerifyContactRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contactId' is not null or undefined
            assertParamExists('verifyContact', 'contactId', contactId)
            // verify required parameter 'verification' is not null or undefined
            assertParamExists('verifyContact', 'verification', verification)
            const localVarPath = `/notification/contact/{contact_id}/verify`
                .replace(`{${"contact_id"}}`, encodeURIComponent(String(contactId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verification, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * Cancels a previously scheduled notification
         * @summary Cancel Scheduled Notification
         * @param {string} scheduleId Schedule ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelScheduledNotification(scheduleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelScheduledNotification(scheduleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.cancelScheduledNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new notification channel
         * @summary Create Channel
         * @param {CordeCommonModelsDtoNotificationsCreateChannelRequest} channel Channel to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createChannel(channel: CordeCommonModelsDtoNotificationsCreateChannelRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoNotificationsCreateChannelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createChannel(channel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.createChannel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new contact for an entity
         * @summary Create Contact
         * @param {CordeCommonModelsDtoNotificationsCreateContactRequest} contact Contact to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createContact(contact: CordeCommonModelsDtoNotificationsCreateContactRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoNotificationsCreateContactResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createContact(contact, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.createContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a new notification template
         * @summary Create Template
         * @param {CordeCommonModelsDtoNotificationsCreateTemplateRequest} template Template to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTemplate(template: CordeCommonModelsDtoNotificationsCreateTemplateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoNotificationsCreateTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTemplate(template, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.createTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a notification channel
         * @summary Delete Channel
         * @param {string} channelId Channel ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteChannel(channelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteChannel(channelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.deleteChannel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a contact
         * @summary Delete Contact
         * @param {string} contactId Contact ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteContact(contactId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteContact(contactId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.deleteContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deletes a notification template
         * @summary Delete Template
         * @param {string} templateId Template ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTemplate(templateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTemplate(templateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.deleteTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets a notification channel by ID
         * @summary Get Channel
         * @param {string} channelId Channel ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChannel(channelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoNotificationsGetChannelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChannel(channelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.getChannel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets health status of a notification channel
         * @summary Get Channel Health
         * @param {string} channelId Channel ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getChannelHealth(channelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoNotificationsGetChannelHealthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getChannelHealth(channelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.getChannelHealth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets a contact by ID
         * @summary Get Contact
         * @param {string} contactId Contact ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContact(contactId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoNotificationsGetContactResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContact(contactId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.getContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets a contact by its value (email, phone, etc.)
         * @summary Get Contact By Value
         * @param {string} value Contact value
         * @param {string} type Contact type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContactByValue(value: string, type: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoNotificationsGetContactResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContactByValue(value, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.getContactByValue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets detailed delivery report for a specific notification
         * @summary Get Delivery Report
         * @param {string} notificationId Notification ID
         * @param {boolean} [includeAttempts] Include delivery attempt details
         * @param {boolean} [includeEvents] Include delivery events timeline
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeliveryReport(notificationId: string, includeAttempts?: boolean, includeEvents?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoNotificationsGetDeliveryReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeliveryReport(notificationId, includeAttempts, includeEvents, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.getDeliveryReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets statistical data about notifications
         * @summary Get Notification Stats
         * @param {string} [startDate] Start date for statistics (RFC3339 format)
         * @param {string} [endDate] End date for statistics (RFC3339 format)
         * @param {string} [channelType] Filter by channel type
         * @param {string} [userId] Filter by user ID
         * @param {string} [platformId] Filter by platform ID
         * @param {string} [granularity] Granularity (hour, day, week, month)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationStats(startDate?: string, endDate?: string, channelType?: string, userId?: string, platformId?: string, granularity?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoNotificationsGetNotificationStatsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationStats(startDate, endDate, channelType, userId, platformId, granularity, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.getNotificationStats']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets the status of a specific notification
         * @summary Get Notification Status
         * @param {string} notificationId Notification ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationStatus(notificationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoNotificationsGetNotificationStatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationStatus(notificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.getNotificationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets audit logs for notification-related activities
         * @summary Get Notifications Audit Logs
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [startDate] Start date filter (RFC3339 format)
         * @param {string} [endDate] End date filter (RFC3339 format)
         * @param {string} [action] Filter by action type
         * @param {string} [entityType] Filter by entity type
         * @param {string} [entityId] Filter by entity ID
         * @param {string} [userId] Filter by user ID
         * @param {string} [platformId] Filter by platform ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationsAuditLogs(limit?: number, offset?: number, startDate?: string, endDate?: string, action?: string, entityType?: string, entityId?: string, userId?: string, platformId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoNotificationsGetNotificationsAuditLogsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationsAuditLogs(limit, offset, startDate, endDate, action, entityType, entityId, userId, platformId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.getNotificationsAuditLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets personal notification overrides for a team member
         * @summary Get Team Member Notification Overrides
         * @param {string} teamId Team ID
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamMemberNotificationOverrides(teamId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoNotificationsGetTeamMemberNotificationOverridesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamMemberNotificationOverrides(teamId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.getTeamMemberNotificationOverrides']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets notification settings for a team (respecting user preferences)
         * @summary Get Team Notification Settings
         * @param {string} teamId Team ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamNotificationSettings(teamId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoNotificationsGetTeamNotificationSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamNotificationSettings(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.getTeamNotificationSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets a notification template by ID
         * @summary Get Template
         * @param {string} templateId Template ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTemplate(templateId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoNotificationsGetTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTemplate(templateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.getTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Gets event-specific channel settings for a user (event -> multiple channels with contact mapping)
         * @summary Get User Event Channel Settings
         * @param {string} userId User ID
         * @param {string} [eventType] Filter by event type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserEventChannelSettings(userId: string, eventType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoNotificationsGetUserEventChannelSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserEventChannelSettings(userId, eventType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.getUserEventChannelSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists all notification channels with optional filtering
         * @summary List Channels
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [type] Filter by channel type
         * @param {boolean} [enabled] Filter by enabled status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listChannels(limit?: number, offset?: number, type?: string, enabled?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoNotificationsListChannelsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listChannels(limit, offset, type, enabled, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.listChannels']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists contacts with optional filtering
         * @summary List Contacts
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [entityType] Filter by entity type
         * @param {string} [entityId] Filter by entity ID
         * @param {string} [contactType] Filter by contact type
         * @param {boolean} [verifiedOnly] Show only verified contacts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listContacts(limit?: number, offset?: number, entityType?: string, entityId?: string, contactType?: string, verifiedOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoNotificationsListContactsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listContacts(limit, offset, entityType, entityId, contactType, verifiedOnly, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.listContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists all scheduled notifications with optional filtering
         * @summary List Scheduled Notifications
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [userId] Filter by user ID
         * @param {string} [status] Filter by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listScheduledNotifications(limit?: number, offset?: number, userId?: string, status?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoNotificationsListScheduledNotificationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listScheduledNotifications(limit, offset, userId, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.listScheduledNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists all notification templates with optional filtering
         * @summary List Templates
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [channelType] Filter by channel type
         * @param {string} [language] Filter by language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTemplates(limit?: number, offset?: number, channelType?: string, language?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoNotificationsListTemplatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTemplates(limit, offset, channelType, language, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.listTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists notifications for a specific user
         * @summary List User Notifications
         * @param {string} userId User ID
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUserNotifications(userId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoNotificationsListUserNotificationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUserNotifications(userId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.listUserNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Marks all notifications for a user as read
         * @summary Mark All Notifications As Read
         * @param {CordeCommonModelsDtoNotificationsMarkAllNotificationsAsReadRequest} request Mark all as read request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markAllNotificationsAsRead(request: CordeCommonModelsDtoNotificationsMarkAllNotificationsAsReadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markAllNotificationsAsRead(request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.markAllNotificationsAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Marks a specific notification as read
         * @summary Mark Notification As Read
         * @param {string} notificationId Notification ID
         * @param {CordeCommonModelsDtoNotificationsMarkNotificationAsReadRequest} request Mark as read request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markNotificationAsRead(notificationId: string, request: CordeCommonModelsDtoNotificationsMarkNotificationAsReadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markNotificationAsRead(notificationId, request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.markNotificationAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Processes delivery confirmation webhooks from notification providers
         * @summary Process Delivery Confirmation
         * @param {CordeCommonModelsDtoNotificationsProcessDeliveryConfirmationRequest} confirmation Delivery confirmation data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processDeliveryConfirmation(confirmation: CordeCommonModelsDtoNotificationsProcessDeliveryConfirmationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processDeliveryConfirmation(confirmation, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.processDeliveryConfirmation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Schedules a notification for future delivery
         * @summary Schedule Notification
         * @param {CordeCommonModelsDtoNotificationsScheduleNotificationRequest} notification Notification to schedule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scheduleNotification(notification: CordeCommonModelsDtoNotificationsScheduleNotificationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoNotificationsScheduleNotificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scheduleNotification(notification, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.scheduleNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Searches contacts by value or other criteria
         * @summary Search Contacts
         * @param {string} q Search query
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [contactType] Filter by contact type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchContacts(q: string, limit?: number, offset?: number, contactType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoNotificationsListContactsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchContacts(q, limit, offset, contactType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.searchContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sends multiple notifications to users
         * @summary Send Bulk Notifications
         * @param {CordeCommonModelsDtoNotificationsSendBulkNotificationsRequest} notifications Bulk notifications to send
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendBulkNotifications(notifications: CordeCommonModelsDtoNotificationsSendBulkNotificationsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoNotificationsSendBulkNotificationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendBulkNotifications(notifications, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.sendBulkNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sends a verification message to a contact
         * @summary Send Contact Verification
         * @param {string} contactId Contact ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendContactVerification(contactId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendContactVerification(contactId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.sendContactVerification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sends a single notification to a user
         * @summary Send Notification
         * @param {CordeCommonModelsDtoNotificationsSendNotificationRequest} notification Notification to send
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendNotification(notification: CordeCommonModelsDtoNotificationsSendNotificationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoNotificationsSendNotificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendNotification(notification, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.sendNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sends a smart notification with automatic channel selection
         * @summary Send Smart Notification
         * @param {CordeCommonModelsDtoNotificationsSendSmartNotificationRequest} notification Smart notification to send
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendSmartNotification(notification: CordeCommonModelsDtoNotificationsSendSmartNotificationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoNotificationsSendSmartNotificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendSmartNotification(notification, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.sendSmartNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sets a contact as primary for an entity and contact type
         * @summary Set Primary Contact
         * @param {CordeCommonModelsDtoNotificationsSetPrimaryContactRequest} request Primary contact data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setPrimaryContact(request: CordeCommonModelsDtoNotificationsSetPrimaryContactRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setPrimaryContact(request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.setPrimaryContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Tests a notification channel configuration
         * @summary Test Channel
         * @param {string} channelId Channel ID
         * @param {CordeCommonModelsDtoNotificationsTestChannelRequest} test Test configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testChannel(channelId: string, test: CordeCommonModelsDtoNotificationsTestChannelRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoNotificationsTestChannelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testChannel(channelId, test, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.testChannel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates an existing notification channel
         * @summary Update Channel
         * @param {string} channelId Channel ID
         * @param {CordeCommonModelsDtoNotificationsUpdateChannelRequest} channel Updated channel data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateChannel(channelId: string, channel: CordeCommonModelsDtoNotificationsUpdateChannelRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateChannel(channelId, channel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.updateChannel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates configuration for a notification channel
         * @summary Update Channel Config
         * @param {string} channelId Channel ID
         * @param {CordeCommonModelsDtoNotificationsUpdateChannelConfigRequest} config Updated configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateChannelConfig(channelId: string, config: CordeCommonModelsDtoNotificationsUpdateChannelConfigRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateChannelConfig(channelId, config, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.updateChannelConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates an existing contact
         * @summary Update Contact
         * @param {string} contactId Contact ID
         * @param {CordeCommonModelsDtoNotificationsUpdateContactRequest} contact Updated contact data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateContact(contactId: string, contact: CordeCommonModelsDtoNotificationsUpdateContactRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateContact(contactId, contact, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.updateContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates personal notification overrides for a team member
         * @summary Update Team Member Notification Overrides
         * @param {string} teamId Team ID
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoNotificationsUpdateTeamMemberNotificationOverridesRequest} overrides Updated member overrides
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeamMemberNotificationOverrides(teamId: string, userId: string, overrides: CordeCommonModelsDtoNotificationsUpdateTeamMemberNotificationOverridesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeamMemberNotificationOverrides(teamId, userId, overrides, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.updateTeamMemberNotificationOverrides']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates notification settings for a team
         * @summary Update Team Notification Settings
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoNotificationsUpdateTeamNotificationSettingsRequest} settings Updated team settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeamNotificationSettings(teamId: string, settings: CordeCommonModelsDtoNotificationsUpdateTeamNotificationSettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeamNotificationSettings(teamId, settings, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.updateTeamNotificationSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates an existing notification template
         * @summary Update Template
         * @param {string} templateId Template ID
         * @param {CordeCommonModelsDtoNotificationsUpdateTemplateRequest} template Updated template data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTemplate(templateId: string, template: CordeCommonModelsDtoNotificationsUpdateTemplateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTemplate(templateId, template, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.updateTemplate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates event-specific channel settings for a user
         * @summary Update User Event Channel Settings
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoNotificationsUpdateUserEventChannelSettingsRequest} settings Updated event channel settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserEventChannelSettings(userId: string, settings: CordeCommonModelsDtoNotificationsUpdateUserEventChannelSettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserEventChannelSettings(userId, settings, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.updateUserEventChannelSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validates channel configuration without saving it
         * @summary Validate Channel Config
         * @param {CordeCommonModelsDtoNotificationsValidateChannelConfigRequest} config Configuration to validate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateChannelConfig(config: CordeCommonModelsDtoNotificationsValidateChannelConfigRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoNotificationsValidateChannelConfigResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateChannelConfig(config, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.validateChannelConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Validates if a contact value is properly formatted
         * @summary Validate Contact Value
         * @param {string} contactValue Contact value to validate
         * @param {string} contactType Contact type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateContactValue(contactValue: string, contactType: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoNotificationsValidateContactValueResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateContactValue(contactValue, contactType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.validateContactValue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Verifies a contact using a verification code
         * @summary Verify Contact
         * @param {string} contactId Contact ID
         * @param {CordeCommonModelsDtoNotificationsVerifyContactRequest} verification Verification data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyContact(contactId: string, verification: CordeCommonModelsDtoNotificationsVerifyContactRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyContact(contactId, verification, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.verifyContact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * Cancels a previously scheduled notification
         * @summary Cancel Scheduled Notification
         * @param {string} scheduleId Schedule ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelScheduledNotification(scheduleId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.cancelScheduledNotification(scheduleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new notification channel
         * @summary Create Channel
         * @param {CordeCommonModelsDtoNotificationsCreateChannelRequest} channel Channel to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createChannel(channel: CordeCommonModelsDtoNotificationsCreateChannelRequest, options?: any): AxiosPromise<CordeCommonModelsDtoNotificationsCreateChannelResponse> {
            return localVarFp.createChannel(channel, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new contact for an entity
         * @summary Create Contact
         * @param {CordeCommonModelsDtoNotificationsCreateContactRequest} contact Contact to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createContact(contact: CordeCommonModelsDtoNotificationsCreateContactRequest, options?: any): AxiosPromise<CordeCommonModelsDtoNotificationsCreateContactResponse> {
            return localVarFp.createContact(contact, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new notification template
         * @summary Create Template
         * @param {CordeCommonModelsDtoNotificationsCreateTemplateRequest} template Template to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTemplate(template: CordeCommonModelsDtoNotificationsCreateTemplateRequest, options?: any): AxiosPromise<CordeCommonModelsDtoNotificationsCreateTemplateResponse> {
            return localVarFp.createTemplate(template, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a notification channel
         * @summary Delete Channel
         * @param {string} channelId Channel ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteChannel(channelId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.deleteChannel(channelId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a contact
         * @summary Delete Contact
         * @param {string} contactId Contact ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteContact(contactId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.deleteContact(contactId, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a notification template
         * @summary Delete Template
         * @param {string} templateId Template ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTemplate(templateId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.deleteTemplate(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a notification channel by ID
         * @summary Get Channel
         * @param {string} channelId Channel ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChannel(channelId: string, options?: any): AxiosPromise<CordeCommonModelsDtoNotificationsGetChannelResponse> {
            return localVarFp.getChannel(channelId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets health status of a notification channel
         * @summary Get Channel Health
         * @param {string} channelId Channel ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChannelHealth(channelId: string, options?: any): AxiosPromise<CordeCommonModelsDtoNotificationsGetChannelHealthResponse> {
            return localVarFp.getChannelHealth(channelId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a contact by ID
         * @summary Get Contact
         * @param {string} contactId Contact ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContact(contactId: string, options?: any): AxiosPromise<CordeCommonModelsDtoNotificationsGetContactResponse> {
            return localVarFp.getContact(contactId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a contact by its value (email, phone, etc.)
         * @summary Get Contact By Value
         * @param {string} value Contact value
         * @param {string} type Contact type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContactByValue(value: string, type: string, options?: any): AxiosPromise<CordeCommonModelsDtoNotificationsGetContactResponse> {
            return localVarFp.getContactByValue(value, type, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets detailed delivery report for a specific notification
         * @summary Get Delivery Report
         * @param {string} notificationId Notification ID
         * @param {boolean} [includeAttempts] Include delivery attempt details
         * @param {boolean} [includeEvents] Include delivery events timeline
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeliveryReport(notificationId: string, includeAttempts?: boolean, includeEvents?: boolean, options?: any): AxiosPromise<CordeCommonModelsDtoNotificationsGetDeliveryReportResponse> {
            return localVarFp.getDeliveryReport(notificationId, includeAttempts, includeEvents, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets statistical data about notifications
         * @summary Get Notification Stats
         * @param {string} [startDate] Start date for statistics (RFC3339 format)
         * @param {string} [endDate] End date for statistics (RFC3339 format)
         * @param {string} [channelType] Filter by channel type
         * @param {string} [userId] Filter by user ID
         * @param {string} [platformId] Filter by platform ID
         * @param {string} [granularity] Granularity (hour, day, week, month)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationStats(startDate?: string, endDate?: string, channelType?: string, userId?: string, platformId?: string, granularity?: string, options?: any): AxiosPromise<CordeCommonModelsDtoNotificationsGetNotificationStatsResponse> {
            return localVarFp.getNotificationStats(startDate, endDate, channelType, userId, platformId, granularity, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets the status of a specific notification
         * @summary Get Notification Status
         * @param {string} notificationId Notification ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationStatus(notificationId: string, options?: any): AxiosPromise<CordeCommonModelsDtoNotificationsGetNotificationStatusResponse> {
            return localVarFp.getNotificationStatus(notificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets audit logs for notification-related activities
         * @summary Get Notifications Audit Logs
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [startDate] Start date filter (RFC3339 format)
         * @param {string} [endDate] End date filter (RFC3339 format)
         * @param {string} [action] Filter by action type
         * @param {string} [entityType] Filter by entity type
         * @param {string} [entityId] Filter by entity ID
         * @param {string} [userId] Filter by user ID
         * @param {string} [platformId] Filter by platform ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationsAuditLogs(limit?: number, offset?: number, startDate?: string, endDate?: string, action?: string, entityType?: string, entityId?: string, userId?: string, platformId?: string, options?: any): AxiosPromise<CordeCommonModelsDtoNotificationsGetNotificationsAuditLogsResponse> {
            return localVarFp.getNotificationsAuditLogs(limit, offset, startDate, endDate, action, entityType, entityId, userId, platformId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets personal notification overrides for a team member
         * @summary Get Team Member Notification Overrides
         * @param {string} teamId Team ID
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamMemberNotificationOverrides(teamId: string, userId: string, options?: any): AxiosPromise<CordeCommonModelsDtoNotificationsGetTeamMemberNotificationOverridesResponse> {
            return localVarFp.getTeamMemberNotificationOverrides(teamId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets notification settings for a team (respecting user preferences)
         * @summary Get Team Notification Settings
         * @param {string} teamId Team ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamNotificationSettings(teamId: string, options?: any): AxiosPromise<CordeCommonModelsDtoNotificationsGetTeamNotificationSettingsResponse> {
            return localVarFp.getTeamNotificationSettings(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets a notification template by ID
         * @summary Get Template
         * @param {string} templateId Template ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTemplate(templateId: string, options?: any): AxiosPromise<CordeCommonModelsDtoNotificationsGetTemplateResponse> {
            return localVarFp.getTemplate(templateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Gets event-specific channel settings for a user (event -> multiple channels with contact mapping)
         * @summary Get User Event Channel Settings
         * @param {string} userId User ID
         * @param {string} [eventType] Filter by event type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserEventChannelSettings(userId: string, eventType?: string, options?: any): AxiosPromise<CordeCommonModelsDtoNotificationsGetUserEventChannelSettingsResponse> {
            return localVarFp.getUserEventChannelSettings(userId, eventType, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all notification channels with optional filtering
         * @summary List Channels
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [type] Filter by channel type
         * @param {boolean} [enabled] Filter by enabled status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChannels(limit?: number, offset?: number, type?: string, enabled?: boolean, options?: any): AxiosPromise<CordeCommonModelsDtoNotificationsListChannelsResponse> {
            return localVarFp.listChannels(limit, offset, type, enabled, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists contacts with optional filtering
         * @summary List Contacts
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [entityType] Filter by entity type
         * @param {string} [entityId] Filter by entity ID
         * @param {string} [contactType] Filter by contact type
         * @param {boolean} [verifiedOnly] Show only verified contacts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listContacts(limit?: number, offset?: number, entityType?: string, entityId?: string, contactType?: string, verifiedOnly?: boolean, options?: any): AxiosPromise<CordeCommonModelsDtoNotificationsListContactsResponse> {
            return localVarFp.listContacts(limit, offset, entityType, entityId, contactType, verifiedOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all scheduled notifications with optional filtering
         * @summary List Scheduled Notifications
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [userId] Filter by user ID
         * @param {string} [status] Filter by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScheduledNotifications(limit?: number, offset?: number, userId?: string, status?: string, options?: any): AxiosPromise<CordeCommonModelsDtoNotificationsListScheduledNotificationsResponse> {
            return localVarFp.listScheduledNotifications(limit, offset, userId, status, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all notification templates with optional filtering
         * @summary List Templates
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [channelType] Filter by channel type
         * @param {string} [language] Filter by language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTemplates(limit?: number, offset?: number, channelType?: string, language?: string, options?: any): AxiosPromise<CordeCommonModelsDtoNotificationsListTemplatesResponse> {
            return localVarFp.listTemplates(limit, offset, channelType, language, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists notifications for a specific user
         * @summary List User Notifications
         * @param {string} userId User ID
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserNotifications(userId: string, limit?: number, offset?: number, options?: any): AxiosPromise<CordeCommonModelsDtoNotificationsListUserNotificationsResponse> {
            return localVarFp.listUserNotifications(userId, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Marks all notifications for a user as read
         * @summary Mark All Notifications As Read
         * @param {CordeCommonModelsDtoNotificationsMarkAllNotificationsAsReadRequest} request Mark all as read request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markAllNotificationsAsRead(request: CordeCommonModelsDtoNotificationsMarkAllNotificationsAsReadRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.markAllNotificationsAsRead(request, options).then((request) => request(axios, basePath));
        },
        /**
         * Marks a specific notification as read
         * @summary Mark Notification As Read
         * @param {string} notificationId Notification ID
         * @param {CordeCommonModelsDtoNotificationsMarkNotificationAsReadRequest} request Mark as read request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationAsRead(notificationId: string, request: CordeCommonModelsDtoNotificationsMarkNotificationAsReadRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.markNotificationAsRead(notificationId, request, options).then((request) => request(axios, basePath));
        },
        /**
         * Processes delivery confirmation webhooks from notification providers
         * @summary Process Delivery Confirmation
         * @param {CordeCommonModelsDtoNotificationsProcessDeliveryConfirmationRequest} confirmation Delivery confirmation data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processDeliveryConfirmation(confirmation: CordeCommonModelsDtoNotificationsProcessDeliveryConfirmationRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.processDeliveryConfirmation(confirmation, options).then((request) => request(axios, basePath));
        },
        /**
         * Schedules a notification for future delivery
         * @summary Schedule Notification
         * @param {CordeCommonModelsDtoNotificationsScheduleNotificationRequest} notification Notification to schedule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleNotification(notification: CordeCommonModelsDtoNotificationsScheduleNotificationRequest, options?: any): AxiosPromise<CordeCommonModelsDtoNotificationsScheduleNotificationResponse> {
            return localVarFp.scheduleNotification(notification, options).then((request) => request(axios, basePath));
        },
        /**
         * Searches contacts by value or other criteria
         * @summary Search Contacts
         * @param {string} q Search query
         * @param {number} [limit] Limit
         * @param {number} [offset] Offset
         * @param {string} [contactType] Filter by contact type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchContacts(q: string, limit?: number, offset?: number, contactType?: string, options?: any): AxiosPromise<CordeCommonModelsDtoNotificationsListContactsResponse> {
            return localVarFp.searchContacts(q, limit, offset, contactType, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends multiple notifications to users
         * @summary Send Bulk Notifications
         * @param {CordeCommonModelsDtoNotificationsSendBulkNotificationsRequest} notifications Bulk notifications to send
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBulkNotifications(notifications: CordeCommonModelsDtoNotificationsSendBulkNotificationsRequest, options?: any): AxiosPromise<CordeCommonModelsDtoNotificationsSendBulkNotificationsResponse> {
            return localVarFp.sendBulkNotifications(notifications, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends a verification message to a contact
         * @summary Send Contact Verification
         * @param {string} contactId Contact ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendContactVerification(contactId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.sendContactVerification(contactId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends a single notification to a user
         * @summary Send Notification
         * @param {CordeCommonModelsDtoNotificationsSendNotificationRequest} notification Notification to send
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendNotification(notification: CordeCommonModelsDtoNotificationsSendNotificationRequest, options?: any): AxiosPromise<CordeCommonModelsDtoNotificationsSendNotificationResponse> {
            return localVarFp.sendNotification(notification, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends a smart notification with automatic channel selection
         * @summary Send Smart Notification
         * @param {CordeCommonModelsDtoNotificationsSendSmartNotificationRequest} notification Smart notification to send
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSmartNotification(notification: CordeCommonModelsDtoNotificationsSendSmartNotificationRequest, options?: any): AxiosPromise<CordeCommonModelsDtoNotificationsSendSmartNotificationResponse> {
            return localVarFp.sendSmartNotification(notification, options).then((request) => request(axios, basePath));
        },
        /**
         * Sets a contact as primary for an entity and contact type
         * @summary Set Primary Contact
         * @param {CordeCommonModelsDtoNotificationsSetPrimaryContactRequest} request Primary contact data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPrimaryContact(request: CordeCommonModelsDtoNotificationsSetPrimaryContactRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.setPrimaryContact(request, options).then((request) => request(axios, basePath));
        },
        /**
         * Tests a notification channel configuration
         * @summary Test Channel
         * @param {string} channelId Channel ID
         * @param {CordeCommonModelsDtoNotificationsTestChannelRequest} test Test configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testChannel(channelId: string, test: CordeCommonModelsDtoNotificationsTestChannelRequest, options?: any): AxiosPromise<CordeCommonModelsDtoNotificationsTestChannelResponse> {
            return localVarFp.testChannel(channelId, test, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an existing notification channel
         * @summary Update Channel
         * @param {string} channelId Channel ID
         * @param {CordeCommonModelsDtoNotificationsUpdateChannelRequest} channel Updated channel data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChannel(channelId: string, channel: CordeCommonModelsDtoNotificationsUpdateChannelRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.updateChannel(channelId, channel, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates configuration for a notification channel
         * @summary Update Channel Config
         * @param {string} channelId Channel ID
         * @param {CordeCommonModelsDtoNotificationsUpdateChannelConfigRequest} config Updated configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateChannelConfig(channelId: string, config: CordeCommonModelsDtoNotificationsUpdateChannelConfigRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.updateChannelConfig(channelId, config, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an existing contact
         * @summary Update Contact
         * @param {string} contactId Contact ID
         * @param {CordeCommonModelsDtoNotificationsUpdateContactRequest} contact Updated contact data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateContact(contactId: string, contact: CordeCommonModelsDtoNotificationsUpdateContactRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.updateContact(contactId, contact, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates personal notification overrides for a team member
         * @summary Update Team Member Notification Overrides
         * @param {string} teamId Team ID
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoNotificationsUpdateTeamMemberNotificationOverridesRequest} overrides Updated member overrides
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamMemberNotificationOverrides(teamId: string, userId: string, overrides: CordeCommonModelsDtoNotificationsUpdateTeamMemberNotificationOverridesRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.updateTeamMemberNotificationOverrides(teamId, userId, overrides, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates notification settings for a team
         * @summary Update Team Notification Settings
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoNotificationsUpdateTeamNotificationSettingsRequest} settings Updated team settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamNotificationSettings(teamId: string, settings: CordeCommonModelsDtoNotificationsUpdateTeamNotificationSettingsRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.updateTeamNotificationSettings(teamId, settings, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an existing notification template
         * @summary Update Template
         * @param {string} templateId Template ID
         * @param {CordeCommonModelsDtoNotificationsUpdateTemplateRequest} template Updated template data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTemplate(templateId: string, template: CordeCommonModelsDtoNotificationsUpdateTemplateRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.updateTemplate(templateId, template, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates event-specific channel settings for a user
         * @summary Update User Event Channel Settings
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoNotificationsUpdateUserEventChannelSettingsRequest} settings Updated event channel settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserEventChannelSettings(userId: string, settings: CordeCommonModelsDtoNotificationsUpdateUserEventChannelSettingsRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.updateUserEventChannelSettings(userId, settings, options).then((request) => request(axios, basePath));
        },
        /**
         * Validates channel configuration without saving it
         * @summary Validate Channel Config
         * @param {CordeCommonModelsDtoNotificationsValidateChannelConfigRequest} config Configuration to validate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateChannelConfig(config: CordeCommonModelsDtoNotificationsValidateChannelConfigRequest, options?: any): AxiosPromise<CordeCommonModelsDtoNotificationsValidateChannelConfigResponse> {
            return localVarFp.validateChannelConfig(config, options).then((request) => request(axios, basePath));
        },
        /**
         * Validates if a contact value is properly formatted
         * @summary Validate Contact Value
         * @param {string} contactValue Contact value to validate
         * @param {string} contactType Contact type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateContactValue(contactValue: string, contactType: string, options?: any): AxiosPromise<CordeCommonModelsDtoNotificationsValidateContactValueResponse> {
            return localVarFp.validateContactValue(contactValue, contactType, options).then((request) => request(axios, basePath));
        },
        /**
         * Verifies a contact using a verification code
         * @summary Verify Contact
         * @param {string} contactId Contact ID
         * @param {CordeCommonModelsDtoNotificationsVerifyContactRequest} verification Verification data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyContact(contactId: string, verification: CordeCommonModelsDtoNotificationsVerifyContactRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.verifyContact(contactId, verification, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     * Cancels a previously scheduled notification
     * @summary Cancel Scheduled Notification
     * @param {string} scheduleId Schedule ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public cancelScheduledNotification(scheduleId: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).cancelScheduledNotification(scheduleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new notification channel
     * @summary Create Channel
     * @param {CordeCommonModelsDtoNotificationsCreateChannelRequest} channel Channel to create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public createChannel(channel: CordeCommonModelsDtoNotificationsCreateChannelRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).createChannel(channel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new contact for an entity
     * @summary Create Contact
     * @param {CordeCommonModelsDtoNotificationsCreateContactRequest} contact Contact to create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public createContact(contact: CordeCommonModelsDtoNotificationsCreateContactRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).createContact(contact, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new notification template
     * @summary Create Template
     * @param {CordeCommonModelsDtoNotificationsCreateTemplateRequest} template Template to create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public createTemplate(template: CordeCommonModelsDtoNotificationsCreateTemplateRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).createTemplate(template, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a notification channel
     * @summary Delete Channel
     * @param {string} channelId Channel ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public deleteChannel(channelId: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).deleteChannel(channelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a contact
     * @summary Delete Contact
     * @param {string} contactId Contact ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public deleteContact(contactId: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).deleteContact(contactId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a notification template
     * @summary Delete Template
     * @param {string} templateId Template ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public deleteTemplate(templateId: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).deleteTemplate(templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a notification channel by ID
     * @summary Get Channel
     * @param {string} channelId Channel ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getChannel(channelId: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getChannel(channelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets health status of a notification channel
     * @summary Get Channel Health
     * @param {string} channelId Channel ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getChannelHealth(channelId: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getChannelHealth(channelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a contact by ID
     * @summary Get Contact
     * @param {string} contactId Contact ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getContact(contactId: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getContact(contactId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a contact by its value (email, phone, etc.)
     * @summary Get Contact By Value
     * @param {string} value Contact value
     * @param {string} type Contact type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getContactByValue(value: string, type: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getContactByValue(value, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets detailed delivery report for a specific notification
     * @summary Get Delivery Report
     * @param {string} notificationId Notification ID
     * @param {boolean} [includeAttempts] Include delivery attempt details
     * @param {boolean} [includeEvents] Include delivery events timeline
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getDeliveryReport(notificationId: string, includeAttempts?: boolean, includeEvents?: boolean, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getDeliveryReport(notificationId, includeAttempts, includeEvents, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets statistical data about notifications
     * @summary Get Notification Stats
     * @param {string} [startDate] Start date for statistics (RFC3339 format)
     * @param {string} [endDate] End date for statistics (RFC3339 format)
     * @param {string} [channelType] Filter by channel type
     * @param {string} [userId] Filter by user ID
     * @param {string} [platformId] Filter by platform ID
     * @param {string} [granularity] Granularity (hour, day, week, month)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getNotificationStats(startDate?: string, endDate?: string, channelType?: string, userId?: string, platformId?: string, granularity?: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getNotificationStats(startDate, endDate, channelType, userId, platformId, granularity, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets the status of a specific notification
     * @summary Get Notification Status
     * @param {string} notificationId Notification ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getNotificationStatus(notificationId: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getNotificationStatus(notificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets audit logs for notification-related activities
     * @summary Get Notifications Audit Logs
     * @param {number} [limit] Limit
     * @param {number} [offset] Offset
     * @param {string} [startDate] Start date filter (RFC3339 format)
     * @param {string} [endDate] End date filter (RFC3339 format)
     * @param {string} [action] Filter by action type
     * @param {string} [entityType] Filter by entity type
     * @param {string} [entityId] Filter by entity ID
     * @param {string} [userId] Filter by user ID
     * @param {string} [platformId] Filter by platform ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getNotificationsAuditLogs(limit?: number, offset?: number, startDate?: string, endDate?: string, action?: string, entityType?: string, entityId?: string, userId?: string, platformId?: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getNotificationsAuditLogs(limit, offset, startDate, endDate, action, entityType, entityId, userId, platformId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets personal notification overrides for a team member
     * @summary Get Team Member Notification Overrides
     * @param {string} teamId Team ID
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getTeamMemberNotificationOverrides(teamId: string, userId: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getTeamMemberNotificationOverrides(teamId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets notification settings for a team (respecting user preferences)
     * @summary Get Team Notification Settings
     * @param {string} teamId Team ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getTeamNotificationSettings(teamId: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getTeamNotificationSettings(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets a notification template by ID
     * @summary Get Template
     * @param {string} templateId Template ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getTemplate(templateId: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getTemplate(templateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Gets event-specific channel settings for a user (event -> multiple channels with contact mapping)
     * @summary Get User Event Channel Settings
     * @param {string} userId User ID
     * @param {string} [eventType] Filter by event type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public getUserEventChannelSettings(userId: string, eventType?: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).getUserEventChannelSettings(userId, eventType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists all notification channels with optional filtering
     * @summary List Channels
     * @param {number} [limit] Limit
     * @param {number} [offset] Offset
     * @param {string} [type] Filter by channel type
     * @param {boolean} [enabled] Filter by enabled status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public listChannels(limit?: number, offset?: number, type?: string, enabled?: boolean, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).listChannels(limit, offset, type, enabled, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists contacts with optional filtering
     * @summary List Contacts
     * @param {number} [limit] Limit
     * @param {number} [offset] Offset
     * @param {string} [entityType] Filter by entity type
     * @param {string} [entityId] Filter by entity ID
     * @param {string} [contactType] Filter by contact type
     * @param {boolean} [verifiedOnly] Show only verified contacts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public listContacts(limit?: number, offset?: number, entityType?: string, entityId?: string, contactType?: string, verifiedOnly?: boolean, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).listContacts(limit, offset, entityType, entityId, contactType, verifiedOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists all scheduled notifications with optional filtering
     * @summary List Scheduled Notifications
     * @param {number} [limit] Limit
     * @param {number} [offset] Offset
     * @param {string} [userId] Filter by user ID
     * @param {string} [status] Filter by status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public listScheduledNotifications(limit?: number, offset?: number, userId?: string, status?: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).listScheduledNotifications(limit, offset, userId, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists all notification templates with optional filtering
     * @summary List Templates
     * @param {number} [limit] Limit
     * @param {number} [offset] Offset
     * @param {string} [channelType] Filter by channel type
     * @param {string} [language] Filter by language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public listTemplates(limit?: number, offset?: number, channelType?: string, language?: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).listTemplates(limit, offset, channelType, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists notifications for a specific user
     * @summary List User Notifications
     * @param {string} userId User ID
     * @param {number} [limit] Limit
     * @param {number} [offset] Offset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public listUserNotifications(userId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).listUserNotifications(userId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Marks all notifications for a user as read
     * @summary Mark All Notifications As Read
     * @param {CordeCommonModelsDtoNotificationsMarkAllNotificationsAsReadRequest} request Mark all as read request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public markAllNotificationsAsRead(request: CordeCommonModelsDtoNotificationsMarkAllNotificationsAsReadRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).markAllNotificationsAsRead(request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Marks a specific notification as read
     * @summary Mark Notification As Read
     * @param {string} notificationId Notification ID
     * @param {CordeCommonModelsDtoNotificationsMarkNotificationAsReadRequest} request Mark as read request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public markNotificationAsRead(notificationId: string, request: CordeCommonModelsDtoNotificationsMarkNotificationAsReadRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).markNotificationAsRead(notificationId, request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Processes delivery confirmation webhooks from notification providers
     * @summary Process Delivery Confirmation
     * @param {CordeCommonModelsDtoNotificationsProcessDeliveryConfirmationRequest} confirmation Delivery confirmation data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public processDeliveryConfirmation(confirmation: CordeCommonModelsDtoNotificationsProcessDeliveryConfirmationRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).processDeliveryConfirmation(confirmation, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Schedules a notification for future delivery
     * @summary Schedule Notification
     * @param {CordeCommonModelsDtoNotificationsScheduleNotificationRequest} notification Notification to schedule
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public scheduleNotification(notification: CordeCommonModelsDtoNotificationsScheduleNotificationRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).scheduleNotification(notification, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Searches contacts by value or other criteria
     * @summary Search Contacts
     * @param {string} q Search query
     * @param {number} [limit] Limit
     * @param {number} [offset] Offset
     * @param {string} [contactType] Filter by contact type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public searchContacts(q: string, limit?: number, offset?: number, contactType?: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).searchContacts(q, limit, offset, contactType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends multiple notifications to users
     * @summary Send Bulk Notifications
     * @param {CordeCommonModelsDtoNotificationsSendBulkNotificationsRequest} notifications Bulk notifications to send
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public sendBulkNotifications(notifications: CordeCommonModelsDtoNotificationsSendBulkNotificationsRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).sendBulkNotifications(notifications, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends a verification message to a contact
     * @summary Send Contact Verification
     * @param {string} contactId Contact ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public sendContactVerification(contactId: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).sendContactVerification(contactId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends a single notification to a user
     * @summary Send Notification
     * @param {CordeCommonModelsDtoNotificationsSendNotificationRequest} notification Notification to send
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public sendNotification(notification: CordeCommonModelsDtoNotificationsSendNotificationRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).sendNotification(notification, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends a smart notification with automatic channel selection
     * @summary Send Smart Notification
     * @param {CordeCommonModelsDtoNotificationsSendSmartNotificationRequest} notification Smart notification to send
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public sendSmartNotification(notification: CordeCommonModelsDtoNotificationsSendSmartNotificationRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).sendSmartNotification(notification, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets a contact as primary for an entity and contact type
     * @summary Set Primary Contact
     * @param {CordeCommonModelsDtoNotificationsSetPrimaryContactRequest} request Primary contact data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public setPrimaryContact(request: CordeCommonModelsDtoNotificationsSetPrimaryContactRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).setPrimaryContact(request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Tests a notification channel configuration
     * @summary Test Channel
     * @param {string} channelId Channel ID
     * @param {CordeCommonModelsDtoNotificationsTestChannelRequest} test Test configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public testChannel(channelId: string, test: CordeCommonModelsDtoNotificationsTestChannelRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).testChannel(channelId, test, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an existing notification channel
     * @summary Update Channel
     * @param {string} channelId Channel ID
     * @param {CordeCommonModelsDtoNotificationsUpdateChannelRequest} channel Updated channel data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public updateChannel(channelId: string, channel: CordeCommonModelsDtoNotificationsUpdateChannelRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).updateChannel(channelId, channel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates configuration for a notification channel
     * @summary Update Channel Config
     * @param {string} channelId Channel ID
     * @param {CordeCommonModelsDtoNotificationsUpdateChannelConfigRequest} config Updated configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public updateChannelConfig(channelId: string, config: CordeCommonModelsDtoNotificationsUpdateChannelConfigRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).updateChannelConfig(channelId, config, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an existing contact
     * @summary Update Contact
     * @param {string} contactId Contact ID
     * @param {CordeCommonModelsDtoNotificationsUpdateContactRequest} contact Updated contact data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public updateContact(contactId: string, contact: CordeCommonModelsDtoNotificationsUpdateContactRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).updateContact(contactId, contact, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates personal notification overrides for a team member
     * @summary Update Team Member Notification Overrides
     * @param {string} teamId Team ID
     * @param {string} userId User ID
     * @param {CordeCommonModelsDtoNotificationsUpdateTeamMemberNotificationOverridesRequest} overrides Updated member overrides
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public updateTeamMemberNotificationOverrides(teamId: string, userId: string, overrides: CordeCommonModelsDtoNotificationsUpdateTeamMemberNotificationOverridesRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).updateTeamMemberNotificationOverrides(teamId, userId, overrides, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates notification settings for a team
     * @summary Update Team Notification Settings
     * @param {string} teamId Team ID
     * @param {CordeCommonModelsDtoNotificationsUpdateTeamNotificationSettingsRequest} settings Updated team settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public updateTeamNotificationSettings(teamId: string, settings: CordeCommonModelsDtoNotificationsUpdateTeamNotificationSettingsRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).updateTeamNotificationSettings(teamId, settings, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an existing notification template
     * @summary Update Template
     * @param {string} templateId Template ID
     * @param {CordeCommonModelsDtoNotificationsUpdateTemplateRequest} template Updated template data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public updateTemplate(templateId: string, template: CordeCommonModelsDtoNotificationsUpdateTemplateRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).updateTemplate(templateId, template, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates event-specific channel settings for a user
     * @summary Update User Event Channel Settings
     * @param {string} userId User ID
     * @param {CordeCommonModelsDtoNotificationsUpdateUserEventChannelSettingsRequest} settings Updated event channel settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public updateUserEventChannelSettings(userId: string, settings: CordeCommonModelsDtoNotificationsUpdateUserEventChannelSettingsRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).updateUserEventChannelSettings(userId, settings, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validates channel configuration without saving it
     * @summary Validate Channel Config
     * @param {CordeCommonModelsDtoNotificationsValidateChannelConfigRequest} config Configuration to validate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public validateChannelConfig(config: CordeCommonModelsDtoNotificationsValidateChannelConfigRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).validateChannelConfig(config, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Validates if a contact value is properly formatted
     * @summary Validate Contact Value
     * @param {string} contactValue Contact value to validate
     * @param {string} contactType Contact type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public validateContactValue(contactValue: string, contactType: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).validateContactValue(contactValue, contactType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verifies a contact using a verification code
     * @summary Verify Contact
     * @param {string} contactId Contact ID
     * @param {CordeCommonModelsDtoNotificationsVerifyContactRequest} verification Verification data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public verifyContact(contactId: string, verification: CordeCommonModelsDtoNotificationsVerifyContactRequest, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).verifyContact(contactId, verification, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TeamApi - axios parameter creator
 * @export
 */
export const TeamApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Accept an invitation to join a team
         * @summary Accept team invitation
         * @param {string} teamId Team ID
         * @param {string} invitationId Invitation ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTeamInvitation: async (teamId: string, invitationId: string, xUserProfileID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('acceptTeamInvitation', 'teamId', teamId)
            // verify required parameter 'invitationId' is not null or undefined
            assertParamExists('acceptTeamInvitation', 'invitationId', invitationId)
            const localVarPath = `/teams/{team_id}/invitations/{invitation_id}/accept`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"invitation_id"}}`, encodeURIComponent(String(invitationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xUserProfileID != null) {
                localVarHeaderParameter['X-User-Profile-ID'] = String(xUserProfileID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a user to a team directly
         * @summary Add user to team
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamAddUserToTeamRequest} req Add User Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserToTeam: async (teamId: string, req: CordeCommonModelsDtoTeamAddUserToTeamRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('addUserToTeam', 'teamId', teamId)
            // verify required parameter 'req' is not null or undefined
            assertParamExists('addUserToTeam', 'req', req)
            const localVarPath = `/teams/{team_id}/members`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Approve a pending team role request
         * @summary Approve requested team role
         * @param {string} teamId Team ID
         * @param {string} requestId Request ID
         * @param {CordeCommonModelsDtoTeamApproveTeamRoleRequest} req Approve Role Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveRequestedTeamRole: async (teamId: string, requestId: string, req: CordeCommonModelsDtoTeamApproveTeamRoleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('approveRequestedTeamRole', 'teamId', teamId)
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('approveRequestedTeamRole', 'requestId', requestId)
            // verify required parameter 'req' is not null or undefined
            assertParamExists('approveRequestedTeamRole', 'req', req)
            const localVarPath = `/teams/{team_id}/roles/{request_id}/approve`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"request_id"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Approve or reject a team membership request
         * @summary Approve team membership
         * @param {string} teamId Team ID
         * @param {string} requestId Request ID
         * @param {CordeCommonModelsDtoTeamApproveTeamMembershipRequest} req Approval Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveTeamMembership: async (teamId: string, requestId: string, req: CordeCommonModelsDtoTeamApproveTeamMembershipRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('approveTeamMembership', 'teamId', teamId)
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('approveTeamMembership', 'requestId', requestId)
            // verify required parameter 'req' is not null or undefined
            assertParamExists('approveTeamMembership', 'req', req)
            const localVarPath = `/teams/{team_id}/membership/{request_id}/approve`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"request_id"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Assign a permission to a team role
         * @summary Assign permission to role
         * @param {string} teamId Team ID
         * @param {string} roleId Role ID
         * @param {CordeCommonModelsDtoTeamAssignPermissionToRoleRequest} req Assign Permission Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignPermissionToRole: async (teamId: string, roleId: string, req: CordeCommonModelsDtoTeamAssignPermissionToRoleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('assignPermissionToRole', 'teamId', teamId)
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('assignPermissionToRole', 'roleId', roleId)
            // verify required parameter 'req' is not null or undefined
            assertParamExists('assignPermissionToRole', 'req', req)
            const localVarPath = `/teams/{team_id}/roles/{role_id}/permissions`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Assign a role to a team member
         * @summary Assign role to user
         * @param {string} teamId Team ID
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoTeamAssignRoleToUserRequest} req Assign Role Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignRoleToUser: async (teamId: string, userId: string, req: CordeCommonModelsDtoTeamAssignRoleToUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('assignRoleToUser', 'teamId', teamId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('assignRoleToUser', 'userId', userId)
            // verify required parameter 'req' is not null or undefined
            assertParamExists('assignRoleToUser', 'req', req)
            const localVarPath = `/teams/{team_id}/members/{user_id}/roles`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel a pending team invitation request
         * @summary Cancel team invitation request
         * @param {string} teamId Team ID
         * @param {string} requestId Request ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTeamInvitationRequest: async (teamId: string, requestId: string, userprofileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('cancelTeamInvitationRequest', 'teamId', teamId)
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('cancelTeamInvitationRequest', 'requestId', requestId)
            // verify required parameter 'userprofileId' is not null or undefined
            assertParamExists('cancelTeamInvitationRequest', 'userprofileId', userprofileId)
            const localVarPath = `/teams/{team_id}/invitations/{request_id}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"request_id"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userprofileId !== undefined) {
                localVarQueryParameter['userprofile_id'] = userprofileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel a pending team membership request
         * @summary Cancel team membership request
         * @param {string} teamId Team ID
         * @param {string} requestId Request ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTeamMembershipRequest: async (teamId: string, requestId: string, userprofileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('cancelTeamMembershipRequest', 'teamId', teamId)
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('cancelTeamMembershipRequest', 'requestId', requestId)
            // verify required parameter 'userprofileId' is not null or undefined
            assertParamExists('cancelTeamMembershipRequest', 'userprofileId', userprofileId)
            const localVarPath = `/teams/{team_id}/membership/{request_id}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"request_id"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userprofileId !== undefined) {
                localVarQueryParameter['userprofile_id'] = userprofileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel a pending team ownership request
         * @summary Cancel team ownership request
         * @param {string} teamId Team ID
         * @param {string} requestId Request ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTeamOwnershipRequest: async (teamId: string, requestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('cancelTeamOwnershipRequest', 'teamId', teamId)
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('cancelTeamOwnershipRequest', 'requestId', requestId)
            const localVarPath = `/teams/{team_id}/ownership/{request_id}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"request_id"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel a pending team role request
         * @summary Cancel team role request
         * @param {string} teamId Team ID
         * @param {string} requestId Request ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTeamRoleRequest: async (teamId: string, requestId: string, userprofileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('cancelTeamRoleRequest', 'teamId', teamId)
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('cancelTeamRoleRequest', 'requestId', requestId)
            // verify required parameter 'userprofileId' is not null or undefined
            assertParamExists('cancelTeamRoleRequest', 'userprofileId', userprofileId)
            const localVarPath = `/teams/{team_id}/roles/{request_id}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"request_id"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userprofileId !== undefined) {
                localVarQueryParameter['userprofile_id'] = userprofileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new role for a team
         * @summary Create team role
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamCreateRoleRequest} req Create Role Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole: async (teamId: string, req: CordeCommonModelsDtoTeamCreateRoleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('createRole', 'teamId', teamId)
            // verify required parameter 'req' is not null or undefined
            assertParamExists('createRole', 'req', req)
            const localVarPath = `/teams/{team_id}/roles`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new team with the provided details
         * @summary Create a new team
         * @param {CordeCommonModelsDtoTeamCreateTeamRequest} req Team Creation Request
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeam: async (req: CordeCommonModelsDtoTeamCreateTeamRequest, xUserProfileID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'req' is not null or undefined
            assertParamExists('createTeam', 'req', req)
            const localVarPath = `/teams`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xUserProfileID != null) {
                localVarHeaderParameter['X-User-Profile-ID'] = String(xUserProfileID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new avatar for a team. Similar to user profile avatar management.
         * @summary Create team avatar
         * @param {string} teamId Team ID
         * @param {File} file Avatar image file
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {string} [name] Avatar name
         * @param {string} [description] Avatar description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamAvatar: async (teamId: string, file: File, xUserProfileID?: string, name?: string, description?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('createTeamAvatar', 'teamId', teamId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('createTeamAvatar', 'file', file)
            const localVarPath = `/teams/{team_id}/avatars`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (xUserProfileID != null) {
                localVarHeaderParameter['X-User-Profile-ID'] = String(xUserProfileID);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (name !== undefined) { 
                localVarFormParams.append('name', name as any);
            }
    
            if (description !== undefined) { 
                localVarFormParams.append('description', description as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new banner for a team
         * @summary Create team banner
         * @param {string} teamId Team ID
         * @param {File} file Banner image file
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {string} [name] Banner name
         * @param {string} [description] Banner description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamBanner: async (teamId: string, file: File, xUserProfileID?: string, name?: string, description?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('createTeamBanner', 'teamId', teamId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('createTeamBanner', 'file', file)
            const localVarPath = `/teams/{team_id}/banner`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            if (xUserProfileID != null) {
                localVarHeaderParameter['X-User-Profile-ID'] = String(xUserProfileID);
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (name !== undefined) { 
                localVarFormParams.append('name', name as any);
            }
    
            if (description !== undefined) { 
                localVarFormParams.append('description', description as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Decline an invitation to join a team
         * @summary Decline team invitation
         * @param {string} teamId Team ID
         * @param {string} invitationId Invitation ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineTeamInvitation: async (teamId: string, invitationId: string, userprofileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('declineTeamInvitation', 'teamId', teamId)
            // verify required parameter 'invitationId' is not null or undefined
            assertParamExists('declineTeamInvitation', 'invitationId', invitationId)
            // verify required parameter 'userprofileId' is not null or undefined
            assertParamExists('declineTeamInvitation', 'userprofileId', userprofileId)
            const localVarPath = `/teams/{team_id}/invitations/{invitation_id}/decline`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"invitation_id"}}`, encodeURIComponent(String(invitationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userprofileId !== undefined) {
                localVarQueryParameter['userprofile_id'] = userprofileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a role from a team
         * @summary Delete team role
         * @param {string} teamId Team ID
         * @param {string} roleId Role ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRole: async (teamId: string, roleId: string, userprofileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('deleteRole', 'teamId', teamId)
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('deleteRole', 'roleId', roleId)
            // verify required parameter 'userprofileId' is not null or undefined
            assertParamExists('deleteRole', 'userprofileId', userprofileId)
            const localVarPath = `/teams/{team_id}/roles/{role_id}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userprofileId !== undefined) {
                localVarQueryParameter['userprofile_id'] = userprofileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an existing team
         * @summary Delete a team
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeam: async (teamId: string, xUserProfileID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('deleteTeam', 'teamId', teamId)
            const localVarPath = `/teams/{team_id}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xUserProfileID != null) {
                localVarHeaderParameter['X-User-Profile-ID'] = String(xUserProfileID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a team avatar
         * @summary Delete team avatar
         * @param {string} teamId Team ID
         * @param {string} avatarId Avatar ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeamAvatar: async (teamId: string, avatarId: string, xUserProfileID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('deleteTeamAvatar', 'teamId', teamId)
            // verify required parameter 'avatarId' is not null or undefined
            assertParamExists('deleteTeamAvatar', 'avatarId', avatarId)
            const localVarPath = `/teams/{team_id}/avatars/{avatar_id}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"avatar_id"}}`, encodeURIComponent(String(avatarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xUserProfileID != null) {
                localVarHeaderParameter['X-User-Profile-ID'] = String(xUserProfileID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete the banner for a team
         * @summary Delete team banner
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeamBanner: async (teamId: string, xUserProfileID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('deleteTeamBanner', 'teamId', teamId)
            const localVarPath = `/teams/{team_id}/banner`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xUserProfileID != null) {
                localVarHeaderParameter['X-User-Profile-ID'] = String(xUserProfileID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the default user profile for a user in team context, with optional entity scope. Results are cached for 24 hours.
         * @summary Get default user profile for team context
         * @param {string} [entityType] Entity type (e.g., \&#39;team\&#39;, \&#39;project\&#39;)
         * @param {string} [entityId] Entity ID for scoped default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultUserProfileForTeam: async (entityType?: string, entityId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/teams/users/default-profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityType !== undefined) {
                localVarQueryParameter['entity_type'] = entityType;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entity_id'] = entityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a team by its ID
         * @summary Get a team
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeam: async (teamId: string, xUserProfileID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeam', 'teamId', teamId)
            const localVarPath = `/teams/{team_id}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xUserProfileID != null) {
                localVarHeaderParameter['X-User-Profile-ID'] = String(xUserProfileID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get audit logs for a team
         * @summary Get team audit logs
         * @param {string} teamId Team ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamAuditLogs: async (teamId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamAuditLogs', 'teamId', teamId)
            const localVarPath = `/teams/{team_id}/audit-logs`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of all available actions/permissions that can be assigned to team roles with i18n translations
         * @summary Get available team actions
         * @param {string} teamId Team ID
         * @param {string} [language] Language code (default: en)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamAvailableActions: async (teamId: string, language?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamAvailableActions', 'teamId', teamId)
            const localVarPath = `/teams/{team_id}/available-actions`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a specific team avatar
         * @summary Get team avatar
         * @param {string} teamId Team ID
         * @param {string} avatarId Avatar ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamAvatar: async (teamId: string, avatarId: string, xUserProfileID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamAvatar', 'teamId', teamId)
            // verify required parameter 'avatarId' is not null or undefined
            assertParamExists('getTeamAvatar', 'avatarId', avatarId)
            const localVarPath = `/teams/{team_id}/avatars/{avatar_id}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"avatar_id"}}`, encodeURIComponent(String(avatarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xUserProfileID != null) {
                localVarHeaderParameter['X-User-Profile-ID'] = String(xUserProfileID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the banner for a team
         * @summary Get team banner
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamBanner: async (teamId: string, xUserProfileID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamBanner', 'teamId', teamId)
            const localVarPath = `/teams/{team_id}/banner`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xUserProfileID != null) {
                localVarHeaderParameter['X-User-Profile-ID'] = String(xUserProfileID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get activity logs for a team
         * @summary Get team logs
         * @param {string} teamId Team ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamLogs: async (teamId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamLogs', 'teamId', teamId)
            const localVarPath = `/teams/{team_id}/logs`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get details of a specific membership request
         * @summary Get team membership request
         * @param {string} teamId Team ID
         * @param {string} requestId Request ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamMembershipRequest: async (teamId: string, requestId: string, userprofileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamMembershipRequest', 'teamId', teamId)
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('getTeamMembershipRequest', 'requestId', requestId)
            // verify required parameter 'userprofileId' is not null or undefined
            assertParamExists('getTeamMembershipRequest', 'userprofileId', userprofileId)
            const localVarPath = `/teams/{team_id}/membership-request/{request_id}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"request_id"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userprofileId !== undefined) {
                localVarQueryParameter['userprofile_id'] = userprofileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get details of a specific ownership request
         * @summary Get team ownership request
         * @param {string} teamId Team ID
         * @param {string} requestId Request ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamOwnershipRequest: async (teamId: string, requestId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamOwnershipRequest', 'teamId', teamId)
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('getTeamOwnershipRequest', 'requestId', requestId)
            const localVarPath = `/teams/{team_id}/ownership-request/{request_id}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"request_id"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get details of a specific role request
         * @summary Get team role request
         * @param {string} teamId Team ID
         * @param {string} requestId Request ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamRoleRequest: async (teamId: string, requestId: string, userprofileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamRoleRequest', 'teamId', teamId)
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('getTeamRoleRequest', 'requestId', requestId)
            // verify required parameter 'userprofileId' is not null or undefined
            assertParamExists('getTeamRoleRequest', 'userprofileId', userprofileId)
            const localVarPath = `/teams/{team_id}/role-request/{request_id}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"request_id"}}`, encodeURIComponent(String(requestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userprofileId !== undefined) {
                localVarQueryParameter['userprofile_id'] = userprofileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get security settings for a team
         * @summary Get team security settings
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamSecuritySettings: async (teamId: string, xUserProfileID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamSecuritySettings', 'teamId', teamId)
            const localVarPath = `/teams/{team_id}/settings/security`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xUserProfileID != null) {
                localVarHeaderParameter['X-User-Profile-ID'] = String(xUserProfileID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get UI settings for a team
         * @summary Get team UI settings
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamUISettings: async (teamId: string, xUserProfileID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamUISettings', 'teamId', teamId)
            const localVarPath = `/teams/{team_id}/settings/ui`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xUserProfileID != null) {
                localVarHeaderParameter['X-User-Profile-ID'] = String(xUserProfileID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user management settings for a team
         * @summary Get team user settings
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamUserSettings: async (teamId: string, xUserProfileID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('getTeamUserSettings', 'teamId', teamId)
            const localVarPath = `/teams/{team_id}/settings/users`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xUserProfileID != null) {
                localVarHeaderParameter['X-User-Profile-ID'] = String(xUserProfileID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Grant ownership of a team to a user
         * @summary Grant team ownership
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamGrantTeamOwnershipRequest} req Grant Ownership Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantTeamOwnership: async (teamId: string, req: CordeCommonModelsDtoTeamGrantTeamOwnershipRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('grantTeamOwnership', 'teamId', teamId)
            // verify required parameter 'req' is not null or undefined
            assertParamExists('grantTeamOwnership', 'req', req)
            const localVarPath = `/teams/{team_id}/ownership/grant`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Grant a role to a team member
         * @summary Grant team role
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamGrantTeamRoleRequest} req Grant Role Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantTeamRole: async (teamId: string, req: CordeCommonModelsDtoTeamGrantTeamRoleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('grantTeamRole', 'teamId', teamId)
            // verify required parameter 'req' is not null or undefined
            assertParamExists('grantTeamRole', 'req', req)
            const localVarPath = `/teams/{team_id}/roles/grant`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Invite a user to join a team
         * @summary Invite user to team
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamInviteUserToTeamRequest} req Invitation Request
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteUserToTeam: async (teamId: string, req: CordeCommonModelsDtoTeamInviteUserToTeamRequest, xUserProfileID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('inviteUserToTeam', 'teamId', teamId)
            // verify required parameter 'req' is not null or undefined
            assertParamExists('inviteUserToTeam', 'req', req)
            const localVarPath = `/teams/{team_id}/invite`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xUserProfileID != null) {
                localVarHeaderParameter['X-User-Profile-ID'] = String(xUserProfileID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all available permissions for a team
         * @summary List team permissions
         * @param {string} teamId Team ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPermissions: async (teamId: string, userprofileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('listPermissions', 'teamId', teamId)
            // verify required parameter 'userprofileId' is not null or undefined
            assertParamExists('listPermissions', 'userprofileId', userprofileId)
            const localVarPath = `/teams/{team_id}/permissions`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userprofileId !== undefined) {
                localVarQueryParameter['userprofile_id'] = userprofileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all roles in a team
         * @summary List team roles
         * @param {string} teamId Team ID
         * @param {string} memberId Member profile ID
         * @param {string} userprofileId Userprofile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRoles: async (teamId: string, memberId: string, userprofileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('listRoles', 'teamId', teamId)
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('listRoles', 'memberId', memberId)
            // verify required parameter 'userprofileId' is not null or undefined
            assertParamExists('listRoles', 'userprofileId', userprofileId)
            const localVarPath = `/teams/{team_id}/roles`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)))
                .replace(`{${"userprofile_id"}}`, encodeURIComponent(String(userprofileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all avatars for a team
         * @summary List team avatars
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTeamAvatars: async (teamId: string, xUserProfileID?: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('listTeamAvatars', 'teamId', teamId)
            const localVarPath = `/teams/{team_id}/avatars`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (xUserProfileID != null) {
                localVarHeaderParameter['X-User-Profile-ID'] = String(xUserProfileID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all invitations for a team
         * @summary List team invitations
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTeamInvitations: async (teamId: string, xUserProfileID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('listTeamInvitations', 'teamId', teamId)
            const localVarPath = `/teams/{team_id}/invitations`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xUserProfileID != null) {
                localVarHeaderParameter['X-User-Profile-ID'] = String(xUserProfileID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all pending membership requests for a team
         * @summary List team membership requests
         * @param {string} teamId Team ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTeamMembershipRequests: async (teamId: string, userprofileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('listTeamMembershipRequests', 'teamId', teamId)
            // verify required parameter 'userprofileId' is not null or undefined
            assertParamExists('listTeamMembershipRequests', 'userprofileId', userprofileId)
            const localVarPath = `/teams/{team_id}/membership-requests`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userprofileId !== undefined) {
                localVarQueryParameter['userprofile_id'] = userprofileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all pending ownership requests for a team
         * @summary List team ownership requests
         * @param {string} teamId Team ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTeamOwnershipRequests: async (teamId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('listTeamOwnershipRequests', 'teamId', teamId)
            const localVarPath = `/teams/{team_id}/ownership-requests`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all role requests for a team
         * @summary List team role requests
         * @param {string} teamId Team ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTeamRoleRequests: async (teamId: string, userprofileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('listTeamRoleRequests', 'teamId', teamId)
            // verify required parameter 'userprofileId' is not null or undefined
            assertParamExists('listTeamRoleRequests', 'userprofileId', userprofileId)
            const localVarPath = `/teams/{team_id}/roles/requests`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userprofileId !== undefined) {
                localVarQueryParameter['userprofile_id'] = userprofileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List teams for a user with filtering and pagination
         * @summary List teams
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {string} [teamType] Filter by team type
         * @param {string} [status] Filter by team status
         * @param {string} [listType] Filter by relationship (all, member_of, managed)
         * @param {string} [sortBy] Sort field (name, last_visited, created_at)
         * @param {string} [sortOrder] Sort order (asc, desc)
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTeams: async (xUserProfileID?: string, teamType?: string, status?: string, listType?: string, sortBy?: string, sortOrder?: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/teams/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (teamType !== undefined) {
                localVarQueryParameter['team_type'] = teamType;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (listType !== undefined) {
                localVarQueryParameter['list_type'] = listType;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (xUserProfileID != null) {
                localVarHeaderParameter['X-User-Profile-ID'] = String(xUserProfileID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all users with a specific role in a team
         * @summary List users by role
         * @param {string} teamId Team ID
         * @param {string} roleId Role ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsersByRole: async (teamId: string, roleId: string, userprofileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('listUsersByRole', 'teamId', teamId)
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('listUsersByRole', 'roleId', roleId)
            // verify required parameter 'userprofileId' is not null or undefined
            assertParamExists('listUsersByRole', 'userprofileId', userprofileId)
            const localVarPath = `/teams/{team_id}/roles/{role_id}/members`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userprofileId !== undefined) {
                localVarQueryParameter['userprofile_id'] = userprofileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all users in a team
         * @summary List users in team
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsersInTeam: async (teamId: string, xUserProfileID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('listUsersInTeam', 'teamId', teamId)
            const localVarPath = `/teams/{team_id}/members`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xUserProfileID != null) {
                localVarHeaderParameter['X-User-Profile-ID'] = String(xUserProfileID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a permission from a team role
         * @summary Remove permission from role
         * @param {string} teamId Team ID
         * @param {string} roleId Role ID
         * @param {string} permission Permission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePermissionFromRole: async (teamId: string, roleId: string, permission: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('removePermissionFromRole', 'teamId', teamId)
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('removePermissionFromRole', 'roleId', roleId)
            // verify required parameter 'permission' is not null or undefined
            assertParamExists('removePermissionFromRole', 'permission', permission)
            const localVarPath = `/teams/{team_id}/roles/{role_id}/permissions/{permission}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)))
                .replace(`{${"permission"}}`, encodeURIComponent(String(permission)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a role from a team member
         * @summary Remove role from user
         * @param {string} teamId Team ID
         * @param {string} userId User ID
         * @param {string} roleId Role ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRoleFromUser: async (teamId: string, userId: string, roleId: string, userprofileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('removeRoleFromUser', 'teamId', teamId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeRoleFromUser', 'userId', userId)
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('removeRoleFromUser', 'roleId', roleId)
            // verify required parameter 'userprofileId' is not null or undefined
            assertParamExists('removeRoleFromUser', 'userprofileId', userprofileId)
            const localVarPath = `/teams/{team_id}/members/{user_id}/roles/{role_id}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userprofileId !== undefined) {
                localVarQueryParameter['userprofile_id'] = userprofileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a user from a team
         * @summary Remove user from team
         * @param {string} teamId Team ID
         * @param {string} userprofileId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserFromTeam: async (teamId: string, userprofileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('removeUserFromTeam', 'teamId', teamId)
            // verify required parameter 'userprofileId' is not null or undefined
            assertParamExists('removeUserFromTeam', 'userprofileId', userprofileId)
            const localVarPath = `/teams/{team_id}/members/{userprofile_id}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"userprofile_id"}}`, encodeURIComponent(String(userprofileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Request to join a team
         * @summary Request team membership
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamRequestTeamMembershipRequest} req Membership Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestTeamMembership: async (teamId: string, req: CordeCommonModelsDtoTeamRequestTeamMembershipRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('requestTeamMembership', 'teamId', teamId)
            // verify required parameter 'req' is not null or undefined
            assertParamExists('requestTeamMembership', 'req', req)
            const localVarPath = `/teams/{team_id}/membership/request`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Request ownership of a team
         * @summary Request team ownership
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamRequestTeamOwnershipRequest} req Request Ownership Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestTeamOwnership: async (teamId: string, req: CordeCommonModelsDtoTeamRequestTeamOwnershipRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('requestTeamOwnership', 'teamId', teamId)
            // verify required parameter 'req' is not null or undefined
            assertParamExists('requestTeamOwnership', 'req', req)
            const localVarPath = `/teams/{team_id}/ownership/request`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Request a role in a team
         * @summary Request team role
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamRequestTeamRoleRequest} req Role Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestTeamRole: async (teamId: string, req: CordeCommonModelsDtoTeamRequestTeamRoleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('requestTeamRole', 'teamId', teamId)
            // verify required parameter 'req' is not null or undefined
            assertParamExists('requestTeamRole', 'req', req)
            const localVarPath = `/teams/{team_id}/roles/request`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revoke ownership of a team from a user
         * @summary Revoke team ownership
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamRevokeTeamOwnershipRequest} req Revoke Ownership Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeTeamOwnership: async (teamId: string, req: CordeCommonModelsDtoTeamRevokeTeamOwnershipRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('revokeTeamOwnership', 'teamId', teamId)
            // verify required parameter 'req' is not null or undefined
            assertParamExists('revokeTeamOwnership', 'req', req)
            const localVarPath = `/teams/{team_id}/ownership/revoke`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revoke a role from a team member
         * @summary Revoke team role
         * @param {string} teamId Team ID
         * @param {string} userId User ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeTeamRole: async (teamId: string, userId: string, userprofileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('revokeTeamRole', 'teamId', teamId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('revokeTeamRole', 'userId', userId)
            // verify required parameter 'userprofileId' is not null or undefined
            assertParamExists('revokeTeamRole', 'userprofileId', userprofileId)
            const localVarPath = `/teams/{team_id}/members/{user_id}/role`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userprofileId !== undefined) {
                localVarQueryParameter['userprofile_id'] = userprofileId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Advanced search for teams with complex criteria
         * @summary Search teams
         * @param {CordeCommonModelsDtoTeamSearchTeamsRequest} req Search Request
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTeams: async (req: CordeCommonModelsDtoTeamSearchTeamsRequest, xUserProfileID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'req' is not null or undefined
            assertParamExists('searchTeams', 'req', req)
            const localVarPath = `/teams/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xUserProfileID != null) {
                localVarHeaderParameter['X-User-Profile-ID'] = String(xUserProfileID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set the active avatar for a team
         * @summary Set active team avatar
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamSetActiveTeamAvatarRequest} req Set Active Avatar Request
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setActiveTeamAvatar: async (teamId: string, req: CordeCommonModelsDtoTeamSetActiveTeamAvatarRequest, xUserProfileID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('setActiveTeamAvatar', 'teamId', teamId)
            // verify required parameter 'req' is not null or undefined
            assertParamExists('setActiveTeamAvatar', 'req', req)
            const localVarPath = `/teams/{team_id}/avatars/active`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xUserProfileID != null) {
                localVarHeaderParameter['X-User-Profile-ID'] = String(xUserProfileID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Transfer ownership of a team to another user
         * @summary Transfer team ownership
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamTransferTeamOwnershipRequest} req Transfer Ownership Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferTeamOwnership: async (teamId: string, req: CordeCommonModelsDtoTeamTransferTeamOwnershipRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('transferTeamOwnership', 'teamId', teamId)
            // verify required parameter 'req' is not null or undefined
            assertParamExists('transferTeamOwnership', 'req', req)
            const localVarPath = `/teams/{team_id}/ownership/transfer`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing team role
         * @summary Update team role
         * @param {string} teamId Team ID
         * @param {string} roleId Role ID
         * @param {CordeCommonModelsDtoTeamUpdateRoleRequest} req Update Role Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole: async (teamId: string, roleId: string, req: CordeCommonModelsDtoTeamUpdateRoleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('updateRole', 'teamId', teamId)
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('updateRole', 'roleId', roleId)
            // verify required parameter 'req' is not null or undefined
            assertParamExists('updateRole', 'req', req)
            const localVarPath = `/teams/{team_id}/roles/{role_id}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing team\'s details
         * @summary Update a team
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamUpdateTeamRequest} req Team Update Request
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeam: async (teamId: string, req: CordeCommonModelsDtoTeamUpdateTeamRequest, xUserProfileID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('updateTeam', 'teamId', teamId)
            // verify required parameter 'req' is not null or undefined
            assertParamExists('updateTeam', 'req', req)
            const localVarPath = `/teams/{team_id}`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xUserProfileID != null) {
                localVarHeaderParameter['X-User-Profile-ID'] = String(xUserProfileID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update security settings for a team
         * @summary Update team security settings
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamUpdateTeamSecuritySettingsRequest} req Update Security Settings Request
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamSecuritySettings: async (teamId: string, req: CordeCommonModelsDtoTeamUpdateTeamSecuritySettingsRequest, xUserProfileID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('updateTeamSecuritySettings', 'teamId', teamId)
            // verify required parameter 'req' is not null or undefined
            assertParamExists('updateTeamSecuritySettings', 'req', req)
            const localVarPath = `/teams/{team_id}/settings/security`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xUserProfileID != null) {
                localVarHeaderParameter['X-User-Profile-ID'] = String(xUserProfileID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update UI settings for a team
         * @summary Update team UI settings
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamUpdateTeamUISettingsRequest} req Update UI Settings Request
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamUISettings: async (teamId: string, req: CordeCommonModelsDtoTeamUpdateTeamUISettingsRequest, xUserProfileID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('updateTeamUISettings', 'teamId', teamId)
            // verify required parameter 'req' is not null or undefined
            assertParamExists('updateTeamUISettings', 'req', req)
            const localVarPath = `/teams/{team_id}/settings/ui`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xUserProfileID != null) {
                localVarHeaderParameter['X-User-Profile-ID'] = String(xUserProfileID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update user management settings for a team
         * @summary Update team user settings
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamUpdateTeamUserSettingsRequest} req Update User Settings Request
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamUserSettings: async (teamId: string, req: CordeCommonModelsDtoTeamUpdateTeamUserSettingsRequest, xUserProfileID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('updateTeamUserSettings', 'teamId', teamId)
            // verify required parameter 'req' is not null or undefined
            assertParamExists('updateTeamUserSettings', 'req', req)
            const localVarPath = `/teams/{team_id}/settings/users`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xUserProfileID != null) {
                localVarHeaderParameter['X-User-Profile-ID'] = String(xUserProfileID);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a user\'s role in a team
         * @summary Update user role in team
         * @param {string} teamId Team ID
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoTeamUpdateUserRoleInTeamRequest} req Update Role Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserRoleInTeam: async (teamId: string, userId: string, req: CordeCommonModelsDtoTeamUpdateUserRoleInTeamRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('updateUserRoleInTeam', 'teamId', teamId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserRoleInTeam', 'userId', userId)
            // verify required parameter 'req' is not null or undefined
            assertParamExists('updateUserRoleInTeam', 'req', req)
            const localVarPath = `/teams/{team_id}/members/{user_id}/role`
                .replace(`{${"team_id"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamApi - functional programming interface
 * @export
 */
export const TeamApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamApiAxiosParamCreator(configuration)
    return {
        /**
         * Accept an invitation to join a team
         * @summary Accept team invitation
         * @param {string} teamId Team ID
         * @param {string} invitationId Invitation ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptTeamInvitation(teamId: string, invitationId: string, xUserProfileID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptTeamInvitation(teamId, invitationId, xUserProfileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.acceptTeamInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a user to a team directly
         * @summary Add user to team
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamAddUserToTeamRequest} req Add User Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addUserToTeam(teamId: string, req: CordeCommonModelsDtoTeamAddUserToTeamRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addUserToTeam(teamId, req, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.addUserToTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Approve a pending team role request
         * @summary Approve requested team role
         * @param {string} teamId Team ID
         * @param {string} requestId Request ID
         * @param {CordeCommonModelsDtoTeamApproveTeamRoleRequest} req Approve Role Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveRequestedTeamRole(teamId: string, requestId: string, req: CordeCommonModelsDtoTeamApproveTeamRoleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveRequestedTeamRole(teamId, requestId, req, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.approveRequestedTeamRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Approve or reject a team membership request
         * @summary Approve team membership
         * @param {string} teamId Team ID
         * @param {string} requestId Request ID
         * @param {CordeCommonModelsDtoTeamApproveTeamMembershipRequest} req Approval Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveTeamMembership(teamId: string, requestId: string, req: CordeCommonModelsDtoTeamApproveTeamMembershipRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveTeamMembership(teamId, requestId, req, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.approveTeamMembership']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Assign a permission to a team role
         * @summary Assign permission to role
         * @param {string} teamId Team ID
         * @param {string} roleId Role ID
         * @param {CordeCommonModelsDtoTeamAssignPermissionToRoleRequest} req Assign Permission Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignPermissionToRole(teamId: string, roleId: string, req: CordeCommonModelsDtoTeamAssignPermissionToRoleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignPermissionToRole(teamId, roleId, req, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.assignPermissionToRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Assign a role to a team member
         * @summary Assign role to user
         * @param {string} teamId Team ID
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoTeamAssignRoleToUserRequest} req Assign Role Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignRoleToUser(teamId: string, userId: string, req: CordeCommonModelsDtoTeamAssignRoleToUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignRoleToUser(teamId, userId, req, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.assignRoleToUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cancel a pending team invitation request
         * @summary Cancel team invitation request
         * @param {string} teamId Team ID
         * @param {string} requestId Request ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelTeamInvitationRequest(teamId: string, requestId: string, userprofileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelTeamInvitationRequest(teamId, requestId, userprofileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.cancelTeamInvitationRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cancel a pending team membership request
         * @summary Cancel team membership request
         * @param {string} teamId Team ID
         * @param {string} requestId Request ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelTeamMembershipRequest(teamId: string, requestId: string, userprofileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelTeamMembershipRequest(teamId, requestId, userprofileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.cancelTeamMembershipRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cancel a pending team ownership request
         * @summary Cancel team ownership request
         * @param {string} teamId Team ID
         * @param {string} requestId Request ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelTeamOwnershipRequest(teamId: string, requestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelTeamOwnershipRequest(teamId, requestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.cancelTeamOwnershipRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cancel a pending team role request
         * @summary Cancel team role request
         * @param {string} teamId Team ID
         * @param {string} requestId Request ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelTeamRoleRequest(teamId: string, requestId: string, userprofileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelTeamRoleRequest(teamId, requestId, userprofileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.cancelTeamRoleRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new role for a team
         * @summary Create team role
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamCreateRoleRequest} req Create Role Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRole(teamId: string, req: CordeCommonModelsDtoTeamCreateRoleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRole(teamId, req, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.createRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new team with the provided details
         * @summary Create a new team
         * @param {CordeCommonModelsDtoTeamCreateTeamRequest} req Team Creation Request
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTeam(req: CordeCommonModelsDtoTeamCreateTeamRequest, xUserProfileID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoTeamTeam>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTeam(req, xUserProfileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.createTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new avatar for a team. Similar to user profile avatar management.
         * @summary Create team avatar
         * @param {string} teamId Team ID
         * @param {File} file Avatar image file
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {string} [name] Avatar name
         * @param {string} [description] Avatar description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTeamAvatar(teamId: string, file: File, xUserProfileID?: string, name?: string, description?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoTeamTeamAvatar>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTeamAvatar(teamId, file, xUserProfileID, name, description, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.createTeamAvatar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new banner for a team
         * @summary Create team banner
         * @param {string} teamId Team ID
         * @param {File} file Banner image file
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {string} [name] Banner name
         * @param {string} [description] Banner description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTeamBanner(teamId: string, file: File, xUserProfileID?: string, name?: string, description?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoTeamTeamBanner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTeamBanner(teamId, file, xUserProfileID, name, description, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.createTeamBanner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Decline an invitation to join a team
         * @summary Decline team invitation
         * @param {string} teamId Team ID
         * @param {string} invitationId Invitation ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async declineTeamInvitation(teamId: string, invitationId: string, userprofileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.declineTeamInvitation(teamId, invitationId, userprofileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.declineTeamInvitation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a role from a team
         * @summary Delete team role
         * @param {string} teamId Team ID
         * @param {string} roleId Role ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRole(teamId: string, roleId: string, userprofileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRole(teamId, roleId, userprofileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.deleteRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an existing team
         * @summary Delete a team
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTeam(teamId: string, xUserProfileID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTeam(teamId, xUserProfileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.deleteTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a team avatar
         * @summary Delete team avatar
         * @param {string} teamId Team ID
         * @param {string} avatarId Avatar ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTeamAvatar(teamId: string, avatarId: string, xUserProfileID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTeamAvatar(teamId, avatarId, xUserProfileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.deleteTeamAvatar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete the banner for a team
         * @summary Delete team banner
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTeamBanner(teamId: string, xUserProfileID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTeamBanner(teamId, xUserProfileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.deleteTeamBanner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the default user profile for a user in team context, with optional entity scope. Results are cached for 24 hours.
         * @summary Get default user profile for team context
         * @param {string} [entityType] Entity type (e.g., \&#39;team\&#39;, \&#39;project\&#39;)
         * @param {string} [entityId] Entity ID for scoped default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefaultUserProfileForTeam(entityType?: string, entityId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoUserprofileUserProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefaultUserProfileForTeam(entityType, entityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getDefaultUserProfileForTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a team by its ID
         * @summary Get a team
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeam(teamId: string, xUserProfileID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoTeamTeam>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeam(teamId, xUserProfileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get audit logs for a team
         * @summary Get team audit logs
         * @param {string} teamId Team ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamAuditLogs(teamId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoTeamGetTeamAuditLogsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamAuditLogs(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getTeamAuditLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get list of all available actions/permissions that can be assigned to team roles with i18n translations
         * @summary Get available team actions
         * @param {string} teamId Team ID
         * @param {string} [language] Language code (default: en)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamAvailableActions(teamId: string, language?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoTeamGetTeamAvailableActionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamAvailableActions(teamId, language, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getTeamAvailableActions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a specific team avatar
         * @summary Get team avatar
         * @param {string} teamId Team ID
         * @param {string} avatarId Avatar ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamAvatar(teamId: string, avatarId: string, xUserProfileID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoTeamTeamAvatar>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamAvatar(teamId, avatarId, xUserProfileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getTeamAvatar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the banner for a team
         * @summary Get team banner
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamBanner(teamId: string, xUserProfileID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoTeamTeamBanner>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamBanner(teamId, xUserProfileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getTeamBanner']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get activity logs for a team
         * @summary Get team logs
         * @param {string} teamId Team ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamLogs(teamId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoTeamGetTeamLogsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamLogs(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getTeamLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get details of a specific membership request
         * @summary Get team membership request
         * @param {string} teamId Team ID
         * @param {string} requestId Request ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamMembershipRequest(teamId: string, requestId: string, userprofileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoTeamGetTeamMembershipRequestRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamMembershipRequest(teamId, requestId, userprofileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getTeamMembershipRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get details of a specific ownership request
         * @summary Get team ownership request
         * @param {string} teamId Team ID
         * @param {string} requestId Request ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamOwnershipRequest(teamId: string, requestId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoTeamTeamOwnershipRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamOwnershipRequest(teamId, requestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getTeamOwnershipRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get details of a specific role request
         * @summary Get team role request
         * @param {string} teamId Team ID
         * @param {string} requestId Request ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamRoleRequest(teamId: string, requestId: string, userprofileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoTeamTeamRoleRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamRoleRequest(teamId, requestId, userprofileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getTeamRoleRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get security settings for a team
         * @summary Get team security settings
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamSecuritySettings(teamId: string, xUserProfileID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoTeamTeamSecuritySettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamSecuritySettings(teamId, xUserProfileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getTeamSecuritySettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get UI settings for a team
         * @summary Get team UI settings
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamUISettings(teamId: string, xUserProfileID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoTeamTeamUISettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamUISettings(teamId, xUserProfileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getTeamUISettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get user management settings for a team
         * @summary Get team user settings
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTeamUserSettings(teamId: string, xUserProfileID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoTeamTeamUserSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTeamUserSettings(teamId, xUserProfileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.getTeamUserSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Grant ownership of a team to a user
         * @summary Grant team ownership
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamGrantTeamOwnershipRequest} req Grant Ownership Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantTeamOwnership(teamId: string, req: CordeCommonModelsDtoTeamGrantTeamOwnershipRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantTeamOwnership(teamId, req, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.grantTeamOwnership']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Grant a role to a team member
         * @summary Grant team role
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamGrantTeamRoleRequest} req Grant Role Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantTeamRole(teamId: string, req: CordeCommonModelsDtoTeamGrantTeamRoleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantTeamRole(teamId, req, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.grantTeamRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Invite a user to join a team
         * @summary Invite user to team
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamInviteUserToTeamRequest} req Invitation Request
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteUserToTeam(teamId: string, req: CordeCommonModelsDtoTeamInviteUserToTeamRequest, xUserProfileID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteUserToTeam(teamId, req, xUserProfileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.inviteUserToTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all available permissions for a team
         * @summary List team permissions
         * @param {string} teamId Team ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listPermissions(teamId: string, userprofileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoTeamListPermissionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listPermissions(teamId, userprofileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.listPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all roles in a team
         * @summary List team roles
         * @param {string} teamId Team ID
         * @param {string} memberId Member profile ID
         * @param {string} userprofileId Userprofile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRoles(teamId: string, memberId: string, userprofileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoTeamListRolesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRoles(teamId, memberId, userprofileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.listRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all avatars for a team
         * @summary List team avatars
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTeamAvatars(teamId: string, xUserProfileID?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoTeamListTeamAvatarsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTeamAvatars(teamId, xUserProfileID, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.listTeamAvatars']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all invitations for a team
         * @summary List team invitations
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTeamInvitations(teamId: string, xUserProfileID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoTeamListTeamInvitationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTeamInvitations(teamId, xUserProfileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.listTeamInvitations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all pending membership requests for a team
         * @summary List team membership requests
         * @param {string} teamId Team ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTeamMembershipRequests(teamId: string, userprofileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoTeamListTeamMembershipRequestsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTeamMembershipRequests(teamId, userprofileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.listTeamMembershipRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all pending ownership requests for a team
         * @summary List team ownership requests
         * @param {string} teamId Team ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTeamOwnershipRequests(teamId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoTeamListTeamOwnershipRequestsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTeamOwnershipRequests(teamId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.listTeamOwnershipRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all role requests for a team
         * @summary List team role requests
         * @param {string} teamId Team ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTeamRoleRequests(teamId: string, userprofileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTeamRoleRequests(teamId, userprofileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.listTeamRoleRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List teams for a user with filtering and pagination
         * @summary List teams
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {string} [teamType] Filter by team type
         * @param {string} [status] Filter by team status
         * @param {string} [listType] Filter by relationship (all, member_of, managed)
         * @param {string} [sortBy] Sort field (name, last_visited, created_at)
         * @param {string} [sortOrder] Sort order (asc, desc)
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTeams(xUserProfileID?: string, teamType?: string, status?: string, listType?: string, sortBy?: string, sortOrder?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoTeamListTeamsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTeams(xUserProfileID, teamType, status, listType, sortBy, sortOrder, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.listTeams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all users with a specific role in a team
         * @summary List users by role
         * @param {string} teamId Team ID
         * @param {string} roleId Role ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUsersByRole(teamId: string, roleId: string, userprofileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoTeamListUsersByRoleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUsersByRole(teamId, roleId, userprofileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.listUsersByRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all users in a team
         * @summary List users in team
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUsersInTeam(teamId: string, xUserProfileID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoTeamListUsersInTeamResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUsersInTeam(teamId, xUserProfileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.listUsersInTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a permission from a team role
         * @summary Remove permission from role
         * @param {string} teamId Team ID
         * @param {string} roleId Role ID
         * @param {string} permission Permission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removePermissionFromRole(teamId: string, roleId: string, permission: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removePermissionFromRole(teamId, roleId, permission, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.removePermissionFromRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a role from a team member
         * @summary Remove role from user
         * @param {string} teamId Team ID
         * @param {string} userId User ID
         * @param {string} roleId Role ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeRoleFromUser(teamId: string, userId: string, roleId: string, userprofileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeRoleFromUser(teamId, userId, roleId, userprofileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.removeRoleFromUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a user from a team
         * @summary Remove user from team
         * @param {string} teamId Team ID
         * @param {string} userprofileId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeUserFromTeam(teamId: string, userprofileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeUserFromTeam(teamId, userprofileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.removeUserFromTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Request to join a team
         * @summary Request team membership
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamRequestTeamMembershipRequest} req Membership Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestTeamMembership(teamId: string, req: CordeCommonModelsDtoTeamRequestTeamMembershipRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestTeamMembership(teamId, req, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.requestTeamMembership']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Request ownership of a team
         * @summary Request team ownership
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamRequestTeamOwnershipRequest} req Request Ownership Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestTeamOwnership(teamId: string, req: CordeCommonModelsDtoTeamRequestTeamOwnershipRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestTeamOwnership(teamId, req, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.requestTeamOwnership']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Request a role in a team
         * @summary Request team role
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamRequestTeamRoleRequest} req Role Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestTeamRole(teamId: string, req: CordeCommonModelsDtoTeamRequestTeamRoleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestTeamRole(teamId, req, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.requestTeamRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Revoke ownership of a team from a user
         * @summary Revoke team ownership
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamRevokeTeamOwnershipRequest} req Revoke Ownership Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeTeamOwnership(teamId: string, req: CordeCommonModelsDtoTeamRevokeTeamOwnershipRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeTeamOwnership(teamId, req, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.revokeTeamOwnership']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Revoke a role from a team member
         * @summary Revoke team role
         * @param {string} teamId Team ID
         * @param {string} userId User ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeTeamRole(teamId: string, userId: string, userprofileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeTeamRole(teamId, userId, userprofileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.revokeTeamRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Advanced search for teams with complex criteria
         * @summary Search teams
         * @param {CordeCommonModelsDtoTeamSearchTeamsRequest} req Search Request
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchTeams(req: CordeCommonModelsDtoTeamSearchTeamsRequest, xUserProfileID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoTeamListTeamsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchTeams(req, xUserProfileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.searchTeams']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set the active avatar for a team
         * @summary Set active team avatar
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamSetActiveTeamAvatarRequest} req Set Active Avatar Request
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setActiveTeamAvatar(teamId: string, req: CordeCommonModelsDtoTeamSetActiveTeamAvatarRequest, xUserProfileID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setActiveTeamAvatar(teamId, req, xUserProfileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.setActiveTeamAvatar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Transfer ownership of a team to another user
         * @summary Transfer team ownership
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamTransferTeamOwnershipRequest} req Transfer Ownership Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transferTeamOwnership(teamId: string, req: CordeCommonModelsDtoTeamTransferTeamOwnershipRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transferTeamOwnership(teamId, req, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.transferTeamOwnership']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing team role
         * @summary Update team role
         * @param {string} teamId Team ID
         * @param {string} roleId Role ID
         * @param {CordeCommonModelsDtoTeamUpdateRoleRequest} req Update Role Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRole(teamId: string, roleId: string, req: CordeCommonModelsDtoTeamUpdateRoleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRole(teamId, roleId, req, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.updateRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing team\'s details
         * @summary Update a team
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamUpdateTeamRequest} req Team Update Request
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeam(teamId: string, req: CordeCommonModelsDtoTeamUpdateTeamRequest, xUserProfileID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoTeamTeam>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeam(teamId, req, xUserProfileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.updateTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update security settings for a team
         * @summary Update team security settings
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamUpdateTeamSecuritySettingsRequest} req Update Security Settings Request
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeamSecuritySettings(teamId: string, req: CordeCommonModelsDtoTeamUpdateTeamSecuritySettingsRequest, xUserProfileID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoTeamTeamSecuritySettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeamSecuritySettings(teamId, req, xUserProfileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.updateTeamSecuritySettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update UI settings for a team
         * @summary Update team UI settings
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamUpdateTeamUISettingsRequest} req Update UI Settings Request
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeamUISettings(teamId: string, req: CordeCommonModelsDtoTeamUpdateTeamUISettingsRequest, xUserProfileID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoTeamTeamUISettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeamUISettings(teamId, req, xUserProfileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.updateTeamUISettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update user management settings for a team
         * @summary Update team user settings
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamUpdateTeamUserSettingsRequest} req Update User Settings Request
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTeamUserSettings(teamId: string, req: CordeCommonModelsDtoTeamUpdateTeamUserSettingsRequest, xUserProfileID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoTeamTeamUserSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTeamUserSettings(teamId, req, xUserProfileID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.updateTeamUserSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a user\'s role in a team
         * @summary Update user role in team
         * @param {string} teamId Team ID
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoTeamUpdateUserRoleInTeamRequest} req Update Role Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserRoleInTeam(teamId: string, userId: string, req: CordeCommonModelsDtoTeamUpdateUserRoleInTeamRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserRoleInTeam(teamId, userId, req, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamApi.updateUserRoleInTeam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeamApi - factory interface
 * @export
 */
export const TeamApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamApiFp(configuration)
    return {
        /**
         * Accept an invitation to join a team
         * @summary Accept team invitation
         * @param {string} teamId Team ID
         * @param {string} invitationId Invitation ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTeamInvitation(teamId: string, invitationId: string, xUserProfileID?: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.acceptTeamInvitation(teamId, invitationId, xUserProfileID, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a user to a team directly
         * @summary Add user to team
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamAddUserToTeamRequest} req Add User Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUserToTeam(teamId: string, req: CordeCommonModelsDtoTeamAddUserToTeamRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.addUserToTeam(teamId, req, options).then((request) => request(axios, basePath));
        },
        /**
         * Approve a pending team role request
         * @summary Approve requested team role
         * @param {string} teamId Team ID
         * @param {string} requestId Request ID
         * @param {CordeCommonModelsDtoTeamApproveTeamRoleRequest} req Approve Role Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveRequestedTeamRole(teamId: string, requestId: string, req: CordeCommonModelsDtoTeamApproveTeamRoleRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.approveRequestedTeamRole(teamId, requestId, req, options).then((request) => request(axios, basePath));
        },
        /**
         * Approve or reject a team membership request
         * @summary Approve team membership
         * @param {string} teamId Team ID
         * @param {string} requestId Request ID
         * @param {CordeCommonModelsDtoTeamApproveTeamMembershipRequest} req Approval Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveTeamMembership(teamId: string, requestId: string, req: CordeCommonModelsDtoTeamApproveTeamMembershipRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.approveTeamMembership(teamId, requestId, req, options).then((request) => request(axios, basePath));
        },
        /**
         * Assign a permission to a team role
         * @summary Assign permission to role
         * @param {string} teamId Team ID
         * @param {string} roleId Role ID
         * @param {CordeCommonModelsDtoTeamAssignPermissionToRoleRequest} req Assign Permission Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignPermissionToRole(teamId: string, roleId: string, req: CordeCommonModelsDtoTeamAssignPermissionToRoleRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.assignPermissionToRole(teamId, roleId, req, options).then((request) => request(axios, basePath));
        },
        /**
         * Assign a role to a team member
         * @summary Assign role to user
         * @param {string} teamId Team ID
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoTeamAssignRoleToUserRequest} req Assign Role Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignRoleToUser(teamId: string, userId: string, req: CordeCommonModelsDtoTeamAssignRoleToUserRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.assignRoleToUser(teamId, userId, req, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel a pending team invitation request
         * @summary Cancel team invitation request
         * @param {string} teamId Team ID
         * @param {string} requestId Request ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTeamInvitationRequest(teamId: string, requestId: string, userprofileId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.cancelTeamInvitationRequest(teamId, requestId, userprofileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel a pending team membership request
         * @summary Cancel team membership request
         * @param {string} teamId Team ID
         * @param {string} requestId Request ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTeamMembershipRequest(teamId: string, requestId: string, userprofileId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.cancelTeamMembershipRequest(teamId, requestId, userprofileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel a pending team ownership request
         * @summary Cancel team ownership request
         * @param {string} teamId Team ID
         * @param {string} requestId Request ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTeamOwnershipRequest(teamId: string, requestId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.cancelTeamOwnershipRequest(teamId, requestId, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel a pending team role request
         * @summary Cancel team role request
         * @param {string} teamId Team ID
         * @param {string} requestId Request ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelTeamRoleRequest(teamId: string, requestId: string, userprofileId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.cancelTeamRoleRequest(teamId, requestId, userprofileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new role for a team
         * @summary Create team role
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamCreateRoleRequest} req Create Role Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole(teamId: string, req: CordeCommonModelsDtoTeamCreateRoleRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.createRole(teamId, req, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new team with the provided details
         * @summary Create a new team
         * @param {CordeCommonModelsDtoTeamCreateTeamRequest} req Team Creation Request
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeam(req: CordeCommonModelsDtoTeamCreateTeamRequest, xUserProfileID?: string, options?: any): AxiosPromise<CordeCommonModelsDtoTeamTeam> {
            return localVarFp.createTeam(req, xUserProfileID, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new avatar for a team. Similar to user profile avatar management.
         * @summary Create team avatar
         * @param {string} teamId Team ID
         * @param {File} file Avatar image file
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {string} [name] Avatar name
         * @param {string} [description] Avatar description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamAvatar(teamId: string, file: File, xUserProfileID?: string, name?: string, description?: string, options?: any): AxiosPromise<CordeCommonModelsDtoTeamTeamAvatar> {
            return localVarFp.createTeamAvatar(teamId, file, xUserProfileID, name, description, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new banner for a team
         * @summary Create team banner
         * @param {string} teamId Team ID
         * @param {File} file Banner image file
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {string} [name] Banner name
         * @param {string} [description] Banner description
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTeamBanner(teamId: string, file: File, xUserProfileID?: string, name?: string, description?: string, options?: any): AxiosPromise<CordeCommonModelsDtoTeamTeamBanner> {
            return localVarFp.createTeamBanner(teamId, file, xUserProfileID, name, description, options).then((request) => request(axios, basePath));
        },
        /**
         * Decline an invitation to join a team
         * @summary Decline team invitation
         * @param {string} teamId Team ID
         * @param {string} invitationId Invitation ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineTeamInvitation(teamId: string, invitationId: string, userprofileId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.declineTeamInvitation(teamId, invitationId, userprofileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a role from a team
         * @summary Delete team role
         * @param {string} teamId Team ID
         * @param {string} roleId Role ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRole(teamId: string, roleId: string, userprofileId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.deleteRole(teamId, roleId, userprofileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an existing team
         * @summary Delete a team
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeam(teamId: string, xUserProfileID?: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.deleteTeam(teamId, xUserProfileID, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a team avatar
         * @summary Delete team avatar
         * @param {string} teamId Team ID
         * @param {string} avatarId Avatar ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeamAvatar(teamId: string, avatarId: string, xUserProfileID?: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.deleteTeamAvatar(teamId, avatarId, xUserProfileID, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete the banner for a team
         * @summary Delete team banner
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTeamBanner(teamId: string, xUserProfileID?: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.deleteTeamBanner(teamId, xUserProfileID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the default user profile for a user in team context, with optional entity scope. Results are cached for 24 hours.
         * @summary Get default user profile for team context
         * @param {string} [entityType] Entity type (e.g., \&#39;team\&#39;, \&#39;project\&#39;)
         * @param {string} [entityId] Entity ID for scoped default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultUserProfileForTeam(entityType?: string, entityId?: string, options?: any): AxiosPromise<CordeCommonModelsDtoUserprofileUserProfileResponse> {
            return localVarFp.getDefaultUserProfileForTeam(entityType, entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a team by its ID
         * @summary Get a team
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeam(teamId: string, xUserProfileID?: string, options?: any): AxiosPromise<CordeCommonModelsDtoTeamTeam> {
            return localVarFp.getTeam(teamId, xUserProfileID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get audit logs for a team
         * @summary Get team audit logs
         * @param {string} teamId Team ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamAuditLogs(teamId: string, options?: any): AxiosPromise<CordeCommonModelsDtoTeamGetTeamAuditLogsResponse> {
            return localVarFp.getTeamAuditLogs(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of all available actions/permissions that can be assigned to team roles with i18n translations
         * @summary Get available team actions
         * @param {string} teamId Team ID
         * @param {string} [language] Language code (default: en)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamAvailableActions(teamId: string, language?: string, options?: any): AxiosPromise<CordeCommonModelsDtoTeamGetTeamAvailableActionsResponse> {
            return localVarFp.getTeamAvailableActions(teamId, language, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a specific team avatar
         * @summary Get team avatar
         * @param {string} teamId Team ID
         * @param {string} avatarId Avatar ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamAvatar(teamId: string, avatarId: string, xUserProfileID?: string, options?: any): AxiosPromise<CordeCommonModelsDtoTeamTeamAvatar> {
            return localVarFp.getTeamAvatar(teamId, avatarId, xUserProfileID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the banner for a team
         * @summary Get team banner
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamBanner(teamId: string, xUserProfileID?: string, options?: any): AxiosPromise<CordeCommonModelsDtoTeamTeamBanner> {
            return localVarFp.getTeamBanner(teamId, xUserProfileID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get activity logs for a team
         * @summary Get team logs
         * @param {string} teamId Team ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamLogs(teamId: string, options?: any): AxiosPromise<CordeCommonModelsDtoTeamGetTeamLogsResponse> {
            return localVarFp.getTeamLogs(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get details of a specific membership request
         * @summary Get team membership request
         * @param {string} teamId Team ID
         * @param {string} requestId Request ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamMembershipRequest(teamId: string, requestId: string, userprofileId: string, options?: any): AxiosPromise<CordeCommonModelsDtoTeamGetTeamMembershipRequestRequest> {
            return localVarFp.getTeamMembershipRequest(teamId, requestId, userprofileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get details of a specific ownership request
         * @summary Get team ownership request
         * @param {string} teamId Team ID
         * @param {string} requestId Request ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamOwnershipRequest(teamId: string, requestId: string, options?: any): AxiosPromise<CordeCommonModelsDtoTeamTeamOwnershipRequest> {
            return localVarFp.getTeamOwnershipRequest(teamId, requestId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get details of a specific role request
         * @summary Get team role request
         * @param {string} teamId Team ID
         * @param {string} requestId Request ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamRoleRequest(teamId: string, requestId: string, userprofileId: string, options?: any): AxiosPromise<CordeCommonModelsDtoTeamTeamRoleRequest> {
            return localVarFp.getTeamRoleRequest(teamId, requestId, userprofileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get security settings for a team
         * @summary Get team security settings
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamSecuritySettings(teamId: string, xUserProfileID?: string, options?: any): AxiosPromise<CordeCommonModelsDtoTeamTeamSecuritySettings> {
            return localVarFp.getTeamSecuritySettings(teamId, xUserProfileID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get UI settings for a team
         * @summary Get team UI settings
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamUISettings(teamId: string, xUserProfileID?: string, options?: any): AxiosPromise<CordeCommonModelsDtoTeamTeamUISettings> {
            return localVarFp.getTeamUISettings(teamId, xUserProfileID, options).then((request) => request(axios, basePath));
        },
        /**
         * Get user management settings for a team
         * @summary Get team user settings
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTeamUserSettings(teamId: string, xUserProfileID?: string, options?: any): AxiosPromise<CordeCommonModelsDtoTeamTeamUserSettings> {
            return localVarFp.getTeamUserSettings(teamId, xUserProfileID, options).then((request) => request(axios, basePath));
        },
        /**
         * Grant ownership of a team to a user
         * @summary Grant team ownership
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamGrantTeamOwnershipRequest} req Grant Ownership Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantTeamOwnership(teamId: string, req: CordeCommonModelsDtoTeamGrantTeamOwnershipRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.grantTeamOwnership(teamId, req, options).then((request) => request(axios, basePath));
        },
        /**
         * Grant a role to a team member
         * @summary Grant team role
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamGrantTeamRoleRequest} req Grant Role Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantTeamRole(teamId: string, req: CordeCommonModelsDtoTeamGrantTeamRoleRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.grantTeamRole(teamId, req, options).then((request) => request(axios, basePath));
        },
        /**
         * Invite a user to join a team
         * @summary Invite user to team
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamInviteUserToTeamRequest} req Invitation Request
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteUserToTeam(teamId: string, req: CordeCommonModelsDtoTeamInviteUserToTeamRequest, xUserProfileID?: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.inviteUserToTeam(teamId, req, xUserProfileID, options).then((request) => request(axios, basePath));
        },
        /**
         * List all available permissions for a team
         * @summary List team permissions
         * @param {string} teamId Team ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPermissions(teamId: string, userprofileId: string, options?: any): AxiosPromise<CordeCommonModelsDtoTeamListPermissionsResponse> {
            return localVarFp.listPermissions(teamId, userprofileId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all roles in a team
         * @summary List team roles
         * @param {string} teamId Team ID
         * @param {string} memberId Member profile ID
         * @param {string} userprofileId Userprofile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRoles(teamId: string, memberId: string, userprofileId: string, options?: any): AxiosPromise<CordeCommonModelsDtoTeamListRolesResponse> {
            return localVarFp.listRoles(teamId, memberId, userprofileId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all avatars for a team
         * @summary List team avatars
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTeamAvatars(teamId: string, xUserProfileID?: string, limit?: number, offset?: number, options?: any): AxiosPromise<CordeCommonModelsDtoTeamListTeamAvatarsResponse> {
            return localVarFp.listTeamAvatars(teamId, xUserProfileID, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * List all invitations for a team
         * @summary List team invitations
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTeamInvitations(teamId: string, xUserProfileID?: string, options?: any): AxiosPromise<CordeCommonModelsDtoTeamListTeamInvitationsResponse> {
            return localVarFp.listTeamInvitations(teamId, xUserProfileID, options).then((request) => request(axios, basePath));
        },
        /**
         * List all pending membership requests for a team
         * @summary List team membership requests
         * @param {string} teamId Team ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTeamMembershipRequests(teamId: string, userprofileId: string, options?: any): AxiosPromise<CordeCommonModelsDtoTeamListTeamMembershipRequestsResponse> {
            return localVarFp.listTeamMembershipRequests(teamId, userprofileId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all pending ownership requests for a team
         * @summary List team ownership requests
         * @param {string} teamId Team ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTeamOwnershipRequests(teamId: string, options?: any): AxiosPromise<CordeCommonModelsDtoTeamListTeamOwnershipRequestsResponse> {
            return localVarFp.listTeamOwnershipRequests(teamId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all role requests for a team
         * @summary List team role requests
         * @param {string} teamId Team ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTeamRoleRequests(teamId: string, userprofileId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.listTeamRoleRequests(teamId, userprofileId, options).then((request) => request(axios, basePath));
        },
        /**
         * List teams for a user with filtering and pagination
         * @summary List teams
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {string} [teamType] Filter by team type
         * @param {string} [status] Filter by team status
         * @param {string} [listType] Filter by relationship (all, member_of, managed)
         * @param {string} [sortBy] Sort field (name, last_visited, created_at)
         * @param {string} [sortOrder] Sort order (asc, desc)
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTeams(xUserProfileID?: string, teamType?: string, status?: string, listType?: string, sortBy?: string, sortOrder?: string, limit?: number, offset?: number, options?: any): AxiosPromise<CordeCommonModelsDtoTeamListTeamsResponse> {
            return localVarFp.listTeams(xUserProfileID, teamType, status, listType, sortBy, sortOrder, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * List all users with a specific role in a team
         * @summary List users by role
         * @param {string} teamId Team ID
         * @param {string} roleId Role ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsersByRole(teamId: string, roleId: string, userprofileId: string, options?: any): AxiosPromise<CordeCommonModelsDtoTeamListUsersByRoleResponse> {
            return localVarFp.listUsersByRole(teamId, roleId, userprofileId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all users in a team
         * @summary List users in team
         * @param {string} teamId Team ID
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsersInTeam(teamId: string, xUserProfileID?: string, options?: any): AxiosPromise<CordeCommonModelsDtoTeamListUsersInTeamResponse> {
            return localVarFp.listUsersInTeam(teamId, xUserProfileID, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a permission from a team role
         * @summary Remove permission from role
         * @param {string} teamId Team ID
         * @param {string} roleId Role ID
         * @param {string} permission Permission
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removePermissionFromRole(teamId: string, roleId: string, permission: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.removePermissionFromRole(teamId, roleId, permission, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a role from a team member
         * @summary Remove role from user
         * @param {string} teamId Team ID
         * @param {string} userId User ID
         * @param {string} roleId Role ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRoleFromUser(teamId: string, userId: string, roleId: string, userprofileId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.removeRoleFromUser(teamId, userId, roleId, userprofileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a user from a team
         * @summary Remove user from team
         * @param {string} teamId Team ID
         * @param {string} userprofileId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserFromTeam(teamId: string, userprofileId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.removeUserFromTeam(teamId, userprofileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Request to join a team
         * @summary Request team membership
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamRequestTeamMembershipRequest} req Membership Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestTeamMembership(teamId: string, req: CordeCommonModelsDtoTeamRequestTeamMembershipRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.requestTeamMembership(teamId, req, options).then((request) => request(axios, basePath));
        },
        /**
         * Request ownership of a team
         * @summary Request team ownership
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamRequestTeamOwnershipRequest} req Request Ownership Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestTeamOwnership(teamId: string, req: CordeCommonModelsDtoTeamRequestTeamOwnershipRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.requestTeamOwnership(teamId, req, options).then((request) => request(axios, basePath));
        },
        /**
         * Request a role in a team
         * @summary Request team role
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamRequestTeamRoleRequest} req Role Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestTeamRole(teamId: string, req: CordeCommonModelsDtoTeamRequestTeamRoleRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.requestTeamRole(teamId, req, options).then((request) => request(axios, basePath));
        },
        /**
         * Revoke ownership of a team from a user
         * @summary Revoke team ownership
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamRevokeTeamOwnershipRequest} req Revoke Ownership Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeTeamOwnership(teamId: string, req: CordeCommonModelsDtoTeamRevokeTeamOwnershipRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.revokeTeamOwnership(teamId, req, options).then((request) => request(axios, basePath));
        },
        /**
         * Revoke a role from a team member
         * @summary Revoke team role
         * @param {string} teamId Team ID
         * @param {string} userId User ID
         * @param {string} userprofileId User Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeTeamRole(teamId: string, userId: string, userprofileId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.revokeTeamRole(teamId, userId, userprofileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Advanced search for teams with complex criteria
         * @summary Search teams
         * @param {CordeCommonModelsDtoTeamSearchTeamsRequest} req Search Request
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchTeams(req: CordeCommonModelsDtoTeamSearchTeamsRequest, xUserProfileID?: string, options?: any): AxiosPromise<CordeCommonModelsDtoTeamListTeamsResponse> {
            return localVarFp.searchTeams(req, xUserProfileID, options).then((request) => request(axios, basePath));
        },
        /**
         * Set the active avatar for a team
         * @summary Set active team avatar
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamSetActiveTeamAvatarRequest} req Set Active Avatar Request
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setActiveTeamAvatar(teamId: string, req: CordeCommonModelsDtoTeamSetActiveTeamAvatarRequest, xUserProfileID?: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.setActiveTeamAvatar(teamId, req, xUserProfileID, options).then((request) => request(axios, basePath));
        },
        /**
         * Transfer ownership of a team to another user
         * @summary Transfer team ownership
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamTransferTeamOwnershipRequest} req Transfer Ownership Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferTeamOwnership(teamId: string, req: CordeCommonModelsDtoTeamTransferTeamOwnershipRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.transferTeamOwnership(teamId, req, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing team role
         * @summary Update team role
         * @param {string} teamId Team ID
         * @param {string} roleId Role ID
         * @param {CordeCommonModelsDtoTeamUpdateRoleRequest} req Update Role Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRole(teamId: string, roleId: string, req: CordeCommonModelsDtoTeamUpdateRoleRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.updateRole(teamId, roleId, req, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing team\'s details
         * @summary Update a team
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamUpdateTeamRequest} req Team Update Request
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeam(teamId: string, req: CordeCommonModelsDtoTeamUpdateTeamRequest, xUserProfileID?: string, options?: any): AxiosPromise<CordeCommonModelsDtoTeamTeam> {
            return localVarFp.updateTeam(teamId, req, xUserProfileID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update security settings for a team
         * @summary Update team security settings
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamUpdateTeamSecuritySettingsRequest} req Update Security Settings Request
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamSecuritySettings(teamId: string, req: CordeCommonModelsDtoTeamUpdateTeamSecuritySettingsRequest, xUserProfileID?: string, options?: any): AxiosPromise<CordeCommonModelsDtoTeamTeamSecuritySettings> {
            return localVarFp.updateTeamSecuritySettings(teamId, req, xUserProfileID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update UI settings for a team
         * @summary Update team UI settings
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamUpdateTeamUISettingsRequest} req Update UI Settings Request
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamUISettings(teamId: string, req: CordeCommonModelsDtoTeamUpdateTeamUISettingsRequest, xUserProfileID?: string, options?: any): AxiosPromise<CordeCommonModelsDtoTeamTeamUISettings> {
            return localVarFp.updateTeamUISettings(teamId, req, xUserProfileID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update user management settings for a team
         * @summary Update team user settings
         * @param {string} teamId Team ID
         * @param {CordeCommonModelsDtoTeamUpdateTeamUserSettingsRequest} req Update User Settings Request
         * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTeamUserSettings(teamId: string, req: CordeCommonModelsDtoTeamUpdateTeamUserSettingsRequest, xUserProfileID?: string, options?: any): AxiosPromise<CordeCommonModelsDtoTeamTeamUserSettings> {
            return localVarFp.updateTeamUserSettings(teamId, req, xUserProfileID, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a user\'s role in a team
         * @summary Update user role in team
         * @param {string} teamId Team ID
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoTeamUpdateUserRoleInTeamRequest} req Update Role Request with userprofile_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserRoleInTeam(teamId: string, userId: string, req: CordeCommonModelsDtoTeamUpdateUserRoleInTeamRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.updateUserRoleInTeam(teamId, userId, req, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TeamApi - object-oriented interface
 * @export
 * @class TeamApi
 * @extends {BaseAPI}
 */
export class TeamApi extends BaseAPI {
    /**
     * Accept an invitation to join a team
     * @summary Accept team invitation
     * @param {string} teamId Team ID
     * @param {string} invitationId Invitation ID
     * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public acceptTeamInvitation(teamId: string, invitationId: string, xUserProfileID?: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).acceptTeamInvitation(teamId, invitationId, xUserProfileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a user to a team directly
     * @summary Add user to team
     * @param {string} teamId Team ID
     * @param {CordeCommonModelsDtoTeamAddUserToTeamRequest} req Add User Request with userprofile_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public addUserToTeam(teamId: string, req: CordeCommonModelsDtoTeamAddUserToTeamRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).addUserToTeam(teamId, req, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Approve a pending team role request
     * @summary Approve requested team role
     * @param {string} teamId Team ID
     * @param {string} requestId Request ID
     * @param {CordeCommonModelsDtoTeamApproveTeamRoleRequest} req Approve Role Request with userprofile_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public approveRequestedTeamRole(teamId: string, requestId: string, req: CordeCommonModelsDtoTeamApproveTeamRoleRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).approveRequestedTeamRole(teamId, requestId, req, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Approve or reject a team membership request
     * @summary Approve team membership
     * @param {string} teamId Team ID
     * @param {string} requestId Request ID
     * @param {CordeCommonModelsDtoTeamApproveTeamMembershipRequest} req Approval Request with userprofile_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public approveTeamMembership(teamId: string, requestId: string, req: CordeCommonModelsDtoTeamApproveTeamMembershipRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).approveTeamMembership(teamId, requestId, req, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Assign a permission to a team role
     * @summary Assign permission to role
     * @param {string} teamId Team ID
     * @param {string} roleId Role ID
     * @param {CordeCommonModelsDtoTeamAssignPermissionToRoleRequest} req Assign Permission Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public assignPermissionToRole(teamId: string, roleId: string, req: CordeCommonModelsDtoTeamAssignPermissionToRoleRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).assignPermissionToRole(teamId, roleId, req, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Assign a role to a team member
     * @summary Assign role to user
     * @param {string} teamId Team ID
     * @param {string} userId User ID
     * @param {CordeCommonModelsDtoTeamAssignRoleToUserRequest} req Assign Role Request with userprofile_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public assignRoleToUser(teamId: string, userId: string, req: CordeCommonModelsDtoTeamAssignRoleToUserRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).assignRoleToUser(teamId, userId, req, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel a pending team invitation request
     * @summary Cancel team invitation request
     * @param {string} teamId Team ID
     * @param {string} requestId Request ID
     * @param {string} userprofileId User Profile ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public cancelTeamInvitationRequest(teamId: string, requestId: string, userprofileId: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).cancelTeamInvitationRequest(teamId, requestId, userprofileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel a pending team membership request
     * @summary Cancel team membership request
     * @param {string} teamId Team ID
     * @param {string} requestId Request ID
     * @param {string} userprofileId User Profile ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public cancelTeamMembershipRequest(teamId: string, requestId: string, userprofileId: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).cancelTeamMembershipRequest(teamId, requestId, userprofileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel a pending team ownership request
     * @summary Cancel team ownership request
     * @param {string} teamId Team ID
     * @param {string} requestId Request ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public cancelTeamOwnershipRequest(teamId: string, requestId: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).cancelTeamOwnershipRequest(teamId, requestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel a pending team role request
     * @summary Cancel team role request
     * @param {string} teamId Team ID
     * @param {string} requestId Request ID
     * @param {string} userprofileId User Profile ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public cancelTeamRoleRequest(teamId: string, requestId: string, userprofileId: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).cancelTeamRoleRequest(teamId, requestId, userprofileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new role for a team
     * @summary Create team role
     * @param {string} teamId Team ID
     * @param {CordeCommonModelsDtoTeamCreateRoleRequest} req Create Role Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public createRole(teamId: string, req: CordeCommonModelsDtoTeamCreateRoleRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).createRole(teamId, req, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new team with the provided details
     * @summary Create a new team
     * @param {CordeCommonModelsDtoTeamCreateTeamRequest} req Team Creation Request
     * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public createTeam(req: CordeCommonModelsDtoTeamCreateTeamRequest, xUserProfileID?: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).createTeam(req, xUserProfileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new avatar for a team. Similar to user profile avatar management.
     * @summary Create team avatar
     * @param {string} teamId Team ID
     * @param {File} file Avatar image file
     * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
     * @param {string} [name] Avatar name
     * @param {string} [description] Avatar description
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public createTeamAvatar(teamId: string, file: File, xUserProfileID?: string, name?: string, description?: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).createTeamAvatar(teamId, file, xUserProfileID, name, description, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new banner for a team
     * @summary Create team banner
     * @param {string} teamId Team ID
     * @param {File} file Banner image file
     * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
     * @param {string} [name] Banner name
     * @param {string} [description] Banner description
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public createTeamBanner(teamId: string, file: File, xUserProfileID?: string, name?: string, description?: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).createTeamBanner(teamId, file, xUserProfileID, name, description, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Decline an invitation to join a team
     * @summary Decline team invitation
     * @param {string} teamId Team ID
     * @param {string} invitationId Invitation ID
     * @param {string} userprofileId User Profile ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public declineTeamInvitation(teamId: string, invitationId: string, userprofileId: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).declineTeamInvitation(teamId, invitationId, userprofileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a role from a team
     * @summary Delete team role
     * @param {string} teamId Team ID
     * @param {string} roleId Role ID
     * @param {string} userprofileId User Profile ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public deleteRole(teamId: string, roleId: string, userprofileId: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).deleteRole(teamId, roleId, userprofileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an existing team
     * @summary Delete a team
     * @param {string} teamId Team ID
     * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public deleteTeam(teamId: string, xUserProfileID?: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).deleteTeam(teamId, xUserProfileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a team avatar
     * @summary Delete team avatar
     * @param {string} teamId Team ID
     * @param {string} avatarId Avatar ID
     * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public deleteTeamAvatar(teamId: string, avatarId: string, xUserProfileID?: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).deleteTeamAvatar(teamId, avatarId, xUserProfileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete the banner for a team
     * @summary Delete team banner
     * @param {string} teamId Team ID
     * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public deleteTeamBanner(teamId: string, xUserProfileID?: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).deleteTeamBanner(teamId, xUserProfileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the default user profile for a user in team context, with optional entity scope. Results are cached for 24 hours.
     * @summary Get default user profile for team context
     * @param {string} [entityType] Entity type (e.g., \&#39;team\&#39;, \&#39;project\&#39;)
     * @param {string} [entityId] Entity ID for scoped default
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getDefaultUserProfileForTeam(entityType?: string, entityId?: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getDefaultUserProfileForTeam(entityType, entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a team by its ID
     * @summary Get a team
     * @param {string} teamId Team ID
     * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getTeam(teamId: string, xUserProfileID?: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getTeam(teamId, xUserProfileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get audit logs for a team
     * @summary Get team audit logs
     * @param {string} teamId Team ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getTeamAuditLogs(teamId: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getTeamAuditLogs(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of all available actions/permissions that can be assigned to team roles with i18n translations
     * @summary Get available team actions
     * @param {string} teamId Team ID
     * @param {string} [language] Language code (default: en)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getTeamAvailableActions(teamId: string, language?: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getTeamAvailableActions(teamId, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a specific team avatar
     * @summary Get team avatar
     * @param {string} teamId Team ID
     * @param {string} avatarId Avatar ID
     * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getTeamAvatar(teamId: string, avatarId: string, xUserProfileID?: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getTeamAvatar(teamId, avatarId, xUserProfileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the banner for a team
     * @summary Get team banner
     * @param {string} teamId Team ID
     * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getTeamBanner(teamId: string, xUserProfileID?: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getTeamBanner(teamId, xUserProfileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get activity logs for a team
     * @summary Get team logs
     * @param {string} teamId Team ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getTeamLogs(teamId: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getTeamLogs(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get details of a specific membership request
     * @summary Get team membership request
     * @param {string} teamId Team ID
     * @param {string} requestId Request ID
     * @param {string} userprofileId User Profile ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getTeamMembershipRequest(teamId: string, requestId: string, userprofileId: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getTeamMembershipRequest(teamId, requestId, userprofileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get details of a specific ownership request
     * @summary Get team ownership request
     * @param {string} teamId Team ID
     * @param {string} requestId Request ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getTeamOwnershipRequest(teamId: string, requestId: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getTeamOwnershipRequest(teamId, requestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get details of a specific role request
     * @summary Get team role request
     * @param {string} teamId Team ID
     * @param {string} requestId Request ID
     * @param {string} userprofileId User Profile ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getTeamRoleRequest(teamId: string, requestId: string, userprofileId: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getTeamRoleRequest(teamId, requestId, userprofileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get security settings for a team
     * @summary Get team security settings
     * @param {string} teamId Team ID
     * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getTeamSecuritySettings(teamId: string, xUserProfileID?: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getTeamSecuritySettings(teamId, xUserProfileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get UI settings for a team
     * @summary Get team UI settings
     * @param {string} teamId Team ID
     * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getTeamUISettings(teamId: string, xUserProfileID?: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getTeamUISettings(teamId, xUserProfileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get user management settings for a team
     * @summary Get team user settings
     * @param {string} teamId Team ID
     * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public getTeamUserSettings(teamId: string, xUserProfileID?: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).getTeamUserSettings(teamId, xUserProfileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Grant ownership of a team to a user
     * @summary Grant team ownership
     * @param {string} teamId Team ID
     * @param {CordeCommonModelsDtoTeamGrantTeamOwnershipRequest} req Grant Ownership Request with userprofile_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public grantTeamOwnership(teamId: string, req: CordeCommonModelsDtoTeamGrantTeamOwnershipRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).grantTeamOwnership(teamId, req, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Grant a role to a team member
     * @summary Grant team role
     * @param {string} teamId Team ID
     * @param {CordeCommonModelsDtoTeamGrantTeamRoleRequest} req Grant Role Request with userprofile_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public grantTeamRole(teamId: string, req: CordeCommonModelsDtoTeamGrantTeamRoleRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).grantTeamRole(teamId, req, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Invite a user to join a team
     * @summary Invite user to team
     * @param {string} teamId Team ID
     * @param {CordeCommonModelsDtoTeamInviteUserToTeamRequest} req Invitation Request
     * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public inviteUserToTeam(teamId: string, req: CordeCommonModelsDtoTeamInviteUserToTeamRequest, xUserProfileID?: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).inviteUserToTeam(teamId, req, xUserProfileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all available permissions for a team
     * @summary List team permissions
     * @param {string} teamId Team ID
     * @param {string} userprofileId User Profile ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public listPermissions(teamId: string, userprofileId: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).listPermissions(teamId, userprofileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all roles in a team
     * @summary List team roles
     * @param {string} teamId Team ID
     * @param {string} memberId Member profile ID
     * @param {string} userprofileId Userprofile ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public listRoles(teamId: string, memberId: string, userprofileId: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).listRoles(teamId, memberId, userprofileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all avatars for a team
     * @summary List team avatars
     * @param {string} teamId Team ID
     * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
     * @param {number} [limit] Number of items to return
     * @param {number} [offset] Number of items to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public listTeamAvatars(teamId: string, xUserProfileID?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).listTeamAvatars(teamId, xUserProfileID, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all invitations for a team
     * @summary List team invitations
     * @param {string} teamId Team ID
     * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public listTeamInvitations(teamId: string, xUserProfileID?: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).listTeamInvitations(teamId, xUserProfileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all pending membership requests for a team
     * @summary List team membership requests
     * @param {string} teamId Team ID
     * @param {string} userprofileId User Profile ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public listTeamMembershipRequests(teamId: string, userprofileId: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).listTeamMembershipRequests(teamId, userprofileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all pending ownership requests for a team
     * @summary List team ownership requests
     * @param {string} teamId Team ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public listTeamOwnershipRequests(teamId: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).listTeamOwnershipRequests(teamId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all role requests for a team
     * @summary List team role requests
     * @param {string} teamId Team ID
     * @param {string} userprofileId User Profile ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public listTeamRoleRequests(teamId: string, userprofileId: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).listTeamRoleRequests(teamId, userprofileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List teams for a user with filtering and pagination
     * @summary List teams
     * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
     * @param {string} [teamType] Filter by team type
     * @param {string} [status] Filter by team status
     * @param {string} [listType] Filter by relationship (all, member_of, managed)
     * @param {string} [sortBy] Sort field (name, last_visited, created_at)
     * @param {string} [sortOrder] Sort order (asc, desc)
     * @param {number} [limit] Number of items to return
     * @param {number} [offset] Number of items to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public listTeams(xUserProfileID?: string, teamType?: string, status?: string, listType?: string, sortBy?: string, sortOrder?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).listTeams(xUserProfileID, teamType, status, listType, sortBy, sortOrder, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all users with a specific role in a team
     * @summary List users by role
     * @param {string} teamId Team ID
     * @param {string} roleId Role ID
     * @param {string} userprofileId User Profile ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public listUsersByRole(teamId: string, roleId: string, userprofileId: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).listUsersByRole(teamId, roleId, userprofileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all users in a team
     * @summary List users in team
     * @param {string} teamId Team ID
     * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public listUsersInTeam(teamId: string, xUserProfileID?: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).listUsersInTeam(teamId, xUserProfileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a permission from a team role
     * @summary Remove permission from role
     * @param {string} teamId Team ID
     * @param {string} roleId Role ID
     * @param {string} permission Permission
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public removePermissionFromRole(teamId: string, roleId: string, permission: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).removePermissionFromRole(teamId, roleId, permission, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a role from a team member
     * @summary Remove role from user
     * @param {string} teamId Team ID
     * @param {string} userId User ID
     * @param {string} roleId Role ID
     * @param {string} userprofileId User Profile ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public removeRoleFromUser(teamId: string, userId: string, roleId: string, userprofileId: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).removeRoleFromUser(teamId, userId, roleId, userprofileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a user from a team
     * @summary Remove user from team
     * @param {string} teamId Team ID
     * @param {string} userprofileId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public removeUserFromTeam(teamId: string, userprofileId: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).removeUserFromTeam(teamId, userprofileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Request to join a team
     * @summary Request team membership
     * @param {string} teamId Team ID
     * @param {CordeCommonModelsDtoTeamRequestTeamMembershipRequest} req Membership Request with userprofile_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public requestTeamMembership(teamId: string, req: CordeCommonModelsDtoTeamRequestTeamMembershipRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).requestTeamMembership(teamId, req, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Request ownership of a team
     * @summary Request team ownership
     * @param {string} teamId Team ID
     * @param {CordeCommonModelsDtoTeamRequestTeamOwnershipRequest} req Request Ownership Request with userprofile_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public requestTeamOwnership(teamId: string, req: CordeCommonModelsDtoTeamRequestTeamOwnershipRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).requestTeamOwnership(teamId, req, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Request a role in a team
     * @summary Request team role
     * @param {string} teamId Team ID
     * @param {CordeCommonModelsDtoTeamRequestTeamRoleRequest} req Role Request with userprofile_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public requestTeamRole(teamId: string, req: CordeCommonModelsDtoTeamRequestTeamRoleRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).requestTeamRole(teamId, req, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revoke ownership of a team from a user
     * @summary Revoke team ownership
     * @param {string} teamId Team ID
     * @param {CordeCommonModelsDtoTeamRevokeTeamOwnershipRequest} req Revoke Ownership Request with userprofile_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public revokeTeamOwnership(teamId: string, req: CordeCommonModelsDtoTeamRevokeTeamOwnershipRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).revokeTeamOwnership(teamId, req, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revoke a role from a team member
     * @summary Revoke team role
     * @param {string} teamId Team ID
     * @param {string} userId User ID
     * @param {string} userprofileId User Profile ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public revokeTeamRole(teamId: string, userId: string, userprofileId: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).revokeTeamRole(teamId, userId, userprofileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Advanced search for teams with complex criteria
     * @summary Search teams
     * @param {CordeCommonModelsDtoTeamSearchTeamsRequest} req Search Request
     * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public searchTeams(req: CordeCommonModelsDtoTeamSearchTeamsRequest, xUserProfileID?: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).searchTeams(req, xUserProfileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set the active avatar for a team
     * @summary Set active team avatar
     * @param {string} teamId Team ID
     * @param {CordeCommonModelsDtoTeamSetActiveTeamAvatarRequest} req Set Active Avatar Request
     * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public setActiveTeamAvatar(teamId: string, req: CordeCommonModelsDtoTeamSetActiveTeamAvatarRequest, xUserProfileID?: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).setActiveTeamAvatar(teamId, req, xUserProfileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Transfer ownership of a team to another user
     * @summary Transfer team ownership
     * @param {string} teamId Team ID
     * @param {CordeCommonModelsDtoTeamTransferTeamOwnershipRequest} req Transfer Ownership Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public transferTeamOwnership(teamId: string, req: CordeCommonModelsDtoTeamTransferTeamOwnershipRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).transferTeamOwnership(teamId, req, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing team role
     * @summary Update team role
     * @param {string} teamId Team ID
     * @param {string} roleId Role ID
     * @param {CordeCommonModelsDtoTeamUpdateRoleRequest} req Update Role Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public updateRole(teamId: string, roleId: string, req: CordeCommonModelsDtoTeamUpdateRoleRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).updateRole(teamId, roleId, req, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing team\'s details
     * @summary Update a team
     * @param {string} teamId Team ID
     * @param {CordeCommonModelsDtoTeamUpdateTeamRequest} req Team Update Request
     * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public updateTeam(teamId: string, req: CordeCommonModelsDtoTeamUpdateTeamRequest, xUserProfileID?: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).updateTeam(teamId, req, xUserProfileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update security settings for a team
     * @summary Update team security settings
     * @param {string} teamId Team ID
     * @param {CordeCommonModelsDtoTeamUpdateTeamSecuritySettingsRequest} req Update Security Settings Request
     * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public updateTeamSecuritySettings(teamId: string, req: CordeCommonModelsDtoTeamUpdateTeamSecuritySettingsRequest, xUserProfileID?: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).updateTeamSecuritySettings(teamId, req, xUserProfileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update UI settings for a team
     * @summary Update team UI settings
     * @param {string} teamId Team ID
     * @param {CordeCommonModelsDtoTeamUpdateTeamUISettingsRequest} req Update UI Settings Request
     * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public updateTeamUISettings(teamId: string, req: CordeCommonModelsDtoTeamUpdateTeamUISettingsRequest, xUserProfileID?: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).updateTeamUISettings(teamId, req, xUserProfileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update user management settings for a team
     * @summary Update team user settings
     * @param {string} teamId Team ID
     * @param {CordeCommonModelsDtoTeamUpdateTeamUserSettingsRequest} req Update User Settings Request
     * @param {string} [xUserProfileID] User Profile ID (optional, uses default if not provided)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public updateTeamUserSettings(teamId: string, req: CordeCommonModelsDtoTeamUpdateTeamUserSettingsRequest, xUserProfileID?: string, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).updateTeamUserSettings(teamId, req, xUserProfileID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a user\'s role in a team
     * @summary Update user role in team
     * @param {string} teamId Team ID
     * @param {string} userId User ID
     * @param {CordeCommonModelsDtoTeamUpdateUserRoleInTeamRequest} req Update Role Request with userprofile_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TeamApi
     */
    public updateUserRoleInTeam(teamId: string, userId: string, req: CordeCommonModelsDtoTeamUpdateUserRoleInTeamRequest, options?: RawAxiosRequestConfig) {
        return TeamApiFp(this.configuration).updateUserRoleInTeam(teamId, userId, req, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deletes a user by their ID.
         * @summary Delete User
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUser', 'userId', userId)
            const localVarPath = `/user/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Disables two-factor authentication for the specified user.
         * @summary Disable Two-Factor Authentication
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoUserDisableTwoFactorAuthRequest} disableTwoFactorRequest Disable Two-Factor Auth Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableTwoFactorAuth: async (userId: string, disableTwoFactorRequest: CordeCommonModelsDtoUserDisableTwoFactorAuthRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('disableTwoFactorAuth', 'userId', userId)
            // verify required parameter 'disableTwoFactorRequest' is not null or undefined
            assertParamExists('disableTwoFactorAuth', 'disableTwoFactorRequest', disableTwoFactorRequest)
            const localVarPath = `/user/{user_id}/disable-two-factor-auth`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(disableTwoFactorRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enables two-factor authentication for the specified user.
         * @summary Enable Two-Factor Authentication
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoUserEnableTwoFactorAuthRequest} enableTwoFactorRequest Enable Two-Factor Auth Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableTwoFactorAuth: async (userId: string, enableTwoFactorRequest: CordeCommonModelsDtoUserEnableTwoFactorAuthRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('enableTwoFactorAuth', 'userId', userId)
            // verify required parameter 'enableTwoFactorRequest' is not null or undefined
            assertParamExists('enableTwoFactorAuth', 'enableTwoFactorRequest', enableTwoFactorRequest)
            const localVarPath = `/user/{user_id}/enable-two-factor-auth`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(enableTwoFactorRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates a unique referral link for the user to invite others.
         * @summary Generate Referral Link
         * @param {CordeCommonModelsDtoUserGenerateReferralLinkRequest} generateReferralRequest Generate Referral Link Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateReferralLink: async (generateReferralRequest: CordeCommonModelsDtoUserGenerateReferralLinkRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'generateReferralRequest' is not null or undefined
            assertParamExists('generateReferralLink', 'generateReferralRequest', generateReferralRequest)
            const localVarPath = `/user/generate-referral-link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generateReferralRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a list of users who were invited through invitations and referral links.
         * @summary Get Invited and Referral Users
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitedAndReferralUsers: async (limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/invited-and-referral`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve user information by ID
         * @summary Get user by ID
         * @param {string} userId User ID
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: async (userId: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUser', 'userId', userId)
            const localVarPath = `/user/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a paginated list of users
         * @summary Get users list
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: async (limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Invalidates all authentication tokens for a user.
         * @summary Invalidate All Tokens
         * @param {CordeCommonModelsDtoUserInvalidateTokensRequest} invalidateAllRequest Invalidate All Tokens Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invalidateAllTokens: async (invalidateAllRequest: CordeCommonModelsDtoUserInvalidateTokensRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invalidateAllRequest' is not null or undefined
            assertParamExists('invalidateAllTokens', 'invalidateAllRequest', invalidateAllRequest)
            const localVarPath = `/auth/invalidate-all-tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(invalidateAllRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Invalidates the current authentication tokens for a user.
         * @summary Invalidate Current Tokens
         * @param {CordeCommonModelsDtoUserInvalidateTokensRequest} invalidateCurrentRequest Invalidate Current Tokens Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invalidateCurrentTokens: async (invalidateCurrentRequest: CordeCommonModelsDtoUserInvalidateTokensRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invalidateCurrentRequest' is not null or undefined
            assertParamExists('invalidateCurrentTokens', 'invalidateCurrentRequest', invalidateCurrentRequest)
            const localVarPath = `/auth/invalidate-current-tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(invalidateCurrentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends an invitation to a new user via email.
         * @summary Invite User
         * @param {CordeCommonModelsDtoUserInviteUserRequest} inviteUserRequest Invite User Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteUser: async (inviteUserRequest: CordeCommonModelsDtoUserInviteUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inviteUserRequest' is not null or undefined
            assertParamExists('inviteUser', 'inviteUserRequest', inviteUserRequest)
            const localVarPath = `/user/invite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inviteUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get paginated login records for a specific user
         * @summary List login records for a user
         * @param {string} userId User ID
         * @param {string} [startDate] Start date for filtering (RFC3339 format)
         * @param {string} [endDate] End date for filtering (RFC3339 format)
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoginRecords: async (userId: string, startDate?: string, endDate?: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('listLoginRecords', 'userId', userId)
            const localVarPath = `/user/{user_id}/login-records`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['start_date'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['end_date'] = endDate;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Refreshes authentication tokens using a refresh token.
         * @summary Refresh Tokens
         * @param {CordeCommonModelsDtoUserRefreshRequest} refreshRequest Refresh Token Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshTokens: async (refreshRequest: CordeCommonModelsDtoUserRefreshRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'refreshRequest' is not null or undefined
            assertParamExists('refreshTokens', 'refreshRequest', refreshRequest)
            const localVarPath = `/auth/refresh-tokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(refreshRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Initiates a password reset process by sending a reset link to the user\'s email.
         * @summary Request Password Reset
         * @param {CordeCommonModelsDtoUserRequestPasswordResetRequest} requestPasswordResetRequest Request Password Reset Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset: async (requestPasswordResetRequest: CordeCommonModelsDtoUserRequestPasswordResetRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestPasswordResetRequest' is not null or undefined
            assertParamExists('requestPasswordReset', 'requestPasswordResetRequest', requestPasswordResetRequest)
            const localVarPath = `/auth/request-password-reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestPasswordResetRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Resends the verification email to the user\'s registered email address.
         * @summary Resend Verification Email
         * @param {CordeCommonModelsDtoUserResendVerificationEmailRequest} resendVerificationRequest Resend Verification Email Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendVerificationEmail: async (resendVerificationRequest: CordeCommonModelsDtoUserResendVerificationEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resendVerificationRequest' is not null or undefined
            assertParamExists('resendVerificationEmail', 'resendVerificationRequest', resendVerificationRequest)
            const localVarPath = `/auth/resend-verification-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resendVerificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Completes the password reset process using a reset token.
         * @summary Reset Password
         * @param {CordeCommonModelsDtoUserResetPasswordRequest} resetPasswordRequest Reset Password Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: async (resetPasswordRequest: CordeCommonModelsDtoUserResetPasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordRequest' is not null or undefined
            assertParamExists('resetPassword', 'resetPasswordRequest', resetPasswordRequest)
            const localVarPath = `/auth/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends a verification email to the user\'s registered email address.
         * @summary Send Verification Email
         * @param {CordeCommonModelsDtoUserSendVerificationEmailRequest} sendVerificationRequest Send Verification Email Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendVerificationEmail: async (sendVerificationRequest: CordeCommonModelsDtoUserSendVerificationEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendVerificationRequest' is not null or undefined
            assertParamExists('sendVerificationEmail', 'sendVerificationRequest', sendVerificationRequest)
            const localVarPath = `/auth/send-verification-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendVerificationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authenticates a user and returns authentication tokens.
         * @summary User Sign In
         * @param {CordeCommonModelsDtoUserSignInRequest} signInRequest Sign In Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signIn: async (signInRequest: CordeCommonModelsDtoUserSignInRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signInRequest' is not null or undefined
            assertParamExists('signIn', 'signInRequest', signInRequest)
            const localVarPath = `/auth/signin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signInRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Registers a new user and returns user details.
         * @summary User Sign Up
         * @param {CordeCommonModelsDtoUserSignUpRequest} signUpRequest Sign Up Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUp: async (signUpRequest: CordeCommonModelsDtoUserSignUpRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'signUpRequest' is not null or undefined
            assertParamExists('signUp', 'signUpRequest', signUpRequest)
            const localVarPath = `/auth/signup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(signUpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the user\'s profile information.
         * @summary Update User Data
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoUserUpdateUserRequest} updateUserRequest Update User Data Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserData: async (userId: string, updateUserRequest: CordeCommonModelsDtoUserUpdateUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserData', 'userId', userId)
            // verify required parameter 'updateUserRequest' is not null or undefined
            assertParamExists('updateUserData', 'updateUserRequest', updateUserRequest)
            const localVarPath = `/user/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the user\'s password.
         * @summary Update Password
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoUserUpdatePasswordRequest} updatePasswordRequest Update Password Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPassword: async (userId: string, updatePasswordRequest: CordeCommonModelsDtoUserUpdatePasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserPassword', 'userId', userId)
            // verify required parameter 'updatePasswordRequest' is not null or undefined
            assertParamExists('updateUserPassword', 'updatePasswordRequest', updatePasswordRequest)
            const localVarPath = `/user/{user_id}/password`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verifies a specific user action by requiring the user\'s password.
         * @summary Verify Action with Password
         * @param {CordeCommonModelsDtoUserVerifyActionWithPasswordRequest} verifyActionRequest Verify Action Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyActionWithPassword: async (verifyActionRequest: CordeCommonModelsDtoUserVerifyActionWithPasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'verifyActionRequest' is not null or undefined
            assertParamExists('verifyActionWithPassword', 'verifyActionRequest', verifyActionRequest)
            const localVarPath = `/auth/verify-action`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyActionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verifies a user\'s email using a verification token.
         * @summary Verify Email
         * @param {string} token Verification Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmail: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('verifyEmail', 'token', token)
            const localVarPath = `/auth/verify-email/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * Deletes a user by their ID.
         * @summary Delete User
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.deleteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Disables two-factor authentication for the specified user.
         * @summary Disable Two-Factor Authentication
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoUserDisableTwoFactorAuthRequest} disableTwoFactorRequest Disable Two-Factor Auth Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableTwoFactorAuth(userId: string, disableTwoFactorRequest: CordeCommonModelsDtoUserDisableTwoFactorAuthRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableTwoFactorAuth(userId, disableTwoFactorRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.disableTwoFactorAuth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Enables two-factor authentication for the specified user.
         * @summary Enable Two-Factor Authentication
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoUserEnableTwoFactorAuthRequest} enableTwoFactorRequest Enable Two-Factor Auth Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enableTwoFactorAuth(userId: string, enableTwoFactorRequest: CordeCommonModelsDtoUserEnableTwoFactorAuthRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableTwoFactorAuth(userId, enableTwoFactorRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.enableTwoFactorAuth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generates a unique referral link for the user to invite others.
         * @summary Generate Referral Link
         * @param {CordeCommonModelsDtoUserGenerateReferralLinkRequest} generateReferralRequest Generate Referral Link Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateReferralLink(generateReferralRequest: CordeCommonModelsDtoUserGenerateReferralLinkRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoUserGenerateReferralLinkResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateReferralLink(generateReferralRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.generateReferralLink']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a list of users who were invited through invitations and referral links.
         * @summary Get Invited and Referral Users
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvitedAndReferralUsers(limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoUserGetInvitedAndReferralUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvitedAndReferralUsers(limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getInvitedAndReferralUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve user information by ID
         * @summary Get user by ID
         * @param {string} userId User ID
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUser(userId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoUserUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUser(userId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve a paginated list of users
         * @summary Get users list
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsers(limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoUserUserListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsers(limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Invalidates all authentication tokens for a user.
         * @summary Invalidate All Tokens
         * @param {CordeCommonModelsDtoUserInvalidateTokensRequest} invalidateAllRequest Invalidate All Tokens Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invalidateAllTokens(invalidateAllRequest: CordeCommonModelsDtoUserInvalidateTokensRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invalidateAllTokens(invalidateAllRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.invalidateAllTokens']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Invalidates the current authentication tokens for a user.
         * @summary Invalidate Current Tokens
         * @param {CordeCommonModelsDtoUserInvalidateTokensRequest} invalidateCurrentRequest Invalidate Current Tokens Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invalidateCurrentTokens(invalidateCurrentRequest: CordeCommonModelsDtoUserInvalidateTokensRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invalidateCurrentTokens(invalidateCurrentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.invalidateCurrentTokens']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sends an invitation to a new user via email.
         * @summary Invite User
         * @param {CordeCommonModelsDtoUserInviteUserRequest} inviteUserRequest Invite User Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteUser(inviteUserRequest: CordeCommonModelsDtoUserInviteUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteUser(inviteUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.inviteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get paginated login records for a specific user
         * @summary List login records for a user
         * @param {string} userId User ID
         * @param {string} [startDate] Start date for filtering (RFC3339 format)
         * @param {string} [endDate] End date for filtering (RFC3339 format)
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listLoginRecords(userId: string, startDate?: string, endDate?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoUserListLoginRecordsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listLoginRecords(userId, startDate, endDate, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.listLoginRecords']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Refreshes authentication tokens using a refresh token.
         * @summary Refresh Tokens
         * @param {CordeCommonModelsDtoUserRefreshRequest} refreshRequest Refresh Token Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshTokens(refreshRequest: CordeCommonModelsDtoUserRefreshRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoUserSignInResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshTokens(refreshRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.refreshTokens']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Initiates a password reset process by sending a reset link to the user\'s email.
         * @summary Request Password Reset
         * @param {CordeCommonModelsDtoUserRequestPasswordResetRequest} requestPasswordResetRequest Request Password Reset Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestPasswordReset(requestPasswordResetRequest: CordeCommonModelsDtoUserRequestPasswordResetRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestPasswordReset(requestPasswordResetRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.requestPasswordReset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Resends the verification email to the user\'s registered email address.
         * @summary Resend Verification Email
         * @param {CordeCommonModelsDtoUserResendVerificationEmailRequest} resendVerificationRequest Resend Verification Email Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendVerificationEmail(resendVerificationRequest: CordeCommonModelsDtoUserResendVerificationEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendVerificationEmail(resendVerificationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.resendVerificationEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Completes the password reset process using a reset token.
         * @summary Reset Password
         * @param {CordeCommonModelsDtoUserResetPasswordRequest} resetPasswordRequest Reset Password Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPassword(resetPasswordRequest: CordeCommonModelsDtoUserResetPasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword(resetPasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.resetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sends a verification email to the user\'s registered email address.
         * @summary Send Verification Email
         * @param {CordeCommonModelsDtoUserSendVerificationEmailRequest} sendVerificationRequest Send Verification Email Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendVerificationEmail(sendVerificationRequest: CordeCommonModelsDtoUserSendVerificationEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendVerificationEmail(sendVerificationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.sendVerificationEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authenticates a user and returns authentication tokens.
         * @summary User Sign In
         * @param {CordeCommonModelsDtoUserSignInRequest} signInRequest Sign In Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signIn(signInRequest: CordeCommonModelsDtoUserSignInRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoUserSignInResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signIn(signInRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.signIn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Registers a new user and returns user details.
         * @summary User Sign Up
         * @param {CordeCommonModelsDtoUserSignUpRequest} signUpRequest Sign Up Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signUp(signUpRequest: CordeCommonModelsDtoUserSignUpRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoUserUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signUp(signUpRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.signUp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the user\'s profile information.
         * @summary Update User Data
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoUserUpdateUserRequest} updateUserRequest Update User Data Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserData(userId: string, updateUserRequest: CordeCommonModelsDtoUserUpdateUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoUserUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserData(userId, updateUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.updateUserData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the user\'s password.
         * @summary Update Password
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoUserUpdatePasswordRequest} updatePasswordRequest Update Password Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserPassword(userId: string, updatePasswordRequest: CordeCommonModelsDtoUserUpdatePasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserPassword(userId, updatePasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.updateUserPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Verifies a specific user action by requiring the user\'s password.
         * @summary Verify Action with Password
         * @param {CordeCommonModelsDtoUserVerifyActionWithPasswordRequest} verifyActionRequest Verify Action Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyActionWithPassword(verifyActionRequest: CordeCommonModelsDtoUserVerifyActionWithPasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyActionWithPassword(verifyActionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.verifyActionWithPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Verifies a user\'s email using a verification token.
         * @summary Verify Email
         * @param {string} token Verification Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyEmail(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyEmail(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.verifyEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * Deletes a user by their ID.
         * @summary Delete User
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(userId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.deleteUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Disables two-factor authentication for the specified user.
         * @summary Disable Two-Factor Authentication
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoUserDisableTwoFactorAuthRequest} disableTwoFactorRequest Disable Two-Factor Auth Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableTwoFactorAuth(userId: string, disableTwoFactorRequest: CordeCommonModelsDtoUserDisableTwoFactorAuthRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.disableTwoFactorAuth(userId, disableTwoFactorRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Enables two-factor authentication for the specified user.
         * @summary Enable Two-Factor Authentication
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoUserEnableTwoFactorAuthRequest} enableTwoFactorRequest Enable Two-Factor Auth Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableTwoFactorAuth(userId: string, enableTwoFactorRequest: CordeCommonModelsDtoUserEnableTwoFactorAuthRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.enableTwoFactorAuth(userId, enableTwoFactorRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates a unique referral link for the user to invite others.
         * @summary Generate Referral Link
         * @param {CordeCommonModelsDtoUserGenerateReferralLinkRequest} generateReferralRequest Generate Referral Link Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateReferralLink(generateReferralRequest: CordeCommonModelsDtoUserGenerateReferralLinkRequest, options?: any): AxiosPromise<CordeCommonModelsDtoUserGenerateReferralLinkResponse> {
            return localVarFp.generateReferralLink(generateReferralRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a list of users who were invited through invitations and referral links.
         * @summary Get Invited and Referral Users
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvitedAndReferralUsers(limit?: number, offset?: number, options?: any): AxiosPromise<CordeCommonModelsDtoUserGetInvitedAndReferralUsersResponse> {
            return localVarFp.getInvitedAndReferralUsers(limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve user information by ID
         * @summary Get user by ID
         * @param {string} userId User ID
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(userId: string, limit?: number, offset?: number, options?: any): AxiosPromise<CordeCommonModelsDtoUserUser> {
            return localVarFp.getUser(userId, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a paginated list of users
         * @summary Get users list
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(limit?: number, offset?: number, options?: any): AxiosPromise<CordeCommonModelsDtoUserUserListResponse> {
            return localVarFp.getUsers(limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Invalidates all authentication tokens for a user.
         * @summary Invalidate All Tokens
         * @param {CordeCommonModelsDtoUserInvalidateTokensRequest} invalidateAllRequest Invalidate All Tokens Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invalidateAllTokens(invalidateAllRequest: CordeCommonModelsDtoUserInvalidateTokensRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.invalidateAllTokens(invalidateAllRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Invalidates the current authentication tokens for a user.
         * @summary Invalidate Current Tokens
         * @param {CordeCommonModelsDtoUserInvalidateTokensRequest} invalidateCurrentRequest Invalidate Current Tokens Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invalidateCurrentTokens(invalidateCurrentRequest: CordeCommonModelsDtoUserInvalidateTokensRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.invalidateCurrentTokens(invalidateCurrentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends an invitation to a new user via email.
         * @summary Invite User
         * @param {CordeCommonModelsDtoUserInviteUserRequest} inviteUserRequest Invite User Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteUser(inviteUserRequest: CordeCommonModelsDtoUserInviteUserRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.inviteUser(inviteUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get paginated login records for a specific user
         * @summary List login records for a user
         * @param {string} userId User ID
         * @param {string} [startDate] Start date for filtering (RFC3339 format)
         * @param {string} [endDate] End date for filtering (RFC3339 format)
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listLoginRecords(userId: string, startDate?: string, endDate?: string, limit?: number, offset?: number, options?: any): AxiosPromise<CordeCommonModelsDtoUserListLoginRecordsResponse> {
            return localVarFp.listLoginRecords(userId, startDate, endDate, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Refreshes authentication tokens using a refresh token.
         * @summary Refresh Tokens
         * @param {CordeCommonModelsDtoUserRefreshRequest} refreshRequest Refresh Token Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshTokens(refreshRequest: CordeCommonModelsDtoUserRefreshRequest, options?: any): AxiosPromise<CordeCommonModelsDtoUserSignInResponse> {
            return localVarFp.refreshTokens(refreshRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Initiates a password reset process by sending a reset link to the user\'s email.
         * @summary Request Password Reset
         * @param {CordeCommonModelsDtoUserRequestPasswordResetRequest} requestPasswordResetRequest Request Password Reset Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestPasswordReset(requestPasswordResetRequest: CordeCommonModelsDtoUserRequestPasswordResetRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.requestPasswordReset(requestPasswordResetRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Resends the verification email to the user\'s registered email address.
         * @summary Resend Verification Email
         * @param {CordeCommonModelsDtoUserResendVerificationEmailRequest} resendVerificationRequest Resend Verification Email Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendVerificationEmail(resendVerificationRequest: CordeCommonModelsDtoUserResendVerificationEmailRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.resendVerificationEmail(resendVerificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Completes the password reset process using a reset token.
         * @summary Reset Password
         * @param {CordeCommonModelsDtoUserResetPasswordRequest} resetPasswordRequest Reset Password Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(resetPasswordRequest: CordeCommonModelsDtoUserResetPasswordRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.resetPassword(resetPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Sends a verification email to the user\'s registered email address.
         * @summary Send Verification Email
         * @param {CordeCommonModelsDtoUserSendVerificationEmailRequest} sendVerificationRequest Send Verification Email Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendVerificationEmail(sendVerificationRequest: CordeCommonModelsDtoUserSendVerificationEmailRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.sendVerificationEmail(sendVerificationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Authenticates a user and returns authentication tokens.
         * @summary User Sign In
         * @param {CordeCommonModelsDtoUserSignInRequest} signInRequest Sign In Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signIn(signInRequest: CordeCommonModelsDtoUserSignInRequest, options?: any): AxiosPromise<CordeCommonModelsDtoUserSignInResponse> {
            return localVarFp.signIn(signInRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Registers a new user and returns user details.
         * @summary User Sign Up
         * @param {CordeCommonModelsDtoUserSignUpRequest} signUpRequest Sign Up Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUp(signUpRequest: CordeCommonModelsDtoUserSignUpRequest, options?: any): AxiosPromise<CordeCommonModelsDtoUserUser> {
            return localVarFp.signUp(signUpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the user\'s profile information.
         * @summary Update User Data
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoUserUpdateUserRequest} updateUserRequest Update User Data Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserData(userId: string, updateUserRequest: CordeCommonModelsDtoUserUpdateUserRequest, options?: any): AxiosPromise<CordeCommonModelsDtoUserUser> {
            return localVarFp.updateUserData(userId, updateUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the user\'s password.
         * @summary Update Password
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoUserUpdatePasswordRequest} updatePasswordRequest Update Password Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPassword(userId: string, updatePasswordRequest: CordeCommonModelsDtoUserUpdatePasswordRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.updateUserPassword(userId, updatePasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Verifies a specific user action by requiring the user\'s password.
         * @summary Verify Action with Password
         * @param {CordeCommonModelsDtoUserVerifyActionWithPasswordRequest} verifyActionRequest Verify Action Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyActionWithPassword(verifyActionRequest: CordeCommonModelsDtoUserVerifyActionWithPasswordRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.verifyActionWithPassword(verifyActionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Verifies a user\'s email using a verification token.
         * @summary Verify Email
         * @param {string} token Verification Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyEmail(token: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.verifyEmail(token, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * Deletes a user by their ID.
     * @summary Delete User
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public deleteUser(userId: string, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).deleteUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Disables two-factor authentication for the specified user.
     * @summary Disable Two-Factor Authentication
     * @param {string} userId User ID
     * @param {CordeCommonModelsDtoUserDisableTwoFactorAuthRequest} disableTwoFactorRequest Disable Two-Factor Auth Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public disableTwoFactorAuth(userId: string, disableTwoFactorRequest: CordeCommonModelsDtoUserDisableTwoFactorAuthRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).disableTwoFactorAuth(userId, disableTwoFactorRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enables two-factor authentication for the specified user.
     * @summary Enable Two-Factor Authentication
     * @param {string} userId User ID
     * @param {CordeCommonModelsDtoUserEnableTwoFactorAuthRequest} enableTwoFactorRequest Enable Two-Factor Auth Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public enableTwoFactorAuth(userId: string, enableTwoFactorRequest: CordeCommonModelsDtoUserEnableTwoFactorAuthRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).enableTwoFactorAuth(userId, enableTwoFactorRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates a unique referral link for the user to invite others.
     * @summary Generate Referral Link
     * @param {CordeCommonModelsDtoUserGenerateReferralLinkRequest} generateReferralRequest Generate Referral Link Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public generateReferralLink(generateReferralRequest: CordeCommonModelsDtoUserGenerateReferralLinkRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).generateReferralLink(generateReferralRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a list of users who were invited through invitations and referral links.
     * @summary Get Invited and Referral Users
     * @param {number} [limit] Number of items to return
     * @param {number} [offset] Number of items to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getInvitedAndReferralUsers(limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).getInvitedAndReferralUsers(limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve user information by ID
     * @summary Get user by ID
     * @param {string} userId User ID
     * @param {number} [limit] Number of items to return
     * @param {number} [offset] Number of items to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUser(userId: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).getUser(userId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve a paginated list of users
     * @summary Get users list
     * @param {number} [limit] Number of items to return
     * @param {number} [offset] Number of items to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUsers(limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).getUsers(limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Invalidates all authentication tokens for a user.
     * @summary Invalidate All Tokens
     * @param {CordeCommonModelsDtoUserInvalidateTokensRequest} invalidateAllRequest Invalidate All Tokens Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public invalidateAllTokens(invalidateAllRequest: CordeCommonModelsDtoUserInvalidateTokensRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).invalidateAllTokens(invalidateAllRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Invalidates the current authentication tokens for a user.
     * @summary Invalidate Current Tokens
     * @param {CordeCommonModelsDtoUserInvalidateTokensRequest} invalidateCurrentRequest Invalidate Current Tokens Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public invalidateCurrentTokens(invalidateCurrentRequest: CordeCommonModelsDtoUserInvalidateTokensRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).invalidateCurrentTokens(invalidateCurrentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends an invitation to a new user via email.
     * @summary Invite User
     * @param {CordeCommonModelsDtoUserInviteUserRequest} inviteUserRequest Invite User Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public inviteUser(inviteUserRequest: CordeCommonModelsDtoUserInviteUserRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).inviteUser(inviteUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get paginated login records for a specific user
     * @summary List login records for a user
     * @param {string} userId User ID
     * @param {string} [startDate] Start date for filtering (RFC3339 format)
     * @param {string} [endDate] End date for filtering (RFC3339 format)
     * @param {number} [limit] Number of items to return
     * @param {number} [offset] Number of items to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public listLoginRecords(userId: string, startDate?: string, endDate?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).listLoginRecords(userId, startDate, endDate, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Refreshes authentication tokens using a refresh token.
     * @summary Refresh Tokens
     * @param {CordeCommonModelsDtoUserRefreshRequest} refreshRequest Refresh Token Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public refreshTokens(refreshRequest: CordeCommonModelsDtoUserRefreshRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).refreshTokens(refreshRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Initiates a password reset process by sending a reset link to the user\'s email.
     * @summary Request Password Reset
     * @param {CordeCommonModelsDtoUserRequestPasswordResetRequest} requestPasswordResetRequest Request Password Reset Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public requestPasswordReset(requestPasswordResetRequest: CordeCommonModelsDtoUserRequestPasswordResetRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).requestPasswordReset(requestPasswordResetRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Resends the verification email to the user\'s registered email address.
     * @summary Resend Verification Email
     * @param {CordeCommonModelsDtoUserResendVerificationEmailRequest} resendVerificationRequest Resend Verification Email Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public resendVerificationEmail(resendVerificationRequest: CordeCommonModelsDtoUserResendVerificationEmailRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).resendVerificationEmail(resendVerificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Completes the password reset process using a reset token.
     * @summary Reset Password
     * @param {CordeCommonModelsDtoUserResetPasswordRequest} resetPasswordRequest Reset Password Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public resetPassword(resetPasswordRequest: CordeCommonModelsDtoUserResetPasswordRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).resetPassword(resetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sends a verification email to the user\'s registered email address.
     * @summary Send Verification Email
     * @param {CordeCommonModelsDtoUserSendVerificationEmailRequest} sendVerificationRequest Send Verification Email Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public sendVerificationEmail(sendVerificationRequest: CordeCommonModelsDtoUserSendVerificationEmailRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).sendVerificationEmail(sendVerificationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Authenticates a user and returns authentication tokens.
     * @summary User Sign In
     * @param {CordeCommonModelsDtoUserSignInRequest} signInRequest Sign In Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public signIn(signInRequest: CordeCommonModelsDtoUserSignInRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).signIn(signInRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Registers a new user and returns user details.
     * @summary User Sign Up
     * @param {CordeCommonModelsDtoUserSignUpRequest} signUpRequest Sign Up Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public signUp(signUpRequest: CordeCommonModelsDtoUserSignUpRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).signUp(signUpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the user\'s profile information.
     * @summary Update User Data
     * @param {string} userId User ID
     * @param {CordeCommonModelsDtoUserUpdateUserRequest} updateUserRequest Update User Data Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public updateUserData(userId: string, updateUserRequest: CordeCommonModelsDtoUserUpdateUserRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).updateUserData(userId, updateUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the user\'s password.
     * @summary Update Password
     * @param {string} userId User ID
     * @param {CordeCommonModelsDtoUserUpdatePasswordRequest} updatePasswordRequest Update Password Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public updateUserPassword(userId: string, updatePasswordRequest: CordeCommonModelsDtoUserUpdatePasswordRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).updateUserPassword(userId, updatePasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verifies a specific user action by requiring the user\'s password.
     * @summary Verify Action with Password
     * @param {CordeCommonModelsDtoUserVerifyActionWithPasswordRequest} verifyActionRequest Verify Action Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public verifyActionWithPassword(verifyActionRequest: CordeCommonModelsDtoUserVerifyActionWithPasswordRequest, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).verifyActionWithPassword(verifyActionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verifies a user\'s email using a verification token.
     * @summary Verify Email
     * @param {string} token Verification Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public verifyEmail(token: string, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).verifyEmail(token, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserprofileApi - axios parameter creator
 * @export
 */
export const UserprofileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Ban a user profile with reason and optional expiration
         * @summary Admin ban profile
         * @param {string} profileId Profile ID
         * @param {CordeCommonModelsDtoUserprofileAdminBanProfileRequest} req Ban Profile Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBanProfile: async (profileId: string, req: CordeCommonModelsDtoUserprofileAdminBanProfileRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('adminBanProfile', 'profileId', profileId)
            // verify required parameter 'req' is not null or undefined
            assertParamExists('adminBanProfile', 'req', req)
            const localVarPath = `/userprofile/admin/profiles/{profile_id}/ban`
                .replace(`{${"profile_id"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get ban history for a profile
         * @summary Admin get profile ban history
         * @param {string} profileId Profile ID
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {string} [sortBy] Sort field
         * @param {AdminGetProfileBanHistorySortOrderEnum} [sortOrder] Sort order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetProfileBanHistory: async (profileId: string, limit?: number, offset?: number, sortBy?: string, sortOrder?: AdminGetProfileBanHistorySortOrderEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('adminGetProfileBanHistory', 'profileId', profileId)
            const localVarPath = `/userprofile/admin/profiles/{profile_id}/ban-history`
                .replace(`{${"profile_id"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get detailed profile information for admin
         * @summary Admin get profile details
         * @param {string} profileId Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetProfileDetails: async (profileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('adminGetProfileDetails', 'profileId', profileId)
            const localVarPath = `/userprofile/admin/profiles/{profile_id}`
                .replace(`{${"profile_id"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all profiles for admin management
         * @summary Admin list profiles
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {string} [sortBy] Sort field
         * @param {AdminListProfilesSortOrderEnum} [sortOrder] Sort order
         * @param {string} [search] Search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListProfiles: async (limit?: number, offset?: number, sortBy?: string, sortOrder?: AdminListProfilesSortOrderEnum, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/userprofile/admin/profiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unban a user profile with admin comment
         * @summary Admin unban profile
         * @param {string} profileId Profile ID
         * @param {CordeCommonModelsDtoUserprofileAdminUnbanProfileRequest} req Unban Profile Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUnbanProfile: async (profileId: string, req: CordeCommonModelsDtoUserprofileAdminUnbanProfileRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('adminUnbanProfile', 'profileId', profileId)
            // verify required parameter 'req' is not null or undefined
            assertParamExists('adminUnbanProfile', 'req', req)
            const localVarPath = `/userprofile/admin/profiles/{profile_id}/unban`
                .replace(`{${"profile_id"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Upload a new avatar for user profile
         * @summary Upload new avatar
         * @param {string} profileId Profile ID
         * @param {File} file Avatar image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAvatar: async (profileId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('createAvatar', 'profileId', profileId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('createAvatar', 'file', file)
            const localVarPath = `/userprofile/{profile_id}/avatar`
                .replace(`{${"profile_id"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new user profile
         * @summary Create user profile
         * @param {CordeCommonModelsDtoUserprofileCreateUserProfileRequest} req Profile Creation Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserProfile: async (req: CordeCommonModelsDtoUserprofileCreateUserProfileRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'req' is not null or undefined
            assertParamExists('createUserProfile', 'req', req)
            const localVarPath = `/userprofile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete user\'s profile avatar
         * @summary Delete user avatar
         * @param {string} profileId Profile ID
         * @param {string} avatarId Avatar ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAvatar: async (profileId: string, avatarId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('deleteAvatar', 'profileId', profileId)
            // verify required parameter 'avatarId' is not null or undefined
            assertParamExists('deleteAvatar', 'avatarId', avatarId)
            const localVarPath = `/userprofile/{profile_id}/avatar/{avatar_id}`
                .replace(`{${"profile_id"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"avatar_id"}}`, encodeURIComponent(String(avatarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete user\'s UI preferences and settings
         * @summary Delete UI settings
         * @param {string} profileId Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUISettings: async (profileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('deleteUISettings', 'profileId', profileId)
            const localVarPath = `/userprofile/{profile_id}/ui-settings`
                .replace(`{${"profile_id"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an existing user profile
         * @summary Delete user profile
         * @param {string} profileId Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserProfile: async (profileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('deleteUserProfile', 'profileId', profileId)
            const localVarPath = `/userprofile/{profile_id}`
                .replace(`{${"profile_id"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get active user profile for current user
         * @summary Get active user profile
         * @param {string} profileId Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveUserProfile: async (profileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('getActiveUserProfile', 'profileId', profileId)
            const localVarPath = `/userprofile/active/{profile_id}`
                .replace(`{${"profile_id"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get default user profile for system or entity scope (if entity params are passed)
         * @summary Get default user profile
         * @param {string} userId User ID
         * @param {string} [entityType] Entity type for scoped default
         * @param {string} [entityId] Entity ID for scoped default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultUserProfile: async (userId: string, entityType?: string, entityId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getDefaultUserProfile', 'userId', userId)
            const localVarPath = `/userprofile/default/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityType !== undefined) {
                localVarQueryParameter['entity_type'] = entityType;
            }

            if (entityId !== undefined) {
                localVarQueryParameter['entity_id'] = entityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user\'s privacy settings
         * @summary Get privacy settings
         * @param {string} profileId Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrivacySettings: async (profileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('getPrivacySettings', 'profileId', profileId)
            const localVarPath = `/userprofile/{profile_id}/privacy`
                .replace(`{${"profile_id"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get change history for a user profile
         * @summary Get profile change history
         * @param {string} profileId Profile ID
         * @param {string} [fromDate] Filter from date (RFC3339)
         * @param {string} [toDate] Filter to date (RFC3339)
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {string} [sortBy] Sort field
         * @param {GetProfileChangeHistorySortOrderEnum} [sortOrder] Sort order
         * @param {string} [search] Search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileChangeHistory: async (profileId: string, fromDate?: string, toDate?: string, limit?: number, offset?: number, sortBy?: string, sortOrder?: GetProfileChangeHistorySortOrderEnum, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('getProfileChangeHistory', 'profileId', profileId)
            const localVarPath = `/userprofile/{profile_id}/history`
                .replace(`{${"profile_id"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fromDate !== undefined) {
                localVarQueryParameter['from_date'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['to_date'] = toDate;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user\'s UI preferences and settings
         * @summary Get UI settings
         * @param {string} profileId Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUISettings: async (profileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('getUISettings', 'profileId', profileId)
            const localVarPath = `/userprofile/{profile_id}/ui-settings`
                .replace(`{${"profile_id"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get specific user avatar by ID
         * @summary Get user avatar
         * @param {string} profileId Profile ID
         * @param {string} avatarId Avatar ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAvatar: async (profileId: string, avatarId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('getUserAvatar', 'profileId', profileId)
            // verify required parameter 'avatarId' is not null or undefined
            assertParamExists('getUserAvatar', 'avatarId', avatarId)
            const localVarPath = `/userprofile/{profile_id}/avatars/{avatar_id}`
                .replace(`{${"profile_id"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"avatar_id"}}`, encodeURIComponent(String(avatarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a user profile by user ID
         * @summary Get user profile
         * @param {string} profileId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProfile: async (profileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('getUserProfile', 'profileId', profileId)
            const localVarPath = `/userprofile/{profile_id}`
                .replace(`{${"profile_id"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user profiles for internal service operations
         * @summary Get user profiles for service
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProfilesForService: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserProfilesForService', 'userId', userId)
            const localVarPath = `/userprofile/service/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get audit logs for a user profile
         * @summary Get audit logs
         * @param {string} [entityId] Filter by entity ID
         * @param {string} [entityType] Filter by entity type
         * @param {string} [fromDate] Filter from date (RFC3339)
         * @param {string} [toDate] Filter to date (RFC3339)
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {string} [sortBy] Sort field
         * @param {GetUserprofileAuditLogsSortOrderEnum} [sortOrder] Sort order
         * @param {string} [search] Search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserprofileAuditLogs: async (entityId?: string, entityType?: string, fromDate?: string, toDate?: string, limit?: number, offset?: number, sortBy?: string, sortOrder?: GetUserprofileAuditLogsSortOrderEnum, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/userprofile/audit-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entityId !== undefined) {
                localVarQueryParameter['entity_id'] = entityId;
            }

            if (entityType !== undefined) {
                localVarQueryParameter['entity_type'] = entityType;
            }

            if (fromDate !== undefined) {
                localVarQueryParameter['from_date'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['to_date'] = toDate;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of user avatars with pagination
         * @summary List user avatars
         * @param {string} profileId Profile ID
         * @param {boolean} [onlyActive] Filter only active avatars
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {string} [sortBy] Sort field
         * @param {ListUserAvatarsSortOrderEnum} [sortOrder] Sort order
         * @param {string} [search] Search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserAvatars: async (profileId: string, onlyActive?: boolean, limit?: number, offset?: number, sortBy?: string, sortOrder?: ListUserAvatarsSortOrderEnum, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('listUserAvatars', 'profileId', profileId)
            const localVarPath = `/userprofile/{profile_id}/avatars`
                .replace(`{${"profile_id"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (onlyActive !== undefined) {
                localVarQueryParameter['only_active'] = onlyActive;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List user profiles with pagination and filters
         * @summary List user profiles
         * @param {string} [userId] Filter by user id
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {string} [sortBy] Sort field
         * @param {ListUserProfilesSortOrderEnum} [sortOrder] Sort order
         * @param {string} [search] Search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserProfiles: async (userId?: string, limit?: number, offset?: number, sortBy?: string, sortOrder?: ListUserProfilesSortOrderEnum, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/userprofile/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sort_order'] = sortOrder;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set specific avatar as active for user profile
         * @summary Set active avatar
         * @param {string} profileId Profile ID
         * @param {string} avatarId Avatar ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setActiveAvatar: async (profileId: string, avatarId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('setActiveAvatar', 'profileId', profileId)
            // verify required parameter 'avatarId' is not null or undefined
            assertParamExists('setActiveAvatar', 'avatarId', avatarId)
            const localVarPath = `/userprofile/{profile_id}/avatars/{avatar_id}/set-active`
                .replace(`{${"profile_id"}}`, encodeURIComponent(String(profileId)))
                .replace(`{${"avatar_id"}}`, encodeURIComponent(String(avatarId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set active user profile for current user
         * @summary Set active user profile
         * @param {CordeCommonModelsDtoUserprofileSetActiveUserProfileRequest} req Set Active Profile Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setActiveUserProfile: async (req: CordeCommonModelsDtoUserprofileSetActiveUserProfileRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'req' is not null or undefined
            assertParamExists('setActiveUserProfile', 'req', req)
            const localVarPath = `/userprofile/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Set default user profile for system or entity scope (if entity params are passed)
         * @summary Set default user profile
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoUserprofileSetDefaultUserProfileRequest} req Set Default Profile Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultUserProfile: async (userId: string, req: CordeCommonModelsDtoUserprofileSetDefaultUserProfileRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('setDefaultUserProfile', 'userId', userId)
            // verify required parameter 'req' is not null or undefined
            assertParamExists('setDefaultUserProfile', 'req', req)
            const localVarPath = `/userprofile/default/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update user\'s privacy settings
         * @summary Update privacy settings
         * @param {string} profileId Profile ID
         * @param {CordeCommonModelsDtoUserprofileUpdatePrivacySettingsRequest} settings Privacy Settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrivacySettings: async (profileId: string, settings: CordeCommonModelsDtoUserprofileUpdatePrivacySettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('updatePrivacySettings', 'profileId', profileId)
            // verify required parameter 'settings' is not null or undefined
            assertParamExists('updatePrivacySettings', 'settings', settings)
            const localVarPath = `/userprofile/{profile_id}/privacy`
                .replace(`{${"profile_id"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(settings, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update user\'s UI preferences and settings
         * @summary Update UI settings
         * @param {string} profileId Profile ID
         * @param {CordeCommonModelsDtoUserprofileUpdateUISettingsRequest} settings UI Settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUISettings: async (profileId: string, settings: CordeCommonModelsDtoUserprofileUpdateUISettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('updateUISettings', 'profileId', profileId)
            // verify required parameter 'settings' is not null or undefined
            assertParamExists('updateUISettings', 'settings', settings)
            const localVarPath = `/userprofile/{profile_id}/ui-settings`
                .replace(`{${"profile_id"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(settings, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing user profile
         * @summary Update user profile
         * @param {string} profileId Profile ID
         * @param {CordeCommonModelsDtoUserprofileUpdateUserProfileRequest} req Profile Update Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserProfile: async (profileId: string, req: CordeCommonModelsDtoUserprofileUpdateUserProfileRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'profileId' is not null or undefined
            assertParamExists('updateUserProfile', 'profileId', profileId)
            // verify required parameter 'req' is not null or undefined
            assertParamExists('updateUserProfile', 'req', req)
            const localVarPath = `/userprofile/{profile_id}`
                .replace(`{${"profile_id"}}`, encodeURIComponent(String(profileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(req, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verifies two-factor authentication code
         * @summary Verify Two-Factor Authentication
         * @param {string} userId User ID
         * @param {string} code 2FA Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTwoFactorAuth: async (userId: string, code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('verifyTwoFactorAuth', 'userId', userId)
            // verify required parameter 'code' is not null or undefined
            assertParamExists('verifyTwoFactorAuth', 'code', code)
            const localVarPath = `/userprofile/verify-two-factor-auth/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserprofileApi - functional programming interface
 * @export
 */
export const UserprofileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserprofileApiAxiosParamCreator(configuration)
    return {
        /**
         * Ban a user profile with reason and optional expiration
         * @summary Admin ban profile
         * @param {string} profileId Profile ID
         * @param {CordeCommonModelsDtoUserprofileAdminBanProfileRequest} req Ban Profile Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminBanProfile(profileId: string, req: CordeCommonModelsDtoUserprofileAdminBanProfileRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminBanProfile(profileId, req, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserprofileApi.adminBanProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get ban history for a profile
         * @summary Admin get profile ban history
         * @param {string} profileId Profile ID
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {string} [sortBy] Sort field
         * @param {AdminGetProfileBanHistorySortOrderEnum} [sortOrder] Sort order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetProfileBanHistory(profileId: string, limit?: number, offset?: number, sortBy?: string, sortOrder?: AdminGetProfileBanHistorySortOrderEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoUserprofileAdminGetProfileBanHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetProfileBanHistory(profileId, limit, offset, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserprofileApi.adminGetProfileBanHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get detailed profile information for admin
         * @summary Admin get profile details
         * @param {string} profileId Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminGetProfileDetails(profileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoUserprofileAdminGetProfileDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminGetProfileDetails(profileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserprofileApi.adminGetProfileDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all profiles for admin management
         * @summary Admin list profiles
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {string} [sortBy] Sort field
         * @param {AdminListProfilesSortOrderEnum} [sortOrder] Sort order
         * @param {string} [search] Search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminListProfiles(limit?: number, offset?: number, sortBy?: string, sortOrder?: AdminListProfilesSortOrderEnum, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoUserprofileAdminListProfilesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminListProfiles(limit, offset, sortBy, sortOrder, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserprofileApi.adminListProfiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unban a user profile with admin comment
         * @summary Admin unban profile
         * @param {string} profileId Profile ID
         * @param {CordeCommonModelsDtoUserprofileAdminUnbanProfileRequest} req Unban Profile Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUnbanProfile(profileId: string, req: CordeCommonModelsDtoUserprofileAdminUnbanProfileRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUnbanProfile(profileId, req, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserprofileApi.adminUnbanProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Upload a new avatar for user profile
         * @summary Upload new avatar
         * @param {string} profileId Profile ID
         * @param {File} file Avatar image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAvatar(profileId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAvatar(profileId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserprofileApi.createAvatar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new user profile
         * @summary Create user profile
         * @param {CordeCommonModelsDtoUserprofileCreateUserProfileRequest} req Profile Creation Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUserProfile(req: CordeCommonModelsDtoUserprofileCreateUserProfileRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoUserprofileUserProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUserProfile(req, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserprofileApi.createUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete user\'s profile avatar
         * @summary Delete user avatar
         * @param {string} profileId Profile ID
         * @param {string} avatarId Avatar ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAvatar(profileId: string, avatarId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAvatar(profileId, avatarId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserprofileApi.deleteAvatar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete user\'s UI preferences and settings
         * @summary Delete UI settings
         * @param {string} profileId Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUISettings(profileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUISettings(profileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserprofileApi.deleteUISettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an existing user profile
         * @summary Delete user profile
         * @param {string} profileId Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserProfile(profileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserProfile(profileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserprofileApi.deleteUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get active user profile for current user
         * @summary Get active user profile
         * @param {string} profileId Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveUserProfile(profileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoUserprofileGetActiveUserProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveUserProfile(profileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserprofileApi.getActiveUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get default user profile for system or entity scope (if entity params are passed)
         * @summary Get default user profile
         * @param {string} userId User ID
         * @param {string} [entityType] Entity type for scoped default
         * @param {string} [entityId] Entity ID for scoped default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefaultUserProfile(userId: string, entityType?: string, entityId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoUserprofileUserProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefaultUserProfile(userId, entityType, entityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserprofileApi.getDefaultUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get user\'s privacy settings
         * @summary Get privacy settings
         * @param {string} profileId Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrivacySettings(profileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoUserprofileGetPrivacySettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrivacySettings(profileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserprofileApi.getPrivacySettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get change history for a user profile
         * @summary Get profile change history
         * @param {string} profileId Profile ID
         * @param {string} [fromDate] Filter from date (RFC3339)
         * @param {string} [toDate] Filter to date (RFC3339)
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {string} [sortBy] Sort field
         * @param {GetProfileChangeHistorySortOrderEnum} [sortOrder] Sort order
         * @param {string} [search] Search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfileChangeHistory(profileId: string, fromDate?: string, toDate?: string, limit?: number, offset?: number, sortBy?: string, sortOrder?: GetProfileChangeHistorySortOrderEnum, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoUserprofileGetProfileChangeHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfileChangeHistory(profileId, fromDate, toDate, limit, offset, sortBy, sortOrder, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserprofileApi.getProfileChangeHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get user\'s UI preferences and settings
         * @summary Get UI settings
         * @param {string} profileId Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUISettings(profileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoUserprofileGetUISettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUISettings(profileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserprofileApi.getUISettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get specific user avatar by ID
         * @summary Get user avatar
         * @param {string} profileId Profile ID
         * @param {string} avatarId Avatar ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserAvatar(profileId: string, avatarId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoUserprofileGetUserAvatarResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserAvatar(profileId, avatarId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserprofileApi.getUserAvatar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a user profile by user ID
         * @summary Get user profile
         * @param {string} profileId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserProfile(profileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoUserprofileUserProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserProfile(profileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserprofileApi.getUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get user profiles for internal service operations
         * @summary Get user profiles for service
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserProfilesForService(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoUserprofileGetUserProfilesForServiceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserProfilesForService(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserprofileApi.getUserProfilesForService']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get audit logs for a user profile
         * @summary Get audit logs
         * @param {string} [entityId] Filter by entity ID
         * @param {string} [entityType] Filter by entity type
         * @param {string} [fromDate] Filter from date (RFC3339)
         * @param {string} [toDate] Filter to date (RFC3339)
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {string} [sortBy] Sort field
         * @param {GetUserprofileAuditLogsSortOrderEnum} [sortOrder] Sort order
         * @param {string} [search] Search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserprofileAuditLogs(entityId?: string, entityType?: string, fromDate?: string, toDate?: string, limit?: number, offset?: number, sortBy?: string, sortOrder?: GetUserprofileAuditLogsSortOrderEnum, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoUserprofileGetAuditLogsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserprofileAuditLogs(entityId, entityType, fromDate, toDate, limit, offset, sortBy, sortOrder, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserprofileApi.getUserprofileAuditLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get list of user avatars with pagination
         * @summary List user avatars
         * @param {string} profileId Profile ID
         * @param {boolean} [onlyActive] Filter only active avatars
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {string} [sortBy] Sort field
         * @param {ListUserAvatarsSortOrderEnum} [sortOrder] Sort order
         * @param {string} [search] Search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUserAvatars(profileId: string, onlyActive?: boolean, limit?: number, offset?: number, sortBy?: string, sortOrder?: ListUserAvatarsSortOrderEnum, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoUserprofileListUserAvatarsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUserAvatars(profileId, onlyActive, limit, offset, sortBy, sortOrder, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserprofileApi.listUserAvatars']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List user profiles with pagination and filters
         * @summary List user profiles
         * @param {string} [userId] Filter by user id
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {string} [sortBy] Sort field
         * @param {ListUserProfilesSortOrderEnum} [sortOrder] Sort order
         * @param {string} [search] Search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUserProfiles(userId?: string, limit?: number, offset?: number, sortBy?: string, sortOrder?: ListUserProfilesSortOrderEnum, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoUserprofileListUserProfilesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUserProfiles(userId, limit, offset, sortBy, sortOrder, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserprofileApi.listUserProfiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set specific avatar as active for user profile
         * @summary Set active avatar
         * @param {string} profileId Profile ID
         * @param {string} avatarId Avatar ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setActiveAvatar(profileId: string, avatarId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setActiveAvatar(profileId, avatarId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserprofileApi.setActiveAvatar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set active user profile for current user
         * @summary Set active user profile
         * @param {CordeCommonModelsDtoUserprofileSetActiveUserProfileRequest} req Set Active Profile Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setActiveUserProfile(req: CordeCommonModelsDtoUserprofileSetActiveUserProfileRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setActiveUserProfile(req, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserprofileApi.setActiveUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Set default user profile for system or entity scope (if entity params are passed)
         * @summary Set default user profile
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoUserprofileSetDefaultUserProfileRequest} req Set Default Profile Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setDefaultUserProfile(userId: string, req: CordeCommonModelsDtoUserprofileSetDefaultUserProfileRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setDefaultUserProfile(userId, req, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserprofileApi.setDefaultUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update user\'s privacy settings
         * @summary Update privacy settings
         * @param {string} profileId Profile ID
         * @param {CordeCommonModelsDtoUserprofileUpdatePrivacySettingsRequest} settings Privacy Settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePrivacySettings(profileId: string, settings: CordeCommonModelsDtoUserprofileUpdatePrivacySettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePrivacySettings(profileId, settings, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserprofileApi.updatePrivacySettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update user\'s UI preferences and settings
         * @summary Update UI settings
         * @param {string} profileId Profile ID
         * @param {CordeCommonModelsDtoUserprofileUpdateUISettingsRequest} settings UI Settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUISettings(profileId: string, settings: CordeCommonModelsDtoUserprofileUpdateUISettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUISettings(profileId, settings, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserprofileApi.updateUISettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing user profile
         * @summary Update user profile
         * @param {string} profileId Profile ID
         * @param {CordeCommonModelsDtoUserprofileUpdateUserProfileRequest} req Profile Update Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserProfile(profileId: string, req: CordeCommonModelsDtoUserprofileUpdateUserProfileRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoUserprofileUserProfileResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserProfile(profileId, req, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserprofileApi.updateUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Verifies two-factor authentication code
         * @summary Verify Two-Factor Authentication
         * @param {string} userId User ID
         * @param {string} code 2FA Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyTwoFactorAuth(userId: string, code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyTwoFactorAuth(userId, code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserprofileApi.verifyTwoFactorAuth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserprofileApi - factory interface
 * @export
 */
export const UserprofileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserprofileApiFp(configuration)
    return {
        /**
         * Ban a user profile with reason and optional expiration
         * @summary Admin ban profile
         * @param {string} profileId Profile ID
         * @param {CordeCommonModelsDtoUserprofileAdminBanProfileRequest} req Ban Profile Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBanProfile(profileId: string, req: CordeCommonModelsDtoUserprofileAdminBanProfileRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.adminBanProfile(profileId, req, options).then((request) => request(axios, basePath));
        },
        /**
         * Get ban history for a profile
         * @summary Admin get profile ban history
         * @param {string} profileId Profile ID
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {string} [sortBy] Sort field
         * @param {AdminGetProfileBanHistorySortOrderEnum} [sortOrder] Sort order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetProfileBanHistory(profileId: string, limit?: number, offset?: number, sortBy?: string, sortOrder?: AdminGetProfileBanHistorySortOrderEnum, options?: any): AxiosPromise<CordeCommonModelsDtoUserprofileAdminGetProfileBanHistoryResponse> {
            return localVarFp.adminGetProfileBanHistory(profileId, limit, offset, sortBy, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * Get detailed profile information for admin
         * @summary Admin get profile details
         * @param {string} profileId Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetProfileDetails(profileId: string, options?: any): AxiosPromise<CordeCommonModelsDtoUserprofileAdminGetProfileDetailsResponse> {
            return localVarFp.adminGetProfileDetails(profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all profiles for admin management
         * @summary Admin list profiles
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {string} [sortBy] Sort field
         * @param {AdminListProfilesSortOrderEnum} [sortOrder] Sort order
         * @param {string} [search] Search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminListProfiles(limit?: number, offset?: number, sortBy?: string, sortOrder?: AdminListProfilesSortOrderEnum, search?: string, options?: any): AxiosPromise<CordeCommonModelsDtoUserprofileAdminListProfilesResponse> {
            return localVarFp.adminListProfiles(limit, offset, sortBy, sortOrder, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Unban a user profile with admin comment
         * @summary Admin unban profile
         * @param {string} profileId Profile ID
         * @param {CordeCommonModelsDtoUserprofileAdminUnbanProfileRequest} req Unban Profile Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUnbanProfile(profileId: string, req: CordeCommonModelsDtoUserprofileAdminUnbanProfileRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.adminUnbanProfile(profileId, req, options).then((request) => request(axios, basePath));
        },
        /**
         * Upload a new avatar for user profile
         * @summary Upload new avatar
         * @param {string} profileId Profile ID
         * @param {File} file Avatar image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAvatar(profileId: string, file: File, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.createAvatar(profileId, file, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new user profile
         * @summary Create user profile
         * @param {CordeCommonModelsDtoUserprofileCreateUserProfileRequest} req Profile Creation Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserProfile(req: CordeCommonModelsDtoUserprofileCreateUserProfileRequest, options?: any): AxiosPromise<CordeCommonModelsDtoUserprofileUserProfileResponse> {
            return localVarFp.createUserProfile(req, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete user\'s profile avatar
         * @summary Delete user avatar
         * @param {string} profileId Profile ID
         * @param {string} avatarId Avatar ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAvatar(profileId: string, avatarId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.deleteAvatar(profileId, avatarId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete user\'s UI preferences and settings
         * @summary Delete UI settings
         * @param {string} profileId Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUISettings(profileId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.deleteUISettings(profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an existing user profile
         * @summary Delete user profile
         * @param {string} profileId Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserProfile(profileId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.deleteUserProfile(profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get active user profile for current user
         * @summary Get active user profile
         * @param {string} profileId Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveUserProfile(profileId: string, options?: any): AxiosPromise<CordeCommonModelsDtoUserprofileGetActiveUserProfileResponse> {
            return localVarFp.getActiveUserProfile(profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get default user profile for system or entity scope (if entity params are passed)
         * @summary Get default user profile
         * @param {string} userId User ID
         * @param {string} [entityType] Entity type for scoped default
         * @param {string} [entityId] Entity ID for scoped default
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultUserProfile(userId: string, entityType?: string, entityId?: string, options?: any): AxiosPromise<CordeCommonModelsDtoUserprofileUserProfileResponse> {
            return localVarFp.getDefaultUserProfile(userId, entityType, entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get user\'s privacy settings
         * @summary Get privacy settings
         * @param {string} profileId Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrivacySettings(profileId: string, options?: any): AxiosPromise<CordeCommonModelsDtoUserprofileGetPrivacySettingsResponse> {
            return localVarFp.getPrivacySettings(profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get change history for a user profile
         * @summary Get profile change history
         * @param {string} profileId Profile ID
         * @param {string} [fromDate] Filter from date (RFC3339)
         * @param {string} [toDate] Filter to date (RFC3339)
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {string} [sortBy] Sort field
         * @param {GetProfileChangeHistorySortOrderEnum} [sortOrder] Sort order
         * @param {string} [search] Search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileChangeHistory(profileId: string, fromDate?: string, toDate?: string, limit?: number, offset?: number, sortBy?: string, sortOrder?: GetProfileChangeHistorySortOrderEnum, search?: string, options?: any): AxiosPromise<CordeCommonModelsDtoUserprofileGetProfileChangeHistoryResponse> {
            return localVarFp.getProfileChangeHistory(profileId, fromDate, toDate, limit, offset, sortBy, sortOrder, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Get user\'s UI preferences and settings
         * @summary Get UI settings
         * @param {string} profileId Profile ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUISettings(profileId: string, options?: any): AxiosPromise<CordeCommonModelsDtoUserprofileGetUISettingsResponse> {
            return localVarFp.getUISettings(profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get specific user avatar by ID
         * @summary Get user avatar
         * @param {string} profileId Profile ID
         * @param {string} avatarId Avatar ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAvatar(profileId: string, avatarId: string, options?: any): AxiosPromise<CordeCommonModelsDtoUserprofileGetUserAvatarResponse> {
            return localVarFp.getUserAvatar(profileId, avatarId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a user profile by user ID
         * @summary Get user profile
         * @param {string} profileId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProfile(profileId: string, options?: any): AxiosPromise<CordeCommonModelsDtoUserprofileUserProfileResponse> {
            return localVarFp.getUserProfile(profileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get user profiles for internal service operations
         * @summary Get user profiles for service
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProfilesForService(userId: string, options?: any): AxiosPromise<CordeCommonModelsDtoUserprofileGetUserProfilesForServiceResponse> {
            return localVarFp.getUserProfilesForService(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get audit logs for a user profile
         * @summary Get audit logs
         * @param {string} [entityId] Filter by entity ID
         * @param {string} [entityType] Filter by entity type
         * @param {string} [fromDate] Filter from date (RFC3339)
         * @param {string} [toDate] Filter to date (RFC3339)
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {string} [sortBy] Sort field
         * @param {GetUserprofileAuditLogsSortOrderEnum} [sortOrder] Sort order
         * @param {string} [search] Search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserprofileAuditLogs(entityId?: string, entityType?: string, fromDate?: string, toDate?: string, limit?: number, offset?: number, sortBy?: string, sortOrder?: GetUserprofileAuditLogsSortOrderEnum, search?: string, options?: any): AxiosPromise<CordeCommonModelsDtoUserprofileGetAuditLogsResponse> {
            return localVarFp.getUserprofileAuditLogs(entityId, entityType, fromDate, toDate, limit, offset, sortBy, sortOrder, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Get list of user avatars with pagination
         * @summary List user avatars
         * @param {string} profileId Profile ID
         * @param {boolean} [onlyActive] Filter only active avatars
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {string} [sortBy] Sort field
         * @param {ListUserAvatarsSortOrderEnum} [sortOrder] Sort order
         * @param {string} [search] Search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserAvatars(profileId: string, onlyActive?: boolean, limit?: number, offset?: number, sortBy?: string, sortOrder?: ListUserAvatarsSortOrderEnum, search?: string, options?: any): AxiosPromise<CordeCommonModelsDtoUserprofileListUserAvatarsResponse> {
            return localVarFp.listUserAvatars(profileId, onlyActive, limit, offset, sortBy, sortOrder, search, options).then((request) => request(axios, basePath));
        },
        /**
         * List user profiles with pagination and filters
         * @summary List user profiles
         * @param {string} [userId] Filter by user id
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {string} [sortBy] Sort field
         * @param {ListUserProfilesSortOrderEnum} [sortOrder] Sort order
         * @param {string} [search] Search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUserProfiles(userId?: string, limit?: number, offset?: number, sortBy?: string, sortOrder?: ListUserProfilesSortOrderEnum, search?: string, options?: any): AxiosPromise<CordeCommonModelsDtoUserprofileListUserProfilesResponse> {
            return localVarFp.listUserProfiles(userId, limit, offset, sortBy, sortOrder, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Set specific avatar as active for user profile
         * @summary Set active avatar
         * @param {string} profileId Profile ID
         * @param {string} avatarId Avatar ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setActiveAvatar(profileId: string, avatarId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.setActiveAvatar(profileId, avatarId, options).then((request) => request(axios, basePath));
        },
        /**
         * Set active user profile for current user
         * @summary Set active user profile
         * @param {CordeCommonModelsDtoUserprofileSetActiveUserProfileRequest} req Set Active Profile Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setActiveUserProfile(req: CordeCommonModelsDtoUserprofileSetActiveUserProfileRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.setActiveUserProfile(req, options).then((request) => request(axios, basePath));
        },
        /**
         * Set default user profile for system or entity scope (if entity params are passed)
         * @summary Set default user profile
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoUserprofileSetDefaultUserProfileRequest} req Set Default Profile Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultUserProfile(userId: string, req: CordeCommonModelsDtoUserprofileSetDefaultUserProfileRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.setDefaultUserProfile(userId, req, options).then((request) => request(axios, basePath));
        },
        /**
         * Update user\'s privacy settings
         * @summary Update privacy settings
         * @param {string} profileId Profile ID
         * @param {CordeCommonModelsDtoUserprofileUpdatePrivacySettingsRequest} settings Privacy Settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePrivacySettings(profileId: string, settings: CordeCommonModelsDtoUserprofileUpdatePrivacySettingsRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.updatePrivacySettings(profileId, settings, options).then((request) => request(axios, basePath));
        },
        /**
         * Update user\'s UI preferences and settings
         * @summary Update UI settings
         * @param {string} profileId Profile ID
         * @param {CordeCommonModelsDtoUserprofileUpdateUISettingsRequest} settings UI Settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUISettings(profileId: string, settings: CordeCommonModelsDtoUserprofileUpdateUISettingsRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.updateUISettings(profileId, settings, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing user profile
         * @summary Update user profile
         * @param {string} profileId Profile ID
         * @param {CordeCommonModelsDtoUserprofileUpdateUserProfileRequest} req Profile Update Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserProfile(profileId: string, req: CordeCommonModelsDtoUserprofileUpdateUserProfileRequest, options?: any): AxiosPromise<CordeCommonModelsDtoUserprofileUserProfileResponse> {
            return localVarFp.updateUserProfile(profileId, req, options).then((request) => request(axios, basePath));
        },
        /**
         * Verifies two-factor authentication code
         * @summary Verify Two-Factor Authentication
         * @param {string} userId User ID
         * @param {string} code 2FA Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyTwoFactorAuth(userId: string, code: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.verifyTwoFactorAuth(userId, code, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserprofileApi - object-oriented interface
 * @export
 * @class UserprofileApi
 * @extends {BaseAPI}
 */
export class UserprofileApi extends BaseAPI {
    /**
     * Ban a user profile with reason and optional expiration
     * @summary Admin ban profile
     * @param {string} profileId Profile ID
     * @param {CordeCommonModelsDtoUserprofileAdminBanProfileRequest} req Ban Profile Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserprofileApi
     */
    public adminBanProfile(profileId: string, req: CordeCommonModelsDtoUserprofileAdminBanProfileRequest, options?: RawAxiosRequestConfig) {
        return UserprofileApiFp(this.configuration).adminBanProfile(profileId, req, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get ban history for a profile
     * @summary Admin get profile ban history
     * @param {string} profileId Profile ID
     * @param {number} [limit] Number of items to return
     * @param {number} [offset] Number of items to skip
     * @param {string} [sortBy] Sort field
     * @param {AdminGetProfileBanHistorySortOrderEnum} [sortOrder] Sort order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserprofileApi
     */
    public adminGetProfileBanHistory(profileId: string, limit?: number, offset?: number, sortBy?: string, sortOrder?: AdminGetProfileBanHistorySortOrderEnum, options?: RawAxiosRequestConfig) {
        return UserprofileApiFp(this.configuration).adminGetProfileBanHistory(profileId, limit, offset, sortBy, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get detailed profile information for admin
     * @summary Admin get profile details
     * @param {string} profileId Profile ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserprofileApi
     */
    public adminGetProfileDetails(profileId: string, options?: RawAxiosRequestConfig) {
        return UserprofileApiFp(this.configuration).adminGetProfileDetails(profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all profiles for admin management
     * @summary Admin list profiles
     * @param {number} [limit] Number of items to return
     * @param {number} [offset] Number of items to skip
     * @param {string} [sortBy] Sort field
     * @param {AdminListProfilesSortOrderEnum} [sortOrder] Sort order
     * @param {string} [search] Search query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserprofileApi
     */
    public adminListProfiles(limit?: number, offset?: number, sortBy?: string, sortOrder?: AdminListProfilesSortOrderEnum, search?: string, options?: RawAxiosRequestConfig) {
        return UserprofileApiFp(this.configuration).adminListProfiles(limit, offset, sortBy, sortOrder, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unban a user profile with admin comment
     * @summary Admin unban profile
     * @param {string} profileId Profile ID
     * @param {CordeCommonModelsDtoUserprofileAdminUnbanProfileRequest} req Unban Profile Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserprofileApi
     */
    public adminUnbanProfile(profileId: string, req: CordeCommonModelsDtoUserprofileAdminUnbanProfileRequest, options?: RawAxiosRequestConfig) {
        return UserprofileApiFp(this.configuration).adminUnbanProfile(profileId, req, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Upload a new avatar for user profile
     * @summary Upload new avatar
     * @param {string} profileId Profile ID
     * @param {File} file Avatar image
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserprofileApi
     */
    public createAvatar(profileId: string, file: File, options?: RawAxiosRequestConfig) {
        return UserprofileApiFp(this.configuration).createAvatar(profileId, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new user profile
     * @summary Create user profile
     * @param {CordeCommonModelsDtoUserprofileCreateUserProfileRequest} req Profile Creation Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserprofileApi
     */
    public createUserProfile(req: CordeCommonModelsDtoUserprofileCreateUserProfileRequest, options?: RawAxiosRequestConfig) {
        return UserprofileApiFp(this.configuration).createUserProfile(req, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete user\'s profile avatar
     * @summary Delete user avatar
     * @param {string} profileId Profile ID
     * @param {string} avatarId Avatar ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserprofileApi
     */
    public deleteAvatar(profileId: string, avatarId: string, options?: RawAxiosRequestConfig) {
        return UserprofileApiFp(this.configuration).deleteAvatar(profileId, avatarId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete user\'s UI preferences and settings
     * @summary Delete UI settings
     * @param {string} profileId Profile ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserprofileApi
     */
    public deleteUISettings(profileId: string, options?: RawAxiosRequestConfig) {
        return UserprofileApiFp(this.configuration).deleteUISettings(profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an existing user profile
     * @summary Delete user profile
     * @param {string} profileId Profile ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserprofileApi
     */
    public deleteUserProfile(profileId: string, options?: RawAxiosRequestConfig) {
        return UserprofileApiFp(this.configuration).deleteUserProfile(profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get active user profile for current user
     * @summary Get active user profile
     * @param {string} profileId Profile ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserprofileApi
     */
    public getActiveUserProfile(profileId: string, options?: RawAxiosRequestConfig) {
        return UserprofileApiFp(this.configuration).getActiveUserProfile(profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get default user profile for system or entity scope (if entity params are passed)
     * @summary Get default user profile
     * @param {string} userId User ID
     * @param {string} [entityType] Entity type for scoped default
     * @param {string} [entityId] Entity ID for scoped default
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserprofileApi
     */
    public getDefaultUserProfile(userId: string, entityType?: string, entityId?: string, options?: RawAxiosRequestConfig) {
        return UserprofileApiFp(this.configuration).getDefaultUserProfile(userId, entityType, entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get user\'s privacy settings
     * @summary Get privacy settings
     * @param {string} profileId Profile ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserprofileApi
     */
    public getPrivacySettings(profileId: string, options?: RawAxiosRequestConfig) {
        return UserprofileApiFp(this.configuration).getPrivacySettings(profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get change history for a user profile
     * @summary Get profile change history
     * @param {string} profileId Profile ID
     * @param {string} [fromDate] Filter from date (RFC3339)
     * @param {string} [toDate] Filter to date (RFC3339)
     * @param {number} [limit] Number of items to return
     * @param {number} [offset] Number of items to skip
     * @param {string} [sortBy] Sort field
     * @param {GetProfileChangeHistorySortOrderEnum} [sortOrder] Sort order
     * @param {string} [search] Search query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserprofileApi
     */
    public getProfileChangeHistory(profileId: string, fromDate?: string, toDate?: string, limit?: number, offset?: number, sortBy?: string, sortOrder?: GetProfileChangeHistorySortOrderEnum, search?: string, options?: RawAxiosRequestConfig) {
        return UserprofileApiFp(this.configuration).getProfileChangeHistory(profileId, fromDate, toDate, limit, offset, sortBy, sortOrder, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get user\'s UI preferences and settings
     * @summary Get UI settings
     * @param {string} profileId Profile ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserprofileApi
     */
    public getUISettings(profileId: string, options?: RawAxiosRequestConfig) {
        return UserprofileApiFp(this.configuration).getUISettings(profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get specific user avatar by ID
     * @summary Get user avatar
     * @param {string} profileId Profile ID
     * @param {string} avatarId Avatar ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserprofileApi
     */
    public getUserAvatar(profileId: string, avatarId: string, options?: RawAxiosRequestConfig) {
        return UserprofileApiFp(this.configuration).getUserAvatar(profileId, avatarId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a user profile by user ID
     * @summary Get user profile
     * @param {string} profileId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserprofileApi
     */
    public getUserProfile(profileId: string, options?: RawAxiosRequestConfig) {
        return UserprofileApiFp(this.configuration).getUserProfile(profileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get user profiles for internal service operations
     * @summary Get user profiles for service
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserprofileApi
     */
    public getUserProfilesForService(userId: string, options?: RawAxiosRequestConfig) {
        return UserprofileApiFp(this.configuration).getUserProfilesForService(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get audit logs for a user profile
     * @summary Get audit logs
     * @param {string} [entityId] Filter by entity ID
     * @param {string} [entityType] Filter by entity type
     * @param {string} [fromDate] Filter from date (RFC3339)
     * @param {string} [toDate] Filter to date (RFC3339)
     * @param {number} [limit] Number of items to return
     * @param {number} [offset] Number of items to skip
     * @param {string} [sortBy] Sort field
     * @param {GetUserprofileAuditLogsSortOrderEnum} [sortOrder] Sort order
     * @param {string} [search] Search query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserprofileApi
     */
    public getUserprofileAuditLogs(entityId?: string, entityType?: string, fromDate?: string, toDate?: string, limit?: number, offset?: number, sortBy?: string, sortOrder?: GetUserprofileAuditLogsSortOrderEnum, search?: string, options?: RawAxiosRequestConfig) {
        return UserprofileApiFp(this.configuration).getUserprofileAuditLogs(entityId, entityType, fromDate, toDate, limit, offset, sortBy, sortOrder, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of user avatars with pagination
     * @summary List user avatars
     * @param {string} profileId Profile ID
     * @param {boolean} [onlyActive] Filter only active avatars
     * @param {number} [limit] Number of items to return
     * @param {number} [offset] Number of items to skip
     * @param {string} [sortBy] Sort field
     * @param {ListUserAvatarsSortOrderEnum} [sortOrder] Sort order
     * @param {string} [search] Search query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserprofileApi
     */
    public listUserAvatars(profileId: string, onlyActive?: boolean, limit?: number, offset?: number, sortBy?: string, sortOrder?: ListUserAvatarsSortOrderEnum, search?: string, options?: RawAxiosRequestConfig) {
        return UserprofileApiFp(this.configuration).listUserAvatars(profileId, onlyActive, limit, offset, sortBy, sortOrder, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List user profiles with pagination and filters
     * @summary List user profiles
     * @param {string} [userId] Filter by user id
     * @param {number} [limit] Number of items to return
     * @param {number} [offset] Number of items to skip
     * @param {string} [sortBy] Sort field
     * @param {ListUserProfilesSortOrderEnum} [sortOrder] Sort order
     * @param {string} [search] Search query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserprofileApi
     */
    public listUserProfiles(userId?: string, limit?: number, offset?: number, sortBy?: string, sortOrder?: ListUserProfilesSortOrderEnum, search?: string, options?: RawAxiosRequestConfig) {
        return UserprofileApiFp(this.configuration).listUserProfiles(userId, limit, offset, sortBy, sortOrder, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set specific avatar as active for user profile
     * @summary Set active avatar
     * @param {string} profileId Profile ID
     * @param {string} avatarId Avatar ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserprofileApi
     */
    public setActiveAvatar(profileId: string, avatarId: string, options?: RawAxiosRequestConfig) {
        return UserprofileApiFp(this.configuration).setActiveAvatar(profileId, avatarId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set active user profile for current user
     * @summary Set active user profile
     * @param {CordeCommonModelsDtoUserprofileSetActiveUserProfileRequest} req Set Active Profile Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserprofileApi
     */
    public setActiveUserProfile(req: CordeCommonModelsDtoUserprofileSetActiveUserProfileRequest, options?: RawAxiosRequestConfig) {
        return UserprofileApiFp(this.configuration).setActiveUserProfile(req, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Set default user profile for system or entity scope (if entity params are passed)
     * @summary Set default user profile
     * @param {string} userId User ID
     * @param {CordeCommonModelsDtoUserprofileSetDefaultUserProfileRequest} req Set Default Profile Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserprofileApi
     */
    public setDefaultUserProfile(userId: string, req: CordeCommonModelsDtoUserprofileSetDefaultUserProfileRequest, options?: RawAxiosRequestConfig) {
        return UserprofileApiFp(this.configuration).setDefaultUserProfile(userId, req, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update user\'s privacy settings
     * @summary Update privacy settings
     * @param {string} profileId Profile ID
     * @param {CordeCommonModelsDtoUserprofileUpdatePrivacySettingsRequest} settings Privacy Settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserprofileApi
     */
    public updatePrivacySettings(profileId: string, settings: CordeCommonModelsDtoUserprofileUpdatePrivacySettingsRequest, options?: RawAxiosRequestConfig) {
        return UserprofileApiFp(this.configuration).updatePrivacySettings(profileId, settings, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update user\'s UI preferences and settings
     * @summary Update UI settings
     * @param {string} profileId Profile ID
     * @param {CordeCommonModelsDtoUserprofileUpdateUISettingsRequest} settings UI Settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserprofileApi
     */
    public updateUISettings(profileId: string, settings: CordeCommonModelsDtoUserprofileUpdateUISettingsRequest, options?: RawAxiosRequestConfig) {
        return UserprofileApiFp(this.configuration).updateUISettings(profileId, settings, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing user profile
     * @summary Update user profile
     * @param {string} profileId Profile ID
     * @param {CordeCommonModelsDtoUserprofileUpdateUserProfileRequest} req Profile Update Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserprofileApi
     */
    public updateUserProfile(profileId: string, req: CordeCommonModelsDtoUserprofileUpdateUserProfileRequest, options?: RawAxiosRequestConfig) {
        return UserprofileApiFp(this.configuration).updateUserProfile(profileId, req, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verifies two-factor authentication code
     * @summary Verify Two-Factor Authentication
     * @param {string} userId User ID
     * @param {string} code 2FA Code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserprofileApi
     */
    public verifyTwoFactorAuth(userId: string, code: string, options?: RawAxiosRequestConfig) {
        return UserprofileApiFp(this.configuration).verifyTwoFactorAuth(userId, code, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AdminGetProfileBanHistorySortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type AdminGetProfileBanHistorySortOrderEnum = typeof AdminGetProfileBanHistorySortOrderEnum[keyof typeof AdminGetProfileBanHistorySortOrderEnum];
/**
 * @export
 */
export const AdminListProfilesSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type AdminListProfilesSortOrderEnum = typeof AdminListProfilesSortOrderEnum[keyof typeof AdminListProfilesSortOrderEnum];
/**
 * @export
 */
export const GetProfileChangeHistorySortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetProfileChangeHistorySortOrderEnum = typeof GetProfileChangeHistorySortOrderEnum[keyof typeof GetProfileChangeHistorySortOrderEnum];
/**
 * @export
 */
export const GetUserprofileAuditLogsSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetUserprofileAuditLogsSortOrderEnum = typeof GetUserprofileAuditLogsSortOrderEnum[keyof typeof GetUserprofileAuditLogsSortOrderEnum];
/**
 * @export
 */
export const ListUserAvatarsSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListUserAvatarsSortOrderEnum = typeof ListUserAvatarsSortOrderEnum[keyof typeof ListUserAvatarsSortOrderEnum];
/**
 * @export
 */
export const ListUserProfilesSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ListUserProfilesSortOrderEnum = typeof ListUserProfilesSortOrderEnum[keyof typeof ListUserProfilesSortOrderEnum];


/**
 * VoiceApi - axios parameter creator
 * @export
 */
export const VoiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Accept an invite to join a voice group
         * @summary Accept invite
         * @param {CordeCommonModelsDtoVoiceAcceptInviteRequest} body Accept Invite Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInvite: async (body: CordeCommonModelsDtoVoiceAcceptInviteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('acceptInvite', 'body', body)
            const localVarPath = `/voice/invites/accept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Accept an ownership transfer
         * @summary Accept ownership transfer
         * @param {CordeCommonModelsDtoVoiceAcceptOwnershipTransferRequest} body Accept Ownership Transfer Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptOwnershipTransfer: async (body: CordeCommonModelsDtoVoiceAcceptOwnershipTransferRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('acceptOwnershipTransfer', 'body', body)
            const localVarPath = `/voice/ownership/accept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a user as a member to a voice group
         * @summary Add member to voice group
         * @param {CordeCommonModelsDtoVoiceAddMemberRequest} body Add Member Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMember: async (body: CordeCommonModelsDtoVoiceAddMemberRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('addMember', 'body', body)
            const localVarPath = `/voice/members`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive a voice room and optionally its groups
         * @summary Archive voice room
         * @param {string} roomId Room ID
         * @param {boolean} [archiveGroups] Also archive all groups in the room
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveRoom: async (roomId: string, archiveGroups?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('archiveRoom', 'roomId', roomId)
            const localVarPath = `/voice/rooms/{room_id}/archive`
                .replace(`{${"room_id"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (archiveGroups !== undefined) {
                localVarQueryParameter['archive_groups'] = archiveGroups;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Archive a voice group and optionally its members
         * @summary Archive voice group
         * @param {string} groupId Group ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveVoiceGroup: async (groupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('archiveVoiceGroup', 'groupId', groupId)
            const localVarPath = `/voice/groups/{group_id}/archive`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Cancel an ownership transfer
         * @summary Cancel ownership transfer
         * @param {CordeCommonModelsDtoVoiceCancelOwnershipTransferRequest} body Cancel Ownership Transfer Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOwnershipTransfer: async (body: CordeCommonModelsDtoVoiceCancelOwnershipTransferRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('cancelOwnershipTransfer', 'body', body)
            const localVarPath = `/voice/ownership/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create an invite for a voice group
         * @summary Create invite
         * @param {CordeCommonModelsDtoVoiceCreateInviteRequest} body Create Invite Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvite: async (body: CordeCommonModelsDtoVoiceCreateInviteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createInvite', 'body', body)
            const localVarPath = `/voice/invites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new voice room with specified settings
         * @summary Create a new voice room
         * @param {CordeCommonModelsDtoVoiceCreateRoomRequest} body Create Room Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoom: async (body: CordeCommonModelsDtoVoiceCreateRoomRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createRoom', 'body', body)
            const localVarPath = `/voice/rooms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new voice group in a room
         * @summary Create a new voice group
         * @param {CordeCommonModelsDtoVoiceCreateVoiceGroupRequest} body Create Voice Group Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVoiceGroup: async (body: CordeCommonModelsDtoVoiceCreateVoiceGroupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createVoiceGroup', 'body', body)
            const localVarPath = `/voice/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deafen a member in a voice group
         * @summary Deafen member
         * @param {string} groupId Group ID
         * @param {string} userId User ID
         * @param {string} [reason] Reason for deafening
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deafenMember: async (groupId: string, userId: string, reason?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('deafenMember', 'groupId', groupId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deafenMember', 'userId', userId)
            const localVarPath = `/voice/groups/{group_id}/members/{user_id}/deafen`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Decline an invite to join a voice group
         * @summary Decline invite
         * @param {CordeCommonModelsDtoVoiceDeclineInviteRequest} body Decline Invite Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineInvite: async (body: CordeCommonModelsDtoVoiceDeclineInviteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('declineInvite', 'body', body)
            const localVarPath = `/voice/invites/decline`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Decline an ownership transfer
         * @summary Decline ownership transfer
         * @param {CordeCommonModelsDtoVoiceDeclineOwnershipTransferRequest} body Decline Ownership Transfer Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineOwnershipTransfer: async (body: CordeCommonModelsDtoVoiceDeclineOwnershipTransferRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('declineOwnershipTransfer', 'body', body)
            const localVarPath = `/voice/ownership/decline`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a voice room and all its groups
         * @summary Delete voice room
         * @param {string} roomId Room ID
         * @param {boolean} [force] Force delete even if room has groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoom: async (roomId: string, force?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('deleteRoom', 'roomId', roomId)
            const localVarPath = `/voice/rooms/{room_id}`
                .replace(`{${"room_id"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (force !== undefined) {
                localVarQueryParameter['force'] = force;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a voice group and all its members
         * @summary Delete voice group
         * @param {string} groupId Group ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVoiceGroup: async (groupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('deleteVoiceGroup', 'groupId', groupId)
            const localVarPath = `/voice/groups/{group_id}`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the history of group moves
         * @summary Get group move history
         * @param {string} [groupId] Filter by group ID
         * @param {string} [roomId] Filter by room ID
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupMoveHistory: async (groupId?: string, roomId?: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/voice/groups/move-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (roomId !== undefined) {
                localVarQueryParameter['room_id'] = roomId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get invite details by invite code
         * @summary Get invite by code
         * @param {string} code Invite Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInviteByCode: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('getInviteByCode', 'code', code)
            const localVarPath = `/voice/invites/code/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the history of ownership transfers
         * @summary Get ownership transfer history
         * @param {string} [resourceType] Filter by resource type (room/group)
         * @param {string} [resourceId] Filter by resource ID
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnershipTransferHistory: async (resourceType?: string, resourceId?: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/voice/ownership/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (resourceType !== undefined) {
                localVarQueryParameter['resource_type'] = resourceType;
            }

            if (resourceId !== undefined) {
                localVarQueryParameter['resource_id'] = resourceId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get detailed information about a voice room
         * @summary Get voice room details
         * @param {string} roomId Room ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoom: async (roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('getRoom', 'roomId', roomId)
            const localVarPath = `/voice/rooms/{room_id}`
                .replace(`{${"room_id"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get detailed information about a voice group
         * @summary Get voice group details
         * @param {string} groupId Group ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoiceGroup: async (groupId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('getVoiceGroup', 'groupId', groupId)
            const localVarPath = `/voice/groups/{group_id}`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bidirectional WebSocket connection for streaming voice group data
         * @summary Voice Group WebSocket Stream
         * @param {string} authorization Bearer {token}
         * @param {string} groupId Voice Group ID
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleVoiceGroupStream: async (authorization: string, groupId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('handleVoiceGroupStream', 'authorization', authorization)
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('handleVoiceGroupStream', 'groupId', groupId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('handleVoiceGroupStream', 'userId', userId)
            const localVarPath = `/voice/groups/{group_id}/stream`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bidirectional WebSocket connection for streaming voice room data
         * @summary Voice Room WebSocket Stream
         * @param {string} authorization Bearer {token}
         * @param {string} roomId Room ID
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleVoiceRoomStream: async (authorization: string, roomId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authorization' is not null or undefined
            assertParamExists('handleVoiceRoomStream', 'authorization', authorization)
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('handleVoiceRoomStream', 'roomId', roomId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('handleVoiceRoomStream', 'userId', userId)
            const localVarPath = `/voice/rooms/{room_id}/stream`
                .replace(`{${"room_id"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['user_id'] = userId;
            }

            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Join a voice group and start a session
         * @summary Join voice group
         * @param {CordeCommonModelsDtoVoiceJoinVoiceGroupRequest} body Join Voice Group Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinVoiceGroup: async (body: CordeCommonModelsDtoVoiceJoinVoiceGroupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('joinVoiceGroup', 'body', body)
            const localVarPath = `/voice/sessions/join`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Leave a voice group and end the session
         * @summary Leave voice group
         * @param {CordeCommonModelsDtoVoiceLeaveVoiceGroupRequest} body Leave Voice Group Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveVoiceGroup: async (body: CordeCommonModelsDtoVoiceLeaveVoiceGroupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('leaveVoiceGroup', 'body', body)
            const localVarPath = `/voice/sessions/leave`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of invites for a voice group
         * @summary List invites
         * @param {string} [groupId] Filter by group ID
         * @param {string} [status] Filter by invite status
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvites: async (groupId?: string, status?: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/voice/invites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of members in a voice group
         * @summary List group members
         * @param {string} groupId Group ID
         * @param {string} [role] Filter by member role
         * @param {string} [status] Filter by member status
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMembers: async (groupId: string, role?: string, status?: string, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('listMembers', 'groupId', groupId)
            const localVarPath = `/voice/groups/{group_id}/members`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of voice rooms with optional filtering
         * @summary List voice rooms
         * @param {string} [type] Filter by room type
         * @param {string} [status] Filter by room status
         * @param {boolean} [includeArchived] Include archived rooms
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRooms: async (type?: string, status?: string, includeArchived?: boolean, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/voice/rooms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (includeArchived !== undefined) {
                localVarQueryParameter['include_archived'] = includeArchived;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of voice groups with optional filtering
         * @summary List voice groups
         * @param {string} [roomId] Filter by room ID
         * @param {string} [status] Filter by group status
         * @param {boolean} [includeArchived] Include archived groups
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVoiceGroups: async (roomId?: string, status?: string, includeArchived?: boolean, limit?: number, offset?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/voice/groups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (roomId !== undefined) {
                localVarQueryParameter['room_id'] = roomId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (includeArchived !== undefined) {
                localVarQueryParameter['include_archived'] = includeArchived;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lock a voice room to prevent new connections
         * @summary Lock voice room
         * @param {string} roomId Room ID
         * @param {string} [reason] Reason for locking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockRoom: async (roomId: string, reason?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('lockRoom', 'roomId', roomId)
            const localVarPath = `/voice/rooms/{room_id}/lock`
                .replace(`{${"room_id"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Move a voice group from one room to another
         * @summary Move group to room
         * @param {CordeCommonModelsDtoVoiceMoveGroupToRoomRequest} body Move Group To Room Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveGroupToRoom: async (body: CordeCommonModelsDtoVoiceMoveGroupToRoomRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('moveGroupToRoom', 'body', body)
            const localVarPath = `/voice/groups/move`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mute a member in a voice group
         * @summary Mute member
         * @param {string} groupId Group ID
         * @param {string} userId User ID
         * @param {string} [reason] Reason for muting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        muteMember: async (groupId: string, userId: string, reason?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('muteMember', 'groupId', groupId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('muteMember', 'userId', userId)
            const localVarPath = `/voice/groups/{group_id}/members/{user_id}/mute`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a member from a voice group
         * @summary Remove member from voice group
         * @param {string} groupId Group ID
         * @param {string} userId User ID
         * @param {string} [reason] Reason for removal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMember: async (groupId: string, userId: string, reason?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('removeMember', 'groupId', groupId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeMember', 'userId', userId)
            const localVarPath = `/voice/groups/{group_id}/members/{user_id}`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (reason !== undefined) {
                localVarQueryParameter['reason'] = reason;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revoke an invite
         * @summary Revoke invite
         * @param {string} inviteId Invite ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeInvite: async (inviteId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inviteId' is not null or undefined
            assertParamExists('revokeInvite', 'inviteId', inviteId)
            const localVarPath = `/voice/invites/{invite_id}`
                .replace(`{${"invite_id"}}`, encodeURIComponent(String(inviteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Transfer ownership of a voice group
         * @summary Transfer group ownership
         * @param {CordeCommonModelsDtoVoiceTransferGroupOwnershipRequest} body Transfer Group Ownership Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferGroupOwnership: async (body: CordeCommonModelsDtoVoiceTransferGroupOwnershipRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('transferGroupOwnership', 'body', body)
            const localVarPath = `/voice/groups/transfer-ownership`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Transfer ownership of a voice room
         * @summary Transfer room ownership
         * @param {CordeCommonModelsDtoVoiceTransferRoomOwnershipRequest} body Transfer Room Ownership Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferRoomOwnership: async (body: CordeCommonModelsDtoVoiceTransferRoomOwnershipRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('transferRoomOwnership', 'body', body)
            const localVarPath = `/voice/rooms/transfer-ownership`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Undeafen a member in a voice group
         * @summary Undeafen member
         * @param {string} groupId Group ID
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undeafenMember: async (groupId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('undeafenMember', 'groupId', groupId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('undeafenMember', 'userId', userId)
            const localVarPath = `/voice/groups/{group_id}/members/{user_id}/undeafen`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unlock a voice room to allow new connections
         * @summary Unlock voice room
         * @param {string} roomId Room ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockRoom: async (roomId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('unlockRoom', 'roomId', roomId)
            const localVarPath = `/voice/rooms/{room_id}/unlock`
                .replace(`{${"room_id"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unmute a member in a voice group
         * @summary Unmute member
         * @param {string} groupId Group ID
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmuteMember: async (groupId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('unmuteMember', 'groupId', groupId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('unmuteMember', 'userId', userId)
            const localVarPath = `/voice/groups/{group_id}/members/{user_id}/unmute`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update the role of a member in a voice group
         * @summary Update member role
         * @param {string} groupId Group ID
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoVoiceUpdateMemberRoleRequest} body Update Member Role Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMemberRole: async (groupId: string, userId: string, body: CordeCommonModelsDtoVoiceUpdateMemberRoleRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('updateMemberRole', 'groupId', groupId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateMemberRole', 'userId', userId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateMemberRole', 'body', body)
            const localVarPath = `/voice/groups/{group_id}/members/{user_id}/role`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)))
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update voice room settings and information
         * @summary Update voice room
         * @param {string} roomId Room ID
         * @param {CordeCommonModelsDtoVoiceUpdateRoomRequest} body Update Room Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoom: async (roomId: string, body: CordeCommonModelsDtoVoiceUpdateRoomRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roomId' is not null or undefined
            assertParamExists('updateRoom', 'roomId', roomId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateRoom', 'body', body)
            const localVarPath = `/voice/rooms/{room_id}`
                .replace(`{${"room_id"}}`, encodeURIComponent(String(roomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update voice group settings and information
         * @summary Update voice group
         * @param {string} groupId Group ID
         * @param {CordeCommonModelsDtoVoiceUpdateVoiceGroupRequest} body Update Voice Group Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVoiceGroup: async (groupId: string, body: CordeCommonModelsDtoVoiceUpdateVoiceGroupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('updateVoiceGroup', 'groupId', groupId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateVoiceGroup', 'body', body)
            const localVarPath = `/voice/groups/{group_id}`
                .replace(`{${"group_id"}}`, encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VoiceApi - functional programming interface
 * @export
 */
export const VoiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VoiceApiAxiosParamCreator(configuration)
    return {
        /**
         * Accept an invite to join a voice group
         * @summary Accept invite
         * @param {CordeCommonModelsDtoVoiceAcceptInviteRequest} body Accept Invite Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptInvite(body: CordeCommonModelsDtoVoiceAcceptInviteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoVoiceAcceptInviteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptInvite(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.acceptInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Accept an ownership transfer
         * @summary Accept ownership transfer
         * @param {CordeCommonModelsDtoVoiceAcceptOwnershipTransferRequest} body Accept Ownership Transfer Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptOwnershipTransfer(body: CordeCommonModelsDtoVoiceAcceptOwnershipTransferRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptOwnershipTransfer(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.acceptOwnershipTransfer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a user as a member to a voice group
         * @summary Add member to voice group
         * @param {CordeCommonModelsDtoVoiceAddMemberRequest} body Add Member Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addMember(body: CordeCommonModelsDtoVoiceAddMemberRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoVoiceAddMemberResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addMember(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.addMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive a voice room and optionally its groups
         * @summary Archive voice room
         * @param {string} roomId Room ID
         * @param {boolean} [archiveGroups] Also archive all groups in the room
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveRoom(roomId: string, archiveGroups?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveRoom(roomId, archiveGroups, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.archiveRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Archive a voice group and optionally its members
         * @summary Archive voice group
         * @param {string} groupId Group ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveVoiceGroup(groupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveVoiceGroup(groupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.archiveVoiceGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Cancel an ownership transfer
         * @summary Cancel ownership transfer
         * @param {CordeCommonModelsDtoVoiceCancelOwnershipTransferRequest} body Cancel Ownership Transfer Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelOwnershipTransfer(body: CordeCommonModelsDtoVoiceCancelOwnershipTransferRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelOwnershipTransfer(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.cancelOwnershipTransfer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create an invite for a voice group
         * @summary Create invite
         * @param {CordeCommonModelsDtoVoiceCreateInviteRequest} body Create Invite Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInvite(body: CordeCommonModelsDtoVoiceCreateInviteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoVoiceCreateInviteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInvite(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.createInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new voice room with specified settings
         * @summary Create a new voice room
         * @param {CordeCommonModelsDtoVoiceCreateRoomRequest} body Create Room Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRoom(body: CordeCommonModelsDtoVoiceCreateRoomRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoVoiceCreateRoomResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRoom(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.createRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new voice group in a room
         * @summary Create a new voice group
         * @param {CordeCommonModelsDtoVoiceCreateVoiceGroupRequest} body Create Voice Group Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createVoiceGroup(body: CordeCommonModelsDtoVoiceCreateVoiceGroupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoVoiceCreateVoiceGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createVoiceGroup(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.createVoiceGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deafen a member in a voice group
         * @summary Deafen member
         * @param {string} groupId Group ID
         * @param {string} userId User ID
         * @param {string} [reason] Reason for deafening
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deafenMember(groupId: string, userId: string, reason?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deafenMember(groupId, userId, reason, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.deafenMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Decline an invite to join a voice group
         * @summary Decline invite
         * @param {CordeCommonModelsDtoVoiceDeclineInviteRequest} body Decline Invite Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async declineInvite(body: CordeCommonModelsDtoVoiceDeclineInviteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.declineInvite(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.declineInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Decline an ownership transfer
         * @summary Decline ownership transfer
         * @param {CordeCommonModelsDtoVoiceDeclineOwnershipTransferRequest} body Decline Ownership Transfer Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async declineOwnershipTransfer(body: CordeCommonModelsDtoVoiceDeclineOwnershipTransferRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.declineOwnershipTransfer(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.declineOwnershipTransfer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a voice room and all its groups
         * @summary Delete voice room
         * @param {string} roomId Room ID
         * @param {boolean} [force] Force delete even if room has groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRoom(roomId: string, force?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRoom(roomId, force, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.deleteRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a voice group and all its members
         * @summary Delete voice group
         * @param {string} groupId Group ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteVoiceGroup(groupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteVoiceGroup(groupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.deleteVoiceGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the history of group moves
         * @summary Get group move history
         * @param {string} [groupId] Filter by group ID
         * @param {string} [roomId] Filter by room ID
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroupMoveHistory(groupId?: string, roomId?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoVoiceGetGroupMoveHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroupMoveHistory(groupId, roomId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.getGroupMoveHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get invite details by invite code
         * @summary Get invite by code
         * @param {string} code Invite Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInviteByCode(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoVoiceGetInviteByCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInviteByCode(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.getInviteByCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the history of ownership transfers
         * @summary Get ownership transfer history
         * @param {string} [resourceType] Filter by resource type (room/group)
         * @param {string} [resourceId] Filter by resource ID
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOwnershipTransferHistory(resourceType?: string, resourceId?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoVoiceGetOwnershipTransferHistoryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOwnershipTransferHistory(resourceType, resourceId, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.getOwnershipTransferHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get detailed information about a voice room
         * @summary Get voice room details
         * @param {string} roomId Room ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoom(roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoVoiceGetRoomResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoom(roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.getRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get detailed information about a voice group
         * @summary Get voice group details
         * @param {string} groupId Group ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVoiceGroup(groupId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoVoiceGetVoiceGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVoiceGroup(groupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.getVoiceGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Bidirectional WebSocket connection for streaming voice group data
         * @summary Voice Group WebSocket Stream
         * @param {string} authorization Bearer {token}
         * @param {string} groupId Voice Group ID
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleVoiceGroupStream(authorization: string, groupId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleVoiceGroupStream(authorization, groupId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.handleVoiceGroupStream']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Bidirectional WebSocket connection for streaming voice room data
         * @summary Voice Room WebSocket Stream
         * @param {string} authorization Bearer {token}
         * @param {string} roomId Room ID
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async handleVoiceRoomStream(authorization: string, roomId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.handleVoiceRoomStream(authorization, roomId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.handleVoiceRoomStream']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Join a voice group and start a session
         * @summary Join voice group
         * @param {CordeCommonModelsDtoVoiceJoinVoiceGroupRequest} body Join Voice Group Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async joinVoiceGroup(body: CordeCommonModelsDtoVoiceJoinVoiceGroupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoVoiceJoinVoiceGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.joinVoiceGroup(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.joinVoiceGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Leave a voice group and end the session
         * @summary Leave voice group
         * @param {CordeCommonModelsDtoVoiceLeaveVoiceGroupRequest} body Leave Voice Group Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leaveVoiceGroup(body: CordeCommonModelsDtoVoiceLeaveVoiceGroupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leaveVoiceGroup(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.leaveVoiceGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a list of invites for a voice group
         * @summary List invites
         * @param {string} [groupId] Filter by group ID
         * @param {string} [status] Filter by invite status
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInvites(groupId?: string, status?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoVoiceListInvitesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInvites(groupId, status, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.listInvites']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a list of members in a voice group
         * @summary List group members
         * @param {string} groupId Group ID
         * @param {string} [role] Filter by member role
         * @param {string} [status] Filter by member status
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMembers(groupId: string, role?: string, status?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoVoiceListMembersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMembers(groupId, role, status, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.listMembers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a list of voice rooms with optional filtering
         * @summary List voice rooms
         * @param {string} [type] Filter by room type
         * @param {string} [status] Filter by room status
         * @param {boolean} [includeArchived] Include archived rooms
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRooms(type?: string, status?: string, includeArchived?: boolean, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoVoiceListRoomsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRooms(type, status, includeArchived, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.listRooms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a list of voice groups with optional filtering
         * @summary List voice groups
         * @param {string} [roomId] Filter by room ID
         * @param {string} [status] Filter by group status
         * @param {boolean} [includeArchived] Include archived groups
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listVoiceGroups(roomId?: string, status?: string, includeArchived?: boolean, limit?: number, offset?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoVoiceListVoiceGroupsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listVoiceGroups(roomId, status, includeArchived, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.listVoiceGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lock a voice room to prevent new connections
         * @summary Lock voice room
         * @param {string} roomId Room ID
         * @param {string} [reason] Reason for locking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lockRoom(roomId: string, reason?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lockRoom(roomId, reason, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.lockRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Move a voice group from one room to another
         * @summary Move group to room
         * @param {CordeCommonModelsDtoVoiceMoveGroupToRoomRequest} body Move Group To Room Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveGroupToRoom(body: CordeCommonModelsDtoVoiceMoveGroupToRoomRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoVoiceMoveGroupToRoomResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveGroupToRoom(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.moveGroupToRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mute a member in a voice group
         * @summary Mute member
         * @param {string} groupId Group ID
         * @param {string} userId User ID
         * @param {string} [reason] Reason for muting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async muteMember(groupId: string, userId: string, reason?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.muteMember(groupId, userId, reason, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.muteMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a member from a voice group
         * @summary Remove member from voice group
         * @param {string} groupId Group ID
         * @param {string} userId User ID
         * @param {string} [reason] Reason for removal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeMember(groupId: string, userId: string, reason?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeMember(groupId, userId, reason, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.removeMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Revoke an invite
         * @summary Revoke invite
         * @param {string} inviteId Invite ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async revokeInvite(inviteId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.revokeInvite(inviteId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.revokeInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Transfer ownership of a voice group
         * @summary Transfer group ownership
         * @param {CordeCommonModelsDtoVoiceTransferGroupOwnershipRequest} body Transfer Group Ownership Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transferGroupOwnership(body: CordeCommonModelsDtoVoiceTransferGroupOwnershipRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoVoiceTransferGroupOwnershipResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transferGroupOwnership(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.transferGroupOwnership']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Transfer ownership of a voice room
         * @summary Transfer room ownership
         * @param {CordeCommonModelsDtoVoiceTransferRoomOwnershipRequest} body Transfer Room Ownership Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transferRoomOwnership(body: CordeCommonModelsDtoVoiceTransferRoomOwnershipRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoVoiceTransferRoomOwnershipResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transferRoomOwnership(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.transferRoomOwnership']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Undeafen a member in a voice group
         * @summary Undeafen member
         * @param {string} groupId Group ID
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async undeafenMember(groupId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.undeafenMember(groupId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.undeafenMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unlock a voice room to allow new connections
         * @summary Unlock voice room
         * @param {string} roomId Room ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlockRoom(roomId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlockRoom(roomId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.unlockRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unmute a member in a voice group
         * @summary Unmute member
         * @param {string} groupId Group ID
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unmuteMember(groupId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unmuteMember(groupId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.unmuteMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update the role of a member in a voice group
         * @summary Update member role
         * @param {string} groupId Group ID
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoVoiceUpdateMemberRoleRequest} body Update Member Role Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMemberRole(groupId: string, userId: string, body: CordeCommonModelsDtoVoiceUpdateMemberRoleRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoResponseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMemberRole(groupId, userId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.updateMemberRole']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update voice room settings and information
         * @summary Update voice room
         * @param {string} roomId Room ID
         * @param {CordeCommonModelsDtoVoiceUpdateRoomRequest} body Update Room Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRoom(roomId: string, body: CordeCommonModelsDtoVoiceUpdateRoomRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoVoiceUpdateRoomResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRoom(roomId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.updateRoom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update voice group settings and information
         * @summary Update voice group
         * @param {string} groupId Group ID
         * @param {CordeCommonModelsDtoVoiceUpdateVoiceGroupRequest} body Update Voice Group Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateVoiceGroup(groupId: string, body: CordeCommonModelsDtoVoiceUpdateVoiceGroupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CordeCommonModelsDtoVoiceUpdateVoiceGroupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateVoiceGroup(groupId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VoiceApi.updateVoiceGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VoiceApi - factory interface
 * @export
 */
export const VoiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VoiceApiFp(configuration)
    return {
        /**
         * Accept an invite to join a voice group
         * @summary Accept invite
         * @param {CordeCommonModelsDtoVoiceAcceptInviteRequest} body Accept Invite Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInvite(body: CordeCommonModelsDtoVoiceAcceptInviteRequest, options?: any): AxiosPromise<CordeCommonModelsDtoVoiceAcceptInviteResponse> {
            return localVarFp.acceptInvite(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Accept an ownership transfer
         * @summary Accept ownership transfer
         * @param {CordeCommonModelsDtoVoiceAcceptOwnershipTransferRequest} body Accept Ownership Transfer Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptOwnershipTransfer(body: CordeCommonModelsDtoVoiceAcceptOwnershipTransferRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.acceptOwnershipTransfer(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a user as a member to a voice group
         * @summary Add member to voice group
         * @param {CordeCommonModelsDtoVoiceAddMemberRequest} body Add Member Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addMember(body: CordeCommonModelsDtoVoiceAddMemberRequest, options?: any): AxiosPromise<CordeCommonModelsDtoVoiceAddMemberResponse> {
            return localVarFp.addMember(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive a voice room and optionally its groups
         * @summary Archive voice room
         * @param {string} roomId Room ID
         * @param {boolean} [archiveGroups] Also archive all groups in the room
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveRoom(roomId: string, archiveGroups?: boolean, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.archiveRoom(roomId, archiveGroups, options).then((request) => request(axios, basePath));
        },
        /**
         * Archive a voice group and optionally its members
         * @summary Archive voice group
         * @param {string} groupId Group ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveVoiceGroup(groupId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.archiveVoiceGroup(groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Cancel an ownership transfer
         * @summary Cancel ownership transfer
         * @param {CordeCommonModelsDtoVoiceCancelOwnershipTransferRequest} body Cancel Ownership Transfer Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOwnershipTransfer(body: CordeCommonModelsDtoVoiceCancelOwnershipTransferRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.cancelOwnershipTransfer(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Create an invite for a voice group
         * @summary Create invite
         * @param {CordeCommonModelsDtoVoiceCreateInviteRequest} body Create Invite Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvite(body: CordeCommonModelsDtoVoiceCreateInviteRequest, options?: any): AxiosPromise<CordeCommonModelsDtoVoiceCreateInviteResponse> {
            return localVarFp.createInvite(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new voice room with specified settings
         * @summary Create a new voice room
         * @param {CordeCommonModelsDtoVoiceCreateRoomRequest} body Create Room Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoom(body: CordeCommonModelsDtoVoiceCreateRoomRequest, options?: any): AxiosPromise<CordeCommonModelsDtoVoiceCreateRoomResponse> {
            return localVarFp.createRoom(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new voice group in a room
         * @summary Create a new voice group
         * @param {CordeCommonModelsDtoVoiceCreateVoiceGroupRequest} body Create Voice Group Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVoiceGroup(body: CordeCommonModelsDtoVoiceCreateVoiceGroupRequest, options?: any): AxiosPromise<CordeCommonModelsDtoVoiceCreateVoiceGroupResponse> {
            return localVarFp.createVoiceGroup(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Deafen a member in a voice group
         * @summary Deafen member
         * @param {string} groupId Group ID
         * @param {string} userId User ID
         * @param {string} [reason] Reason for deafening
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deafenMember(groupId: string, userId: string, reason?: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.deafenMember(groupId, userId, reason, options).then((request) => request(axios, basePath));
        },
        /**
         * Decline an invite to join a voice group
         * @summary Decline invite
         * @param {CordeCommonModelsDtoVoiceDeclineInviteRequest} body Decline Invite Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineInvite(body: CordeCommonModelsDtoVoiceDeclineInviteRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.declineInvite(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Decline an ownership transfer
         * @summary Decline ownership transfer
         * @param {CordeCommonModelsDtoVoiceDeclineOwnershipTransferRequest} body Decline Ownership Transfer Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineOwnershipTransfer(body: CordeCommonModelsDtoVoiceDeclineOwnershipTransferRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.declineOwnershipTransfer(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a voice room and all its groups
         * @summary Delete voice room
         * @param {string} roomId Room ID
         * @param {boolean} [force] Force delete even if room has groups
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoom(roomId: string, force?: boolean, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.deleteRoom(roomId, force, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a voice group and all its members
         * @summary Delete voice group
         * @param {string} groupId Group ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteVoiceGroup(groupId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.deleteVoiceGroup(groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the history of group moves
         * @summary Get group move history
         * @param {string} [groupId] Filter by group ID
         * @param {string} [roomId] Filter by room ID
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupMoveHistory(groupId?: string, roomId?: string, limit?: number, offset?: number, options?: any): AxiosPromise<CordeCommonModelsDtoVoiceGetGroupMoveHistoryResponse> {
            return localVarFp.getGroupMoveHistory(groupId, roomId, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Get invite details by invite code
         * @summary Get invite by code
         * @param {string} code Invite Code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInviteByCode(code: string, options?: any): AxiosPromise<CordeCommonModelsDtoVoiceGetInviteByCodeResponse> {
            return localVarFp.getInviteByCode(code, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the history of ownership transfers
         * @summary Get ownership transfer history
         * @param {string} [resourceType] Filter by resource type (room/group)
         * @param {string} [resourceId] Filter by resource ID
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOwnershipTransferHistory(resourceType?: string, resourceId?: string, limit?: number, offset?: number, options?: any): AxiosPromise<CordeCommonModelsDtoVoiceGetOwnershipTransferHistoryResponse> {
            return localVarFp.getOwnershipTransferHistory(resourceType, resourceId, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Get detailed information about a voice room
         * @summary Get voice room details
         * @param {string} roomId Room ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoom(roomId: string, options?: any): AxiosPromise<CordeCommonModelsDtoVoiceGetRoomResponse> {
            return localVarFp.getRoom(roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get detailed information about a voice group
         * @summary Get voice group details
         * @param {string} groupId Group ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVoiceGroup(groupId: string, options?: any): AxiosPromise<CordeCommonModelsDtoVoiceGetVoiceGroupResponse> {
            return localVarFp.getVoiceGroup(groupId, options).then((request) => request(axios, basePath));
        },
        /**
         * Bidirectional WebSocket connection for streaming voice group data
         * @summary Voice Group WebSocket Stream
         * @param {string} authorization Bearer {token}
         * @param {string} groupId Voice Group ID
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleVoiceGroupStream(authorization: string, groupId: string, userId: string, options?: any): AxiosPromise<void> {
            return localVarFp.handleVoiceGroupStream(authorization, groupId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Bidirectional WebSocket connection for streaming voice room data
         * @summary Voice Room WebSocket Stream
         * @param {string} authorization Bearer {token}
         * @param {string} roomId Room ID
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleVoiceRoomStream(authorization: string, roomId: string, userId: string, options?: any): AxiosPromise<void> {
            return localVarFp.handleVoiceRoomStream(authorization, roomId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Join a voice group and start a session
         * @summary Join voice group
         * @param {CordeCommonModelsDtoVoiceJoinVoiceGroupRequest} body Join Voice Group Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinVoiceGroup(body: CordeCommonModelsDtoVoiceJoinVoiceGroupRequest, options?: any): AxiosPromise<CordeCommonModelsDtoVoiceJoinVoiceGroupResponse> {
            return localVarFp.joinVoiceGroup(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Leave a voice group and end the session
         * @summary Leave voice group
         * @param {CordeCommonModelsDtoVoiceLeaveVoiceGroupRequest} body Leave Voice Group Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveVoiceGroup(body: CordeCommonModelsDtoVoiceLeaveVoiceGroupRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.leaveVoiceGroup(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of invites for a voice group
         * @summary List invites
         * @param {string} [groupId] Filter by group ID
         * @param {string} [status] Filter by invite status
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvites(groupId?: string, status?: string, limit?: number, offset?: number, options?: any): AxiosPromise<CordeCommonModelsDtoVoiceListInvitesResponse> {
            return localVarFp.listInvites(groupId, status, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of members in a voice group
         * @summary List group members
         * @param {string} groupId Group ID
         * @param {string} [role] Filter by member role
         * @param {string} [status] Filter by member status
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMembers(groupId: string, role?: string, status?: string, limit?: number, offset?: number, options?: any): AxiosPromise<CordeCommonModelsDtoVoiceListMembersResponse> {
            return localVarFp.listMembers(groupId, role, status, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of voice rooms with optional filtering
         * @summary List voice rooms
         * @param {string} [type] Filter by room type
         * @param {string} [status] Filter by room status
         * @param {boolean} [includeArchived] Include archived rooms
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRooms(type?: string, status?: string, includeArchived?: boolean, limit?: number, offset?: number, options?: any): AxiosPromise<CordeCommonModelsDtoVoiceListRoomsResponse> {
            return localVarFp.listRooms(type, status, includeArchived, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of voice groups with optional filtering
         * @summary List voice groups
         * @param {string} [roomId] Filter by room ID
         * @param {string} [status] Filter by group status
         * @param {boolean} [includeArchived] Include archived groups
         * @param {number} [limit] Number of items to return
         * @param {number} [offset] Number of items to skip
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVoiceGroups(roomId?: string, status?: string, includeArchived?: boolean, limit?: number, offset?: number, options?: any): AxiosPromise<CordeCommonModelsDtoVoiceListVoiceGroupsResponse> {
            return localVarFp.listVoiceGroups(roomId, status, includeArchived, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * Lock a voice room to prevent new connections
         * @summary Lock voice room
         * @param {string} roomId Room ID
         * @param {string} [reason] Reason for locking
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lockRoom(roomId: string, reason?: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.lockRoom(roomId, reason, options).then((request) => request(axios, basePath));
        },
        /**
         * Move a voice group from one room to another
         * @summary Move group to room
         * @param {CordeCommonModelsDtoVoiceMoveGroupToRoomRequest} body Move Group To Room Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveGroupToRoom(body: CordeCommonModelsDtoVoiceMoveGroupToRoomRequest, options?: any): AxiosPromise<CordeCommonModelsDtoVoiceMoveGroupToRoomResponse> {
            return localVarFp.moveGroupToRoom(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Mute a member in a voice group
         * @summary Mute member
         * @param {string} groupId Group ID
         * @param {string} userId User ID
         * @param {string} [reason] Reason for muting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        muteMember(groupId: string, userId: string, reason?: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.muteMember(groupId, userId, reason, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a member from a voice group
         * @summary Remove member from voice group
         * @param {string} groupId Group ID
         * @param {string} userId User ID
         * @param {string} [reason] Reason for removal
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeMember(groupId: string, userId: string, reason?: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.removeMember(groupId, userId, reason, options).then((request) => request(axios, basePath));
        },
        /**
         * Revoke an invite
         * @summary Revoke invite
         * @param {string} inviteId Invite ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        revokeInvite(inviteId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.revokeInvite(inviteId, options).then((request) => request(axios, basePath));
        },
        /**
         * Transfer ownership of a voice group
         * @summary Transfer group ownership
         * @param {CordeCommonModelsDtoVoiceTransferGroupOwnershipRequest} body Transfer Group Ownership Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferGroupOwnership(body: CordeCommonModelsDtoVoiceTransferGroupOwnershipRequest, options?: any): AxiosPromise<CordeCommonModelsDtoVoiceTransferGroupOwnershipResponse> {
            return localVarFp.transferGroupOwnership(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Transfer ownership of a voice room
         * @summary Transfer room ownership
         * @param {CordeCommonModelsDtoVoiceTransferRoomOwnershipRequest} body Transfer Room Ownership Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferRoomOwnership(body: CordeCommonModelsDtoVoiceTransferRoomOwnershipRequest, options?: any): AxiosPromise<CordeCommonModelsDtoVoiceTransferRoomOwnershipResponse> {
            return localVarFp.transferRoomOwnership(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Undeafen a member in a voice group
         * @summary Undeafen member
         * @param {string} groupId Group ID
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        undeafenMember(groupId: string, userId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.undeafenMember(groupId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Unlock a voice room to allow new connections
         * @summary Unlock voice room
         * @param {string} roomId Room ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlockRoom(roomId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.unlockRoom(roomId, options).then((request) => request(axios, basePath));
        },
        /**
         * Unmute a member in a voice group
         * @summary Unmute member
         * @param {string} groupId Group ID
         * @param {string} userId User ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unmuteMember(groupId: string, userId: string, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.unmuteMember(groupId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update the role of a member in a voice group
         * @summary Update member role
         * @param {string} groupId Group ID
         * @param {string} userId User ID
         * @param {CordeCommonModelsDtoVoiceUpdateMemberRoleRequest} body Update Member Role Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMemberRole(groupId: string, userId: string, body: CordeCommonModelsDtoVoiceUpdateMemberRoleRequest, options?: any): AxiosPromise<CordeCommonModelsDtoResponseResponse> {
            return localVarFp.updateMemberRole(groupId, userId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Update voice room settings and information
         * @summary Update voice room
         * @param {string} roomId Room ID
         * @param {CordeCommonModelsDtoVoiceUpdateRoomRequest} body Update Room Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoom(roomId: string, body: CordeCommonModelsDtoVoiceUpdateRoomRequest, options?: any): AxiosPromise<CordeCommonModelsDtoVoiceUpdateRoomResponse> {
            return localVarFp.updateRoom(roomId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Update voice group settings and information
         * @summary Update voice group
         * @param {string} groupId Group ID
         * @param {CordeCommonModelsDtoVoiceUpdateVoiceGroupRequest} body Update Voice Group Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateVoiceGroup(groupId: string, body: CordeCommonModelsDtoVoiceUpdateVoiceGroupRequest, options?: any): AxiosPromise<CordeCommonModelsDtoVoiceUpdateVoiceGroupResponse> {
            return localVarFp.updateVoiceGroup(groupId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VoiceApi - object-oriented interface
 * @export
 * @class VoiceApi
 * @extends {BaseAPI}
 */
export class VoiceApi extends BaseAPI {
    /**
     * Accept an invite to join a voice group
     * @summary Accept invite
     * @param {CordeCommonModelsDtoVoiceAcceptInviteRequest} body Accept Invite Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public acceptInvite(body: CordeCommonModelsDtoVoiceAcceptInviteRequest, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).acceptInvite(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Accept an ownership transfer
     * @summary Accept ownership transfer
     * @param {CordeCommonModelsDtoVoiceAcceptOwnershipTransferRequest} body Accept Ownership Transfer Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public acceptOwnershipTransfer(body: CordeCommonModelsDtoVoiceAcceptOwnershipTransferRequest, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).acceptOwnershipTransfer(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a user as a member to a voice group
     * @summary Add member to voice group
     * @param {CordeCommonModelsDtoVoiceAddMemberRequest} body Add Member Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public addMember(body: CordeCommonModelsDtoVoiceAddMemberRequest, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).addMember(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive a voice room and optionally its groups
     * @summary Archive voice room
     * @param {string} roomId Room ID
     * @param {boolean} [archiveGroups] Also archive all groups in the room
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public archiveRoom(roomId: string, archiveGroups?: boolean, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).archiveRoom(roomId, archiveGroups, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Archive a voice group and optionally its members
     * @summary Archive voice group
     * @param {string} groupId Group ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public archiveVoiceGroup(groupId: string, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).archiveVoiceGroup(groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Cancel an ownership transfer
     * @summary Cancel ownership transfer
     * @param {CordeCommonModelsDtoVoiceCancelOwnershipTransferRequest} body Cancel Ownership Transfer Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public cancelOwnershipTransfer(body: CordeCommonModelsDtoVoiceCancelOwnershipTransferRequest, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).cancelOwnershipTransfer(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create an invite for a voice group
     * @summary Create invite
     * @param {CordeCommonModelsDtoVoiceCreateInviteRequest} body Create Invite Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public createInvite(body: CordeCommonModelsDtoVoiceCreateInviteRequest, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).createInvite(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new voice room with specified settings
     * @summary Create a new voice room
     * @param {CordeCommonModelsDtoVoiceCreateRoomRequest} body Create Room Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public createRoom(body: CordeCommonModelsDtoVoiceCreateRoomRequest, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).createRoom(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new voice group in a room
     * @summary Create a new voice group
     * @param {CordeCommonModelsDtoVoiceCreateVoiceGroupRequest} body Create Voice Group Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public createVoiceGroup(body: CordeCommonModelsDtoVoiceCreateVoiceGroupRequest, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).createVoiceGroup(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deafen a member in a voice group
     * @summary Deafen member
     * @param {string} groupId Group ID
     * @param {string} userId User ID
     * @param {string} [reason] Reason for deafening
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public deafenMember(groupId: string, userId: string, reason?: string, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).deafenMember(groupId, userId, reason, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Decline an invite to join a voice group
     * @summary Decline invite
     * @param {CordeCommonModelsDtoVoiceDeclineInviteRequest} body Decline Invite Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public declineInvite(body: CordeCommonModelsDtoVoiceDeclineInviteRequest, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).declineInvite(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Decline an ownership transfer
     * @summary Decline ownership transfer
     * @param {CordeCommonModelsDtoVoiceDeclineOwnershipTransferRequest} body Decline Ownership Transfer Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public declineOwnershipTransfer(body: CordeCommonModelsDtoVoiceDeclineOwnershipTransferRequest, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).declineOwnershipTransfer(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a voice room and all its groups
     * @summary Delete voice room
     * @param {string} roomId Room ID
     * @param {boolean} [force] Force delete even if room has groups
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public deleteRoom(roomId: string, force?: boolean, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).deleteRoom(roomId, force, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a voice group and all its members
     * @summary Delete voice group
     * @param {string} groupId Group ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public deleteVoiceGroup(groupId: string, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).deleteVoiceGroup(groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the history of group moves
     * @summary Get group move history
     * @param {string} [groupId] Filter by group ID
     * @param {string} [roomId] Filter by room ID
     * @param {number} [limit] Number of items to return
     * @param {number} [offset] Number of items to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public getGroupMoveHistory(groupId?: string, roomId?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).getGroupMoveHistory(groupId, roomId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get invite details by invite code
     * @summary Get invite by code
     * @param {string} code Invite Code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public getInviteByCode(code: string, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).getInviteByCode(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the history of ownership transfers
     * @summary Get ownership transfer history
     * @param {string} [resourceType] Filter by resource type (room/group)
     * @param {string} [resourceId] Filter by resource ID
     * @param {number} [limit] Number of items to return
     * @param {number} [offset] Number of items to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public getOwnershipTransferHistory(resourceType?: string, resourceId?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).getOwnershipTransferHistory(resourceType, resourceId, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get detailed information about a voice room
     * @summary Get voice room details
     * @param {string} roomId Room ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public getRoom(roomId: string, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).getRoom(roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get detailed information about a voice group
     * @summary Get voice group details
     * @param {string} groupId Group ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public getVoiceGroup(groupId: string, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).getVoiceGroup(groupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Bidirectional WebSocket connection for streaming voice group data
     * @summary Voice Group WebSocket Stream
     * @param {string} authorization Bearer {token}
     * @param {string} groupId Voice Group ID
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public handleVoiceGroupStream(authorization: string, groupId: string, userId: string, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).handleVoiceGroupStream(authorization, groupId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Bidirectional WebSocket connection for streaming voice room data
     * @summary Voice Room WebSocket Stream
     * @param {string} authorization Bearer {token}
     * @param {string} roomId Room ID
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public handleVoiceRoomStream(authorization: string, roomId: string, userId: string, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).handleVoiceRoomStream(authorization, roomId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Join a voice group and start a session
     * @summary Join voice group
     * @param {CordeCommonModelsDtoVoiceJoinVoiceGroupRequest} body Join Voice Group Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public joinVoiceGroup(body: CordeCommonModelsDtoVoiceJoinVoiceGroupRequest, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).joinVoiceGroup(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Leave a voice group and end the session
     * @summary Leave voice group
     * @param {CordeCommonModelsDtoVoiceLeaveVoiceGroupRequest} body Leave Voice Group Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public leaveVoiceGroup(body: CordeCommonModelsDtoVoiceLeaveVoiceGroupRequest, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).leaveVoiceGroup(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a list of invites for a voice group
     * @summary List invites
     * @param {string} [groupId] Filter by group ID
     * @param {string} [status] Filter by invite status
     * @param {number} [limit] Number of items to return
     * @param {number} [offset] Number of items to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public listInvites(groupId?: string, status?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).listInvites(groupId, status, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a list of members in a voice group
     * @summary List group members
     * @param {string} groupId Group ID
     * @param {string} [role] Filter by member role
     * @param {string} [status] Filter by member status
     * @param {number} [limit] Number of items to return
     * @param {number} [offset] Number of items to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public listMembers(groupId: string, role?: string, status?: string, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).listMembers(groupId, role, status, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a list of voice rooms with optional filtering
     * @summary List voice rooms
     * @param {string} [type] Filter by room type
     * @param {string} [status] Filter by room status
     * @param {boolean} [includeArchived] Include archived rooms
     * @param {number} [limit] Number of items to return
     * @param {number} [offset] Number of items to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public listRooms(type?: string, status?: string, includeArchived?: boolean, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).listRooms(type, status, includeArchived, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a list of voice groups with optional filtering
     * @summary List voice groups
     * @param {string} [roomId] Filter by room ID
     * @param {string} [status] Filter by group status
     * @param {boolean} [includeArchived] Include archived groups
     * @param {number} [limit] Number of items to return
     * @param {number} [offset] Number of items to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public listVoiceGroups(roomId?: string, status?: string, includeArchived?: boolean, limit?: number, offset?: number, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).listVoiceGroups(roomId, status, includeArchived, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lock a voice room to prevent new connections
     * @summary Lock voice room
     * @param {string} roomId Room ID
     * @param {string} [reason] Reason for locking
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public lockRoom(roomId: string, reason?: string, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).lockRoom(roomId, reason, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Move a voice group from one room to another
     * @summary Move group to room
     * @param {CordeCommonModelsDtoVoiceMoveGroupToRoomRequest} body Move Group To Room Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public moveGroupToRoom(body: CordeCommonModelsDtoVoiceMoveGroupToRoomRequest, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).moveGroupToRoom(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mute a member in a voice group
     * @summary Mute member
     * @param {string} groupId Group ID
     * @param {string} userId User ID
     * @param {string} [reason] Reason for muting
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public muteMember(groupId: string, userId: string, reason?: string, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).muteMember(groupId, userId, reason, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a member from a voice group
     * @summary Remove member from voice group
     * @param {string} groupId Group ID
     * @param {string} userId User ID
     * @param {string} [reason] Reason for removal
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public removeMember(groupId: string, userId: string, reason?: string, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).removeMember(groupId, userId, reason, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revoke an invite
     * @summary Revoke invite
     * @param {string} inviteId Invite ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public revokeInvite(inviteId: string, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).revokeInvite(inviteId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Transfer ownership of a voice group
     * @summary Transfer group ownership
     * @param {CordeCommonModelsDtoVoiceTransferGroupOwnershipRequest} body Transfer Group Ownership Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public transferGroupOwnership(body: CordeCommonModelsDtoVoiceTransferGroupOwnershipRequest, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).transferGroupOwnership(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Transfer ownership of a voice room
     * @summary Transfer room ownership
     * @param {CordeCommonModelsDtoVoiceTransferRoomOwnershipRequest} body Transfer Room Ownership Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public transferRoomOwnership(body: CordeCommonModelsDtoVoiceTransferRoomOwnershipRequest, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).transferRoomOwnership(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Undeafen a member in a voice group
     * @summary Undeafen member
     * @param {string} groupId Group ID
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public undeafenMember(groupId: string, userId: string, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).undeafenMember(groupId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unlock a voice room to allow new connections
     * @summary Unlock voice room
     * @param {string} roomId Room ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public unlockRoom(roomId: string, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).unlockRoom(roomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unmute a member in a voice group
     * @summary Unmute member
     * @param {string} groupId Group ID
     * @param {string} userId User ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public unmuteMember(groupId: string, userId: string, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).unmuteMember(groupId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update the role of a member in a voice group
     * @summary Update member role
     * @param {string} groupId Group ID
     * @param {string} userId User ID
     * @param {CordeCommonModelsDtoVoiceUpdateMemberRoleRequest} body Update Member Role Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public updateMemberRole(groupId: string, userId: string, body: CordeCommonModelsDtoVoiceUpdateMemberRoleRequest, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).updateMemberRole(groupId, userId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update voice room settings and information
     * @summary Update voice room
     * @param {string} roomId Room ID
     * @param {CordeCommonModelsDtoVoiceUpdateRoomRequest} body Update Room Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public updateRoom(roomId: string, body: CordeCommonModelsDtoVoiceUpdateRoomRequest, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).updateRoom(roomId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update voice group settings and information
     * @summary Update voice group
     * @param {string} groupId Group ID
     * @param {CordeCommonModelsDtoVoiceUpdateVoiceGroupRequest} body Update Voice Group Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VoiceApi
     */
    public updateVoiceGroup(groupId: string, body: CordeCommonModelsDtoVoiceUpdateVoiceGroupRequest, options?: RawAxiosRequestConfig) {
        return VoiceApiFp(this.configuration).updateVoiceGroup(groupId, body, options).then((request) => request(this.axios, this.basePath));
    }
}



